// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/glyphicons-halflings-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../fonts/glyphicons-halflings-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../fonts/glyphicons-halflings-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../fonts/glyphicons-halflings-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../fonts/glyphicons-halflings-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./base/patterns/header-profile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./base/patterns/shattered.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./base/patterns/header-profile-skin-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./base/patterns/header-profile-skin-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./base/patterns/header-profile-skin-3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,300,500,700);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefixx" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
 *
 *   INSPINIA - Responsive Admin Theme
 *   version 2.9.3
 *
*/
h1, h2, h3, h4, h5, h6 {
  font-weight: 100;
}

.h1, .h2, .h3, h1, h2, h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

h1 {
  font-size: 30px;
}

h2 {
  font-size: 24px;
}

h3 {
  font-size: 16px;
}

h4 {
  font-size: 14px;
}

h5 {
  font-size: 12px;
}

h6 {
  font-size: 10px;
}

h3, h4, h5 {
  margin-top: 5px;
  font-weight: 600;
}

@font-face {
  font-family: "Glyphicons Halflings";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
}
.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.glyphicon-asterisk:before {
  content: "*";
}

.glyphicon-plus:before {
  content: "+";
}

.glyphicon-euro:before,
.glyphicon-eur:before {
  content: "€";
}

.glyphicon-minus:before {
  content: "−";
}

.glyphicon-cloud:before {
  content: "☁";
}

.glyphicon-envelope:before {
  content: "✉";
}

.glyphicon-pencil:before {
  content: "✏";
}

.glyphicon-glass:before {
  content: "";
}

.glyphicon-music:before {
  content: "";
}

.glyphicon-search:before {
  content: "";
}

.glyphicon-heart:before {
  content: "";
}

.glyphicon-star:before {
  content: "";
}

.glyphicon-star-empty:before {
  content: "";
}

.glyphicon-user:before {
  content: "";
}

.glyphicon-film:before {
  content: "";
}

.glyphicon-th-large:before {
  content: "";
}

.glyphicon-th:before {
  content: "";
}

.glyphicon-th-list:before {
  content: "";
}

.glyphicon-ok:before {
  content: "";
}

.glyphicon-remove:before {
  content: "";
}

.glyphicon-zoom-in:before {
  content: "";
}

.glyphicon-zoom-out:before {
  content: "";
}

.glyphicon-off:before {
  content: "";
}

.glyphicon-signal:before {
  content: "";
}

.glyphicon-cog:before {
  content: "";
}

.glyphicon-trash:before {
  content: "";
}

.glyphicon-home:before {
  content: "";
}

.glyphicon-file:before {
  content: "";
}

.glyphicon-time:before {
  content: "";
}

.glyphicon-road:before {
  content: "";
}

.glyphicon-download-alt:before {
  content: "";
}

.glyphicon-download:before {
  content: "";
}

.glyphicon-upload:before {
  content: "";
}

.glyphicon-inbox:before {
  content: "";
}

.glyphicon-play-circle:before {
  content: "";
}

.glyphicon-repeat:before {
  content: "";
}

.glyphicon-refresh:before {
  content: "";
}

.glyphicon-list-alt:before {
  content: "";
}

.glyphicon-lock:before {
  content: "";
}

.glyphicon-flag:before {
  content: "";
}

.glyphicon-headphones:before {
  content: "";
}

.glyphicon-volume-off:before {
  content: "";
}

.glyphicon-volume-down:before {
  content: "";
}

.glyphicon-volume-up:before {
  content: "";
}

.glyphicon-qrcode:before {
  content: "";
}

.glyphicon-barcode:before {
  content: "";
}

.glyphicon-tag:before {
  content: "";
}

.glyphicon-tags:before {
  content: "";
}

.glyphicon-book:before {
  content: "";
}

.glyphicon-bookmark:before {
  content: "";
}

.glyphicon-print:before {
  content: "";
}

.glyphicon-camera:before {
  content: "";
}

.glyphicon-font:before {
  content: "";
}

.glyphicon-bold:before {
  content: "";
}

.glyphicon-italic:before {
  content: "";
}

.glyphicon-text-height:before {
  content: "";
}

.glyphicon-text-width:before {
  content: "";
}

.glyphicon-align-left:before {
  content: "";
}

.glyphicon-align-center:before {
  content: "";
}

.glyphicon-align-right:before {
  content: "";
}

.glyphicon-align-justify:before {
  content: "";
}

.glyphicon-list:before {
  content: "";
}

.glyphicon-indent-left:before {
  content: "";
}

.glyphicon-indent-right:before {
  content: "";
}

.glyphicon-facetime-video:before {
  content: "";
}

.glyphicon-picture:before {
  content: "";
}

.glyphicon-map-marker:before {
  content: "";
}

.glyphicon-adjust:before {
  content: "";
}

.glyphicon-tint:before {
  content: "";
}

.glyphicon-edit:before {
  content: "";
}

.glyphicon-share:before {
  content: "";
}

.glyphicon-check:before {
  content: "";
}

.glyphicon-move:before {
  content: "";
}

.glyphicon-step-backward:before {
  content: "";
}

.glyphicon-fast-backward:before {
  content: "";
}

.glyphicon-backward:before {
  content: "";
}

.glyphicon-play:before {
  content: "";
}

.glyphicon-pause:before {
  content: "";
}

.glyphicon-stop:before {
  content: "";
}

.glyphicon-forward:before {
  content: "";
}

.glyphicon-fast-forward:before {
  content: "";
}

.glyphicon-step-forward:before {
  content: "";
}

.glyphicon-eject:before {
  content: "";
}

.glyphicon-chevron-left:before {
  content: "";
}

.glyphicon-chevron-right:before {
  content: "";
}

.glyphicon-plus-sign:before {
  content: "";
}

.glyphicon-minus-sign:before {
  content: "";
}

.glyphicon-remove-sign:before {
  content: "";
}

.glyphicon-ok-sign:before {
  content: "";
}

.glyphicon-question-sign:before {
  content: "";
}

.glyphicon-info-sign:before {
  content: "";
}

.glyphicon-screenshot:before {
  content: "";
}

.glyphicon-remove-circle:before {
  content: "";
}

.glyphicon-ok-circle:before {
  content: "";
}

.glyphicon-ban-circle:before {
  content: "";
}

.glyphicon-arrow-left:before {
  content: "";
}

.glyphicon-arrow-right:before {
  content: "";
}

.glyphicon-arrow-up:before {
  content: "";
}

.glyphicon-arrow-down:before {
  content: "";
}

.glyphicon-share-alt:before {
  content: "";
}

.glyphicon-resize-full:before {
  content: "";
}

.glyphicon-resize-small:before {
  content: "";
}

.glyphicon-exclamation-sign:before {
  content: "";
}

.glyphicon-gift:before {
  content: "";
}

.glyphicon-leaf:before {
  content: "";
}

.glyphicon-fire:before {
  content: "";
}

.glyphicon-eye-open:before {
  content: "";
}

.glyphicon-eye-close:before {
  content: "";
}

.glyphicon-warning-sign:before {
  content: "";
}

.glyphicon-plane:before {
  content: "";
}

.glyphicon-calendar:before {
  content: "";
}

.glyphicon-random:before {
  content: "";
}

.glyphicon-comment:before {
  content: "";
}

.glyphicon-magnet:before {
  content: "";
}

.glyphicon-chevron-up:before {
  content: "";
}

.glyphicon-chevron-down:before {
  content: "";
}

.glyphicon-retweet:before {
  content: "";
}

.glyphicon-shopping-cart:before {
  content: "";
}

.glyphicon-folder-close:before {
  content: "";
}

.glyphicon-folder-open:before {
  content: "";
}

.glyphicon-resize-vertical:before {
  content: "";
}

.glyphicon-resize-horizontal:before {
  content: "";
}

.glyphicon-hdd:before {
  content: "";
}

.glyphicon-bullhorn:before {
  content: "";
}

.glyphicon-bell:before {
  content: "";
}

.glyphicon-certificate:before {
  content: "";
}

.glyphicon-thumbs-up:before {
  content: "";
}

.glyphicon-thumbs-down:before {
  content: "";
}

.glyphicon-hand-right:before {
  content: "";
}

.glyphicon-hand-left:before {
  content: "";
}

.glyphicon-hand-up:before {
  content: "";
}

.glyphicon-hand-down:before {
  content: "";
}

.glyphicon-circle-arrow-right:before {
  content: "";
}

.glyphicon-circle-arrow-left:before {
  content: "";
}

.glyphicon-circle-arrow-up:before {
  content: "";
}

.glyphicon-circle-arrow-down:before {
  content: "";
}

.glyphicon-globe:before {
  content: "";
}

.glyphicon-wrench:before {
  content: "";
}

.glyphicon-tasks:before {
  content: "";
}

.glyphicon-filter:before {
  content: "";
}

.glyphicon-briefcase:before {
  content: "";
}

.glyphicon-fullscreen:before {
  content: "";
}

.glyphicon-dashboard:before {
  content: "";
}

.glyphicon-paperclip:before {
  content: "";
}

.glyphicon-heart-empty:before {
  content: "";
}

.glyphicon-link:before {
  content: "";
}

.glyphicon-phone:before {
  content: "";
}

.glyphicon-pushpin:before {
  content: "";
}

.glyphicon-usd:before {
  content: "";
}

.glyphicon-gbp:before {
  content: "";
}

.glyphicon-sort:before {
  content: "";
}

.glyphicon-sort-by-alphabet:before {
  content: "";
}

.glyphicon-sort-by-alphabet-alt:before {
  content: "";
}

.glyphicon-sort-by-order:before {
  content: "";
}

.glyphicon-sort-by-order-alt:before {
  content: "";
}

.glyphicon-sort-by-attributes:before {
  content: "";
}

.glyphicon-sort-by-attributes-alt:before {
  content: "";
}

.glyphicon-unchecked:before {
  content: "";
}

.glyphicon-expand:before {
  content: "";
}

.glyphicon-collapse-down:before {
  content: "";
}

.glyphicon-collapse-up:before {
  content: "";
}

.glyphicon-log-in:before {
  content: "";
}

.glyphicon-flash:before {
  content: "";
}

.glyphicon-log-out:before {
  content: "";
}

.glyphicon-new-window:before {
  content: "";
}

.glyphicon-record:before {
  content: "";
}

.glyphicon-save:before {
  content: "";
}

.glyphicon-open:before {
  content: "";
}

.glyphicon-saved:before {
  content: "";
}

.glyphicon-import:before {
  content: "";
}

.glyphicon-export:before {
  content: "";
}

.glyphicon-send:before {
  content: "";
}

.glyphicon-floppy-disk:before {
  content: "";
}

.glyphicon-floppy-saved:before {
  content: "";
}

.glyphicon-floppy-remove:before {
  content: "";
}

.glyphicon-floppy-save:before {
  content: "";
}

.glyphicon-floppy-open:before {
  content: "";
}

.glyphicon-credit-card:before {
  content: "";
}

.glyphicon-transfer:before {
  content: "";
}

.glyphicon-cutlery:before {
  content: "";
}

.glyphicon-header:before {
  content: "";
}

.glyphicon-compressed:before {
  content: "";
}

.glyphicon-earphone:before {
  content: "";
}

.glyphicon-phone-alt:before {
  content: "";
}

.glyphicon-tower:before {
  content: "";
}

.glyphicon-stats:before {
  content: "";
}

.glyphicon-sd-video:before {
  content: "";
}

.glyphicon-hd-video:before {
  content: "";
}

.glyphicon-subtitles:before {
  content: "";
}

.glyphicon-sound-stereo:before {
  content: "";
}

.glyphicon-sound-dolby:before {
  content: "";
}

.glyphicon-sound-5-1:before {
  content: "";
}

.glyphicon-sound-6-1:before {
  content: "";
}

.glyphicon-sound-7-1:before {
  content: "";
}

.glyphicon-copyright-mark:before {
  content: "";
}

.glyphicon-registration-mark:before {
  content: "";
}

.glyphicon-cloud-download:before {
  content: "";
}

.glyphicon-cloud-upload:before {
  content: "";
}

.glyphicon-tree-conifer:before {
  content: "";
}

.glyphicon-tree-deciduous:before {
  content: "";
}

.glyphicon-cd:before {
  content: "";
}

.glyphicon-save-file:before {
  content: "";
}

.glyphicon-open-file:before {
  content: "";
}

.glyphicon-level-up:before {
  content: "";
}

.glyphicon-copy:before {
  content: "";
}

.glyphicon-paste:before {
  content: "";
}

.glyphicon-alert:before {
  content: "";
}

.glyphicon-equalizer:before {
  content: "";
}

.glyphicon-king:before {
  content: "";
}

.glyphicon-queen:before {
  content: "";
}

.glyphicon-pawn:before {
  content: "";
}

.glyphicon-bishop:before {
  content: "";
}

.glyphicon-knight:before {
  content: "";
}

.glyphicon-baby-formula:before {
  content: "";
}

.glyphicon-tent:before {
  content: "⛺";
}

.glyphicon-blackboard:before {
  content: "";
}

.glyphicon-bed:before {
  content: "";
}

.glyphicon-apple:before {
  content: "";
}

.glyphicon-erase:before {
  content: "";
}

.glyphicon-hourglass:before {
  content: "⌛";
}

.glyphicon-lamp:before {
  content: "";
}

.glyphicon-duplicate:before {
  content: "";
}

.glyphicon-piggy-bank:before {
  content: "";
}

.glyphicon-scissors:before {
  content: "";
}

.glyphicon-bitcoin:before {
  content: "";
}

.glyphicon-btc:before {
  content: "";
}

.glyphicon-xbt:before {
  content: "";
}

.glyphicon-yen:before {
  content: "¥";
}

.glyphicon-jpy:before {
  content: "¥";
}

.glyphicon-ruble:before {
  content: "₽";
}

.glyphicon-rub:before {
  content: "₽";
}

.glyphicon-scale:before {
  content: "";
}

.glyphicon-ice-lolly:before {
  content: "";
}

.glyphicon-ice-lolly-tasted:before {
  content: "";
}

.glyphicon-education:before {
  content: "";
}

.glyphicon-option-horizontal:before {
  content: "";
}

.glyphicon-option-vertical:before {
  content: "";
}

.glyphicon-menu-hamburger:before {
  content: "";
}

.glyphicon-modal-window:before {
  content: "";
}

.glyphicon-oil:before {
  content: "";
}

.glyphicon-grain:before {
  content: "";
}

.glyphicon-sunglasses:before {
  content: "";
}

.glyphicon-text-size:before {
  content: "";
}

.glyphicon-text-color:before {
  content: "";
}

.glyphicon-text-background:before {
  content: "";
}

.glyphicon-object-align-top:before {
  content: "";
}

.glyphicon-object-align-bottom:before {
  content: "";
}

.glyphicon-object-align-horizontal:before {
  content: "";
}

.glyphicon-object-align-left:before {
  content: "";
}

.glyphicon-object-align-vertical:before {
  content: "";
}

.glyphicon-object-align-right:before {
  content: "";
}

.glyphicon-triangle-right:before {
  content: "";
}

.glyphicon-triangle-left:before {
  content: "";
}

.glyphicon-triangle-bottom:before {
  content: "";
}

.glyphicon-triangle-top:before {
  content: "";
}

.glyphicon-console:before {
  content: "";
}

.glyphicon-superscript:before {
  content: "";
}

.glyphicon-subscript:before {
  content: "";
}

.glyphicon-menu-left:before {
  content: "";
}

.glyphicon-menu-right:before {
  content: "";
}

.glyphicon-menu-down:before {
  content: "";
}

.glyphicon-menu-up:before {
  content: "";
}

.nav > li > a {
  color: #6E6E6E;
  font-weight: 600;
  padding: 14px 20px 14px 20px;
  display: block;
}
.nav > li > a:hover, .nav > li > a:focus {
  text-decoration: none;
}

.nav.metismenu > li {
  display: block;
  width: 100%;
  position: relative;
}

.nav.metismenu .dropdown-menu > li > a {
  padding: 3px 20px;
  display: block;
}

.nav.navbar-right > li > a {
  color: #999c9e;
}

.nav > li.active > a {
  color: #ffffff;
}

.navbar-default .nav > li > a:hover, .navbar-default .nav > li > a:focus {
  color: #242424;
}

.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {
  background: #fff;
}

.nav.navbar-top-links > li > a:hover, .nav.navbar-top-links > li > a:focus {
  background-color: transparent;
}

.nav > li > a i {
  margin-right: 6px;
}

.navbar {
  border: 0;
}

.navbar-default {
  background-color: transparent;
  border-color: #2F4050;
}

.navbar-top-links li {
  display: inline-block;
  align-self: center;
}

.body-small .navbar-top-links li:last-child {
  margin-right: 0;
}

.navbar-top-links li a {
  padding: 20px 10px;
  min-height: 50px;
}

.dropdown-menu {
  border: medium none;
  border-radius: 3px;
  box-shadow: 0 0 3px rgba(86, 96, 117, 0.7);
  display: none;
  float: left;
  font-size: 12px;
  left: 0;
  list-style: none outside none;
  padding: 0;
  position: absolute;
  text-shadow: none;
  top: 100%;
  z-index: 1000;
}

.dropdown-menu > li > a {
  border-radius: 3px;
  color: inherit;
  line-height: 25px;
  margin: 4px;
  text-align: left;
  font-weight: normal;
  display: block;
  padding: 3px 20px;
}

.dropdown-menu > li > a:focus, .dropdown-menu > li > a:hover {
  color: #262626;
  text-decoration: none;
  background-color: #f5f5f5;
}

.dropdown-menu > .active > a,
.dropdown-menu > .active > a:focus,
.dropdown-menu > .active > a:hover {
  color: #fff;
  text-decoration: none;
  background-color: #1db5b6;
  outline: 0;
}

.dropdown-menu > li > a.font-bold {
  font-weight: 600;
}

.navbar-top-links .dropdown-menu li {
  display: block;
}

.navbar-top-links .dropdown-menu li:last-child {
  margin-right: 0;
}

.navbar-top-links .dropdown-menu li a {
  padding: 3px 20px;
  min-height: 0;
}

.navbar-top-links .dropdown-menu li a div {
  white-space: normal;
}

.navbar-top-links .dropdown-messages,
.navbar-top-links .dropdown-tasks,
.navbar-top-links .dropdown-alerts {
  width: 310px;
  min-width: 0;
}

.navbar-top-links .dropdown-messages {
  margin-left: 5px;
}

.navbar-top-links .dropdown-tasks {
  margin-left: -59px;
}

.navbar-top-links .dropdown-alerts {
  margin-left: -123px;
}

.navbar-top-links .dropdown-user {
  right: 0;
  left: auto;
}

.dropdown-messages, .dropdown-alerts {
  padding: 10px 10px 10px 10px;
}

.dropdown-messages li a, .dropdown-alerts li a {
  font-size: 12px;
}

.dropdown-messages li em, .dropdown-alerts li em {
  font-size: 10px;
}

.nav.navbar-top-links .dropdown-alerts a {
  font-size: 12px;
}

.nav-header {
  padding: 33px 25px;
  background-color: #2F4050;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.profile-element .dropdown-toggle::after {
  display: none;
}

.pace-done .nav-header {
  transition: all 0.4s;
}

ul.nav-second-level {
  background: #293846;
}

.nav > li.active {
  border-left: 4px solid #1cacad;
  background: #293846;
}

.nav.nav-second-level > li.active {
  border: none;
}

.nav.nav-second-level.collapse[style] {
  height: auto !important;
}

.nav-header a {
  color: #DFE4ED;
}

.nav-header .text-muted {
  color: #8095a8 !important;
}

.minimalize-styl-2 {
  padding: 4px 12px;
  margin: 14px 5px 5px 20px;
  font-size: 14px;
  float: left;
}

.navbar-form-custom {
  float: left;
  height: 50px;
  padding: 0;
  width: 200px;
  display: block;
}

.navbar-form-custom .form-group {
  margin-bottom: 0;
}

.nav.navbar-top-links a {
  font-size: 14px;
}

.navbar-form-custom .form-control {
  background: none repeat scroll 0 0 rgba(0, 0, 0, 0);
  border: medium none;
  font-size: 14px;
  height: 60px;
  margin: 0;
  z-index: 2000;
}

.nav.navbar-top-links .dropdown-toggle::after {
  display: none;
}

.navbar.navbar-static-top {
  padding: 0;
  width: 100%;
  align-items: inherit;
}

.navbar-static-top .dropdown-menu {
  right: 0;
  left: auto;
}

.count-info .label {
  line-height: 12px;
  padding: 2px 5px;
  position: absolute;
  right: 6px;
  top: 12px;
}

.arrow {
  float: right;
}

.fa.arrow:before {
  content: "";
}

.active > a > .fa.arrow:before {
  content: "";
}

.nav-second-level li,
.nav-third-level li {
  border-bottom: none !important;
}

.nav.nav-third-level > li.active {
  border: none;
}

.nav-second-level li a {
  padding: 7px 10px 7px 10px;
  padding-left: 52px;
}

.fixed-sidebar.mini-navbar .nav-second-level.collapsing li a, .nav-second-level.collapsing li a {
  min-width: 220px;
}

.body-small .nav-second-level.collapsing li a, .mini-navbar .nav-second-level.collapsing li a {
  min-width: 140px;
}

.nav-third-level li a, .fixed-sidebar.mini-navbar .nav-second-level li .nav-third-level li a {
  padding-left: 62px;
}

.nav-second-level li:last-child {
  padding-bottom: 10px;
}

body:not(.fixed-sidebar):not(.canvas-menu).mini-navbar .nav li:hover > .nav-second-level,
.mini-navbar .nav li:focus > .nav-second-level {
  display: block;
  border-radius: 0 2px 2px 0;
  min-width: 160px;
  height: auto;
}

body.mini-navbar .navbar-default .nav > li > .nav-second-level li a {
  font-size: 12px;
  border-radius: 3px;
}

.fixed-nav .slimScrollDiv #side-menu {
  padding-bottom: 60px;
}

.mini-navbar .nav-second-level li a {
  padding: 10px 10px 10px 15px;
}

.mini-navbar .nav .nav-second-level {
  position: absolute;
  left: 70px;
  top: 0;
  background-color: #2F4050;
  padding: 10px 10px 10px 10px;
  font-size: 12px;
}

.canvas-menu.mini-navbar .nav-second-level {
  background: #293846;
}

.mini-navbar li.active .nav-second-level {
  left: 65px;
}

.navbar-default .special_link a {
  background: #1db5b6;
  color: white;
}

.navbar-default .special_link a:hover {
  background: #17987e !important;
  color: white;
}

.navbar-default .special_link a span.label {
  background: #fff;
  color: #1db5b6;
}

.navbar-default .landing_link a {
  background: #1fc2c3;
  color: white;
}

.navbar-default .landing_link a:hover {
  background: #1db5b6 !important;
  color: white;
}

.navbar-default .landing_link a span.label {
  background: #fff;
  color: #1fc2c3;
}

.logo-element {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: white;
  display: none;
  padding: 18px 0;
}

.navbar-static-side {
  transition: width 0s;
}

.footer {
  transition: margin 0s;
}

.pace-done .navbar-static-side, .pace-done .nav-header, .pace-done li.active, .pace-done #page-wrapper, .pace-done .footer {
  transition: all 0.4s;
}

.navbar-fixed-top {
  background: #fff;
  transition-duration: 0.4s;
  border-bottom: 1px solid #e7eaec !important;
  z-index: 2030;
  position: fixed;
  right: 0;
  left: 0;
  padding: 0;
  top: 0;
}

.navbar-fixed-top .navbar-form-custom .form-control {
  height: 50px;
}

.navbar-fixed-top, .navbar-static-top {
  background: #f3f3f4;
}

.fixed-nav #wrapper {
  margin-top: 0;
}

.nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {
  -moz-border-bottom-colors: none;
  -moz-border-left-colors: none;
  -moz-border-right-colors: none;
  -moz-border-top-colors: none;
  background: none;
  border-color: #DDDDDD #DDDDDD rgba(0, 0, 0, 0);
  border-bottom: #f3f3f4;
  border-image: none;
  border-style: solid;
  border-width: 1px;
  color: #555555;
  cursor: default;
}

.nav.nav-tabs li {
  background: none;
  border: none;
}

body.fixed-nav #wrapper .navbar-static-side,
body.fixed-nav #wrapper #page-wrapper {
  margin-top: 60px;
}

body.top-navigation.fixed-nav #wrapper #page-wrapper {
  margin-top: 0;
}

body.fixed-nav.fixed-nav-basic .navbar-fixed-top {
  left: 220px;
}

body.fixed-nav.fixed-nav-basic.mini-navbar .navbar-fixed-top {
  left: 70px;
}

body.fixed-nav.fixed-nav-basic.fixed-sidebar.mini-navbar .navbar-fixed-top {
  left: 0;
}

body.fixed-nav.fixed-nav-basic #wrapper .navbar-static-side {
  margin-top: 0;
}

body.fixed-nav.fixed-nav-basic.body-small .navbar-fixed-top {
  left: 0;
}

body.fixed-nav.fixed-nav-basic.fixed-sidebar.mini-navbar.body-small .navbar-fixed-top {
  left: 220px;
}

.fixed-nav .minimalize-styl-2 {
  margin: 10px 5px 5px 15px;
}

.body-small .navbar-fixed-top {
  margin-left: 0;
}

body.mini-navbar .navbar-static-side {
  width: 70px;
}

body.mini-navbar .profile-element, body.mini-navbar .nav-label, body.mini-navbar .navbar-default .nav li a span {
  display: none;
}

body.canvas-menu .profile-element {
  display: block;
}

body:not(.fixed-sidebar):not(.canvas-menu).mini-navbar .nav-second-level {
  display: none;
}

body.mini-navbar .navbar-default .nav > li > a {
  font-size: 16px;
}

body.mini-navbar .logo-element {
  display: block;
}

body.canvas-menu .logo-element {
  display: none;
}

body.mini-navbar .nav-header {
  padding: 0;
  background-color: #1db5b6;
}

body.canvas-menu .nav-header {
  padding: 33px 25px;
}

body.canvas-menu .sidebar-collapse li {
  width: 100%;
}

body.mini-navbar #page-wrapper {
  width: calc(100% - 70px);
}

body.canvas-menu.mini-navbar #page-wrapper,
body.canvas-menu.mini-navbar .footer {
  margin: 0;
  width: 100%;
}

body.fixed-sidebar .navbar-static-side,
body.canvas-menu .navbar-static-side {
  width: 220px;
  z-index: 2001;
  height: 100vh;
  position: fixed;
}

body.fixed-sidebar.mini-navbar .navbar-static-side {
  width: 0;
}

body.fixed-sidebar #page-wrapper {
  margin: 0 0 0 220px;
}

body.fixed-sidebar.body-small #page-wrapper {
  margin: 0;
}

body.fixed-sidebar.mini-navbar #page-wrapper {
  margin: 0 0 0 0;
  width: 100%;
}

body.body-small.fixed-sidebar.mini-navbar #page-wrapper {
  margin: 0 0 0 220px;
}

body.body-small.fixed-sidebar.mini-navbar .navbar-static-side {
  width: 220px;
}

.fixed-sidebar.mini-navbar .nav li:focus > .nav-second-level,
.canvas-menu.mini-navbar .nav li:focus > .nav-second-level {
  display: block;
  height: auto;
}

body.fixed-sidebar.mini-navbar .navbar-default .nav > li > .nav-second-level li a {
  font-size: 12px;
  border-radius: 3px;
}

body.canvas-menu.mini-navbar .navbar-default .nav > li > .nav-second-level li a {
  font-size: 13px;
  border-radius: 3px;
}

.fixed-sidebar.mini-navbar .nav-second-level li a,
.canvas-menu.mini-navbar .nav-second-level li a {
  padding: 10px 10px 10px 15px;
}

.fixed-sidebar.mini-navbar .nav-second-level,
.canvas-menu.mini-navbar .nav-second-level {
  position: relative;
  padding: 0;
  font-size: 13px;
}

.fixed-sidebar.mini-navbar li.active .nav-second-level,
.canvas-menu.mini-navbar li.active .nav-second-level {
  left: 0;
}

body.fixed-sidebar.mini-navbar .navbar-default .nav > li > a,
body.canvas-menu.mini-navbar .navbar-default .nav > li > a {
  font-size: 13px;
}

body.fixed-sidebar.mini-navbar .nav-label,
body.fixed-sidebar.mini-navbar .navbar-default .nav li a span,
body.canvas-menu.mini-navbar .nav-label,
body.canvas-menu.mini-navbar .navbar-default .nav li a span {
  display: inline;
}

body.canvas-menu.mini-navbar .navbar-default .nav li .profile-element a span {
  display: block;
}

.canvas-menu.mini-navbar .nav-second-level li a,
.fixed-sidebar.mini-navbar .nav-second-level li a {
  padding: 7px 10px 7px 52px;
}

.fixed-sidebar.mini-navbar .nav-second-level,
.canvas-menu.mini-navbar .nav-second-level {
  left: 0;
}

body.canvas-menu nav.navbar-static-side {
  z-index: 2001;
  background: #2F4050;
  height: 100%;
  position: fixed;
  display: none;
}

body.canvas-menu.mini-navbar nav.navbar-static-side {
  display: block;
  width: 220px;
}

.top-navigation #page-wrapper {
  width: 100%;
}

.top-navigation .navbar-nav .dropdown-menu > .active > a {
  background: white;
  color: #1db5b6;
  font-weight: bold;
}

.white-bg .navbar-fixed-top, .white-bg .navbar-static-top {
  background: #fff;
}

.top-navigation .navbar {
  margin-bottom: 0;
}

.top-navigation .nav > li > a {
  padding: 15px 20px;
  color: #676a6c;
}

.top-navigation .nav > li a:hover, .top-navigation .nav > li a:focus {
  background: #fff;
  color: #1db5b6;
}

.top-navigation .navbar .nav > li.active {
  background: #fff;
  border: none;
}

.top-navigation .nav > li.active > a {
  color: #1db5b6;
}

.top-navigation .navbar-right {
  margin-right: 10px;
}

.top-navigation .navbar-nav .dropdown-menu {
  box-shadow: none;
  border: 1px solid #e7eaec;
}

.top-navigation .dropdown-menu > li > a {
  margin: 0;
  padding: 7px 20px;
}

.navbar .dropdown-menu {
  margin-top: 0;
}

.top-navigation .navbar-brand {
  background: #1db5b6;
  color: #fff;
  padding: 15px 25px;
  font-size: 18px;
  line-height: 20px;
}

.top-navigation .navbar-top-links li:last-child {
  margin-right: 0;
}

.top-navigation.mini-navbar #page-wrapper,
.top-navigation.body-small.fixed-sidebar.mini-navbar #page-wrapper,
.mini-navbar .top-navigation #page-wrapper,
.body-small.fixed-sidebar.mini-navbar .top-navigation #page-wrapper,
.canvas-menu #page-wrapper {
  margin: 0;
  width: 100%;
}

.top-navigation.fixed-nav #wrapper, .fixed-nav #wrapper.top-navigation {
  margin-top: 50px;
}

.top-navigation .footer.fixed {
  margin-left: 0 !important;
}

.top-navigation .wrapper.wrapper-content {
  padding: 40px;
}

.top-navigation.body-small .wrapper.wrapper-content, .body-small .top-navigation .wrapper.wrapper-content {
  padding: 40px 0 40px 0;
}

.navbar-toggler {
  background-color: #1db5b6;
  color: #fff;
  padding: 6px 12px;
  font-size: 14px;
  margin: 8px;
}

.top-navigation .navbar-nav .open .dropdown-menu > li > a, .top-navigation .navbar-nav .open .dropdown-menu .dropdown-header {
  padding: 10px 15px 10px 20px;
}

@media (max-width: 768px) {
  .top-navigation .navbar-header {
    display: block;
    float: none;
  }
}
.menu-visible-lg, .menu-visible-md {
  display: none !important;
}

@media (min-width: 1200px) {
  .menu-visible-lg {
    display: block !important;
  }
}
@media (min-width: 992px) {
  .menu-visible-md {
    display: block !important;
  }
}
@media (max-width: 767px) {
  .menu-visible-md {
    display: block !important;
  }

  .menu-visible-lg {
    display: block !important;
  }
}
button:focus {
  outline: 0 !important;
}

.btn {
  font-size: 15px !important;
  font-weight: 700 !important;
  border-radius: 12px !important;
  transition: 0.4ms;
  font-family: "Inter", sans-serif;
  line-height: 14px !important;
  padding: 12px !important;
}

.btn:hover {
  transform: scale(0.97);
}

.btn-icon-wrapper {
  display: inline-block;
  margin: 0 5px;
}

.btn:focus {
  box-shadow: none;
}

.btn-xs {
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
}

.btn-group-sm > .btn, .btn-sm {
  font-size: 0.8rem;
}

.float-e-margins .btn {
  margin-bottom: 5px;
}

.btn-w-m {
  min-width: 120px;
}

.btn-primary.btn-outline {
  color: #1db5b6;
}

.btn-success.btn-outline {
  color: #1c84c6;
}

.btn-info.btn-outline {
  color: #23c6c8;
}

.btn-warning.btn-outline {
  color: #f8ac59;
}

.btn-danger.btn-outline {
  color: #ED5565;
}

.btn-primary.btn-outline:hover,
.btn-success.btn-outline:hover,
.btn-info.btn-outline:hover,
.btn-warning.btn-outline:hover,
.btn-danger.btn-outline:hover {
  color: #fff;
}

.btn.active, .btn:active {
  background-image: none;
  outline: 0;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-primary {
  background-color: #1db5b6;
  border-color: #1db5b6;
}

.btn-primary:hover, .btn-primary:focus, .btn-primary.focus {
  background-color: #1ba8a9;
  border-color: #1ba8a9;
  color: #000;
}

.btn-primary.disabled, .btn-primary:disabled {
  color: #000;
  background-color: #1ba8a9;
  border-color: #1ba8a9;
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #1ba8a9;
  border-color: #1ba8a9;
}

.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-success {
  color: #fff;
  background-color: #1c84c6;
  border-color: #1c84c6;
}

.btn-success:hover, .btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #1a7bb9;
  border-color: #1a7bb9;
}

.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #1a7bb9;
  border-color: #1a7bb9;
}

.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #1a7bb9;
  border-color: #1a7bb9;
}

.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-info {
  color: #fff;
  background-color: #23c6c8;
  border-color: #23c6c8;
}

.btn-info:hover, .btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: #21b9bb;
  border-color: #21b9bb;
}

.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #21b9bb;
  border-color: #21b9bb;
}

.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #21b9bb;
  border-color: #21b9bb;
}

.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-default {
  color: inherit;
  background: white;
  border: 1px solid #e7eaec;
}

.btn-default:hover, .btn-default:focus, .btn-default:active, .btn-default.active, .open .dropdown-toggle.btn-default, .btn-default:active:focus, .btn-default:active:hover, .btn-default.active:hover, .btn-default.active:focus {
  color: inherit;
  border: 1px solid #d2d2d2;
}

.btn-default:active, .btn-default.active, .open .dropdown-toggle.btn-default {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15) inset;
}

.btn-default.disabled, .btn-default.disabled:hover, .btn-default.disabled:focus, .btn-default.disabled:active, .btn-default.disabled.active, .btn-default[disabled], .btn-default[disabled]:hover, .btn-default[disabled]:focus, .btn-default[disabled]:active, .btn-default.active[disabled], fieldset[disabled] .btn-default, fieldset[disabled] .btn-default:hover, fieldset[disabled] .btn-default:focus, fieldset[disabled] .btn-default:active, fieldset[disabled] .btn-default.active {
  color: #cacaca;
}

.btn-warning {
  color: #ffffff;
  background-color: #f8ac59;
  border-color: #f8ac59;
}

.btn-warning:hover, .btn-warning:focus, .btn-warning.focus {
  color: #ffffff;
  background-color: #f7a54a;
  border-color: #f7a54a;
}

.btn-warning.disabled, .btn-warning:disabled {
  color: #ffffff;
  background-color: #f7a54a;
  border-color: #f7a54a;
}

.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,
.show > .btn-warning.dropdown-toggle {
  color: #ffffff;
  background-color: #f7a54a;
  border-color: #f7a54a;
}

.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-danger {
  color: #fff;
  background-color: #ED5565;
  border-color: #ED5565;
}

.btn-danger:hover, .btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: #ec4758;
  border-color: #ec4758;
}

.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #ec4758;
  border-color: #ec4758;
}

.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #ec4758;
  border-color: #ec4758;
}

.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-link {
  color: inherit;
}

.btn-link:hover, .btn-link:focus, .btn-link:active, .btn-link.active, .open .dropdown-toggle.btn-link {
  color: #1db5b6;
  text-decoration: none;
}

.btn-link:active, .btn-link.active, .open .dropdown-toggle.btn-link {
  background-image: none;
  box-shadow: none;
}

.btn-link.disabled, .btn-link.disabled:hover, .btn-link.disabled:focus, .btn-link.disabled:active, .btn-link.disabled.active, .btn-link[disabled], .btn-link[disabled]:hover, .btn-link[disabled]:focus, .btn-link[disabled]:active, .btn-link.active[disabled], fieldset[disabled] .btn-link, fieldset[disabled] .btn-link:hover, fieldset[disabled] .btn-link:focus, fieldset[disabled] .btn-link:active, fieldset[disabled] .btn-link.active {
  color: #cacaca;
}

.btn-white {
  color: inherit;
  background: white;
  border: 1px solid #e7eaec;
}

.btn-white:hover, .btn-white:focus, .btn-white:active, .btn-white.active, .open .dropdown-toggle.btn-white, .btn-white:active:focus, .btn-white:active:hover, .btn-white.active:hover, .btn-white.active:focus {
  color: inherit;
  border: 1px solid #d2d2d2;
}

.btn-white:active, .btn-white.active {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15) inset;
}

.btn-white:active, .btn-white.active, .open .dropdown-toggle.btn-white {
  background-image: none;
}

.btn-white.disabled, .btn-white.disabled:hover, .btn-white.disabled:focus, .btn-white.disabled:active, .btn-white.disabled.active, .btn-white[disabled], .btn-white[disabled]:hover, .btn-white[disabled]:focus, .btn-white[disabled]:active, .btn-white.active[disabled], fieldset[disabled] .btn-white, fieldset[disabled] .btn-white:hover, fieldset[disabled] .btn-white:focus, fieldset[disabled] .btn-white:active, fieldset[disabled] .btn-white.active {
  color: #cacaca;
}

.form-control, .form-control:focus, .has-error .form-control:focus, .has-success .form-control:focus, .has-warning .form-control:focus, .navbar-collapse, .navbar-form, .navbar-form-custom .form-control:focus, .navbar-form-custom .form-control:hover, .open .btn.dropdown-toggle, .panel, .popover, .progress, .progress-bar {
  box-shadow: none;
}

.btn-outline {
  color: inherit;
  background-color: transparent;
  transition: all 0.5s;
}

.btn-rounded {
  border-radius: 50px;
}

.btn-large-dim {
  width: 90px;
  height: 90px;
  font-size: 42px;
}

button.dim {
  display: inline-block;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  padding-top: 6px;
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  border-radius: 5px;
  font-weight: 600;
  margin-bottom: 20px !important;
}

button.dim:active {
  top: 3px;
}

button.btn-primary.dim {
  box-shadow: inset 0 0 0 #199b9c, 0 5px 0 0 #199b9c, 0 10px 5px #999 !important;
}

button.btn-primary.dim:active {
  box-shadow: inset 0 0 0 #199b9c, 0 2px 0 0 #199b9c, 0 5px 3px #999 !important;
}

button.btn-default.dim {
  box-shadow: inset 0 0 0 #b3b3b3, 0 5px 0 0 #b3b3b3, 0 10px 5px #999 !important;
}

button.btn-default.dim:active {
  box-shadow: inset 0 0 0 #b3b3b3, 0 2px 0 0 #b3b3b3, 0 5px 3px #999 !important;
}

button.btn-warning.dim {
  box-shadow: inset 0 0 0 #f79d3c, 0 5px 0 0 #f79d3c, 0 10px 5px #999 !important;
}

button.btn-warning.dim:active {
  box-shadow: inset 0 0 0 #f79d3c, 0 2px 0 0 #f79d3c, 0 5px 3px #999 !important;
}

button.btn-info.dim {
  box-shadow: inset 0 0 0 #1eacae, 0 5px 0 0 #1eacae, 0 10px 5px #999 !important;
}

button.btn-info.dim:active {
  box-shadow: inset 0 0 0 #1eacae, 0 2px 0 0 #1eacae, 0 5px 3px #999 !important;
}

button.btn-success.dim {
  box-shadow: inset 0 0 0 #1872ab, 0 5px 0 0 #1872ab, 0 10px 5px #999 !important;
}

button.btn-success.dim:active {
  box-shadow: inset 0 0 0 #1872ab, 0 2px 0 0 #1872ab, 0 5px 3px #999 !important;
}

button.btn-danger.dim {
  box-shadow: inset 0 0 0 #ea394c, 0 5px 0 0 #ea394c, 0 10px 5px #999 !important;
}

button.btn-danger.dim:active {
  box-shadow: inset 0 0 0 #ea394c, 0 2px 0 0 #ea394c, 0 5px 3px #999 !important;
}

button.dim:before {
  font-size: 50px;
  line-height: 1em;
  font-weight: normal;
  color: #fff;
  display: block;
  padding-top: 10px;
}

button.dim:active:before {
  top: 7px;
  font-size: 50px;
}

.btn:focus {
  outline: none !important;
}

.label {
  background-color: #D1DADE;
  color: #5E5E5E;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  padding: 3px 8px;
  text-shadow: none;
  border-radius: 0.25em;
  line-height: 1;
  white-space: nowrap;
}

.nav .label, .ibox .label {
  font-size: 10px;
}

.badge {
  background-color: #D1DADE;
  color: #5E5E5E;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11px;
  font-weight: 600;
  padding-bottom: 4px;
  padding-left: 6px;
  padding-right: 6px;
  text-shadow: none;
  white-space: nowrap;
}

.label-primary, .badge-primary {
  background-color: #1db5b6;
  color: #FFFFFF;
}

.label-success, .badge-success {
  background-color: #1c84c6;
  color: #FFFFFF;
}

.label-warning, .badge-warning {
  background-color: #f8ac59;
  color: #FFFFFF;
}

.label-warning-light, .badge-warning-light {
  background-color: #f8ac59;
  color: #ffffff;
}

.label-danger, .badge-danger {
  background-color: #ED5565;
  color: #FFFFFF;
}

.label-info, .badge-info {
  background-color: #23c6c8;
  color: #FFFFFF;
}

.label-inverse, .badge-inverse {
  background-color: #262626;
  color: #FFFFFF;
}

.label-white, .badge-white {
  background-color: #FFFFFF;
  color: #5E5E5E;
}

.label-white, .badge-disable {
  background-color: #2A2E36;
  color: #8B91A0;
}

/* TOOGLE SWICH */
.onoffswitch {
  position: relative;
  width: 64px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #1db5b6;
  border-radius: 2px;
}

.onoffswitch-inner {
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch-inner:before, .onoffswitch-inner:after {
  float: left;
  width: 50%;
  height: 20px;
  padding: 0;
  line-height: 20px;
  font-size: 12px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  box-sizing: border-box;
}

.onoffswitch-inner:before {
  content: "ON";
  padding-left: 10px;
  background-color: #1db5b6;
  color: #FFFFFF;
}

.onoffswitch-inner:after {
  content: "OFF";
  padding-right: 10px;
  background-color: #FFFFFF;
  color: #999999;
  text-align: right;
}

.onoffswitch-switch {
  width: 20px;
  margin: 0;
  background: #FFFFFF;
  border: 2px solid #1db5b6;
  border-radius: 2px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 44px;
  transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0;
}

.onoffswitch-checkbox:disabled + .onoffswitch-label .onoffswitch-inner:before {
  background-color: #919191;
}

.onoffswitch-checkbox:disabled + .onoffswitch-label,
.onoffswitch-checkbox:disabled + .onoffswitch-label .onoffswitch-switch {
  border-color: #919191;
}

/* CHOSEN PLUGIN */
.chosen-container-single .chosen-single {
  background: #ffffff;
  box-shadow: none;
  -moz-box-sizing: border-box;
  border-radius: 2px;
  cursor: text;
  height: auto !important;
  margin: 0;
  min-height: 30px;
  overflow: hidden;
  padding: 4px 12px;
  position: relative;
  width: 100%;
}

.chosen-container-multi .chosen-choices li.search-choice {
  background: #f1f1f1;
  border: 1px solid #e5e6e7;
  border-radius: 2px;
  box-shadow: none;
  color: #333333;
  cursor: default;
  line-height: 13px;
  margin: 3px 0 3px 5px;
  padding: 3px 20px 3px 5px;
  position: relative;
}

/* Tags Input Plugin */
.bootstrap-tagsinput {
  border: 1px solid #e5e6e7;
  box-shadow: none;
}

/* PAGINATIN */
.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus {
  border-color: #DDDDDD;
  cursor: default;
  z-index: 2;
}

.pagination > li > a, .pagination > li > span {
  background-color: #FFFFFF;
  border: 1px solid #DDDDDD;
  color: inherit;
  float: left;
  line-height: 1.42857;
  margin-left: -1px;
  padding: 4px 10px;
  position: relative;
  text-decoration: none;
}

.page-item.active .page-link {
  background-color: #1db5b6;
  border-color: #1db5b6;
}

.page-link:focus {
  box-shadow: none;
}

.page-link:hover {
  color: #676a6c;
}

.pagination .footable-page.active a {
  background-color: #1db5b6;
  border-color: #1db5b6;
  color: white;
}

/* TOOLTIPS */
.tooltip-inner {
  background-color: #2F4050;
}

.tooltip.top .tooltip-arrow {
  border-top-color: #2F4050;
}

.tooltip.right .tooltip-arrow {
  border-right-color: #2F4050;
}

.tooltip.bottom .tooltip-arrow {
  border-bottom-color: #2F4050;
}

.tooltip.left .tooltip-arrow {
  border-left-color: #2F4050;
}

/* EASY PIE CHART*/
.easypiechart {
  position: relative;
  text-align: center;
}

.easypiechart .h2 {
  margin-left: 10px;
  margin-top: 10px;
  display: inline-block;
}

.easypiechart canvas {
  top: 0;
  left: 0;
}

.easypiechart .easypie-text {
  line-height: 1;
  position: absolute;
  top: 33px;
  width: 100%;
  z-index: 1;
}

.easypiechart img {
  margin-top: -4px;
}

.jqstooltip {
  box-sizing: content-box;
}

/* FULLCALENDAR */
.fc-state-default {
  background-color: #ffffff;
  background-image: none;
  background-repeat: repeat-x;
  box-shadow: none;
  color: #333333;
  text-shadow: none;
}

.fc-state-default {
  border: 1px solid;
}

.fc-button {
  color: inherit;
  border: 1px solid #e7eaec;
  cursor: pointer;
  display: inline-block;
  height: 1.9em;
  line-height: 1.9em;
  overflow: hidden;
  padding: 0 0.6em;
  position: relative;
  white-space: nowrap;
}

.fc-state-active {
  background-color: #1db5b6;
  border-color: #1db5b6;
  color: #ffffff;
}

.fc-header-title h2 {
  font-size: 16px;
  font-weight: 600;
  color: inherit;
}

.fc-content .fc-widget-header, .fc-content .fc-widget-content {
  border-color: #e7eaec;
  font-weight: normal;
}

.fc-border-separate tbody {
  background-color: #F8F8F8;
}

.fc-state-highlight {
  background: none repeat scroll 0 0 #FCF8E3;
}

.external-event {
  padding: 5px 10px;
  border-radius: 2px;
  cursor: pointer;
  margin-bottom: 5px;
}

.fc-ltr .fc-event-hori.fc-event-end, .fc-rtl .fc-event-hori.fc-event-start {
  border-radius: 2px;
}

.fc-event,
.fc-agenda .fc-event-time,
.fc-event a {
  padding: 4px 6px;
  background-color: #1db5b6;
  /* background color */
  border-color: #1db5b6;
  /* border color */
}

.fc-event-time, .fc-event-title {
  color: #717171;
  padding: 0 1px;
}

.ui-calendar .fc-event-time, .ui-calendar .fc-event-title {
  color: #fff;
}

.fc-event-container a.fc-event {
  color: #fff;
}

/* Chat */
.chat-activity-list .chat-element {
  border-bottom: 1px solid #e7eaec;
}

.chat-element:first-child {
  margin-top: 0;
}

.chat-element {
  padding-bottom: 15px;
}

.chat-element, .chat-element .media {
  margin-top: 15px;
}

.chat-element, .media-body {
  overflow: hidden;
}

.chat-element .media-body {
  display: block;
  width: auto;
}

.chat-element > .float-left {
  margin-right: 10px;
}

.chat-element img.rounded-circle, .dropdown-messages-box img.rounded-circle {
  width: 38px;
  height: 38px;
}

.chat-element .well {
  border: 1px solid #e7eaec;
  box-shadow: none;
  margin-top: 10px;
  margin-bottom: 5px;
  padding: 10px 20px;
  font-size: 11px;
  line-height: 16px;
}

.chat-element .actions {
  margin-top: 10px;
}

.chat-element .photos {
  margin: 10px 0;
}

.right.chat-element > .float-right {
  margin-left: 10px;
}

.chat-photo {
  max-height: 180px;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 10px;
  margin-bottom: 10px;
}

.chat {
  margin: 0;
  padding: 0;
  list-style: none;
}

.chat li {
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px dotted #B3A9A9;
}

.chat li.left .chat-body {
  margin-left: 60px;
}

.chat li.right .chat-body {
  margin-right: 60px;
}

.chat li .chat-body p {
  margin: 0;
  color: #777777;
}

.panel .slidedown .glyphicon,
.chat .glyphicon {
  margin-right: 5px;
}

.chat-panel .panel-body {
  height: 350px;
  overflow-y: scroll;
}

/* LIST GROUP */
a.list-group-item.active, a.list-group-item.active:hover, a.list-group-item.active:focus {
  background-color: #1db5b6;
  border-color: #1db5b6;
  color: #FFFFFF;
  z-index: 2;
}

.list-group-item-heading {
  margin-top: 10px;
}

.list-group-item-text {
  margin: 0 0 10px;
  color: inherit;
  font-size: 12px;
  line-height: inherit;
}

.no-padding .list-group-item {
  border-left: none;
  border-right: none;
  border-bottom: none;
}

.no-padding .list-group-item:first-child {
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-top: none;
}

.no-padding .list-group {
  margin-bottom: 0;
}

.list-group-item {
  background-color: inherit;
  border: 1px solid #e7eaec;
  display: block;
  margin-bottom: -1px;
  padding: 10px 15px;
  position: relative;
}

.elements-list .list-group-item {
  border-left: none;
  border-right: none;
  padding: 0;
}

.elements-list .list-group-item:first-child {
  border-left: none;
  border-right: none;
  border-top: none !important;
}

.elements-list .list-group {
  margin-bottom: 0;
}

.elements-list a {
  color: inherit;
}

.elements-list .list-group-item a.active,
.elements-list .list-group-item a:hover {
  background: #f3f3f4;
  color: inherit;
  border-color: #e7eaec;
  border-radius: 0;
}

.elements-list li.active {
  transition: none;
}

.elements-list .nav-link {
  padding: 15px 25px;
}

.element-detail-box {
  padding: 25px;
}

/* FLOT CHART  */
.flot-chart {
  display: block;
  height: 200px;
}

.widget .flot-chart.dashboard-chart {
  display: block;
  height: 120px;
  margin-top: 40px;
}

.flot-chart.dashboard-chart {
  display: block;
  height: 180px;
  margin-top: 40px;
}

.flot-chart-content {
  width: 100%;
  height: 100%;
}

.flot-chart-pie-content {
  width: 200px;
  height: 200px;
  margin: auto;
}

.jqstooltip {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  visibility: hidden;
  background: #2b303a;
  background-color: rgba(43, 48, 58, 0.8);
  color: white;
  text-align: left;
  white-space: nowrap;
  z-index: 10000;
  padding: 5px 5px 5px 5px;
  min-height: 22px;
  border-radius: 3px;
}

.jqsfield {
  color: white;
  text-align: left;
}

.fh-150 {
  height: 150px;
}

.fh-200 {
  height: 200px;
}

.h-150 {
  min-height: 150px;
}

.h-200 {
  min-height: 200px;
}

.h-300 {
  min-height: 300px;
}

.w-150 {
  min-width: 150px;
}

.w-200 {
  min-width: 200px;
}

.w-300 {
  min-width: 300px;
}

.legendLabel {
  padding-left: 5px;
}

.stat-list li:first-child {
  margin-top: 0;
}

.stat-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.stat-percent {
  float: right;
}

.stat-list li {
  margin-top: 15px;
  position: relative;
}

/* DATATABLES */
table.dataTable thead .sorting,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  background: transparent;
}

.dataTables_wrapper {
  padding-bottom: 30px;
}

.dataTables_length {
  float: left;
}

.dataTables_filter label {
  margin-right: 5px;
}

.html5buttons {
  float: right;
}

.html5buttons a {
  border: 1px solid #e7eaec;
  background: #fff;
  color: #676a6c;
  box-shadow: none;
  padding: 6px 8px;
  font-size: 12px;
}
.html5buttons a:hover, .html5buttons a:focus:active {
  background-color: #eee;
  color: inherit;
  border-color: #d2d2d2;
}

div.dt-button-info {
  z-index: 100;
}

@media (max-width: 768px) {
  .html5buttons {
    float: none;
    margin-top: 10px;
  }

  .dataTables_length {
    float: none;
  }
}
/* CIRCLE */
.img-circle {
  border-radius: 50%;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.428571429;
}

.btn-circle.btn-lg {
  width: 50px;
  height: 50px;
  padding: 10px 16px;
  border-radius: 25px;
  font-size: 18px;
  line-height: 1.33;
}

.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.show-grid [class^=col-] {
  padding-top: 10px;
  padding-bottom: 10px;
  border: 1px solid #ddd;
  background-color: #eee !important;
}

.show-grid {
  margin: 15px 0;
}

/* ANIMATION */
.css-animation-box h1 {
  font-size: 44px;
}

.animation-efect-links a {
  padding: 4px 6px;
  font-size: 12px;
}

#animation_box {
  background-color: #f9f8f8;
  border-radius: 16px;
  width: 80%;
  margin: 0 auto;
  padding-top: 80px;
}

.animation-text-box {
  position: absolute;
  margin-top: 40px;
  left: 50%;
  margin-left: -100px;
  width: 200px;
}

.animation-text-info {
  position: absolute;
  margin-top: -60px;
  left: 50%;
  margin-left: -100px;
  width: 200px;
  font-size: 10px;
}

.animation-text-box h2 {
  font-size: 54px;
  font-weight: 600;
  margin-bottom: 5px;
}

.animation-text-box p {
  font-size: 12px;
  text-transform: uppercase;
}

/* PEACE */
.pace {
  -webkit-pointer-events: none;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}

.pace-inactive {
  display: none;
}

.pace .pace-progress {
  background: #1db5b6;
  position: fixed;
  z-index: 2040;
  top: 0;
  right: 100%;
  width: 100%;
  height: 2px;
}

.pace-inactive {
  display: none;
}

/* WIDGETS */
.widget {
  border-radius: 5px;
  padding: 15px 20px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.widget.style1 h2 {
  font-size: 30px;
}

.widget h2, .widget h3 {
  margin-top: 5px;
  margin-bottom: 0;
}

.widget-text-box {
  padding: 20px;
  border: 1px solid #e7eaec;
  background: #ffffff;
}

.widget-head-color-box {
  border-radius: 5px 5px 0 0;
  margin-top: 10px;
}

.widget .flot-chart {
  height: 100px;
}

.vertical-align div {
  display: inline-block;
  vertical-align: middle;
}

.vertical-align h2, .vertical-align h3 {
  margin: 0;
}

.todo-list {
  list-style: none outside none;
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.todo-list.small-list {
  font-size: 12px;
}

.todo-list.small-list > li {
  background: #f3f3f4;
  border-left: none;
  border-right: none;
  border-radius: 4px;
  color: inherit;
  margin-bottom: 2px;
  padding: 6px 6px 6px 12px;
}

.todo-list.small-list .btn-xs, .todo-list.small-list .btn-group-xs > .btn {
  border-radius: 5px;
  font-size: 10px;
  line-height: 1.5;
  padding: 1px 2px 1px 5px;
}

.todo-list > li {
  background: #f3f3f4;
  border-left: 6px solid #e7eaec;
  border-right: 6px solid #e7eaec;
  border-radius: 4px;
  color: inherit;
  margin-bottom: 2px;
  padding: 10px;
}

.todo-list .handle {
  cursor: move;
  display: inline-block;
  font-size: 16px;
  margin: 0 5px;
}

.todo-list > li .label {
  font-size: 9px;
  margin-left: 10px;
}

.check-link {
  font-size: 16px;
}

.todo-completed {
  text-decoration: line-through;
}

.geo-statistic h1 {
  font-size: 36px;
  margin-bottom: 0;
}

.glyphicon.fa {
  font-family: "FontAwesome";
}

/* INPUTS */
.inline {
  display: inline-block !important;
}

.input-s-sm {
  width: 120px;
}

.input-s {
  width: 200px;
}

.form-control {
  font-size: 0.9rem;
}

select.form-control:not([size]):not([multiple]) {
  height: 2.05rem;
}

.input-sm, .form-control-sm {
  height: 31px;
}

.input-s-lg {
  width: 250px;
}

.i-checks {
  padding-left: 0;
}

.form-control, .single-line {
  background-color: #FFFFFF !important;
  background-image: none !important;
  border: 1px solid #e5e6e7 !important;
  border-radius: 1px !important;
  color: inherit;
  display: block;
  padding: 6px 12px;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  width: 100% !important;
}

.form-group {
  margin-bottom: 1rem;
}

.form-control:focus, .single-line:focus {
  border-color: #1db5b6;
}

.has-success .form-control, .has-success .form-control:focus {
  border-color: #1db5b6;
}

.has-warning .form-control, .has-warning .form-control:focus {
  border-color: #f8ac59;
}

.has-error .form-control, .has-error .form-control:focus {
  border-color: #ED5565;
}

.has-success .control-label {
  color: #1db5b6;
}

.has-warning .control-label {
  color: #f8ac59;
}

.has-error .control-label {
  color: #ED5565;
}

.input-group-addon {
  background-color: #fff;
  border: 1px solid #E5E6E7;
  border-radius: 1px;
  color: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  padding: 9px 12px 4px 12px;
  text-align: center;
}

.input-daterange .input-group-addon {
  margin: 0;
}

.input-group.date .input-group-addon {
  border-right: 0;
}

.spinner-buttons.input-group-btn .btn-xs {
  line-height: 1.13;
}

.spinner-buttons.input-group-btn {
  width: 20%;
}

.noUi-connect {
  background: none repeat scroll 0 0 #1db5b6;
  box-shadow: none;
}

.slider_red .noUi-connect {
  background: none repeat scroll 0 0 #ED5565;
  box-shadow: none;
}

/* UI Sortable */
.ui-sortable .ibox-title {
  cursor: move;
}

.ui-sortable-placeholder {
  border: 1px dashed #cecece !important;
  visibility: visible !important;
  background: #e7eaec;
}

.ibox.ui-sortable-placeholder {
  margin: 0 0 23px !important;
}

/* SWITCHES */
.onoffswitch {
  position: relative;
  width: 54px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #1AB394;
  border-radius: 3px;
}

.onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch-inner:before, .onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 16px;
  padding: 0;
  line-height: 16px;
  font-size: 10px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  box-sizing: border-box;
}

.onoffswitch-inner:before {
  content: "ON";
  padding-left: 7px;
  background-color: #1AB394;
  color: #FFFFFF;
}

.onoffswitch-inner:after {
  content: "OFF";
  padding-right: 7px;
  background-color: #FFFFFF;
  color: #919191;
  text-align: right;
}

.onoffswitch-switch {
  display: block;
  width: 18px;
  margin: 0;
  background: #FFFFFF;
  border: 2px solid #1AB394;
  border-radius: 3px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 36px;
  transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0;
}

/* jqGrid */
.ui-jqgrid {
  -moz-box-sizing: content-box;
}

.ui-jqgrid-btable {
  border-collapse: separate;
}

.ui-jqgrid-htable {
  border-collapse: separate;
}

.ui-jqgrid-titlebar {
  height: 40px;
  line-height: 15px;
  color: #676a6c;
  background-color: #F9F9F9;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

.ui-jqgrid .ui-jqgrid-title {
  float: left;
  margin: 1.1em 1em 0.2em;
}

.ui-jqgrid .ui-jqgrid-titlebar {
  position: relative;
  border-left: 0 solid;
  border-right: 0 solid;
  border-top: 0 solid;
}

.ui-widget-header {
  background: none;
  background-image: none;
  background-color: #f5f5f6;
  text-transform: uppercase;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.ui-jqgrid tr.ui-row-ltr td {
  border-right-color: inherit;
  border-right-style: solid;
  border-right-width: 1px;
  text-align: left;
  border-color: #DDDDDD;
  background-color: inherit;
}

.ui-search-toolbar input[type=text] {
  font-size: 12px;
  height: 15px;
  border: 1px solid #CCCCCC;
  border-radius: 0;
}

.ui-state-default, .ui-widget-content .ui-state-default, .ui-widget-header .ui-state-default {
  background: #F9F9F9;
  border: 1px solid #DDDDDD;
  line-height: 15px;
  font-weight: bold;
  color: #676a6c;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

.ui-widget-content {
  box-sizing: content-box;
}

.ui-icon-triangle-1-n {
  background-position: 1px -16px;
}

.ui-jqgrid tr.ui-search-toolbar th {
  border-top-width: 0 !important;
  border-top-color: inherit !important;
  border-top-style: ridge !important;
}

.ui-state-hover, .ui-widget-content .ui-state-hover, .ui-state-focus, .ui-widget-content .ui-state-focus, .ui-widget-header .ui-state-focus {
  background: #f5f5f5;
  border-collapse: separate;
}

.ui-state-highlight, .ui-widget-content .ui-state-highlight, .ui-widget-header .ui-state-highlight {
  background: #f2fbff;
}

.ui-state-active, .ui-widget-content .ui-state-active, .ui-widget-header .ui-state-active {
  border: 1px solid #dddddd;
  background: #ffffff;
  font-weight: normal;
  color: #212121;
}

.ui-jqgrid .ui-pg-input {
  font-size: inherit;
  width: 50px;
  border: 1px solid #CCCCCC;
  height: 15px;
}

.ui-jqgrid .ui-pg-selbox {
  display: block;
  font-size: 1em;
  height: 25px;
  line-height: 18px;
  margin: 0;
  width: auto;
}

.ui-jqgrid .ui-pager-control {
  position: relative;
}

.ui-jqgrid .ui-jqgrid-pager {
  height: 32px;
  position: relative;
}

.ui-pg-table .navtable .ui-corner-all {
  border-radius: 0;
}

.ui-jqgrid .ui-pg-button:hover {
  padding: 1px;
  border: 0;
}

.ui-jqgrid .loading {
  position: absolute;
  top: 45%;
  left: 45%;
  width: auto;
  height: auto;
  z-index: 101;
  padding: 6px;
  margin: 5px;
  text-align: center;
  font-weight: bold;
  display: none;
  border-width: 2px !important;
  font-size: 11px;
}

.ui-jqgrid .form-control {
  height: 10px;
  width: auto;
  display: inline;
  padding: 10px 12px;
}

.ui-jqgrid-pager {
  height: 32px;
}

.ui-corner-all, .ui-corner-top, .ui-corner-left, .ui-corner-tl {
  border-top-left-radius: 0;
}

.ui-corner-all, .ui-corner-top, .ui-corner-right, .ui-corner-tr {
  border-top-right-radius: 0;
}

.ui-corner-all, .ui-corner-bottom, .ui-corner-left, .ui-corner-bl {
  border-bottom-left-radius: 0;
}

.ui-corner-all, .ui-corner-bottom, .ui-corner-right, .ui-corner-br {
  border-bottom-right-radius: 0;
}

.ui-widget-content {
  border: 1px solid #ddd;
}

.ui-jqgrid .ui-jqgrid-titlebar {
  padding: 0;
}

.ui-jqgrid .ui-jqgrid-titlebar {
  border-bottom: 1px solid #ddd;
}

.ui-jqgrid tr.jqgrow td {
  padding: 6px;
}

.ui-jqdialog .ui-jqdialog-titlebar {
  padding: 10px 10px;
}

.ui-jqdialog .ui-jqdialog-title {
  float: none !important;
}

.ui-jqdialog > .ui-resizable-se {
  position: absolute;
}

/* Nestable list */
.dd {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  line-height: 20px;
}

.dd-list {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dd-list .dd-list {
  padding-left: 30px;
}

.dd-collapsed .dd-list {
  display: none;
}

.dd-item,
.dd-empty,
.dd-placeholder {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  min-height: 20px;
  font-size: 13px;
  line-height: 20px;
}

.dd-handle {
  display: block;
  margin: 5px 0;
  padding: 5px 10px;
  color: #333;
  text-decoration: none;
  border: 1px solid #e7eaec;
  background: #f5f5f5;
  border-radius: 3px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.dd-handle span {
  font-weight: bold;
}

.dd-handle:hover {
  background: #f0f0f0;
  cursor: pointer;
  font-weight: bold;
}

.dd-item > button {
  display: block;
  position: relative;
  cursor: pointer;
  float: left;
  width: 25px;
  height: 20px;
  margin: 5px 0;
  padding: 0;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  border: 0;
  background: transparent;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  font-weight: bold;
}

.dd-item > button:before {
  content: "+";
  display: block;
  position: absolute;
  width: 100%;
  text-align: center;
  text-indent: 0;
}

.dd-item > button[data-action=collapse]:before {
  content: "-";
}

#nestable2 .dd-item > button {
  font-family: FontAwesome;
  height: 34px;
  width: 33px;
  color: #c1c1c1;
}

#nestable2 .dd-item > button:before {
  content: "";
}

#nestable2 .dd-item > button[data-action=collapse]:before {
  content: "";
}

.dd-placeholder,
.dd-empty {
  margin: 5px 0;
  padding: 0;
  min-height: 30px;
  background: #f2fbff;
  border: 1px dashed #b6bcbf;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.dd-empty {
  border: 1px dashed #bbb;
  min-height: 100px;
  background-color: #e5e5e5;
  background-image: linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff), linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff);
  background-size: 60px 60px;
  background-position: 0 0, 30px 30px;
}

.dd-dragel {
  position: absolute;
  z-index: 9999;
  pointer-events: none;
}

.dd-dragel > .dd-item .dd-handle {
  margin-top: 0;
}

.dd-dragel .dd-handle {
  box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);
}

/**
* Nestable Extras
*/
.nestable-lists {
  display: block;
  clear: both;
  padding: 30px 0;
  width: 100%;
  border: 0;
  border-top: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
}

#nestable-menu {
  padding: 0;
  margin: 10px 0 20px 0;
}

#nestable-output,
#nestable2-output {
  width: 100%;
  font-size: 0.75em;
  line-height: 1.333333em;
  font-family: open sans, lucida grande, lucida sans unicode, helvetica, arial, sans-serif;
  padding: 5px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#nestable2 .dd-handle {
  color: inherit;
  border: 1px dashed #e7eaec;
  background: #f3f3f4;
  padding: 10px;
}

#nestable2 span.label {
  margin-right: 10px;
}

#nestable-output,
#nestable2-output {
  font-size: 12px;
  padding: 25px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

/* CodeMirror */
.CodeMirror {
  border: 1px solid #eee;
  height: auto;
}

.CodeMirror-scroll {
  overflow-y: hidden;
  overflow-x: auto;
}

/* Google Maps */
.google-map {
  height: 300px;
}

/* Validation */
label.error {
  color: #cc5965;
  display: inline-block;
  margin-left: 5px;
}

.form-control.error {
  border: 1px dotted #cc5965;
}

/* ngGrid */
.gridStyle {
  border: 1px solid #d4d4d4;
  width: 100%;
  height: 400px;
}

.gridStyle2 {
  border: 1px solid #d4d4d4;
  width: 500px;
  height: 300px;
}

.ngH eaderCell {
  border-right: none;
  border-bottom: 1px solid #e7eaec;
}

.ngCell {
  border-right: none;
}

.ngTopPanel {
  background: #F5F5F6;
}

.ngRow.even {
  background: #f9f9f9;
}

.ngRow.selected {
  background: #EBF2F1;
}

.ngRow {
  border-bottom: 1px solid #e7eaec;
}

.ngCell {
  background-color: transparent;
}

.ngHeaderCell {
  border-right: none;
}

/* Toastr custom style */
#toast-container > div {
  box-shadow: 0 0 3px #999;
  opacity: 0.9;
  -ms-filter: alpha(Opacity=90);
  filter: alpha(opacity=90);
}

#toast-container > :hover {
  box-shadow: 0 0 4px #999;
  opacity: 1;
  -ms-filter: alpha(Opacity=100);
  filter: alpha(opacity=100);
  cursor: pointer;
}

.toast {
  background-color: #1db5b6;
  border-color: #e7eaec;
}

.toast-success {
  background-color: #1db5b6;
}

.toast-error {
  background-color: #ED5565;
}

.toast-info {
  background-color: #23c6c8;
}

.toast-warning {
  background-color: #f8ac59;
}

.toast-top-full-width {
  margin-top: 20px;
}

.toast-bottom-full-width {
  margin-bottom: 20px;
}

.toast {
  z-index: 3000;
}

.toast.toast-bootstrap {
  background-color: white;
}
.toast.toast-bootstrap .toast-body {
  background-color: #fbfbfb;
  font-size: 0.775rem;
}

/* Notifie */
.cg-notify-message.inspinia-notify {
  background: #fff;
  padding: 0;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);
  border: none;
  margin-top: 30px;
  color: inherit;
}

.inspinia-notify.alert-warning {
  border-left: 6px solid #f8ac59;
}

.inspinia-notify.alert-success {
  border-left: 6px solid #1c84c6;
}

.inspinia-notify.alert-danger {
  border-left: 6px solid #ED5565;
}

.inspinia-notify.alert-info {
  border-left: 6px solid #1db5b6;
}

/* Image cropper style */
.img-container, .img-preview {
  overflow: hidden;
  text-align: center;
  width: 100%;
}

.img-preview-sm {
  height: 130px;
  width: 200px;
}

/* Forum styles  */
.forum-post-container .media {
  margin: 10px 10px 10px 10px;
  padding: 20px 10px 20px 10px;
  border-bottom: 1px solid #f1f1f1;
}

.forum-avatar {
  float: left;
  margin-right: 20px;
  text-align: center;
  width: 110px;
}

.forum-avatar .rounded-circle {
  height: 48px;
  width: 48px;
}

.author-info {
  color: #676a6c;
  font-size: 11px;
  margin-top: 5px;
  text-align: center;
}

.forum-post-info {
  padding: 9px 12px 6px 12px;
  background: #f9f9f9;
  border: 1px solid #f1f1f1;
}

.media-body > .media {
  background: #f9f9f9;
  border-radius: 3px;
  border: 1px solid #f1f1f1;
}

.forum-post-container .media-body .photos {
  margin: 10px 0;
}

.forum-photo {
  max-width: 140px;
  border-radius: 3px;
}

.media-body > .media .forum-avatar {
  width: 70px;
  margin-right: 10px;
}

.media-body > .media .forum-avatar .rounded-circle {
  height: 38px;
  width: 38px;
}

.mid-icon {
  font-size: 66px;
}

.forum-item {
  margin: 10px 0;
  padding: 10px 0 20px;
  border-bottom: 1px solid #f1f1f1;
}

.views-number {
  font-size: 24px;
  line-height: 18px;
  font-weight: 400;
}

.forum-container, .forum-post-container {
  padding: 30px !important;
}

.forum-item small {
  color: #999;
}

.forum-item .forum-sub-title {
  color: #999;
  margin-left: 50px;
}

.forum-title {
  margin: 15px 0 15px 0;
}

.forum-info {
  text-align: center;
}

.forum-desc {
  color: #999;
}

.forum-icon {
  float: left;
  width: 30px;
  margin-right: 20px;
  text-align: center;
}

a.forum-item-title {
  color: inherit;
  display: block;
  font-size: 18px;
  font-weight: 600;
}

a.forum-item-title:hover {
  color: inherit;
}

.forum-icon .fa {
  font-size: 30px;
  margin-top: 8px;
  color: #9b9b9b;
}

.forum-item.active .fa {
  color: #1db5b6;
}

.forum-item.active a.forum-item-title {
  color: #1db5b6;
}

@media (max-width: 992px) {
  .forum-info {
    margin: 15px 0 10px 0;
    /* Comment this is you want to show forum info in small devices */
    display: none;
  }

  .forum-desc {
    float: none !important;
  }
}
/* New Timeline style */
.vertical-container {
  /* this class is used to give a max-width to the element it is applied to, and center it horizontally when it reaches that max-width */
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
}

.vertical-container::after {
  /* clearfix */
  content: "";
  display: table;
  clear: both;
}

#vertical-timeline {
  position: relative;
  padding: 0;
  margin-top: 2em;
  margin-bottom: 2em;
}

#vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 18px;
  height: 100%;
  width: 4px;
  background: #f1f1f1;
}

.vertical-timeline-content .btn {
  float: right;
}

#vertical-timeline.light-timeline:before {
  background: #e7eaec;
}

.dark-timeline .vertical-timeline-content:before {
  border-color: transparent #f5f5f5 transparent transparent;
}

.dark-timeline.center-orientation .vertical-timeline-content:before {
  border-color: transparent transparent transparent #f5f5f5;
}

.dark-timeline .vertical-timeline-block:nth-child(2n) .vertical-timeline-content:before,
.dark-timeline.center-orientation .vertical-timeline-block:nth-child(2n) .vertical-timeline-content:before {
  border-color: transparent #f5f5f5 transparent transparent;
}

.dark-timeline .vertical-timeline-content,
.dark-timeline.center-orientation .vertical-timeline-content {
  background: #f5f5f5;
}

@media only screen and (min-width: 1170px) {
  #vertical-timeline.center-orientation {
    margin-top: 3em;
    margin-bottom: 3em;
  }

  #vertical-timeline.center-orientation:before {
    left: 50%;
    margin-left: -2px;
  }
}
@media only screen and (max-width: 1170px) {
  .center-orientation.dark-timeline .vertical-timeline-content:before {
    border-color: transparent #f5f5f5 transparent transparent;
  }
}
.vertical-timeline-block {
  position: relative;
  margin: 2em 0;
}

.vertical-timeline-block:after {
  content: "";
  display: table;
  clear: both;
}

.vertical-timeline-block:first-child {
  margin-top: 0;
}

.vertical-timeline-block:last-child {
  margin-bottom: 0;
}

@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-block {
    margin: 4em 0;
  }

  .center-orientation .vertical-timeline-block:first-child {
    margin-top: 0;
  }

  .center-orientation .vertical-timeline-block:last-child {
    margin-bottom: 0;
  }
}
.vertical-timeline-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 16px;
  border: 3px solid #f1f1f1;
  text-align: center;
}

.vertical-timeline-icon i {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-left: -12px;
  margin-top: -9px;
}

@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-icon {
    width: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    -webkit-transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    font-size: 19px;
  }

  .center-orientation .vertical-timeline-icon i {
    margin-left: -12px;
    margin-top: -10px;
  }

  .center-orientation .cssanimations .vertical-timeline-icon.is-hidden {
    visibility: hidden;
  }
}
.vertical-timeline-content {
  position: relative;
  margin-left: 60px;
  background: white;
  border-radius: 0.25em;
  padding: 1em;
}

.vertical-timeline-content:after {
  content: "";
  display: table;
  clear: both;
}

.vertical-timeline-content h2 {
  font-weight: 400;
  margin-top: 4px;
}

.vertical-timeline-content p {
  margin: 1em 0;
  line-height: 1.6;
}

.vertical-timeline-content .vertical-date {
  float: left;
  font-weight: 500;
}

.vertical-date small {
  color: #1db5b6;
  font-weight: 400;
}

.vertical-timeline-content::before {
  content: "";
  position: absolute;
  top: 16px;
  right: 100%;
  height: 0;
  width: 0;
  border: 7px solid transparent;
  border-right: 7px solid white;
}

@media only screen and (min-width: 768px) {
  .vertical-timeline-content h2 {
    font-size: 18px;
  }

  .vertical-timeline-content p {
    font-size: 13px;
  }
}
@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-content {
    margin-left: 0;
    padding: 1.6em;
    width: 45%;
  }

  .center-orientation .vertical-timeline-content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left-color: white;
  }

  .center-orientation .vertical-timeline-content .btn {
    float: left;
  }

  .center-orientation .vertical-timeline-content .vertical-date {
    position: absolute;
    width: 100%;
    left: 122%;
    top: 2px;
    font-size: 14px;
  }

  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content {
    float: right;
  }

  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right-color: white;
  }

  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .btn {
    float: right;
  }

  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .vertical-date {
    left: auto;
    right: 122%;
    text-align: right;
  }

  .center-orientation .cssanimations .vertical-timeline-content.is-hidden {
    visibility: hidden;
  }
}
/* Tabs */
.tabs-container .panel-body {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 2px;
  padding: 20px;
  position: relative;
}
.tabs-container .nav-tabs > li.active > a,
.tabs-container .nav-tabs > li.active > a:hover,
.tabs-container .nav-tabs > li.active > a:focus {
  border: 1px solid #e7eaec;
  border-bottom-color: transparent;
  background-color: #fff;
}
.tabs-container .nav-tabs > li {
  float: left;
  margin-bottom: -1px;
}
.tabs-container .tab-pane .panel-body {
  border-top: none;
}
.tabs-container .nav-tabs > li.active > a, .tabs-container .nav-tabs > li.active > a:hover, .tabs-container .nav-tabs > li.active > a:focus {
  border: 1px solid #e7eaec;
  border-bottom-color: transparent;
}
.tabs-container .nav-tabs {
  border-bottom: 1px solid #e7eaec;
}
.tabs-container .tab-pane .panel-body {
  border-top: none;
}
.tabs-container .tabs-left .tab-pane .panel-body, .tabs-container .tabs-right .tab-pane .panel-body {
  border-top: 1px solid #e7eaec;
}
.tabs-container .tabs-below > .nav-tabs,
.tabs-container .tabs-right > .nav-tabs,
.tabs-container .tabs-left > .nav-tabs {
  border-bottom: 0;
}
.tabs-container .tabs-left .panel-body {
  position: static;
}
.tabs-container .tabs-left > .nav-tabs, .tabs-container .tabs-right > .nav-tabs {
  width: 20%;
}
.tabs-container .tabs-left .panel-body {
  width: 80%;
  margin-left: 20%;
}
.tabs-container .tabs-right .panel-body {
  width: 80%;
  margin-right: 20%;
}
.tabs-container .tab-content > .tab-pane,
.tabs-container .pill-content > .pill-pane {
  display: none;
}
.tabs-container .tab-content > .active,
.tabs-container .pill-content > .active {
  display: block;
}
.tabs-container .tabs-below > .nav-tabs {
  border-top: 1px solid #e7eaec;
}
.tabs-container .tabs-below > .nav-tabs > li {
  margin-top: -1px;
  margin-bottom: 0;
}
.tabs-container .tabs-below > .nav-tabs > li > a {
  border-radius: 0 0 4px 4px;
}
.tabs-container .tabs-below > .nav-tabs > li > a:hover,
.tabs-container .tabs-below > .nav-tabs > li > a:focus {
  border-top-color: #e7eaec;
  border-bottom-color: transparent;
}
.tabs-container .tabs-left > .nav-tabs > li,
.tabs-container .tabs-right > .nav-tabs > li {
  float: none;
  word-break: break-word;
  width: 100%;
}
.tabs-container .tabs-left > .nav-tabs > li > a,
.tabs-container .tabs-right > .nav-tabs > li > a {
  min-width: 124px;
  margin-right: 0;
  margin-bottom: 3px;
}
.tabs-container .tabs-left > .nav-tabs {
  float: left;
  margin-right: 19px;
}
.tabs-container .tabs-left > .nav-tabs > li > a {
  margin-right: -1px;
  border-radius: 4px 0 0 4px;
}
.tabs-container .tabs-left > .nav-tabs a.active,
.tabs-container .tabs-left > .nav-tabs a.active:hover,
.tabs-container .tabs-left > .nav-tabs a.active:focus {
  border-color: #e7eaec transparent #e7eaec #e7eaec;
}
.tabs-container .tabs-right > .nav-tabs {
  float: right;
  margin-left: 19px;
}
.tabs-container .tabs-right > .nav-tabs > li > a {
  margin-left: -1px;
  border-radius: 0 4px 4px 0;
}
.tabs-container .tabs-right > .nav-tabs a.active,
.tabs-container .tabs-right > .nav-tabs a.active:hover,
.tabs-container .tabs-right > .nav-tabs a.active:focus {
  border-color: #e7eaec #e7eaec #e7eaec transparent;
  z-index: 1;
}
.tabs-container .tabs-right > .nav-tabs li {
  z-index: 1;
}

.nav-tabs .nav-link:not(.active):focus, .nav-tabs .nav-link:not(.active):hover {
  border-color: transparent;
}

@media (max-width: 767px) {
  .tabs-container .nav-tabs > li {
    float: none !important;
  }

  .tabs-container .nav-tabs > li.active > a {
    border-bottom: 1px solid #e7eaec !important;
    margin: 0;
  }
}
/* jsvectormap */
.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #CDCDCD;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 5px;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #1db5b6;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/*Slick Carousel */
.slick-prev:before,
.slick-next:before {
  color: #1db5b6 !important;
}

/* Payments */
.payment-card {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 25px;
  border: 1px solid #e7eaec;
}

.payment-icon-big {
  font-size: 60px;
  color: #D1DADE;
}

.payments-method.panel-group .panel + .panel {
  margin-top: -1px;
}

.payments-method .panel-heading {
  padding: 15px;
  background-color: #f3f3f4;
}

.payments-method .panel-default {
  border: 1px solid #e7eaec;
}

.payments-method .panel {
  border-radius: 0;
}

.payments-method .panel-heading h5 {
  margin-bottom: 5px;
}

.payments-method .panel-heading i {
  font-size: 26px;
}

/* Select2 custom styles */
.select2-container--bootstrap4 .select2-results__option--highlighted,
.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected=true] {
  background-color: #1db5b6;
}

.select2-container--bootstrap4 .select2-selection,
.select2-container--bootstrap4 .select2-dropdown.select2-dropdown--above,
.select2-container--bootstrap4 .select2-dropdown {
  border-color: #e7eaec;
}

.select2-container :focus {
  outline: none;
}

.select2-container--bootstrap4.select2-container--focus .select2-selection {
  box-shadow: none;
  border-color: #1db5b6;
}

.select2-container--bootstrap4 .select2-selection__clear {
  margin-top: 0.9em;
}

/* Tour */
.tour-tour .btn.btn-default {
  background-color: #ffffff;
  border: 1px solid #d2d2d2;
  color: inherit;
}

.tour-step-backdrop {
  z-index: 2101;
}

.tour-backdrop {
  z-index: 2100;
  opacity: 0.7;
}

.popover[class*=tour-] {
  z-index: 2100;
}

.popover-header {
  margin-top: 0;
}

body.tour-open .animated {
  animation-fill-mode: initial;
}

.tour-tour .btn.btn-secondary {
  background-color: #ffffff;
  border: 1px solid #d2d2d2;
  color: inherit;
}

/* Resizable */
.resizable-panels .ibox {
  clear: none;
  margin: 10px;
  float: left;
  overflow: hidden;
  min-height: 150px;
  min-width: 150px;
}

.resizable-panels .ibox .ibox-content {
  height: calc(100% - 49px);
}

.ui-resizable-helper {
  background: rgba(211, 211, 211, 0.4);
}

/* Wizard step fix */
.wizard > .content > .body {
  position: relative;
}

/* PDF js style */
.pdf-toolbar {
  max-width: 600px;
  margin: 0 auto;
}
.pdf-toolbar .input-group {
  width: 100px;
}

/* Dropzone */
.dropzone {
  min-height: 140px;
  border: 1px dashed #1db5b6;
  background: white;
  padding: 20px 15px;
  text-align: center;
}
.dropzone .dz-message {
  font-size: 16px;
}

/* Activity stream */
.stream {
  position: relative;
  padding: 10px 0;
}
.stream:first-child .stream-badge:before {
  top: 10px;
}
.stream:last-child .stream-badge:before {
  height: 30px;
}
.stream .stream-badge {
  width: 50px;
}
.stream .stream-badge i {
  border: 1px solid #e7eaec;
  border-radius: 50%;
  padding: 6px;
  color: #808486;
  position: absolute;
  background-color: #ffffff;
  left: 8px;
}
.stream .stream-badge i.fa-circle {
  color: #ced0d1;
}
.stream .stream-badge i.bg-success {
  color: #ffffff;
  background-color: #1c84c6;
  border-color: #1c84c6;
}
.stream .stream-badge i.bg-primary {
  color: #ffffff;
  background-color: #1db5b6;
  border-color: #1db5b6;
}
.stream .stream-badge i.bg-warning {
  color: #ffffff;
  background-color: #f8ac59;
  border-color: #f8ac59;
}
.stream .stream-badge i.bg-info {
  color: #ffffff;
  background-color: #23c6c8;
  border-color: #23c6c8;
}
.stream .stream-badge i.bg-danger {
  color: #ffffff;
  background-color: #ED5565;
  border-color: #ED5565;
}
.stream .stream-badge:before {
  content: "";
  width: 1px;
  background-color: #e7eaec;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 20px;
}
.stream .stream-info {
  font-size: 12px;
  margin-bottom: 5px;
}
.stream .stream-info img {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  margin-right: 2px;
  margin-top: -4px;
}
.stream .stream-info .date {
  color: #9a9d9f;
  font-size: 80%;
}
.stream .stream-panel {
  margin-left: 55px;
}

.stream-small {
  margin: 10px 0;
}
.stream-small .label {
  padding: 2px 6px;
  margin-right: 2px;
}

/* Touch Spin */
.bootstrap-touchspin-postfix.input-group-addon {
  padding: inherit;
}

.bootstrap-touchspin-postfix .input-group-text {
  background-color: inherit;
  line-height: 1;
  border: none;
}

/* Code */
pre {
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #333;
  word-break: break-all;
  word-wrap: break-word;
  background-color: #eff2f3;
  border: 1px solid #D1DADE;
  border-radius: 2px;
}

code, kbd, pre, samp {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
}

.sidebar-panel {
  width: 220px;
  background: #ebebed;
  padding: 10px 20px;
  position: absolute;
  right: 0;
  height: calc(100% - 62px);
}

.sidebar-panel .feed-element img.rounded-circle {
  width: 32px;
  height: 32px;
}

.sidebar-panel .feed-element, .media-body, .sidebar-panel p {
  font-size: 12px;
}

.sidebar-panel .feed-element {
  margin-top: 20px;
  padding-bottom: 0;
}

.sidebar-panel .list-group {
  margin-bottom: 10px;
}

.sidebar-panel .list-group .list-group-item {
  padding: 5px 0;
  font-size: 12px;
  border: 0;
}

.sidebar-content .wrapper, .wrapper.sidebar-content {
  padding-right: 230px !important;
}

.body-small .sidebar-content .wrapper, .body-small .wrapper.sidebar-content {
  padding-right: 20px !important;
}

#right-sidebar {
  background-color: #fff;
  border-left: 1px solid #e7eaec;
  border-top: 1px solid #e7eaec;
  overflow: hidden;
  position: fixed;
  top: 60px;
  width: 260px !important;
  z-index: 1009;
  bottom: 0;
  right: -260px;
}

#right-sidebar.sidebar-open {
  right: 0;
}

#right-sidebar.sidebar-open.sidebar-top {
  top: 0;
  border-top: none;
}

.sidebar-container ul.nav-tabs {
  border: none;
}
.sidebar-container ul.nav-tabs.navs-4 li {
  width: 25%;
}
.sidebar-container ul.nav-tabs.navs-3 li {
  width: 33.3333%;
}
.sidebar-container ul.nav-tabs.navs-2 li {
  width: 50%;
}
.sidebar-container ul.nav-tabs li {
  border: none;
}
.sidebar-container ul.nav-tabs li a {
  border: none;
  padding: 12px 10px;
  margin: 0;
  border-radius: 0;
  background: #2F4050;
  color: #fff;
  text-align: center;
  border-right: 1px solid #334556;
}
.sidebar-container ul.nav-tabs li.active a {
  border: none;
  background: #f9f9f9;
  color: #676a6c;
  font-weight: bold;
}
.sidebar-container .nav-tabs > li.active > a:hover,
.sidebar-container .nav-tabs > li.active > a:focus {
  border: none;
}
.sidebar-container ul.sidebar-list {
  margin: 0;
  padding: 0;
}
.sidebar-container ul.sidebar-list li {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 20px;
  list-style: none;
  font-size: 12px;
}
.sidebar-container .sidebar-message:nth-child(2n+2) {
  background: #f9f9f9;
}
.sidebar-container ul.sidebar-list li a {
  text-decoration: none;
  color: inherit;
}
.sidebar-container .sidebar-content {
  padding: 15px 20px;
  font-size: 12px;
}
.sidebar-container .sidebar-title {
  background: #f9f9f9;
  padding: 20px;
  border-bottom: 1px solid #e7eaec;
}
.sidebar-container .sidebar-title h3 {
  margin-bottom: 3px;
  padding-left: 2px;
}
.sidebar-container .tab-content h4 {
  margin-bottom: 5px;
}
.sidebar-container .sidebar-message > a > .float-left {
  margin-right: 10px;
}
.sidebar-container .sidebar-message > a {
  text-decoration: none;
  color: inherit;
}
.sidebar-container .sidebar-message {
  padding: 15px 20px;
}
.sidebar-container .sidebar-message .media-body {
  display: block;
  width: auto;
}
.sidebar-container .sidebar-message .message-avatar {
  height: 38px;
  width: 38px;
  border-radius: 50%;
}
.sidebar-container .setings-item {
  padding: 15px 20px;
  border-bottom: 1px solid #e7eaec;
}

body {
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: #2F4050;
  font-size: 13px;
  color: #676a6c;
  overflow-x: hidden;
}

html, body {
  height: 100%;
}

body.full-height-layout #wrapper,
body.full-height-layout #page-wrapper {
  height: 100%;
}

#page-wrapper {
  min-height: 100vh;
}

body.boxed-layout {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

body.boxed-layout #wrapper {
  background-color: #2F4050;
  max-width: 1200px;
  margin: 0 auto;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
}

.top-navigation.boxed-layout #wrapper,
.boxed-layout #wrapper.top-navigation {
  max-width: 1300px !important;
}

.block {
  display: block;
}

.clear {
  display: block;
  overflow: hidden;
}

a {
  color: #337ab7;
  cursor: pointer;
}

a:hover, a:focus {
  text-decoration: none;
}

.border-bottom {
  border-bottom: 1px solid #e7eaec !important;
}

.font-bold {
  font-weight: 600;
}

.font-normal {
  font-weight: 400;
}

.text-uppercase {
  text-transform: uppercase;
}

.font-italic {
  font-style: italic;
}

.b-r {
  border-right: 1px solid #e7eaec;
}

.hr-line-dashed {
  border-top: 1px dashed #e7eaec;
  color: #ffffff;
  background-color: #ffffff;
  height: 1px;
  margin: 20px 0;
}

.hr-line-solid {
  border-bottom: 1px solid #e7eaec;
  background-color: rgba(0, 0, 0, 0);
  border-style: solid !important;
  margin-top: 15px;
  margin-bottom: 15px;
}

video {
  width: 100% !important;
  height: auto !important;
}

/* GALLERY */
.gallery > .row > div {
  margin-bottom: 15px;
}

.fancybox img {
  margin-bottom: 5px;
  /* Only for demo */
  width: 24%;
}

/* Summernote text editor  */
.note-editor {
  height: auto !important;
}

.note-editor.fullscreen {
  z-index: 2050;
}

.note-editor.note-frame.fullscreen {
  z-index: 2020;
}

.note-editor.note-frame .note-editing-area .note-editable {
  color: #676a6c;
  padding: 15px;
}

.note-editor.note-frame {
  border: none;
}

.note-editor.panel {
  margin-bottom: 0;
}

/* MODAL */
.modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}

.modal-dialog {
  z-index: 2200;
}

.modal-body {
  padding: 20px 30px 30px 30px;
}

.inmodal .modal-body {
  background: #f8fafb;
}

.inmodal .modal-header {
  padding: 30px 15px;
  text-align: center;
  display: block;
}

.animated.modal.fade .modal-dialog {
  transform: none;
}

.inmodal .modal-title {
  font-size: 26px;
}

.inmodal .modal-icon {
  font-size: 84px;
  color: #e2e3e3;
}

.modal-footer {
  margin-top: 0;
}

/* WRAPPERS */
#wrapper {
  width: 100%;
  overflow-x: hidden;
  display: -ms-flex;
  display: flex;
}

.wrapper {
  padding: 0 20px;
}

.wrapper-content {
  padding: 20px 10px 40px;
}

#page-wrapper {
  padding: 0 15px;
  position: relative !important;
  flex-shrink: 1;
  width: calc(100% - 220px);
}

@media (min-width: 768px) {
  #page-wrapper {
    position: inherit;
  }
}
.title-action {
  text-align: right;
  padding-top: 30px;
}

.ibox-content h1, .ibox-content h2, .ibox-content h3, .ibox-content h4, .ibox-content h5,
.ibox-title h1, .ibox-title h2, .ibox-title h3, .ibox-title h4, .ibox-title h5 {
  margin-top: 5px;
}

ul.unstyled, ol.unstyled {
  list-style: none outside none;
  margin-left: 0;
}

.big-icon {
  font-size: 100px !important;
  color: #e5e6e7;
}

/* FOOTER */
.footer {
  background: none repeat scroll 0 0 white;
  border-top: 1px solid #e7eaec;
  bottom: 0;
  left: 0;
  padding: 10px 20px;
  position: absolute;
  right: 0;
}

.footer.fixed_full {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 10px 20px;
  background: white;
  border-top: 1px solid #e7eaec;
}

.footer.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 10px 20px;
  background: white;
  border-top: 1px solid #e7eaec;
  margin-left: 220px;
}

body.mini-navbar .footer.fixed,
body.body-small.mini-navbar .footer.fixed {
  margin: 0 0 0 70px;
}

body.mini-navbar.fixed-sidebar .footer.fixed {
  margin: 0;
}

body.mini-navbar.canvas-menu .footer.fixed,
body.canvas-menu .footer.fixed {
  margin: 0 !important;
}

body.fixed-sidebar.body-small.mini-navbar .footer.fixed {
  margin: 0 0 0 220px;
}

body.body-small .footer.fixed {
  margin-left: 0;
}

/* PANELS */
.panel-title > .small, .panel-title > .small > a, .panel-title > a, .panel-title > small, .panel-title > small > a {
  color: inherit;
}

.page-heading {
  border-top: 0;
  padding: 0 10px 20px 10px;
}

.panel-heading h1, .panel-heading h2 {
  margin-bottom: 5px;
}

.panel-body {
  padding: 15px;
}

/* Bootstrap 3.3.x panels */
.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
}

.panel-heading {
  color: white;
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.panel-footer {
  padding: 10px 15px;
  border-top: 1px solid #e7eaec;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.panel-default > .panel-heading {
  color: #333;
  background-color: #f5f5f5;
  border-color: #e7eaec;
}

.panel-default {
  border-color: #e7eaec;
}

.panel-group .panel + .panel {
  margin-top: 5px;
}

.panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
}

/* TABLES */
.table > caption + thead > tr:first-child > td, .table > caption + thead > tr:first-child > th, .table > colgroup + thead > tr:first-child > td, .table > colgroup + thead > tr:first-child > th, .table > thead:first-child > tr:first-child > td, .table > thead:first-child > tr:first-child > th {
  border-top: 0;
}

.table-bordered {
  border: 1px solid #EBEBEB;
}

.table-bordered > thead > tr > th, .table-bordered > thead > tr > td {
  background-color: #F5F5F6;
  border-bottom-width: 1px;
}

.table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td {
  border: 1px solid #e7e7e7;
}

.table > thead > tr > th {
  border-bottom: 1px solid #DDDDDD;
  vertical-align: bottom;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
  border-top: 1px solid #e7eaec;
  line-height: 1.42857;
  padding: 8px;
  vertical-align: top;
}

/* PANELS */
.panel.blank-panel {
  background: none;
  margin: 0;
}

.blank-panel .panel-heading {
  padding-bottom: 0;
}

.nav-tabs > li > a {
  color: #A7B1C2;
  font-weight: 600;
  padding: 10px 20px 10px 25px;
}

.nav-tabs > li > a:hover, .nav-tabs > li > a:focus {
  color: #676a6c;
}

.ui-tab .tab-content {
  padding: 20px 0;
}

/* GLOBAL  */
.no-padding {
  padding: 0 !important;
}

.no-borders {
  border: none !important;
}

.no-margins {
  margin: 0 !important;
}

.no-top-border {
  border-top: 0 !important;
}

.ibox-content.text-box {
  padding-bottom: 0;
  padding-top: 15px;
}

.border-left-right {
  border-left: 1px solid #e7eaec;
  border-right: 1px solid #e7eaec;
}

.border-top-bottom {
  border-top: 1px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
}

.border-left {
  border-left: 1px solid #e7eaec;
}

.border-right {
  border-right: 1px solid #e7eaec;
}

.border-top {
  border-top: 1px solid #e7eaec;
}

.border-bottom {
  border-bottom: 1px solid #e7eaec;
}

.border-size-sm {
  border-width: 3px;
}

.border-size-md {
  border-width: 6px;
}

.border-size-lg {
  border-width: 9px;
}

.border-size-xl {
  border-width: 12px;
}

.full-width {
  width: 100% !important;
}

.link-block {
  font-size: 12px;
  padding: 10px;
}

.nav.navbar-top-links .link-block a {
  font-size: 12px;
}

.navbar-top-links {
  text-align: right;
}

.link-block a {
  font-size: 10px;
  color: inherit;
}

body.mini-navbar .branding {
  display: none;
}

img.circle-border {
  border: 6px solid #FFFFFF;
  border-radius: 50%;
}

.branding {
  float: left;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  padding: 17px 20px;
  text-align: center;
  background-color: #1db5b6;
}

.login-panel {
  margin-top: 25%;
}

.icons-box h3 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.icons-box .infont a i {
  font-size: 25px;
  display: block;
  color: #676a6c;
}

.icons-box .infont a {
  color: #a6a8a9;
}

.icons-box .infont a {
  padding: 10px;
  margin: 1px;
  display: block;
}

.ui-draggable .ibox-title {
  cursor: move;
}

.breadcrumb {
  background-color: #ffffff;
  padding: 0;
  margin-bottom: 0;
}

.breadcrumb > li a {
  color: inherit;
}

.breadcrumb > .active {
  color: inherit;
}

code {
  background-color: #F9F2F4;
  border-radius: 4px;
  color: #ca4440;
  font-size: 90%;
  padding: 2px 4px;
  white-space: nowrap;
}

.ibox {
  clear: both;
  margin-bottom: 25px;
  margin-top: 0;
  padding: 0;
}

.ibox.collapsed .ibox-content {
  display: none;
}

.ibox.collapsed .fa.fa-chevron-up:before {
  content: "";
}

.ibox.collapsed .fa.fa-chevron-down:before {
  content: "";
}

.ibox:after, .ibox:before {
  display: table;
}

.ibox-title {
  background-color: #ffffff;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 90px 8px 15px;
  min-height: 48px;
  position: relative;
  clear: both;
  border-radius: 2px 2px 0 0;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid;
  border-width: 1px;
  border-radius: 10px;
}

.ibox-footer {
  color: inherit;
  border-top: 1px solid #e7eaec;
  font-size: 90%;
  background: #ffffff;
  padding: 10px 15px;
}

table.table-mail tr td {
  padding: 12px;
}

.table-mail .check-mail {
  padding-left: 20px;
}

.table-mail .mail-date {
  padding-right: 20px;
}

.star-mail, .check-mail {
  width: 40px;
}

.unread td a, .unread td {
  font-weight: 600;
  color: inherit;
}

.read td a, .read td {
  font-weight: normal;
  color: inherit;
}

.unread td {
  background-color: #f9f8f8;
}

.ibox-content {
  clear: both;
}

.ibox-heading {
  background-color: #f3f6fb;
  border-bottom: none;
}

.ibox-heading h3 {
  font-weight: 200;
  font-size: 24px;
}

.ibox-title h5 {
  display: inline-block;
  font-size: 14px;
  margin: 0 0 7px;
  padding: 0;
  text-overflow: ellipsis;
  float: none;
}

.ibox-title .label {
  margin-left: 4px;
}

.ibox-title .pull-right {
  position: absolute;
  right: 15px;
  top: 15px;
}

.ibox-tools {
  display: block;
  float: none;
  margin-top: 0;
  position: absolute;
  top: 15px;
  right: 15px;
  padding: 0;
  text-align: right;
}

.ibox-tools a {
  cursor: pointer;
  margin-left: 5px;
  color: #c4c4c4 !important;
}

.ibox-tools a.btn-primary {
  color: #fff !important;
}

.ibox-tools .dropdown-menu > li > a {
  padding: 4px 10px;
  font-size: 12px;
  color: #676a6c !important;
}

.ibox .ibox-tools.open > .dropdown-menu {
  left: auto;
  right: 0;
}

.ibox-tools .dropdown-toggle::after {
  display: none;
}

.dropdown-item {
  width: auto;
}

.dropdown-item.active, .dropdown-item:active {
  background-color: inherit;
  color: inherit;
}

/* BACKGROUNDS */
.gray-bg, .bg-muted {
  background-color: #f3f3f4;
}

.white-bg {
  background-color: #ffffff;
}

.blue-bg, .bg-success {
  background-color: #1c84c6 !important;
  color: #ffffff;
}

.navy-bg, .bg-primary {
  background-color: #1db5b6 !important;
  color: #ffffff;
}

.lazur-bg, .bg-info {
  background-color: #23c6c8 !important;
  color: #ffffff;
}

.yellow-bg, .bg-warning {
  background-color: #f8ac59 !important;
  color: #ffffff;
}

.red-bg, .bg-danger {
  background-color: #ED5565 !important;
  color: #ffffff;
}

.black-bg {
  background-color: #262626;
}

.panel-primary {
  border-color: #1db5b6;
}

.panel-primary > .panel-heading {
  background-color: #1db5b6;
  border-color: #1db5b6;
}

.panel-success {
  border-color: #1c84c6;
}

.panel-success > .panel-heading {
  background-color: #1c84c6;
  border-color: #1c84c6;
  color: #ffffff;
}

.panel-info {
  border-color: #23c6c8;
}

.panel-info > .panel-heading {
  background-color: #23c6c8;
  border-color: #23c6c8;
  color: #ffffff;
}

.panel-warning {
  border-color: #f8ac59;
}

.panel-warning > .panel-heading {
  background-color: #f8ac59;
  border-color: #f8ac59;
  color: #ffffff;
}

.panel-danger {
  border-color: #ED5565;
}

.panel-danger > .panel-heading {
  background-color: #ED5565;
  border-color: #ED5565;
  color: #ffffff;
}

.progress-bar {
  background-color: #1db5b6;
}

.progress-small, .progress-small .progress-bar {
  height: 10px;
}

.progress-small, .progress-mini {
  margin-top: 5px;
}

.progress-mini, .progress-mini .progress-bar {
  height: 5px;
  margin-bottom: 0;
}

.progress-bar-navy-light {
  background-color: #3dc7ab;
}

.progress-bar-success {
  background-color: #1c84c6;
}

.progress-bar-info {
  background-color: #23c6c8;
}

.progress-bar-warning {
  background-color: #f8ac59;
}

.progress-bar-danger {
  background-color: #ED5565;
}

.panel-title {
  font-size: inherit;
}

.jumbotron {
  border-radius: 6px;
  padding: 40px;
}

.jumbotron h1 {
  margin-top: 0;
}

/* COLORS */
.text-navy {
  color: #1db5b6 !important;
}

.text-primary {
  color: inherit !important;
}

.text-success {
  color: #1c84c6 !important;
}

.text-info {
  color: #23c6c8 !important;
}

.text-warning {
  color: #f8ac59 !important;
}

.text-danger {
  color: #ED5565 !important;
}

.text-muted {
  color: #888888 !important;
}

.text-white {
  color: #ffffff;
}

.simple_tag {
  background-color: #f3f3f4;
  border: 1px solid #e7eaec;
  border-radius: 2px;
  color: inherit;
  font-size: 10px;
  margin-right: 5px;
  margin-top: 5px;
  padding: 5px 12px;
  display: inline-block;
}

.img-shadow {
  box-shadow: 0 0 3px 0 #919191;
}

.dashboards\\.dashboard_2 nav.navbar,
.dashboards\\.dashboard_3 nav.navbar,
.mailbox\\.inbox nav.navbar,
.mailbox\\.email_view nav.navbar,
.mailbox\\.email_compose nav.navbar,
.dashboards\\.dashboard_4_1 nav.navbar,
.metrics nav.navbar, .metrics\\.index nav.navbar,
.dashboards\\.dashboard_5 nav.navbar {
  background: #fff;
}

a.close-canvas-menu {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 1011;
  color: #a7b1c2;
}

a.close-canvas-menu:hover {
  color: #fff;
}

.close-canvas-menu {
  display: none;
}

.canvas-menu .close-canvas-menu {
  display: block;
}

.light-navbar .navbar.navbar-static-top {
  background-color: #fff;
}

/* FULL HEIGHT */
.full-height {
  height: 100%;
}

.fh-breadcrumb {
  height: calc(100% - 196px);
  margin: 0 -15px;
  position: relative;
}

.fh-no-breadcrumb {
  height: calc(100% - 99px);
  margin: 0 -15px;
  position: relative;
}

.fh-column {
  background: #fff;
  height: 100%;
  width: 240px;
  float: left;
}

.modal-backdrop {
  z-index: 2040 !important;
}

.modal {
  z-index: 2050 !important;
}

.spiner-example {
  height: 200px;
  padding-top: 70px;
}

legend {
  font-size: 1rem;
}

/* MARGINS & PADDINGS */
.p-xxs {
  padding: 5px;
}

.p-xs {
  padding: 10px;
}

.p-sm {
  padding: 15px;
}

.p-m {
  padding: 20px;
}

.p-md {
  padding: 25px;
}

.p-lg {
  padding: 30px;
}

.p-xl {
  padding: 40px;
}

.p-w-xs {
  padding: 0 10px;
}

.p-w-sm {
  padding: 0 15px;
}

.p-w-m {
  padding: 0 20px;
}

.p-w-md {
  padding: 0 25px;
}

.p-w-lg {
  padding: 0 30px;
}

.p-w-xl {
  padding: 0 40px;
}

.p-h-xs {
  padding: 10px 0;
}

.p-h-sm {
  padding: 15px 0;
}

.p-h-m {
  padding: 20px 0;
}

.p-h-md {
  padding: 25px 0;
}

.p-h-lg {
  padding: 30px 0;
}

.p-h-xl {
  padding: 40px 0;
}

.m-xxs {
  margin: 2px 4px;
}

.m {
  margin: 15px;
}

.m-xs {
  margin: 5px;
}

.m-sm {
  margin: 10px;
}

.m-md {
  margin: 20px;
}

.m-lg {
  margin: 30px;
}

.m-xl {
  margin: 50px;
}

.m-n {
  margin: 0 !important;
}

.m-l-none {
  margin-left: 0;
}

.m-l-xs {
  margin-left: 5px;
}

.m-l-sm {
  margin-left: 10px;
}

.m-l {
  margin-left: 15px;
}

.m-l-md {
  margin-left: 20px;
}

.m-l-lg {
  margin-left: 30px;
}

.m-l-xl {
  margin-left: 40px;
}

.m-l-n-xxs {
  margin-left: -1px;
}

.m-l-n-xs {
  margin-left: -5px;
}

.m-l-n-sm {
  margin-left: -10px;
}

.m-l-n {
  margin-left: -15px;
}

.m-l-n-md {
  margin-left: -20px;
}

.m-l-n-lg {
  margin-left: -30px;
}

.m-l-n-xl {
  margin-left: -40px;
}

.m-t-none {
  margin-top: 0;
}

.m-t-xxs {
  margin-top: 1px;
}

.m-t-xs {
  margin-top: 5px;
}

.m-t-sm {
  margin-top: 10px;
}

.m-t {
  margin-top: 15px;
}

.m-t-md {
  margin-top: 20px;
}

.m-t-lg {
  margin-top: 30px;
}

.m-t-xl {
  margin-top: 40px;
}

.m-t-n-xxs {
  margin-top: -1px;
}

.m-t-n-xs {
  margin-top: -5px;
}

.m-t-n-sm {
  margin-top: -10px;
}

.m-t-n {
  margin-top: -15px;
}

.m-t-n-md {
  margin-top: -20px;
}

.m-t-n-lg {
  margin-top: -30px;
}

.m-t-n-xl {
  margin-top: -40px;
}

.m-r-none {
  margin-right: 0;
}

.m-r-xxs {
  margin-right: 1px;
}

.m-r-xs {
  margin-right: 5px;
}

.m-r-sm {
  margin-right: 10px;
}

.m-r {
  margin-right: 15px;
}

.m-r-md {
  margin-right: 20px;
}

.m-r-lg {
  margin-right: 30px;
}

.m-r-xl {
  margin-right: 40px;
}

.m-r-n-xxs {
  margin-right: -1px;
}

.m-r-n-xs {
  margin-right: -5px;
}

.m-r-n-sm {
  margin-right: -10px;
}

.m-r-n {
  margin-right: -15px;
}

.m-r-n-md {
  margin-right: -20px;
}

.m-r-n-lg {
  margin-right: -30px;
}

.m-r-n-xl {
  margin-right: -40px;
}

.m-b-none {
  margin-bottom: 0;
}

.m-b-xxs {
  margin-bottom: 1px;
}

.m-b-xs {
  margin-bottom: 5px;
}

.m-b-sm {
  margin-bottom: 10px;
}

.m-b {
  margin-bottom: 15px;
}

.m-b-md {
  margin-bottom: 20px;
}

.m-b-lg {
  margin-bottom: 30px;
}

.m-b-xl {
  margin-bottom: 40px;
}

.m-b-n-xxs {
  margin-bottom: -1px;
}

.m-b-n-xs {
  margin-bottom: -5px;
}

.m-b-n-sm {
  margin-bottom: -10px;
}

.m-b-n {
  margin-bottom: -15px;
}

.m-b-n-md {
  margin-bottom: -20px;
}

.m-b-n-lg {
  margin-bottom: -30px;
}

.m-b-n-xl {
  margin-bottom: -40px;
}

.space-15 {
  margin: 15px 0;
}

.space-20 {
  margin: 20px 0;
}

.space-25 {
  margin: 25px 0;
}

.space-30 {
  margin: 30px 0;
}

.img-sm {
  width: 32px;
  height: 32px;
}

.img-md {
  width: 64px;
  height: 64px;
}

.img-lg {
  width: 96px;
  height: 96px;
}

.b-r-xs {
  border-radius: 1px;
}

.b-r-sm {
  border-radius: 3px;
}

.b-r-md {
  border-radius: 6px;
}

.b-r-lg {
  border-radius: 12px;
}

.b-r-xl {
  border-radius: 24px;
}

.fullscreen-ibox-mode .animated {
  animation: none;
}

body.fullscreen-ibox-mode {
  overflow-y: hidden;
}

.ibox.fullscreen {
  z-index: 2030;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  margin-bottom: 0;
}

.ibox.fullscreen .collapse-link {
  display: none;
}

.ibox.fullscreen .ibox-content {
  min-height: calc(100% - 48px);
}

body.modal-open {
  padding-right: inherit !important;
}

_::-webkit-full-page-media, _:future, :root body.modal-open .wrapper-content.animated {
  -webkit-animation: none;
  -ms-animation-nam: none;
  animation: none;
}

body.modal-open .animated {
  animation-fill-mode: initial;
  z-index: inherit;
}

/* Show profile dropdown on fixed sidebar */
body.mini-navbar.fixed-sidebar .profile-element, .block {
  display: block !important;
}

body.mini-navbar.fixed-sidebar .nav-header {
  padding: 33px 25px;
}

body.mini-navbar.fixed-sidebar .logo-element {
  display: none;
}

.fullscreen-video .animated {
  animation: none;
}

.list-inline > li {
  display: inline-block;
}

.custom-file-label {
  padding: 0.5rem 0.75rem;
}
.custom-file-label::after {
  padding: 0.5rem 0.75rem;
}

#small-chat {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

#small-chat .badge {
  position: absolute;
  top: -3px;
  right: -4px;
}

.open-small-chat {
  height: 38px;
  width: 38px;
  display: block;
  background: #1ab394;
  padding: 9px 8px;
  text-align: center;
  color: #fff;
  border-radius: 50%;
}

.open-small-chat:hover {
  color: white;
  background: #1ab394;
}

.small-chat-box {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 75px;
  background: #fff;
  border: 1px solid #e7eaec;
  width: 230px;
  height: 320px;
  border-radius: 4px;
}

.small-chat-box.ng-small-chat {
  display: block;
}

.body-small .small-chat-box {
  bottom: 70px;
  right: 20px;
}

.small-chat-box.active {
  display: block;
}

.small-chat-box {
  z-index: 1001;
}
.small-chat-box .heading {
  background: #2F4050;
  padding: 8px 15px;
  font-weight: bold;
  color: #fff;
}
.small-chat-box .chat-date {
  opacity: 0.6;
  font-size: 10px;
  font-weight: normal;
}
.small-chat-box .content {
  padding: 15px 15px;
}
.small-chat-box .content .author-name {
  font-weight: bold;
  margin-bottom: 3px;
  font-size: 11px;
}
.small-chat-box .content > div {
  padding-bottom: 20px;
}
.small-chat-box .content .chat-message {
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11px;
  line-height: 14px;
  max-width: 80%;
  background: #f3f3f4;
  margin-bottom: 10px;
}
.small-chat-box .content .chat-message.active {
  background: #1ab394;
  color: #fff;
}
.small-chat-box .content .left {
  text-align: left;
  clear: both;
}
.small-chat-box .content .left .chat-message {
  float: left;
}
.small-chat-box .content .right {
  text-align: right;
  clear: both;
}
.small-chat-box .content .right .chat-message {
  float: right;
}
.small-chat-box .form-chat {
  padding: 10px 10px;
}

/*
 * metismenu - v2.0.2
 * A jQuery menu plugin
 * https://github.com/onokumus/metisMenu
 *
 * Made by Osman Nuri Okumus
 * Under MIT License
 */
.metismenu .plus-minus, .metismenu .plus-times {
  float: right;
}

.metismenu .arrow {
  float: right;
  line-height: 1.42857;
}

.metismenu .glyphicon.arrow:before {
  content: "";
}

.metismenu .active > a > .glyphicon.arrow:before {
  content: "";
}

.metismenu .fa.arrow:before {
  content: "";
}

.metismenu .active > a > .fa.arrow:before {
  content: "";
}

.metismenu .ion.arrow:before {
  content: "";
}

.metismenu .active > a > .ion.arrow:before {
  content: "";
}

.metismenu .fa.plus-minus:before, .metismenu .fa.plus-times:before {
  content: "";
}

.metismenu .active > a > .fa.plus-times {
  transform: rotate(45deg);
}

.metismenu .active > a > .fa.plus-minus:before {
  content: "";
}

.metismenu .collapse {
  display: none;
}

.metismenu .collapse.in {
  display: block;
}

.metismenu .collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-timing-function: ease;
  transition-duration: 0.35s;
  transition-property: height, visibility;
}

.mini-navbar .metismenu .collapse {
  opacity: 0;
}
.mini-navbar .metismenu .collapse.in {
  opacity: 1;
}
.mini-navbar .metismenu .collapse a {
  display: none;
}
.mini-navbar .metismenu .collapse.in a {
  display: block;
}

/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-rotating-plane"></div>
 *
 */
.sk-spinner-rotating-plane.sk-spinner {
  width: 30px;
  height: 30px;
  background-color: #1db5b6;
  margin: 0 auto;
  animation: sk-rotatePlane 1.2s infinite ease-in-out;
}
@keyframes sk-rotatePlane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-double-bounce">
 *      <div class="sk-double-bounce1"></div>
 *      <div class="sk-double-bounce2"></div>
 *    </div>
 *
 */
.sk-spinner-double-bounce.sk-spinner {
  width: 40px;
  height: 40px;
  position: relative;
  margin: 0 auto;
}

.sk-spinner-double-bounce .sk-double-bounce1, .sk-spinner-double-bounce .sk-double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #1db5b6;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  animation: sk-doubleBounce 2s infinite ease-in-out;
}

.sk-spinner-double-bounce .sk-double-bounce2 {
  animation-delay: -1s;
}
@keyframes sk-doubleBounce {
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-wave">
 *      <div class="sk-rect1"></div>
 *      <div class="sk-rect2"></div>
 *      <div class="sk-rect3"></div>
 *      <div class="sk-rect4"></div>
 *      <div class="sk-rect5"></div>
 *    </div>
 *
 */
.sk-spinner-wave.sk-spinner {
  margin: 0 auto;
  width: 50px;
  height: 30px;
  text-align: center;
  font-size: 10px;
}

.sk-spinner-wave div {
  background-color: #1db5b6;
  height: 100%;
  width: 6px;
  display: inline-block;
  animation: sk-waveStretchDelay 1.2s infinite ease-in-out;
}

.sk-spinner-wave .sk-rect2 {
  animation-delay: -1.1s;
}

.sk-spinner-wave .sk-rect3 {
  animation-delay: -1s;
}

.sk-spinner-wave .sk-rect4 {
  animation-delay: -0.9s;
}

.sk-spinner-wave .sk-rect5 {
  animation-delay: -0.8s;
}
@keyframes sk-waveStretchDelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-wandering-cubes">
 *      <div class="sk-cube1"></div>
 *      <div class="sk-cube2"></div>
 *    </div>
 *
 */
.sk-spinner-wandering-cubes.sk-spinner {
  margin: 0 auto;
  width: 32px;
  height: 32px;
  position: relative;
}

.sk-spinner-wandering-cubes .sk-cube1, .sk-spinner-wandering-cubes .sk-cube2 {
  background-color: #1db5b6;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  animation: sk-wanderingCubeMove 1.8s infinite ease-in-out;
}

.sk-spinner-wandering-cubes .sk-cube2 {
  animation-delay: -0.9s;
}
@keyframes sk-wanderingCubeMove {
  25% {
    transform: translateX(42px) rotate(-90deg) scale(0.5);
  }
  50% {
    /* Hack to make FF rotate in the right direction */
    transform: translateX(42px) translateY(42px) rotate(-179deg);
  }
  50.1% {
    transform: translateX(42px) translateY(42px) rotate(-180deg);
  }
  75% {
    transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
  }
  100% {
    transform: rotate(-360deg);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-pulse"></div>
 *
 */
.sk-spinner-pulse.sk-spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  background-color: #1db5b6;
  border-radius: 100%;
  animation: sk-pulseScaleOut 1s infinite ease-in-out;
}
@keyframes sk-pulseScaleOut {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-chasing-dots">
 *      <div class="sk-dot1"></div>
 *      <div class="sk-dot2"></div>
 *    </div>
 *
 */
.sk-spinner-chasing-dots.sk-spinner {
  margin: 0 auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
  animation: sk-chasingDotsRotate 2s infinite linear;
}

.sk-spinner-chasing-dots .sk-dot1, .sk-spinner-chasing-dots .sk-dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #1db5b6;
  border-radius: 100%;
  animation: sk-chasingDotsBounce 2s infinite ease-in-out;
}

.sk-spinner-chasing-dots .sk-dot2 {
  top: auto;
  bottom: 0;
  animation-delay: -1s;
}
@keyframes sk-chasingDotsRotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes sk-chasingDotsBounce {
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-three-bounce">
 *      <div class="sk-bounce1"></div>
 *      <div class="sk-bounce2"></div>
 *      <div class="sk-bounce3"></div>
 *    </div>
 *
 */
.sk-spinner-three-bounce.sk-spinner {
  margin: 0 auto;
  width: 70px;
  text-align: center;
}

.sk-spinner-three-bounce div {
  width: 18px;
  height: 18px;
  background-color: #1db5b6;
  border-radius: 100%;
  display: inline-block;
  animation: sk-threeBounceDelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  animation-fill-mode: both;
}

.sk-spinner-three-bounce .sk-bounce1 {
  animation-delay: -0.32s;
}

.sk-spinner-three-bounce .sk-bounce2 {
  animation-delay: -0.16s;
}
@keyframes sk-threeBounceDelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-circle">
 *      <div class="sk-circle1 sk-circle"></div>
 *      <div class="sk-circle2 sk-circle"></div>
 *      <div class="sk-circle3 sk-circle"></div>
 *      <div class="sk-circle4 sk-circle"></div>
 *      <div class="sk-circle5 sk-circle"></div>
 *      <div class="sk-circle6 sk-circle"></div>
 *      <div class="sk-circle7 sk-circle"></div>
 *      <div class="sk-circle8 sk-circle"></div>
 *      <div class="sk-circle9 sk-circle"></div>
 *      <div class="sk-circle10 sk-circle"></div>
 *      <div class="sk-circle11 sk-circle"></div>
 *      <div class="sk-circle12 sk-circle"></div>
 *    </div>
 *
 */
.sk-spinner-circle.sk-spinner {
  margin: 0 auto;
  width: 22px;
  height: 22px;
  position: relative;
}

.sk-spinner-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sk-spinner-circle .sk-circle:before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 20%;
  height: 20%;
  background-color: #1db5b6;
  border-radius: 100%;
  animation: sk-circleBounceDelay 1.2s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  animation-fill-mode: both;
}

.sk-spinner-circle .sk-circle2 {
  transform: rotate(30deg);
}

.sk-spinner-circle .sk-circle3 {
  transform: rotate(60deg);
}

.sk-spinner-circle .sk-circle4 {
  transform: rotate(90deg);
}

.sk-spinner-circle .sk-circle5 {
  transform: rotate(120deg);
}

.sk-spinner-circle .sk-circle6 {
  transform: rotate(150deg);
}

.sk-spinner-circle .sk-circle7 {
  transform: rotate(180deg);
}

.sk-spinner-circle .sk-circle8 {
  transform: rotate(210deg);
}

.sk-spinner-circle .sk-circle9 {
  transform: rotate(240deg);
}

.sk-spinner-circle .sk-circle10 {
  transform: rotate(270deg);
}

.sk-spinner-circle .sk-circle11 {
  transform: rotate(300deg);
}

.sk-spinner-circle .sk-circle12 {
  transform: rotate(330deg);
}

.sk-spinner-circle .sk-circle2:before {
  animation-delay: -1.1s;
}

.sk-spinner-circle .sk-circle3:before {
  animation-delay: -1s;
}

.sk-spinner-circle .sk-circle4:before {
  animation-delay: -0.9s;
}

.sk-spinner-circle .sk-circle5:before {
  animation-delay: -0.8s;
}

.sk-spinner-circle .sk-circle6:before {
  animation-delay: -0.7s;
}

.sk-spinner-circle .sk-circle7:before {
  animation-delay: -0.6s;
}

.sk-spinner-circle .sk-circle8:before {
  animation-delay: -0.5s;
}

.sk-spinner-circle .sk-circle9:before {
  animation-delay: -0.4s;
}

.sk-spinner-circle .sk-circle10:before {
  animation-delay: -0.3s;
}

.sk-spinner-circle .sk-circle11:before {
  animation-delay: -0.2s;
}

.sk-spinner-circle .sk-circle12:before {
  animation-delay: -0.1s;
}
@keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-cube-grid">
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *      <div class="sk-cube"></div>
 *    </div>
 *
 */
.sk-spinner-cube-grid {
  /*
   * Spinner positions
   * 1 2 3
   * 4 5 6
   * 7 8 9
   */
}

.sk-spinner-cube-grid.sk-spinner {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.sk-spinner-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: #1db5b6;
  float: left;
  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}

.sk-spinner-cube-grid .sk-cube:nth-child(1) {
  animation-delay: 0.2s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(2) {
  animation-delay: 0.3s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(3) {
  animation-delay: 0.4s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(4) {
  animation-delay: 0.1s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(5) {
  animation-delay: 0.2s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(6) {
  animation-delay: 0.3s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(7) {
  animation-delay: 0s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(8) {
  animation-delay: 0.1s;
}

.sk-spinner-cube-grid .sk-cube:nth-child(9) {
  animation-delay: 0.2s;
}
@keyframes sk-cubeGridScaleDelay {
  0%, 70%, 100% {
    transform: scale3D(1, 1, 1);
  }
  35% {
    transform: scale3D(0, 0, 1);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-wordpress">
 *      <span class="sk-inner-circle"></span>
 *    </div>
 *
 */
.sk-spinner-wordpress.sk-spinner {
  background-color: #1db5b6;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  position: relative;
  margin: 0 auto;
  animation: sk-innerCircle 1s linear infinite;
}

.sk-spinner-wordpress .sk-inner-circle {
  display: block;
  background-color: #fff;
  width: 8px;
  height: 8px;
  position: absolute;
  border-radius: 8px;
  top: 5px;
  left: 5px;
}
@keyframes sk-innerCircle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*
 *  Usage:
 *
 *    <div class="sk-spinner sk-spinner-fading-circle">
 *      <div class="sk-circle1 sk-circle"></div>
 *      <div class="sk-circle2 sk-circle"></div>
 *      <div class="sk-circle3 sk-circle"></div>
 *      <div class="sk-circle4 sk-circle"></div>
 *      <div class="sk-circle5 sk-circle"></div>
 *      <div class="sk-circle6 sk-circle"></div>
 *      <div class="sk-circle7 sk-circle"></div>
 *      <div class="sk-circle8 sk-circle"></div>
 *      <div class="sk-circle9 sk-circle"></div>
 *      <div class="sk-circle10 sk-circle"></div>
 *      <div class="sk-circle11 sk-circle"></div>
 *      <div class="sk-circle12 sk-circle"></div>
 *    </div>
 *
 */
.sk-spinner-fading-circle.sk-spinner {
  margin: 0 auto;
  width: 22px;
  height: 22px;
  position: relative;
}

.sk-spinner-fading-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sk-spinner-fading-circle .sk-circle:before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 18%;
  height: 18%;
  background-color: #1db5b6;
  border-radius: 100%;
  animation: sk-circleFadeDelay 1.2s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  animation-fill-mode: both;
}

.sk-spinner-fading-circle .sk-circle2 {
  transform: rotate(30deg);
}

.sk-spinner-fading-circle .sk-circle3 {
  transform: rotate(60deg);
}

.sk-spinner-fading-circle .sk-circle4 {
  transform: rotate(90deg);
}

.sk-spinner-fading-circle .sk-circle5 {
  transform: rotate(120deg);
}

.sk-spinner-fading-circle .sk-circle6 {
  transform: rotate(150deg);
}

.sk-spinner-fading-circle .sk-circle7 {
  transform: rotate(180deg);
}

.sk-spinner-fading-circle .sk-circle8 {
  transform: rotate(210deg);
}

.sk-spinner-fading-circle .sk-circle9 {
  transform: rotate(240deg);
}

.sk-spinner-fading-circle .sk-circle10 {
  transform: rotate(270deg);
}

.sk-spinner-fading-circle .sk-circle11 {
  transform: rotate(300deg);
}

.sk-spinner-fading-circle .sk-circle12 {
  transform: rotate(330deg);
}

.sk-spinner-fading-circle .sk-circle2:before {
  animation-delay: -1.1s;
}

.sk-spinner-fading-circle .sk-circle3:before {
  animation-delay: -1s;
}

.sk-spinner-fading-circle .sk-circle4:before {
  animation-delay: -0.9s;
}

.sk-spinner-fading-circle .sk-circle5:before {
  animation-delay: -0.8s;
}

.sk-spinner-fading-circle .sk-circle6:before {
  animation-delay: -0.7s;
}

.sk-spinner-fading-circle .sk-circle7:before {
  animation-delay: -0.6s;
}

.sk-spinner-fading-circle .sk-circle8:before {
  animation-delay: -0.5s;
}

.sk-spinner-fading-circle .sk-circle9:before {
  animation-delay: -0.4s;
}

.sk-spinner-fading-circle .sk-circle10:before {
  animation-delay: -0.3s;
}

.sk-spinner-fading-circle .sk-circle11:before {
  animation-delay: -0.2s;
}

.sk-spinner-fading-circle .sk-circle12:before {
  animation-delay: -0.1s;
}
@keyframes sk-circleFadeDelay {
  0%, 39%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
.ibox-content > .sk-spinner {
  display: none;
}

.sk-loading {
  position: relative;
}

.sk-loading:after {
  content: "";
  background-color: rgba(255, 255, 255, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
}

.sk-loading > .sk-spinner {
  display: block;
  position: absolute;
  top: 40%;
  left: 0;
  right: 0;
  z-index: 2000;
}

/*
 *
 *   SKIN 1 - INSPINIA - Responsive Admin Theme
 *   NAME - Blue light
 *
*/
.skin-1 .minimalize-styl-2 {
  margin: 14px 5px 5px 30px;
}

.skin-1 .navbar-top-links li:last-child {
  margin-right: 30px;
}

.skin-1.fixed-nav .minimalize-styl-2 {
  margin: 14px 5px 5px 15px;
}

.skin-1 .spin-icon {
  background: #0e9aef !important;
}

.skin-1 .nav-header {
  background-color: #0e9aef;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.skin-1.mini-navbar .nav-second-level {
  background: #3e495f;
}

.skin-1 .breadcrumb {
  background: transparent;
}

.skin-1 .page-heading {
  border: none;
}

.skin-1 .nav > li.active {
  background: #3a4459;
}

.skin-1 .nav > li > a {
  color: #9ea6b9;
}

.skin-1 ul.nav-second-level {
  background-color: inherit;
}

.skin-1 .nav > li.active > a {
  color: #fff;
}

.skin-1 .navbar-minimalize {
  background: #0e9aef;
  border-color: #0e9aef;
}

body.skin-1 {
  background: #3e495f;
}

.skin-1 .navbar-static-top {
  background: #ffffff;
}

.skin-1 .dashboard-header {
  background: transparent;
  border-bottom: none !important;
  border-top: none;
  padding: 20px 30px 10px 30px;
}

.fixed-nav.skin-1 .navbar-fixed-top {
  background: #fff;
}

.skin-1 .wrapper-content {
  padding: 30px 15px;
}

.skin-1 #page-wrapper {
  background: #f4f6fa;
}

.skin-1 .ibox-title, .skin-1 .ibox-content {
  border-width: 1px;
}

.skin-1 .ibox-content:last-child {
  border-style: solid solid solid solid;
}

.skin-1 .nav > li.active {
  border: none;
}

.skin-1 .nav-header {
  padding: 35px 25px 25px 25px;
}

.skin-1 .nav-header a.dropdown-toggle {
  color: #fff;
  margin-top: 10px;
}

.skin-1 .nav-header a.dropdown-toggle .text-muted {
  color: #fff;
  opacity: 0.8;
}

.skin-1 .profile-element {
  text-align: center;
}

.skin-1 .rounded-circle {
  border-radius: 5px;
}

.skin-1 .navbar-default .nav > li > a:hover, .skin-1 .navbar-default .nav > li > a:focus {
  background: #3a4459;
  color: #fff;
}

.skin-1 .nav.nav-tabs > li.active > a {
  color: #555;
}

.skin-1 .nav.nav-tabs > li.active {
  background: transparent;
}

/*
 *
 *   SKIN 2 - INSPINIA - Responsive Admin Theme
 *   NAME - Inspinia Ultra
 *
*/
body.skin-2 {
  color: #565758 !important;
}

.skin-2 .minimalize-styl-2 {
  margin: 14px 5px 5px 25px;
}

.skin-2 .navbar-top-links li:last-child {
  margin-right: 30px;
}

.skin-2 .spin-icon {
  background: #23c6c8 !important;
}

.skin-2 .nav-header {
  background-color: #23c6c8;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.skin-2.mini-navbar .nav-second-level {
  background: #ededed;
}

.skin-2 .breadcrumb {
  background: transparent;
}

.skin-2.fixed-nav .minimalize-styl-2 {
  margin: 14px 5px 5px 15px;
}

.skin-2 .page-heading {
  border: none;
  background: rgba(255, 255, 255, 0.7);
}

.skin-2 ul.nav-second-level {
  background-color: inherit;
}

.skin-2 .nav > li.active {
  background: #e0e0e0;
}

.skin-2 .logo-element {
  padding: 17px 0;
}

.skin-2 .nav > li > a, .skin-2 .welcome-message {
  color: #edf6ff;
}

.skin-2 #top-search::-moz-placeholder {
  color: #edf6ff;
  opacity: 0.5;
}

.skin-2 #side-menu > li > a, .skin-2 .nav.nav-second-level > li > a {
  color: #586b7d;
}

.skin-2 .nav > li.active > a {
  color: #213a53;
}

.skin-2.mini-navbar .nav-header {
  background: #213a53;
}

.skin-2 .navbar-minimalize {
  background: #23c6c8;
  border-color: #23c6c8;
}

.skin-2 .border-bottom {
  border-bottom: none !important;
}

.skin-2 #top-search {
  color: #fff;
}

body.skin-2 #wrapper {
  background-color: #ededed;
}

.skin-2 .navbar-static-top {
  background: #213a53;
}

.fixed-nav.skin-2 .navbar-fixed-top {
  background: #213a53;
  border-bottom: none !important;
}

.skin-2 .nav-header {
  padding: 30px 25px 30px 25px;
}

.skin-2 .dashboard-header {
  background: rgba(255, 255, 255, 0.4);
  border-bottom: none !important;
  border-top: none;
  padding: 20px 30px 20px 30px;
}

.skin-2 .wrapper-content {
  padding: 30px 15px;
}

.skin-2 .dashoard-1 .wrapper-content {
  padding: 0 30px 25px 30px;
}

.skin-2 .ibox-title {
  background: rgba(255, 255, 255, 0.7);
  border: none;
  margin-bottom: 1px;
}

.skin-2 .ibox-content {
  background: rgba(255, 255, 255, 0.4);
  border: none !important;
}

.skin-2 #page-wrapper {
  background: #f6f6f6;
  background: radial-gradient(ellipse at center, #f6f6f6 20%, #d5d5d5 100%);
  -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#f6f6f6, endColorstr=#d5d5d5)";
}

.skin-2 .ibox-title, .skin-2 .ibox-content {
  border-width: 1px;
}

.skin-2 .ibox-content:last-child {
  border-style: solid solid solid solid;
}

.skin-2 .nav > li.active {
  border: none;
}

.skin-2 .nav-header a.dropdown-toggle {
  color: #edf6ff;
  margin-top: 10px;
}

.skin-2 .nav-header a.dropdown-toggle .text-muted {
  color: #edf6ff;
  opacity: 0.8;
}

.skin-2 .rounded-circle {
  border-radius: 10px;
}

.skin-2 .nav.navbar-top-links > li > a:hover, .skin-2 .nav.navbar-top-links > li > a:focus {
  background: #1a2d41;
}

.skin-2 .navbar-default .nav > li > a:hover, .skin-2 .navbar-default .nav > li > a:focus {
  background: #e0e0e0;
  color: #213a53;
}

.skin-2 .nav.nav-tabs > li.active > a {
  color: #555;
}

.skin-2 .nav.nav-tabs > li.active {
  background: transparent;
}

/*
 *
 *   SKIN 3 - INSPINIA - Responsive Admin Theme
 *   NAME - Yellow/purple
 *
*/
.skin-3 .minimalize-styl-2 {
  margin: 14px 5px 5px 30px;
}

.skin-3 .navbar-top-links li:last-child {
  margin-right: 30px;
}

.skin-3.fixed-nav .minimalize-styl-2 {
  margin: 14px 5px 5px 15px;
}

.skin-3 .spin-icon {
  background: #ecba52 !important;
}

body.boxed-layout.skin-3 #wrapper {
  background: #3e2c42;
}

.skin-3 .nav-header {
  background-color: #ecba52;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.skin-3.mini-navbar .nav-second-level {
  background: #3e2c42;
}

.skin-3 .breadcrumb {
  background: transparent;
}

.skin-3 .page-heading {
  border: none;
}

.skin-3 ul.nav-second-level {
  background-color: inherit;
}

.skin-3 .nav > li.active {
  background: #38283c;
}

.fixed-nav.skin-3 .navbar-fixed-top {
  background: #fff;
}

.skin-3 .nav > li > a {
  color: #948b96;
}

.skin-3 .nav > li.active > a {
  color: #fff;
}

.skin-3 .navbar-minimalize {
  background: #ecba52;
  border-color: #ecba52;
}

body.skin-3 {
  background: #3e2c42;
}

.skin-3 .navbar-static-top {
  background: #ffffff;
}

.skin-3 .dashboard-header {
  background: transparent;
  border-bottom: none !important;
  border-top: none;
  padding: 20px 30px 10px 30px;
}

.skin-3 .wrapper-content {
  padding: 30px 15px;
}

.skin-3 #page-wrapper {
  background: #f4f6fa;
}

.skin-3 .ibox-title, .skin-3 .ibox-content {
  border-width: 1px;
}

.skin-3 .ibox-content:last-child {
  border-style: solid solid solid solid;
}

.skin-3 .nav > li.active {
  border: none;
}

.skin-3 .nav-header {
  padding: 35px 25px 25px 25px;
}

.skin-3 .nav-header a.dropdown-toggle {
  color: #fff;
  margin-top: 10px;
}

.skin-3 .nav-header a.dropdown-toggle .text-muted {
  color: #fff;
  opacity: 0.8;
}

.skin-3 .profile-element {
  text-align: center;
}

.skin-3 .rounded-circle {
  border-radius: 5px;
}

.skin-3 .navbar-default .nav > li > a:hover, .skin-3 .navbar-default .nav > li > a:focus {
  background: #38283c;
  color: #fff;
}

.skin-3 .nav.nav-tabs > li.active > a {
  color: #555;
}

.skin-3 .nav.nav-tabs > li.active {
  background: transparent;
}

/*
 *
 *   SKIN 4 - INSPINIA - Responsive Admin Theme
 *   NAME - Light-Skin
 *
*/
body.light-skin {
  background-color: #f9f9f9;
  color: #3e5476;
}

.light-skin .select2-container--default .select2-selection--single, .light-skin .select2-container--default .select2-selection--multiple, .light-skin .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 2.05rem;
}
.light-skin .select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 32px;
}
.light-skin .navbar-fixed-top, .light-skin .navbar-static-top {
  background-color: transparent;
}
.light-skin .dashboards\\.dashboard_2 nav.navbar,
.light-skin .dashboards\\.dashboard_3 nav.navbar,
.light-skin .mailbox\\.inbox nav.navbar,
.light-skin .mailbox\\.email_view nav.navbar,
.light-skin .mailbox\\.email_compose nav.navbar,
.light-skin .dashboards\\.dashboard_4_1 nav.navbar,
.light-skin .metrics nav.navbar, .light-skin .metrics\\.index nav.navbar,
.light-skin .dashboards\\.dashboard_5 nav.navbar {
  background: transparent;
}
.light-skin.fixed-nav .navbar-fixed-top {
  background-color: #FFFFFF;
}
.light-skin.mini-navbar .nav .nav-second-level {
  background-color: #f9f9f9;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}
.light-skin.fixed-sidebar.mini-navbar .nav .nav-second-level, .light-skin.canvas-menu.mini-navbar .nav .nav-second-level {
  box-shadow: none;
}
.light-skin.canvas-menu nav.navbar-static-side {
  background-color: #f9f9f9;
}
.light-skin.canvas-menu.mini-navbar nav.navbar-static-side {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}
.light-skin.mini-navbar .nav-header {
  background-color: #f9f9f9;
}
.light-skin #page-wrapper.gray-bg, .light-skin #page-wrapper.bg-muted {
  background-color: #f9f9f9;
}
.light-skin .logo-element {
  color: #7c899a;
}
.light-skin nav > .sidebar-collapse > ul > li a {
  color: #7c899a;
  padding-top: 9px;
  padding-bottom: 9px;
}
.light-skin nav > .sidebar-collapse .nav-second-level li a {
  padding-top: 7px;
  padding-bottom: 7px;
}
.light-skin .nav > li.active > a {
  color: #384D6C;
  font-weight: 700;
}
.light-skin .nav-header a {
  color: #384D6C;
}
.light-skin .navbar-default .nav > li > a:hover, .light-skin .navbar-default .nav > li > a:focus {
  background-color: inherit;
  color: #384D6C;
  font-weight: 700;
}
.light-skin .nav-header .font-bold {
  font-size: 12px;
  font-weight: 700;
  color: #384D6C;
}
.light-skin .nav-header .text-muted {
  color: #8291a3 !important;
  font-size: 12px;
}
.light-skin .nav-header {
  background-color: #f9f9f9;
  background-image: none;
  padding: 20px 25px 20px 25px;
}
.light-skin .profile-element img {
  border-radius: 6px !important;
}
.light-skin .nav > li.active {
  background: #f9f9f9;
}
.light-skin ul.nav-second-level {
  background: #f9f9f9;
}
.light-skin .dashboard-header {
  border-bottom: none !important;
  border-top: 0;
  border-radius: 4px;
  padding: 20px 20px 20px 20px;
  margin: 10px 10px 0 10px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}
.light-skin .page-heading {
  padding-bottom: 10px;
}
.light-skin .ibox-title {
  background-color: transparent;
  border: none;
  padding-left: 5px;
}
.light-skin .ibox-title h5 {
  font-size: 12px;
}
.light-skin .ibox-tools {
  right: 5px;
}
.light-skin .ibox-tools a {
  color: #7c899a !important;
}
.light-skin .ibox-heading {
  background-color: #fff;
  margin-bottom: 20px;
}
.light-skin .ibox-content {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: none;
  background-color: #FFFFFF;
}
.light-skin .breadcrumb {
  background-color: transparent;
}
.light-skin .minimalize-styl-2 {
  margin: 14px 5px 5px 30px;
}
.light-skin .footer {
  border: none;
  background: none;
}
.light-skin .sidebar-panel {
  background-color: #fff;
}
.light-skin #page-wrapper > .border-bottom, .light-skin .ibox.border-bottom {
  border-bottom: transparent !important;
}
.light-skin .fh-breadcrumb {
  height: calc(100% - 176px);
}
.light-skin.top-navigation #page-wrapper > .border-bottom {
  border-bottom: 1px solid #e7eaec !important;
}
.light-skin .wrapper.white-bg {
  background-color: transparent;
}
.light-skin .ibox-tools a.btn-primary {
  color: #FFFFFF !important;
}
.light-skin .chat-discussion {
  background-color: #FFFFFF;
}
.light-skin .ibox-footer {
  margin-top: 4px;
  border: none;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.light-skin .contact-box, .light-skin .social-feed-box, .light-skin .vertical-timeline-content {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  border: none;
}
.light-skin .navbar-default .landing_link a,
.light-skin .navbar-default .special_link a {
  color: #FFFFFF;
}

@media (min-width: 768px) {
  #page-wrapper {
    position: inherit;
    min-height: 100vh;
  }

  .navbar-static-side {
    z-index: 1000;
    max-width: 220px;
  }

  .navbar-top-links .dropdown-messages,
.navbar-top-links .dropdown-tasks,
.navbar-top-links .dropdown-alerts {
    margin-left: auto;
  }
}
@media (max-width: 768px) {
  #page-wrapper {
    position: inherit;
    margin: 0 0 0 0;
    min-height: 100vh;
    width: 100%;
  }

  .body-small .navbar-static-side {
    display: block;
    z-index: 2001;
    width: 0;
    overflow: hidden;
  }

  .body-small.mini-navbar .navbar-static-side {
    display: block;
    overflow: visible;
  }

  .lock-word {
    display: none;
  }

  .navbar-form-custom {
    display: none;
  }

  .navbar-header {
    display: inline;
    float: left;
  }

  .sidebar-panel {
    z-index: 2;
    position: relative;
    width: auto;
    min-height: 100% !important;
  }

  .sidebar-content .wrapper {
    padding-right: 0;
    z-index: 1;
  }

  .fixed-sidebar.body-small .navbar-static-side {
    display: none;
    z-index: 2001;
    position: fixed;
    width: 220px;
  }

  .fixed-sidebar.body-small.mini-navbar .navbar-static-side {
    display: block;
  }

  .ibox-tools {
    float: none;
    text-align: right;
    display: block;
  }

  .navbar-static-side {
    display: none;
  }

  body:not(.mini-navbar) {
    transition: background-color 500ms linear;
    background-color: #f3f3f4;
  }
}
@media (max-width: 350px) {
  .timeline-item .date {
    text-align: left;
    width: 110px;
    position: relative;
    padding-top: 30px;
  }

  .timeline-item .date i {
    position: absolute;
    top: 0;
    left: 15px;
    padding: 5px;
    width: 30px;
    text-align: center;
    border: 1px solid #e7eaec;
    background: #f8f8f8;
  }

  .timeline-item .content {
    border-left: none;
    border-top: 1px solid #e7eaec;
    padding-top: 10px;
    min-height: 100px;
  }

  .nav.navbar-top-links li.dropdown {
    display: none;
  }

  .ibox-tools {
    float: none;
    text-align: left;
    display: inline-block;
  }
}
@media print {
  nav.navbar-static-side {
    display: none;
  }

  body {
    overflow: visible !important;
  }

  #page-wrapper {
    margin: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/vendor/inspinia/style.scss","webpack://./src/styles/vendor/inspinia/base/typography.scss","webpack://./src/styles/vendor/inspinia/base/glyphicons.scss","webpack://./src/styles/vendor/inspinia/base/navigation.scss","webpack://./src/styles/vendor/inspinia/base/variables.scss","webpack://./src/styles/vendor/inspinia/base/top_navigation.scss","webpack://./src/styles/vendor/inspinia/base/buttons.scss","webpack://./src/styles/vendor/inspinia/base/badges_labels.scss","webpack://./src/styles/vendor/inspinia/base/elements.scss","webpack://./src/styles/vendor/inspinia/base/sidebar.scss","webpack://./src/styles/vendor/inspinia/base/base.scss","webpack://./src/styles/vendor/inspinia/base/chat.scss","webpack://./src/styles/vendor/inspinia/base/metismenu.scss","webpack://./src/styles/vendor/inspinia/base/spinners.scss","webpack://./src/styles/vendor/inspinia/base/skins.scss","webpack://./src/styles/vendor/inspinia/base/media.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;CAAA;ACAA;EACE,gBAAA;ADUF;;ACPA;EACE,gBAAA;EACA,mBAAA;ADUF;;ACPA;EACE,eAAA;ADUF;;ACPA;EACE,eAAA;ADUF;;ACPA;EACE,eAAA;ADUF;;ACPA;EACE,eAAA;ADUF;;ACPA;EACE,eAAA;ADUF;;ACPA;EACE,eAAA;ADUF;;ACPA;EACE,eAAA;EACA,gBAAA;ADUF;;AEpCA;EACE,mCAAA;EACA,4CAAA;EACA,4SAAA;AFuCF;AE/BA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AFiCF;;AE5BE;EACE,YAAA;AF+BJ;;AE1BE;EACE,YAAA;AF6BJ;;AEvBE;;EACE,YAAA;AF2BJ;;AEtBE;EACE,YAAA;AFyBJ;;AEpBE;EACE,YAAA;AFuBJ;;AElBE;EACE,YAAA;AFqBJ;;AEhBE;EACE,YAAA;AFmBJ;;AEdE;EACE,YAAA;AFiBJ;;AEZE;EACE,YAAA;AFeJ;;AEVE;EACE,YAAA;AFaJ;;AERE;EACE,YAAA;AFWJ;;AENE;EACE,YAAA;AFSJ;;AEJE;EACE,YAAA;AFOJ;;AEFE;EACE,YAAA;AFKJ;;AEAE;EACE,YAAA;AFGJ;;AEEE;EACE,YAAA;AFCJ;;AEIE;EACE,YAAA;AFDJ;;AEME;EACE,YAAA;AFHJ;;AEQE;EACE,YAAA;AFLJ;;AEUE;EACE,YAAA;AFPJ;;AEYE;EACE,YAAA;AFTJ;;AEcE;EACE,YAAA;AFXJ;;AEgBE;EACE,YAAA;AFbJ;;AEkBE;EACE,YAAA;AFfJ;;AEoBE;EACE,YAAA;AFjBJ;;AEsBE;EACE,YAAA;AFnBJ;;AEwBE;EACE,YAAA;AFrBJ;;AE0BE;EACE,YAAA;AFvBJ;;AE4BE;EACE,YAAA;AFzBJ;;AE8BE;EACE,YAAA;AF3BJ;;AEgCE;EACE,YAAA;AF7BJ;;AEkCE;EACE,YAAA;AF/BJ;;AEoCE;EACE,YAAA;AFjCJ;;AEsCE;EACE,YAAA;AFnCJ;;AEwCE;EACE,YAAA;AFrCJ;;AE0CE;EACE,YAAA;AFvCJ;;AE4CE;EACE,YAAA;AFzCJ;;AE8CE;EACE,YAAA;AF3CJ;;AEgDE;EACE,YAAA;AF7CJ;;AEkDE;EACE,YAAA;AF/CJ;;AEoDE;EACE,YAAA;AFjDJ;;AEsDE;EACE,YAAA;AFnDJ;;AEwDE;EACE,YAAA;AFrDJ;;AE0DE;EACE,YAAA;AFvDJ;;AE4DE;EACE,YAAA;AFzDJ;;AE8DE;EACE,YAAA;AF3DJ;;AEgEE;EACE,YAAA;AF7DJ;;AEkEE;EACE,YAAA;AF/DJ;;AEoEE;EACE,YAAA;AFjEJ;;AEsEE;EACE,YAAA;AFnEJ;;AEwEE;EACE,YAAA;AFrEJ;;AE0EE;EACE,YAAA;AFvEJ;;AE4EE;EACE,YAAA;AFzEJ;;AE8EE;EACE,YAAA;AF3EJ;;AEgFE;EACE,YAAA;AF7EJ;;AEkFE;EACE,YAAA;AF/EJ;;AEoFE;EACE,YAAA;AFjFJ;;AEsFE;EACE,YAAA;AFnFJ;;AEwFE;EACE,YAAA;AFrFJ;;AE0FE;EACE,YAAA;AFvFJ;;AE4FE;EACE,YAAA;AFzFJ;;AE8FE;EACE,YAAA;AF3FJ;;AEgGE;EACE,YAAA;AF7FJ;;AEkGE;EACE,YAAA;AF/FJ;;AEoGE;EACE,YAAA;AFjGJ;;AEsGE;EACE,YAAA;AFnGJ;;AEwGE;EACE,YAAA;AFrGJ;;AE0GE;EACE,YAAA;AFvGJ;;AE4GE;EACE,YAAA;AFzGJ;;AE8GE;EACE,YAAA;AF3GJ;;AEgHE;EACE,YAAA;AF7GJ;;AEkHE;EACE,YAAA;AF/GJ;;AEoHE;EACE,YAAA;AFjHJ;;AEsHE;EACE,YAAA;AFnHJ;;AEwHE;EACE,YAAA;AFrHJ;;AE0HE;EACE,YAAA;AFvHJ;;AE4HE;EACE,YAAA;AFzHJ;;AE8HE;EACE,YAAA;AF3HJ;;AEgIE;EACE,YAAA;AF7HJ;;AEkIE;EACE,YAAA;AF/HJ;;AEoIE;EACE,YAAA;AFjIJ;;AEsIE;EACE,YAAA;AFnIJ;;AEwIE;EACE,YAAA;AFrIJ;;AE0IE;EACE,YAAA;AFvIJ;;AE4IE;EACE,YAAA;AFzIJ;;AE8IE;EACE,YAAA;AF3IJ;;AEgJE;EACE,YAAA;AF7IJ;;AEkJE;EACE,YAAA;AF/IJ;;AEoJE;EACE,YAAA;AFjJJ;;AEsJE;EACE,YAAA;AFnJJ;;AEwJE;EACE,YAAA;AFrJJ;;AE0JE;EACE,YAAA;AFvJJ;;AE4JE;EACE,YAAA;AFzJJ;;AE8JE;EACE,YAAA;AF3JJ;;AEgKE;EACE,YAAA;AF7JJ;;AEkKE;EACE,YAAA;AF/JJ;;AEoKE;EACE,YAAA;AFjKJ;;AEsKE;EACE,YAAA;AFnKJ;;AEwKE;EACE,YAAA;AFrKJ;;AE0KE;EACE,YAAA;AFvKJ;;AE4KE;EACE,YAAA;AFzKJ;;AE8KE;EACE,YAAA;AF3KJ;;AEgLE;EACE,YAAA;AF7KJ;;AEkLE;EACE,YAAA;AF/KJ;;AEoLE;EACE,YAAA;AFjLJ;;AEsLE;EACE,YAAA;AFnLJ;;AEwLE;EACE,YAAA;AFrLJ;;AE0LE;EACE,YAAA;AFvLJ;;AE4LE;EACE,YAAA;AFzLJ;;AE8LE;EACE,YAAA;AF3LJ;;AEgME;EACE,YAAA;AF7LJ;;AEkME;EACE,YAAA;AF/LJ;;AEoME;EACE,YAAA;AFjMJ;;AEsME;EACE,YAAA;AFnMJ;;AEwME;EACE,YAAA;AFrMJ;;AE0ME;EACE,YAAA;AFvMJ;;AE4ME;EACE,YAAA;AFzMJ;;AE8ME;EACE,YAAA;AF3MJ;;AEgNE;EACE,YAAA;AF7MJ;;AEkNE;EACE,YAAA;AF/MJ;;AEoNE;EACE,YAAA;AFjNJ;;AEsNE;EACE,YAAA;AFnNJ;;AEwNE;EACE,YAAA;AFrNJ;;AE0NE;EACE,YAAA;AFvNJ;;AE4NE;EACE,YAAA;AFzNJ;;AE8NE;EACE,YAAA;AF3NJ;;AEgOE;EACE,YAAA;AF7NJ;;AEkOE;EACE,YAAA;AF/NJ;;AEoOE;EACE,YAAA;AFjOJ;;AEsOE;EACE,YAAA;AFnOJ;;AEwOE;EACE,YAAA;AFrOJ;;AE0OE;EACE,YAAA;AFvOJ;;AE4OE;EACE,YAAA;AFzOJ;;AE8OE;EACE,YAAA;AF3OJ;;AEgPE;EACE,YAAA;AF7OJ;;AEkPE;EACE,YAAA;AF/OJ;;AEoPE;EACE,YAAA;AFjPJ;;AEsPE;EACE,YAAA;AFnPJ;;AEwPE;EACE,YAAA;AFrPJ;;AE0PE;EACE,YAAA;AFvPJ;;AE4PE;EACE,YAAA;AFzPJ;;AE8PE;EACE,YAAA;AF3PJ;;AEgQE;EACE,YAAA;AF7PJ;;AEkQE;EACE,YAAA;AF/PJ;;AEoQE;EACE,YAAA;AFjQJ;;AEsQE;EACE,YAAA;AFnQJ;;AEwQE;EACE,YAAA;AFrQJ;;AE0QE;EACE,YAAA;AFvQJ;;AE4QE;EACE,YAAA;AFzQJ;;AE8QE;EACE,YAAA;AF3QJ;;AEgRE;EACE,YAAA;AF7QJ;;AEkRE;EACE,YAAA;AF/QJ;;AEoRE;EACE,YAAA;AFjRJ;;AEsRE;EACE,YAAA;AFnRJ;;AEwRE;EACE,YAAA;AFrRJ;;AE0RE;EACE,YAAA;AFvRJ;;AE4RE;EACE,YAAA;AFzRJ;;AE8RE;EACE,YAAA;AF3RJ;;AEgSE;EACE,YAAA;AF7RJ;;AEkSE;EACE,YAAA;AF/RJ;;AEoSE;EACE,YAAA;AFjSJ;;AEsSE;EACE,YAAA;AFnSJ;;AEwSE;EACE,YAAA;AFrSJ;;AE0SE;EACE,YAAA;AFvSJ;;AE4SE;EACE,YAAA;AFzSJ;;AE8SE;EACE,YAAA;AF3SJ;;AEgTE;EACE,YAAA;AF7SJ;;AEkTE;EACE,YAAA;AF/SJ;;AEoTE;EACE,YAAA;AFjTJ;;AEsTE;EACE,YAAA;AFnTJ;;AEwTE;EACE,YAAA;AFrTJ;;AE0TE;EACE,YAAA;AFvTJ;;AE4TE;EACE,YAAA;AFzTJ;;AE8TE;EACE,YAAA;AF3TJ;;AEgUE;EACE,YAAA;AF7TJ;;AEkUE;EACE,YAAA;AF/TJ;;AEoUE;EACE,YAAA;AFjUJ;;AEsUE;EACE,YAAA;AFnUJ;;AEwUE;EACE,YAAA;AFrUJ;;AE0UE;EACE,YAAA;AFvUJ;;AE4UE;EACE,YAAA;AFzUJ;;AE8UE;EACE,YAAA;AF3UJ;;AEgVE;EACE,YAAA;AF7UJ;;AEkVE;EACE,YAAA;AF/UJ;;AEoVE;EACE,YAAA;AFjVJ;;AEsVE;EACE,YAAA;AFnVJ;;AEwVE;EACE,YAAA;AFrVJ;;AE0VE;EACE,YAAA;AFvVJ;;AE4VE;EACE,YAAA;AFzVJ;;AE8VE;EACE,YAAA;AF3VJ;;AEgWE;EACE,YAAA;AF7VJ;;AEkWE;EACE,YAAA;AF/VJ;;AEoWE;EACE,YAAA;AFjWJ;;AEsWE;EACE,YAAA;AFnWJ;;AEwWE;EACE,YAAA;AFrWJ;;AE0WE;EACE,YAAA;AFvWJ;;AE4WE;EACE,YAAA;AFzWJ;;AE8WE;EACE,YAAA;AF3WJ;;AEgXE;EACE,YAAA;AF7WJ;;AEkXE;EACE,YAAA;AF/WJ;;AEoXE;EACE,YAAA;AFjXJ;;AEsXE;EACE,YAAA;AFnXJ;;AEwXE;EACE,YAAA;AFrXJ;;AE0XE;EACE,YAAA;AFvXJ;;AE4XE;EACE,YAAA;AFzXJ;;AE8XE;EACE,YAAA;AF3XJ;;AEwYE;EACE,YAAA;AFrYJ;;AE0YE;EACE,YAAA;AFvYJ;;AE4YE;EACE,YAAA;AFzYJ;;AE8YE;EACE,YAAA;AF3YJ;;AEgZE;EACE,YAAA;AF7YJ;;AEkZE;EACE,YAAA;AF/YJ;;AEoZE;EACE,YAAA;AFjZJ;;AEsZE;EACE,YAAA;AFnZJ;;AEwZE;EACE,YAAA;AFrZJ;;AE0ZE;EACE,YAAA;AFvZJ;;AE4ZE;EACE,YAAA;AFzZJ;;AE8ZE;EACE,YAAA;AF3ZJ;;AEgaE;EACE,YAAA;AF7ZJ;;AEkaE;EACE,YAAA;AF/ZJ;;AEoaE;EACE,YAAA;AFjaJ;;AEsaE;EACE,YAAA;AFnaJ;;AEwaE;EACE,YAAA;AFraJ;;AE0aE;EACE,YAAA;AFvaJ;;AE4aE;EACE,YAAA;AFzaJ;;AE8aE;EACE,YAAA;AF3aJ;;AEgbE;EACE,YAAA;AF7aJ;;AEkbE;EACE,YAAA;AF/aJ;;AEobE;EACE,YAAA;AFjbJ;;AEsbE;EACE,YAAA;AFnbJ;;AEwbE;EACE,YAAA;AFrbJ;;AE0bE;EACE,YAAA;AFvbJ;;AE4bE;EACE,YAAA;AFzbJ;;AE8bE;EACE,YAAA;AF3bJ;;AEgcE;EACE,YAAA;AF7bJ;;AEkcE;EACE,YAAA;AF/bJ;;AEocE;EACE,YAAA;AFjcJ;;AEscE;EACE,YAAA;AFncJ;;AEwcE;EACE,YAAA;AFrcJ;;AE0cE;EACE,YAAA;AFvcJ;;AE4cE;EACE,YAAA;AFzcJ;;AE8cE;EACE,YAAA;AF3cJ;;AEgdE;EACE,YAAA;AF7cJ;;AEkdE;EACE,YAAA;AF/cJ;;AEodE;EACE,YAAA;AFjdJ;;AEsdE;EACE,YAAA;AFndJ;;AEwdE;EACE,YAAA;AFrdJ;;AE0dE;EACE,YAAA;AFvdJ;;AE4dE;EACE,YAAA;AFzdJ;;AE8dE;EACE,YAAA;AF3dJ;;AEgeE;EACE,YAAA;AF7dJ;;AEkeE;EACE,YAAA;AF/dJ;;AEoeE;EACE,YAAA;AFjeJ;;AEseE;EACE,YAAA;AFneJ;;AEweE;EACE,YAAA;AFreJ;;AE0eE;EACE,YAAA;AFveJ;;AE4eE;EACE,YAAA;AFzeJ;;AE8eE;EACE,YAAA;AF3eJ;;AEgfE;EACE,YAAA;AF7eJ;;AEkfE;EACE,YAAA;AF/eJ;;AEofE;EACE,YAAA;AFjfJ;;AEsfE;EACE,YAAA;AFnfJ;;AGvlCA;EACE,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;AH0lCF;AGzlCE;EACE,qBAAA;AH2lCJ;;AGvlCA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;AH0lCF;;AGvlCA;EACE,iBAAA;EACA,cAAA;AH0lCF;;AGvlCA;EACE,cAAA;AH0lCF;;AGvlCA;EACE,cAAA;AH0lCF;;AGvlCA;EACE,cAAA;AH0lCF;;AGvlCA;EACE,gBAAA;AH0lCF;;AGvlCA;EACE,6BAAA;AH0lCF;;AGvlCA;EACE,iBAAA;AH0lCF;;AGvlCA;EACE,SAAA;AH0lCF;;AGvlCA;EACE,6BAAA;EACA,qBCbO;AJumCT;;AGvlCA;EACE,qBAAA;EACA,kBAAA;AH0lCF;;AGvlCA;EACE,eAAA;AH0lCF;;AGvlCA;EACE,kBAAA;EACA,gBAAA;AH0lCF;;AGvlCA;EACE,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,OAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;AH0lCF;;AGvlCA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AH0lCF;;AGvlCA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AH0lCF;;AGvlCA;;;EAGE,WAAA;EACA,qBAAA;EACA,yBCzGK;ED0GL,UAAA;AH0lCF;;AGvlCA;EACE,gBAAA;AH0lCF;;AGvlCA;EACE,cAAA;AH0lCF;;AGvlCA;EACE,eAAA;AH0lCF;;AGvlCA;EACE,iBAAA;EACA,aAAA;AH0lCF;;AGvlCA;EACE,mBAAA;AH0lCF;;AGvlCA;;;EAGE,YAAA;EACA,YAAA;AH0lCF;;AGvlCA;EACE,gBAAA;AH0lCF;;AGvlCA;EACE,kBAAA;AH0lCF;;AGvlCA;EACE,mBAAA;AH0lCF;;AGvlCA;EACE,QAAA;EACA,UAAA;AH0lCF;;AGvlCA;EACE,4BAAA;AH0lCF;;AGvlCA;EACE,eAAA;AH0lCF;;AGvlCA;EACE,eAAA;AH0lCF;;AGvlCA;EACE,eAAA;AH0lCF;;AGvlCA;EACE,kBAAA;EACA,yBCvIO;EDwIP,yDCvIoB;AJiuCtB;;AGtlCA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mCAAA;EACA,kCAAA;AHylCF;;AGtlCA;EACE,aAAA;AHylCF;;AGtlCA;EACE,oBAAA;AHylCF;;AGtlCA;EACE,mBAAA;AHylCF;;AGtlCA;EACE,8BAAA;EACA,mBAAA;AHylCF;;AGtlCA;EACE,YAAA;AHylCF;;AGtlCA;EACE,uBAAA;AHylCF;;AGtlCA;EACE,cAAA;AHylCF;;AGtlCA;EACE,yBAAA;AHylCF;;AGtlCA;EACE,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;AHylCF;;AGtlCA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AHylCF;;AGtlCA;EACE,gBAAA;AHylCF;;AGtlCA;EACE,eAAA;AHylCF;;AGtlCA;EACE,mDAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;AHylCF;;AGtlCA;EACE,aAAA;AHylCF;;AGtlCA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;AHylCF;;AGtlCA;EACE,QAAA;EACA,UAAA;AHylCF;;AGtlCA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AHylCF;;AGtlCA;EACE,YAAA;AHylCF;;AGtlCA;EACE,YAAA;AHylCF;;AGtlCA;EACE,YAAA;AHylCF;;AGtlCA;;EAEE,8BAAA;AHylCF;;AGtlCA;EACE,YAAA;AHylCF;;AGtlCA;EACE,0BAAA;EACA,kBAAA;AHylCF;;AGtlCA;EACE,gBCpRc;AJ62ChB;;AGtlCA;EACE,gBAAA;AHylCF;;AGtlCA;EACE,kBAAA;AHylCF;;AGtlCA;EACE,oBAAA;AHylCF;;AGtlCA;;EAEE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;AHylCF;;AGtlCA;EACE,eAAA;EACA,kBAAA;AHylCF;;AGtlCA;EACE,oBAAA;AHylCF;;AGtlCA;EACE,4BAAA;AHylCF;;AGtlCA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,yBClTO;EDmTP,4BAAA;EACA,eAAA;AHylCF;;AGtlCA;EACE,mBAAA;AHylCF;;AGtlCA;EACE,UAAA;AHylCF;;AGtlCA;EACE,mBCrWK;EDsWL,YAAA;AHylCF;;AGtlCA;EACE,8BAAA;EACA,YAAA;AHylCF;;AGtlCA;EACE,gBAAA;EACA,cChXK;AJy8CP;;AGtlCA;EACE,mBAAA;EACA,YAAA;AHylCF;;AGtlCA;EACE,8BAAA;EACA,YAAA;AHylCF;;AGtlCA;EACE,gBAAA;EACA,cAAA;AHylCF;;AGtlCA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AHylCF;;AGtlCA;EAAsB,oBAAA;AH0lCtB;;AGzlCA;EAAU,qBAAA;AH6lCV;;AG3lCA;EAIE,oBAAA;AH8lCF;;AG3lCA;EACE,gBAAA;EACA,yBAAA;EACA,2CAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,MAAA;AH8lCF;;AG3lCA;EAAsD,YAAA;AH+lCtD;;AG7lCA;EACE,mBC3ZK;AJ2/CP;;AG7lCA;EACE,aAAA;AHgmCF;;AG7lCA;EACE,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,gBAAA;EACA,8CAAA;EACA,sBCzaK;ED0aL,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AHgmCF;;AG7lCA;EACE,gBAAA;EACA,YAAA;AHgmCF;;AG7lCA;;EAEE,gBAAA;AHgmCF;;AG7lCA;EACE,aAAA;AHgmCF;;AG7lCA;EACE,WC9ac;AJ8gDhB;;AG7lCA;EACE,UAAA;AHgmCF;;AG7lCA;EACE,OAAA;AHgmCF;;AG7lCA;EACE,aAAA;AHgmCF;;AG7lCA;EACE,OAAA;AHgmCF;;AG7lCA;EACE,WClcc;AJkiDhB;;AG7lCA;EACE,yBAAA;AHgmCF;;AG7lCA;EACE,cAAA;AHgmCF;;AG7lCA;EACE,WAAA;AHgmCF;;AG7lCA;EACE,aAAA;AHgmCF;;AG7lCA;EACE,cAAA;AHgmCF;;AG7lCA;EACE,aAAA;AHgmCF;;AG7lCA;EACE,eAAA;AHgmCF;;AG7lCA;EACE,cAAA;AHgmCF;;AG7lCA;EACE,aAAA;AHgmCF;;AG7lCA;EACE,UAAA;EACA,yBCtgBK;AJsmDP;;AG7lCA;EACE,kBAAA;AHgmCF;;AG7lCA;EACE,WAAA;AHgmCF;;AG7lCA;EACE,wBAAA;AHgmCF;;AG5lCA;;EAEE,SAAA;EACA,WAAA;AH+lCF;;AG5lCA;;EAEE,YCngBc;EDogBd,aAAA;EACA,aAAA;EACA,eAAA;AH+lCF;;AG5lCA;EACE,QAAA;AH+lCF;;AG5lCA;EACE,mBAAA;AH+lCF;;AG5lCA;EACE,SAAA;AH+lCF;;AG5lCA;EACE,eAAA;EACA,WAAA;AH+lCF;;AG5lCA;EACE,mBAAA;AH+lCF;;AG5lCA;EACE,YC/hBc;AJ8nDhB;;AG5lCA;;EAEE,cAAA;EACA,YAAA;AH+lCF;;AG5lCA;EACE,eAAA;EACA,kBAAA;AH+lCF;;AG5lCA;EACE,eAAA;EACA,kBAAA;AH+lCF;;AG5lCA;;EAEE,4BAAA;AH+lCF;;AG5lCA;;EAEE,kBAAA;EACA,UAAA;EACA,eAAA;AH+lCF;;AG5lCA;;EAEE,OAAA;AH+lCF;;AG5lCA;;EAEE,eAAA;AH+lCF;;AG5lCA;;;;EAIE,eAAA;AH+lCF;;AG5lCA;EACE,cAAA;AH+lCF;;AG5lCA;;EAEE,0BAAA;AH+lCF;;AG5lCA;;EAEE,OAAA;AH+lCF;;AG5lCA;EACE,aAAA;EACA,mBCrlBO;EDslBP,YAAA;EACA,eAAA;EACA,aAAA;AH+lCF;;AG5lCA;EACE,cAAA;EACA,YCvmBc;AJssDhB;;AKluDA;EACE,WAAA;ALquDF;;AKluDA;EACE,iBAAA;EACA,cDLK;ECML,iBAAA;ALquDF;;AKluDA;EACE,gBAAA;ALquDF;;AKluDA;EACE,gBAAA;ALquDF;;AKluDA;EACE,kBAAA;EACA,cAAA;ALquDF;;AKluDA;EACE,gBAAA;EACA,cDxBK;AJ6vDP;;AKluDA;EACE,gBAAA;EACA,YAAA;ALquDF;;AKluDA;EACE,cDjCK;AJswDP;;AKluDA;EACE,kBAAA;ALquDF;;AKluDA;EACE,gBAAA;EACA,yBAAA;ALquDF;;AKluDA;EACE,SAAA;EACA,iBAAA;ALquDF;;AKluDA;EACE,aAAA;ALquDF;;AKluDA;EACE,mBDvDK;ECwDL,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;ALquDF;;AKjuDA;EACE,eAAA;ALouDF;;AKjuDA;;;;;EAKE,SAAA;EACA,WAAA;ALouDF;;AKjuDA;EACE,gBAAA;ALouDF;;AKjuDA;EACE,yBAAA;ALouDF;;AKjuDA;EACE,aAAA;ALouDF;;AKjuDA;EACE,sBAAA;ALouDF;;AKjuDA;EACE,yBD7FK;EC8FL,WAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;ALouDF;;AKjuDA;EACE,4BAAA;ALouDF;;AKjuDA;EACE;IACE,cAAA;IACA,WAAA;ELouDF;AACF;AKjuDA;EACE,wBAAA;ALmuDF;;AKhuDA;EACE;IACE,yBAAA;ELmuDF;AACF;AKhuDA;EACE;IACE,yBAAA;ELkuDF;AACF;AK/tDA;EACE;IACE,yBAAA;ELiuDF;;EK9tDA;IACE,yBAAA;ELiuDF;AACF;AMx2DA;EACE,qBAAA;AN02DF;;AMv2DA;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;AN02DF;;AMv2DA;EACE,sBAAA;AN02DF;;AMv2DA;EACE,qBAAA;EACA,aAAA;AN02DF;;AMv2DA;EACE,gBAAA;AN02DF;;AMv2DA;EACE,iBAAA;EACA,sBAAA;AN02DF;;AMv2DA;EACE,iBAAA;AN02DF;;AMv2DA;EACE,kBAAA;AN02DF;;AMv2DA;EACE,gBAAA;AN02DF;;AMv2DA;EACE,cF5CK;AJs5DP;;AMv2DA;EACE,cF9CK;AJw5DP;;AMv2DA;EACE,cFjDM;AJ25DR;;AMv2DA;EACE,cFpDO;AJ85DT;;AMv2DA;EACE,cFvDI;AJi6DN;;AMv2DA;;;;;EAKE,WAAA;AN02DF;;AMv2DA;EACE,sBAAA;EACA,UAAA;EAEA,gDAAA;AN02DF;;AMv2DA;EACE,yBF/EK;EEgFL,qBFhFK;AJ07DP;;AMv2DA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAGE,gDAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,yBF5GK;EE6GL,qBF7GK;AJu9DP;;AMv2DA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAGE,gDAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,yBF1IM;EE2IN,qBF3IM;AJq/DR;;AMv2DA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAGE,gDAAA;AN02DF;;AMv2DA;EACE,cAAA;EACA,iBAAA;EACA,yBAAA;AN02DF;;AMv2DA;EACE,cAAA;EACA,yBAAA;AN02DF;;AMv2DA;EACE,+CAAA;AN02DF;;AMv2DA;EACE,cAAA;AN02DF;;AMv2DA;EACE,cAAA;EACA,yBF3LO;EE4LP,qBF5LO;AJsiET;;AMv2DA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAGE,gDAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,yBFzNI;EE0NJ,qBF1NI;AJokEN;;AMv2DA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AN02DF;;AMv2DA;;EAGE,gDAAA;AN02DF;;AMv2DA;EACE,cAAA;AN02DF;;AMv2DA;EACE,cFhQK;EEiQL,qBAAA;AN02DF;;AMv2DA;EACE,sBAAA;EACA,gBAAA;AN02DF;;AMv2DA;EACE,cAAA;AN02DF;;AMv2DA;EACE,cAAA;EACA,iBAAA;EACA,yBAAA;AN02DF;;AMv2DA;EACE,cAAA;EACA,yBAAA;AN02DF;;AMv2DA;EACE,+CAAA;AN02DF;;AMv2DA;EACE,sBAAA;AN02DF;;AMv2DA;EACE,cAAA;AN02DF;;AMv2DA;EACE,gBAAA;AN02DF;;AMv2DA;EACE,cAAA;EACA,6BAAA;EACA,oBAAA;AN02DF;;AMv2DA;EACE,mBAAA;AN02DF;;AMv2DA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AN02DF;;AMv2DA;EACE,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AN02DF;;AMv2DA;EACE,QAAA;AN02DF;;AMv2DA;EACE,8EAAA;AN02DF;;AMv2DA;EACE,6EAAA;AN02DF;;AMv2DA;EACE,8EAAA;AN02DF;;AMv2DA;EACE,6EAAA;AN02DF;;AMv2DA;EACE,8EAAA;AN02DF;;AMv2DA;EACE,6EAAA;AN02DF;;AMv2DA;EACE,8EAAA;AN02DF;;AMv2DA;EACE,6EAAA;AN02DF;;AMv2DA;EACE,8EAAA;AN02DF;;AMv2DA;EACE,6EAAA;AN02DF;;AMv2DA;EACE,8EAAA;AN02DF;;AMv2DA;EACE,6EAAA;AN02DF;;AMv2DA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AN02DF;;AMt2DA;EACE,QAAA;EACA,eAAA;ANy2DF;;AMt2DA;EACE,wBAAA;ANy2DF;;AOnvEA;EACE,yBHSW;EGRX,cHSkB;EGRlB,wEAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;APsvEF;;AOnvEA;EACE,eAAA;APsvEF;;AOnvEA;EACE,yBHPW;EGQX,cHPkB;EGQlB,wEAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;APsvEF;;AOnvEA;EACE,yBH9BK;EG+BL,cAAA;APsvEF;;AOnvEA;EACE,yBHjCK;EGkCL,cAAA;APsvEF;;AOnvEA;EACE,yBHpCO;EGqCP,cAAA;APsvEF;;AOnvEA;EACE,yBHzCO;EG0CP,cAAA;APsvEF;;AOnvEA;EACE,yBH7CI;EG8CJ,cAAA;APsvEF;;AOnvEA;EACE,yBHpDM;EGqDN,cAAA;APsvEF;;AOnvEA;EACE,yBAAA;EACA,cAAA;APsvEF;;AOnvEA;EACE,yBAAA;EACA,cAAA;APsvEF;;AOnvEA;EACE,yBAAA;EACA,cAAA;APsvEF;;AQ9zEA,iBAAA;AAEA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ARg0EF;;AQ7zEA;EACE,aAAA;ARg0EF;;AQ7zEA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;ARg0EF;;AQ7zEA;EACE,WAAA;EACA,kBAAA;EAIA,kCAAA;ARg0EF;;AQ7zEA;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,yCAAA;EACA,iBAAA;EAGA,sBAAA;ARg0EF;;AQ7zEA;EACE,aAAA;EACA,kBAAA;EACA,yBJhDK;EIiDL,cAAA;ARg0EF;;AQ7zEA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;ARg0EF;;AQ7zEA;EACE,WAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EAIA,+BAAA;ARg0EF;;AQ7zEA;EACE,cAAA;ARg0EF;;AQ7zEA;EACE,QAAA;ARg0EF;;AQ7zEA;EACE,yBAAA;ARg0EF;;AQ7zEA;;EAEE,qBAAA;ARg0EF;;AQ7zEA,kBAAA;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AR+zEF;;AQ5zEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AR+zEF;;AQ5zEA,sBAAA;AAEA;EACE,yBAAA;EACA,gBAAA;AR8zEF;;AQ3zEA,cAAA;AAEA;EAEE,qBAAA;EAEA,eAAA;EACA,UAAA;AR2zEF;;AQxzEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AR2zEF;;AQxzEA;EACE,yBJzJK;EI0JL,qBJ1JK;AJq9EP;;AQxzEA;EACE,gBAAA;AR2zEF;;AQxzEA;EACE,cJ1JW;AJq9Eb;;AQxzEA;EACE,yBJtKK;EIuKL,qBJvKK;EIwKL,YAAA;AR2zEF;;AQxzEA,aAAA;AAEA;EACE,yBJzIO;AJm8ET;;AQvzEA;EACE,yBJ7IO;AJu8ET;;AQvzEA;EACE,2BJjJO;AJ28ET;;AQvzEA;EACE,4BJrJO;AJ+8ET;;AQvzEA;EACE,0BJzJO;AJm9ET;;AQvzEA,kBAAA;AAEA;EACE,kBAAA;EACA,kBAAA;ARyzEF;;AQtzEA;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;ARyzEF;;AQtzEA;EACE,MAAA;EACA,OAAA;ARyzEF;;AQtzEA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;ARyzEF;;AQtzEA;EACE,gBAAA;ARyzEF;;AQtzEA;EAGE,uBAAA;ARyzEF;;AQtzEA,iBAAA;AAEA;EACE,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ARwzEF;;AQrzEA;EACE,iBAAA;ARwzEF;;AQrzEA;EACE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ARwzEF;;AQrzEA;EACE,yBJlQK;EImQL,qBJnQK;EIoQL,cAAA;ARwzEF;;AQrzEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;ARwzEF;;AQrzEA;EACE,qBJxPa;EIyPb,mBAAA;ARwzEF;;AQrzEA;EACE,yBAAA;ARwzEF;;AQrzEA;EACE,0CAAA;ARwzEF;;AQrzEA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;ARwzEF;;AQrzEA;EACE,kBAAA;ARwzEF;;AQrzEA;;;EAGE,gBAAA;EACA,yBJzSK;EIySoB,qBAAA;EACzB,qBJ1SK;EI0SgB,iBAAA;AR0zEvB;;AQvzEA;EACE,cAAA;EACA,cAAA;AR0zEF;;AQvzEA;EACE,WAAA;AR0zEF;;AQvzEA;EACE,WAAA;AR0zEF;;AQvzEA,SAAA;AACA;EACE,gCAAA;AR0zEF;;AQvzEA;EACE,aAAA;AR0zEF;;AQvzEA;EACE,oBAAA;AR0zEF;;AQvzEA;EACE,gBAAA;AR0zEF;;AQvzEA;EACE,gBAAA;AR0zEF;;AQvzEA;EACE,cAAA;EACA,WAAA;AR0zEF;;AQvzEA;EACE,kBAAA;AR0zEF;;AQvzEA;EACE,WAAA;EACA,YAAA;AR0zEF;;AQvzEA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AR0zEF;;AQvzEA;EACE,gBAAA;AR0zEF;;AQvzEA;EACE,cAAA;AR0zEF;;AQtzEA;EACE,iBAAA;ARyzEF;;AQtzEA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ARyzEF;;AQtzEA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;ARyzEF;;AQtzEA;EACE,mBAAA;EACA,mBAAA;EACA,iCAAA;ARyzEF;;AQtzEA;EACE,iBAAA;ARyzEF;;AQtzEA;EACE,kBAAA;ARyzEF;;AQtzEA;EACE,SAAA;EACA,cAAA;ARyzEF;;AQtzEA;;EAEE,iBAAA;ARyzEF;;AQtzEA;EACE,aAAA;EACA,kBAAA;ARyzEF;;AQtzEA,eAAA;AAEA;EACE,yBJlaK;EImaL,qBJnaK;EIoaL,cAAA;EACA,UAAA;ARwzEF;;AQrzEA;EACE,gBAAA;ARwzEF;;AQrzEA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;ARwzEF;;AQrzEA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;ARwzEF;;AQrzEA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ARwzEF;;AQrzEA;EACE,gBAAA;ARwzEF;;AQrzEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ARwzEF;;AQrzEA;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;ARwzEF;;AQpzEA;EACE,iBAAA;EACA,kBAAA;EACA,2BAAA;ARuzEF;;AQpzEA;EACE,gBAAA;ARuzEF;;AQpzEA;EACE,cAAA;ARuzEF;;AQpzEA;;EAEE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;ARuzEF;;AQpzEA;EACE,gBAAA;ARuzEF;;AQpzEA;EACE,kBAAA;ARuzEF;;AQpzEA;EACE,aAAA;ARuzEF;;AQpzEA,gBAAA;AAEA;EACE,cAAA;EACA,aAAA;ARszEF;;AQnzEA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;ARszEF;;AQnzEA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;ARszEF;;AQnzEA;EACE,WAAA;EACA,YAAA;ARszEF;;AQnzEA;EACE,YAAA;EACA,aAAA;EACA,YAAA;ARszEF;;AQnzEA;EACE,kBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;ARszEF;;AQnzEA;EACE,YAAA;EACA,gBAAA;ARszEF;;AQnzEA;EACE,aAAA;ARszEF;;AQnzEA;EACE,aAAA;ARszEF;;AQnzEA;EACE,iBAAA;ARszEF;;AQnzEA;EACE,iBAAA;ARszEF;;AQnzEA;EACE,iBAAA;ARszEF;;AQnzEA;EACE,gBAAA;ARszEF;;AQnzEA;EACE,gBAAA;ARszEF;;AQnzEA;EACE,gBAAA;ARszEF;;AQnzEA;EACE,iBAAA;ARszEF;;AQnzEA;EACE,aAAA;ARszEF;;AQnzEA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;ARszEF;;AQnzEA;EACE,YAAA;ARszEF;;AQnzEA;EACE,gBAAA;EACA,kBAAA;ARszEF;;AQnzEA,eAAA;AAEA;;;;;EAKE,uBAAA;ARqzEF;;AQlzEA;EACE,oBAAA;ARqzEF;;AQlzEA;EACE,WAAA;ARqzEF;;AQlzEA;EACE,iBAAA;ARqzEF;;AQlzEA;EACE,YAAA;ARqzEF;;AQlzEA;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ARqzEF;AQnzEE;EACE,sBAAA;EACA,cAAA;EACA,qBAAA;ARqzEJ;;AQjzEA;EACE,YAAA;ARozEF;;AQjzEA;EACE;IACE,WAAA;IACA,gBAAA;ERozEF;;EQjzEA;IACE,WAAA;ERozEF;AACF;AQjzEA,WAAA;AAEA;EACE,kBAAA;ARkzEF;;AQ/yEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;ARkzEF;;AQ/yEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ARkzEF;;AQ/yEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ARkzEF;;AQ/yEA;EACE,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iCAAA;ARkzEF;;AQ/yEA;EACE,cAAA;ARkzEF;;AQ/yEA,cAAA;AAEA;EACE,eAAA;ARizEF;;AQ9yEA;EACE,gBAAA;EACA,eAAA;ARizEF;;AQ9yEA;EACE,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;ARizEF;;AQ9yEA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;ARizEF;;AQ9yEA;EACE,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;ARizEF;;AQ9yEA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;ARizEF;;AQ9yEA;EACE,eAAA;EACA,yBAAA;ARizEF;;AQ9yEA,UAAA;AAEA;EACE,4BAAA;EACA,oBAAA;EAEA,yBAAA;EAEA,iBAAA;AR+yEF;;AQ5yEA;EACE,aAAA;AR+yEF;;AQ5yEA;EACE,mBJrwBK;EIswBL,eAAA;EACA,aAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AR+yEF;;AQ5yEA;EACE,aAAA;AR+yEF;;AQ5yEA,YAAA;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AR8yEF;;AQ3yEA;EACE,eAAA;AR8yEF;;AQ3yEA;EACE,eAAA;EACA,gBAAA;AR8yEF;;AQ3yEA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AR8yEF;;AQ3yEA;EACE,0BAAA;EACA,gBAAA;AR8yEF;;AQ1yEA;EACE,aAAA;AR6yEF;;AQ1yEA;EACE,qBAAA;EACA,sBAAA;AR6yEF;;AQ1yEA;EACE,SAAA;AR6yEF;;AQ1yEA;EACE,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AR6yEF;;AQ1yEA;EACE,eAAA;AR6yEF;;AQ1yEA;EACE,mBJh0BK;EIi0BL,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AR6yEF;;AQ1yEA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AR6yEF;;AQ1yEA;EACE,mBJj1BK;EIk1BL,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AR6yEF;;AQ1yEA;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;AR6yEF;;AQ1yEA;EACE,cAAA;EACA,iBAAA;AR6yEF;;AQ1yEA;EACE,eAAA;AR6yEF;;AQ1yEA;EACE,6BAAA;AR6yEF;;AQ1yEA;EACE,eAAA;EACA,gBAAA;AR6yEF;;AQ1yEA;EACE,0BAAA;AR6yEF;;AQ1yEA,WAAA;AACA;EACE,gCAAA;AR6yEF;;AQ1yEA;EACE,YAAA;AR6yEF;;AQ1yEA;EACE,YAAA;AR6yEF;;AQ1yEA;EACE,iBAAA;AR6yEF;;AQ1yEA;EACE,eAAA;AR6yEF;;AQ1yEA;EACE,YAAA;AR6yEF;;AQ1yEA;EACE,YAAA;AR6yEF;;AQ1yEA;EACE,eAAA;AR6yEF;;AQ1yEA;EACE,oCAAA;EACA,iCAAA;EACA,oCAAA;EACA,6BAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,8EAAA;EACA,sBAAA;AR6yEF;;AQ1yEA;EACE,mBAAA;AR6yEF;;AQ1yEA;EACE,qBJl7BK;AJ+tGP;;AQ1yEA;EACE,qBJt7BK;AJmuGP;;AQ1yEA;EACE,qBJt7BO;AJmuGT;;AQ1yEA;EACE,qBJz7BI;AJsuGN;;AQ1yEA;EACE,cJl8BK;AJ+uGP;;AQ1yEA;EACE,cJl8BO;AJ+uGT;;AQ1yEA;EACE,cJr8BI;AJkvGN;;AQ1yEA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;AR6yEF;;AQ1yEA;EACE,SAAA;AR6yEF;;AQ1yEA;EACE,eAAA;AR6yEF;;AQ1yEA;EACE,iBAAA;AR6yEF;;AQ1yEA;EACE,UAAA;AR6yEF;;AQ1yEA;EACE,0CAAA;EACA,gBAAA;AR6yEF;;AQ1yEA;EACE,0CAAA;EACA,gBAAA;AR6yEF;;AQ1yEA,gBAAA;AAEA;EACE,YAAA;AR4yEF;;AQzyEA;EACE,qCAAA;EACA,8BAAA;EACA,mBAAA;AR4yEF;;AQzyEA;EACE,2BAAA;AR4yEF;;AQzyEA,aAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AR4yEF;;AQzyEA;EACE,aAAA;AR4yEF;;AQzyEA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AR4yEF;;AQzyEA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EAIA,kCAAA;AR4yEF;;AQzyEA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,yCAAA;EACA,iBAAA;EAGA,sBAAA;AR4yEF;;AQzyEA;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AR4yEF;;AQzyEA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AR4yEF;;AQzyEA;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EAIA,+BAAA;AR4yEF;;AQzyEA;EACE,cAAA;AR4yEF;;AQzyEA;EACE,QAAA;AR4yEF;;AQzyEA,WAAA;AAEA;EACE,4BAAA;AR2yEF;;AQxyEA;EACE,yBAAA;AR2yEF;;AQxyEA;EACE,yBAAA;AR2yEF;;AQxyEA;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,6CAAA;AR2yEF;;AQxyEA;EACE,WAAA;EACA,uBAAA;AR2yEF;;AQxyEA;EACE,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;AR2yEF;;AQxyEA;EACE,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;AR2yEF;;AQxyEA;EACE,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AR2yEF;;AQxyEA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AR2yEF;;AQxyEA;EACE,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,6CAAA;AR2yEF;;AQxyEA;EACE,uBAAA;AR2yEF;;AQxyEA;EACE,8BAAA;AR2yEF;;AQxyEA;EACE,8BAAA;EACA,oCAAA;EACA,kCAAA;AR2yEF;;AQxyEA;EACE,mBAAA;EACA,yBAAA;AR2yEF;;AQxyEA;EACE,mBAAA;AR2yEF;;AQxyEA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AR2yEF;;AQxyEA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AR2yEF;;AQxyEA;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AR2yEF;;AQxyEA;EACE,kBAAA;AR2yEF;;AQxyEA;EACE,YAAA;EACA,kBAAA;AR2yEF;;AQxyEA;EACE,gBAAA;AR2yEF;;AQxyEA;EACE,YAAA;EACA,SAAA;AR2yEF;;AQxyEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,4BAAA;EACA,eAAA;AR2yEF;;AQxyEA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AR2yEF;;AQxyEA;EACE,YAAA;AR2yEF;;AQxyEA;EACE,yBAAA;AR2yEF;;AQxyEA;EACE,0BAAA;AR2yEF;;AQxyEA;EACE,4BAAA;AR2yEF;;AQxyEA;EACE,6BAAA;AR2yEF;;AQxyEA;EACE,sBAAA;AR2yEF;;AQxyEA;EACE,UAAA;AR2yEF;;AQxyEA;EACE,6BAAA;AR2yEF;;AQxyEA;EACE,YAAA;AR2yEF;;AQxyEA;EACE,kBAAA;AR2yEF;;AQvyEA;EACE,sBAAA;AR0yEF;;AQvyEA;EACE,kBAAA;AR0yEF;;AQvyEA,kBAAA;AAEA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ARyyEF;;AQtyEA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;ARyyEF;;AQtyEA;EACE,kBAAA;ARyyEF;;AQtyEA;EACE,aAAA;ARyyEF;;AQtyEA;;;EAGE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ARyyEF;;AQtyEA;EACE,cAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,sBAAA;EACA,2BAAA;ARyyEF;;AQtyEA;EACE,iBAAA;ARyyEF;;AQtyEA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;ARyyEF;;AQtyEA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;ARyyEF;;AQtyEA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;ARyyEF;;AQtyEA;EACE,YAAA;ARyyEF;;AQtyEA;EACE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;ARyyEF;;AQryEA;EACE,YAAA;ARwyEF;;AQryEA;EACE,YAAA;ARwyEF;;AQryEA;;EAEE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;ARwyEF;;AQryEA;EACE,uBAAA;EACA,iBAAA;EACA,yBAAA;EAGA,wLAAA;EACA,0BAAA;EACA,mCAAA;ARwyEF;;AQryEA;EACE,kBAAA;EACA,aAAA;EACA,oBAAA;ARwyEF;;AQryEA;EACE,aAAA;ARwyEF;;AQryEA;EAEE,4CAAA;ARwyEF;;AQryEA;;CAAA;AAGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,6BAAA;ARwyEF;;AQryEA;EACE,UAAA;EACA,qBAAA;ARwyEF;;AQryEA;;EAEE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,wFAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;ARwyEF;;AQryEA;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;ARwyEF;;AQryEA;EACE,kBAAA;ARwyEF;;AQryEA;;EAEE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;ARwyEF;;AQryEA,eAAA;AACA;EACE,sBAAA;EACA,YAAA;ARwyEF;;AQryEA;EACE,kBAAA;EACA,gBAAA;ARwyEF;;AQryEA,gBAAA;AACA;EACE,aAAA;ARwyEF;;AQryEA,eAAA;AACA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;ARwyEF;;AQryEA;EACE,0BAAA;ARwyEF;;AQryEA,WAAA;AACA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;ARwyEF;;AQryEA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;ARwyEF;;AQryEA;EACE,kBAAA;EACA,gCAAA;ARwyEF;;AQryEA;EACE,kBAAA;ARwyEF;;AQryEA;EACE,mBAAA;ARwyEF;;AQryEA;EACE,mBAAA;ARwyEF;;AQryEA;EACE,mBAAA;ARwyEF;;AQryEA;EACE,gCAAA;ARwyEF;;AQryEA;EACE,6BAAA;ARwyEF;;AQryEA;EACE,kBAAA;ARwyEF;;AQryEA,wBAAA;AAEA;EAGE,wBAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;ARuyEF;;AQpyEA;EAGE,wBAAA;EACA,UAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;ARuyEF;;AQpyEA;EACE,yBJ3kDK;EI4kDL,qBJtjDa;AJ61Hf;;AQpyEA;EACE,yBJhlDK;AJu3HP;;AQpyEA;EACE,yBJ/kDI;AJs3HN;;AQpyEA;EACE,yBJrlDM;AJ43HR;;AQpyEA;EACE,yBJxlDO;AJ+3HT;;AQpyEA;EACE,gBAAA;ARuyEF;;AQpyEA;EACE,mBAAA;ARuyEF;;AQpyEA;EACE,aAAA;ARuyEF;;AQpyEA;EACE,uBAAA;ARuyEF;AQryEE;EACE,yBAAA;EACA,mBAAA;ARuyEJ;;AQnyEA,YAAA;AACA;EACE,gBAAA;EACA,UAAA;EACA,oEAAA;EACA,4EAAA;EACA,yEAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;ARsyEF;;AQnyEA;EACE,8BAAA;ARsyEF;;AQnyEA;EACE,8BAAA;ARsyEF;;AQnyEA;EACE,8BAAA;ARsyEF;;AQnyEA;EACE,8BAAA;ARsyEF;;AQnyEA,wBAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;ARsyEF;;AQnyEA;EACE,aAAA;EACA,YAAA;ARsyEF;;AQnyEA,kBAAA;AACA;EACE,2BAAA;EACA,4BAAA;EACA,gCAAA;ARsyEF;;AQnyEA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;ARsyEF;;AQnyEA;EACE,YAAA;EACA,WAAA;ARsyEF;;AQnyEA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;ARsyEF;;AQnyEA;EACE,0BAAA;EACA,mBAAA;EACA,yBAAA;ARsyEF;;AQnyEA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;ARsyEF;;AQnyEA;EACE,cAAA;ARsyEF;;AQnyEA;EACE,gBAAA;EACA,kBAAA;ARsyEF;;AQlyEA;EACE,WAAA;EACA,kBAAA;ARqyEF;;AQlyEA;EACE,YAAA;EACA,WAAA;ARqyEF;;AQlyEA;EACE,eAAA;ARqyEF;;AQlyEA;EACE,cAAA;EACA,oBAAA;EACA,gCAAA;ARqyEF;;AQlyEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;ARqyEF;;AQlyEA;EACE,wBAAA;ARqyEF;;AQlyEA;EACE,WAAA;ARqyEF;;AQlyEA;EACE,WAAA;EACA,iBAAA;ARqyEF;;AQlyEA;EACE,qBAAA;ARqyEF;;AQlyEA;EACE,kBAAA;ARqyEF;;AQlyEA;EACE,WAAA;ARqyEF;;AQlyEA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;ARqyEF;;AQlyEA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ARqyEF;;AQlyEA;EACE,cAAA;ARqyEF;;AQlyEA;EAEE,eAAA;EACA,eAAA;EACA,cAAA;ARoyEF;;AQjyEA;EACE,cJzxDK;AJ6jIP;;AQjyEA;EACE,cJ7xDK;AJikIP;;AQjyEA;EAEE;IACE,qBAAA;IAEA,iEAAA;IACA,aAAA;ERkyEF;;EQ/xEA;IACE,sBAAA;ERkyEF;AACF;AQ9xEA,uBAAA;AAEA;EACE,sIAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AR+xEF;;AQ5xEA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;AR+xEF;;AQ5xEA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AR+xEF;;AQ5xEA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AR+xEF;;AQ5xEA;EACE,YAAA;AR+xEF;;AQ5xEA;EACE,mBAAA;AR+xEF;;AQ5xEA;EACE,yDAAA;AR+xEF;;AQ5xEA;EACE,yDAAA;AR+xEF;;AQ5xEA;;EAEE,yDAAA;AR+xEF;;AQ5xEA;;EAEE,mBAAA;AR+xEF;;AQ5xEA;EACE;IACE,eAAA;IACA,kBAAA;ER+xEF;;EQ5xEA;IACE,SAAA;IACA,iBAAA;ER+xEF;AACF;AQ5xEA;EACE;IACE,yDAAA;ER8xEF;AACF;AQ3xEA;EACE,kBAAA;EACA,aAAA;AR6xEF;;AQ1xEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AR6xEF;;AQ1xEA;EACE,aAAA;AR6xEF;;AQ1xEA;EACE,gBAAA;AR6xEF;;AQ1xEA;EACE;IACE,aAAA;ER6xEF;;EQ1xEA;IACE,aAAA;ER6xEF;;EQ1xEA;IACE,gBAAA;ER6xEF;AACF;AQ1xEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AR4xEF;;AQzxEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;AR4xEF;;AQzxEA;EACE;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,gCAAA;IACA,mCAAA;IACA,eAAA;ER4xEF;;EQzxEA;IACE,kBAAA;IACA,iBAAA;ER4xEF;;EQzxEA;IACE,kBAAA;ER4xEF;AACF;AQzxEA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AR2xEF;;AQxxEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AR2xEF;;AQxxEA;EACE,gBAAA;EACA,eAAA;AR2xEF;;AQxxEA;EACE,aAAA;EACA,gBAAA;AR2xEF;;AQxxEA;EACE,WAAA;EACA,gBAAA;AR2xEF;;AQxxEA;EACE,cJv+DK;EIw+DL,gBAAA;AR2xEF;;AQxxEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,6BAAA;AR2xEF;;AQxxEA;EACE;IACE,eAAA;ER2xEF;;EQxxEA;IACE,eAAA;ER2xEF;AACF;AQvxEA;EACE;IACE,cAAA;IACA,cAAA;IACA,UAAA;ERyxEF;;EQtxEA;IACE,SAAA;IACA,UAAA;IACA,yBAAA;IACA,wBAAA;ERyxEF;;EQtxEA;IACE,WAAA;ERyxEF;;EQtxEA;IACE,kBAAA;IACA,WAAA;IACA,UAAA;IACA,QAAA;IACA,eAAA;ERyxEF;;EQtxEA;IACE,YAAA;ERyxEF;;EQtxEA;IACE,SAAA;IACA,UAAA;IACA,WAAA;IACA,yBAAA;IACA,yBAAA;ERyxEF;;EQtxEA;IACE,YAAA;ERyxEF;;EQtxEA;IACE,UAAA;IACA,WAAA;IACA,iBAAA;ERyxEF;;EQtxEA;IACE,kBAAA;ERyxEF;AACF;AQtxEA,SAAA;AAIE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ARqxEJ;AQlxEE;;;EAGE,yBAAA;EACA,gCAAA;EACA,sBAAA;ARoxEJ;AQjxEE;EACE,WAAA;EACA,mBAAA;ARmxEJ;AQhxEE;EACE,gBAAA;ARkxEJ;AQ/wEE;EACE,yBAAA;EACA,gCAAA;ARixEJ;AQ9wEE;EACE,gCAAA;ARgxEJ;AQ7wEE;EACE,gBAAA;AR+wEJ;AQ5wEE;EACE,6BAAA;AR8wEJ;AQ3wEE;;;EAGE,gBAAA;AR6wEJ;AQ1wEE;EACE,gBAAA;AR4wEJ;AQzwEE;EACE,UAAA;AR2wEJ;AQxwEE;EACE,UAAA;EACA,gBAAA;AR0wEJ;AQvwEE;EACE,UAAA;EACA,iBAAA;ARywEJ;AQtwEE;;EAEE,aAAA;ARwwEJ;AQrwEE;;EAEE,cAAA;ARuwEJ;AQpwEE;EACE,6BAAA;ARswEJ;AQnwEE;EACE,gBAAA;EACA,gBAAA;ARqwEJ;AQlwEE;EAGE,0BAAA;ARowEJ;AQjwEE;;EAEE,yBJjoEW;EIkoEX,gCAAA;ARmwEJ;AQhwEE;;EAEE,WAAA;EACA,sBAAA;EACA,WAAA;ARkwEJ;AQ/vEE;;EAEE,gBAAA;EACA,eAAA;EACA,kBAAA;ARiwEJ;AQ9vEE;EACE,WAAA;EACA,kBAAA;ARgwEJ;AQ7vEE;EACE,kBAAA;EAGA,0BAAA;AR+vEJ;AQ5vEE;;;EAGE,iDAAA;AR8vEJ;AQ3vEE;EACE,YAAA;EACA,iBAAA;AR6vEJ;AQ1vEE;EACE,iBAAA;EAGA,0BAAA;AR4vEJ;AQzvEE;;;EAGE,iDAAA;EACA,UAAA;AR2vEJ;AQxvEE;EACE,UAAA;AR0vEJ;;AQrvEA;EACE,yBAAA;ARwvEF;;AQrvEA;EACE;IACE,sBAAA;ERwvEF;;EQrvEA;IACE,2CAAA;IACA,SAAA;ERwvEF;AACF;AQrvEA,gBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;ARuvEF;;AQpvEA;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;ARuvEF;;AQpvEA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBJ3vEK;EI4vEL,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;ARuvEF;;AQpvEA;EACE,WAAA;EACA,YAAA;ARuvEF;;AQpvEA;EACE,SAAA;ARuvEF;;AQpvEA;EACE,SAAA;ARuvEF;;AQpvEA;EACE,YAAA;EACA,aAAA;EACA,YAAA;ARuvEF;;AQpvEA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oEAAA;ARuvEF;;AQpvEA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;ARuvEF;;AQpvEA;EACE,kBAAA;ARuvEF;;AQpvEA;EACE,SAAA;EACA,QAAA;ARuvEF;;AQpvEA;EACE,MAAA;EACA,QAAA;ARuvEF;;AQpvEA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;ARuvEF;;AQpvEA;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;ARuvEF;;AQpvEA;EACE,WAAA;ARuvEF;;AQpvEA;EACE,qBAAA;EACA,YAAA;ARuvEF;;AQpvEA;EACE,WAAA;ARuvEF;;AQpvEA;EACE,YAAA;ARuvEF;;AQpvEA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;ARuvEF;;AQpvEA;EACE,eAAA;ARuvEF;;AQpvEA;EACE,kBAAA;ARuvEF;;AQpvEA;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;ARuvEF;;AQpvEA,kBAAA;AAEA;;EAEE,yBAAA;ARsvEF;;AQnvEA,aAAA;AAEA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;ARqvEF;;AQlvEA;EACE,eAAA;EACA,cJ/2EW;AJomJb;;AQlvEA;EACE,gBAAA;ARqvEF;;AQlvEA;EACE,aAAA;EACA,yBJz3EK;AJ8mJP;;AQlvEA;EACE,yBAAA;ARqvEF;;AQlvEA;EACE,gBAAA;ARqvEF;;AQlvEA;EACE,kBAAA;ARqvEF;;AQlvEA;EACE,eAAA;ARqvEF;;AQlvEA,0BAAA;AACA;;EAEE,yBJx5EK;AJ6oJP;;AQlvEA;;;EAGE,qBJx4Ea;AJ6nJf;;AQlvEA;EACE,aAAA;ARqvEF;;AQjvEA;EACE,gBAAA;EACA,qBJx6EK;AJ4pJP;;AQjvEA;EACE,iBAAA;ARovEF;;AQlvEA,SAAA;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;ARovEF;;AQjvEA;EACE,aAAA;ARovEF;;AQjvEA;EACE,aAAA;EACA,YAAA;ARovEF;;AQjvEA;EACE,aAAA;ARovEF;;AQjvEA;EACE,aAAA;ARovEF;;AQjvEA;EACE,4BAAA;ARovEF;;AQjvEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;ARovEF;;AQjvEA,cAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ARmvEF;;AQhvEA;EACE,yBAAA;ARmvEF;;AQhvEA;EACE,oCAAA;ARmvEF;;AQ/uEA,oBAAA;AACA;EACE,kBAAA;ARkvEF;;AQ/uEA,iBAAA;AAEA;EACE,gBAAA;EACA,cAAA;ARivEF;AQ/uEE;EACE,YAAA;ARivEJ;;AQ9uEA,aAAA;AAEA;EACE,iBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ARgvEF;AQ9uEE;EACE,eAAA;ARgvEJ;;AQ3uEA,oBAAA;AAEA;EAEE,kBAAA;EACA,eAAA;AR4uEF;AQ1uEE;EACE,SAAA;AR4uEJ;AQzuEE;EACE,YAAA;AR2uEJ;AQxuEE;EACE,WAAA;AR0uEJ;AQxuEI;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;AR0uEN;AQxuEM;EACE,cAAA;AR0uER;AQvuEM;EACE,cAAA;EACA,yBJliFD;EImiFC,qBJniFD;AJ4wJP;AQtuEM;EACE,cAAA;EACA,yBJ1iFD;EI2iFC,qBJ3iFD;AJmxJP;AQruEM;EACE,cAAA;EACA,yBJ5iFC;EI6iFD,qBJ7iFC;AJoxJT;AQpuEM;EACE,cAAA;EACA,yBJnjFA;EIojFA,qBJpjFA;AJ0xJR;AQnuEM;EACE,cAAA;EACA,yBJvjFF;EIwjFE,qBJxjFF;AJ6xJN;AQhuEI;EACE,WAAA;EACA,UAAA;EACA,yBJ/iFS;EIgjFT,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;ARkuEN;AQ5tEE;EACE,eAAA;EACA,kBAAA;AR8tEJ;AQ5tEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AR8tEN;AQ3tEI;EACE,cAAA;EACA,cAAA;AR6tEN;AQxtEE;EACE,iBAAA;AR0tEJ;;AQrtEA;EACE,cAAA;ARwtEF;AQttEE;EACE,gBAAA;EACA,iBAAA;ARwtEJ;;AQptEA,eAAA;AAEA;EACE,gBAAA;ARstEF;;AQltEA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;ARqtEF;;AQltEA,SAAA;AAEA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;ARotEF;;AQjtEA;EACE,8DAAA;ARotEF;;ASp2JA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;ATu2JF;;ASp2JA;EACE,WAAA;EACA,YAAA;ATu2JF;;ASp2JA;EACE,eAAA;ATu2JF;;ASp2JA;EACE,gBAAA;EACA,iBAAA;ATu2JF;;ASp2JA;EACE,mBAAA;ATu2JF;;ASp2JA;EACE,cAAA;EACA,eAAA;EACA,SAAA;ATu2JF;;ASp2JA;EACE,+BAAA;ATu2JF;;ASp2JA;EACE,8BAAA;ATu2JF;;ASl2JA;EACE,sBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;ATq2JF;;ASl2JA;EACE,QAAA;ATq2JF;;ASl2JA;EACE,MAAA;EACA,gBAAA;ATq2JF;;ASh2JE;EACE,YAAA;ATm2JJ;ASh2JE;EACE,UAAA;ATk2JJ;ASh2JE;EACE,eAAA;ATk2JJ;ASh2JE;EACE,UAAA;ATk2JJ;AS/1JE;EACE,YAAA;ATi2JJ;AS91JE;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBLpDK;EKqDL,WAAA;EACA,kBAAA;EAEA,+BAAA;AT+1JJ;AS51JE;EACE,YAAA;EACA,mBAAA;EACA,cL3FS;EK4FT,iBAAA;AT81JJ;AS11JE;;EAGE,YAAA;AT21JJ;ASv1JE;EACE,SAAA;EACA,UAAA;ATy1JJ;ASt1JE;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EAEA,eAAA;ATu1JJ;ASh1JE;EACE,mBAAA;ATk1JJ;AS/0JE;EACE,qBAAA;EACA,cAAA;ATi1JJ;AS90JE;EACE,kBAAA;EACA,eAAA;ATg1JJ;ASz0JE;EACE,mBAAA;EACA,aAAA;EACA,gCAAA;AT20JJ;ASz0JI;EACE,kBAAA;EACA,iBAAA;AT20JN;ASr0JI;EACE,kBAAA;ATu0JN;ASl0JE;EACE,kBAAA;ATo0JJ;ASj0JE;EACE,qBAAA;EACA,cAAA;ATm0JJ;ASh0JE;EACE,kBAAA;ATk0JJ;AS/zJE;EACE,cAAA;EACA,WAAA;ATi0JJ;AS1zJE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AT4zJJ;ASzzJE;EACE,kBAAA;EACA,gCAAA;AT2zJJ;;AU//JA;EACE,wEAAA;EACA,yBNoCO;EMnCP,eAAA;EACA,cNKW;EMJX,kBAAA;AVkgKF;;AU9/JA;EACE,YAAA;AVigKF;;AU7/JA;;EAEE,YAAA;AVggKF;;AU7/JA;EACE,iBAAA;AVggKF;;AU7/JA;EACE,mDNQiB;AJw/JnB;;AU7/JA;EACE,yBNUO;EMTP,iBNEY;EMDZ,cAAA;EAGA,yCAAA;AVggKF;;AU7/JA;;EAEE,4BAAA;AVggKF;;AU7/JA;EACE,cAAA;AVggKF;;AU7/JA;EACE,cAAA;EACA,gBAAA;AVggKF;;AU7/JA;EACE,cN/BiB;EMgCjB,eAAA;AVggKF;;AU7/JA;EACE,qBAAA;AVggKF;;AU7/JA;EACE,2CAAA;AVggKF;;AU7/JA;EACE,gBAAA;AVggKF;;AU7/JA;EACE,gBAAA;AVggKF;;AU7/JA;EACE,yBAAA;AVggKF;;AU7/JA;EACE,kBAAA;AVggKF;;AU7/JA;EACE,+BAAA;AVggKF;;AU7/JA;EACE,8BAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;AVggKF;;AU7/JA;EACE,gCAAA;EACA,kCAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AVggKF;;AU7/JA;EACE,sBAAA;EACA,uBAAA;AVggKF;;AU7/JA,YAAA;AACA;EACE,mBAAA;AVggKF;;AU7/JA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AVggKF;;AU7/JA,4BAAA;AACA;EACE,uBAAA;AVggKF;;AU5/JA;EACE,aAAA;AV+/JF;;AU5/JA;EACE,aAAA;AV+/JF;;AU5/JA;EACE,cNzHW;EM0HX,aAAA;AV+/JF;;AU5/JA;EACE,YAAA;AV+/JF;;AU5/JA;EACE,gBAAA;AV+/JF;;AU5/JA,UAAA;AACA;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AV+/JF;;AU5/JA;EACE,aAAA;AV+/JF;;AU5/JA;EACE,4BAAA;AV+/JF;;AU5/JA;EACE,mBAAA;AV+/JF;;AU5/JA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AV+/JF;;AU5/JA;EAIE,eAAA;AV+/JF;;AU5/JA;EACE,eAAA;AV+/JF;;AU5/JA;EACE,eAAA;EACA,cAAA;AV+/JF;;AU5/JA;EACE,aAAA;AV+/JF;;AU5/JA,aAAA;AAEA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EAEA,aAAA;AV8/JF;;AU1/JA;EACE,eAAA;AV6/JF;;AU1/JA;EACE,uBAAA;AV6/JF;;AU1/JA;EACE,eAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;AV6/JF;;AU1/JA;EACE;IACE,iBAAA;EV6/JF;AACF;AU1/JA;EACE,iBAAA;EACA,iBAAA;AV4/JF;;AUz/JA;;EAEE,eAAA;AV4/JF;;AUz/JA;EACE,6BAAA;EACA,cAAA;AV4/JF;;AUz/JA;EACE,2BAAA;EACA,cAAA;AV4/JF;;AUz/JA,WAAA;AAEA;EAEE,wCAAA;EACA,6BAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AV0/JF;;AUv/JA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AV0/JF;;AUv/JA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBNxPc;AJkvKhB;;AUv/JA;;EAEE,kBAAA;AV0/JF;;AUv/JA;EACE,SAAA;AV0/JF;;AUv/JA;;EAEE,oBAAA;AV0/JF;;AUv/JA;EACE,mBAAA;AV0/JF;;AUv/JA;EACE,cAAA;AV0/JF;;AUv/JA,WAAA;AAEA;EACE,cAAA;AVy/JF;;AUt/JA;EACE,aAAA;EACA,yBAAA;AVy/JF;;AUt/JA;EACE,kBAAA;AVy/JF;;AUt/JA;EACE,aAAA;AVy/JF;;AUt/JA,2BAAA;AACA;EACE,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;AVy/JF;;AUt/JA;EACE,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;EACA,4BAAA;AVy/JF;;AUt/JA;EACE,kBAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;AVy/JF;;AUt/JA;EACE,WAAA;EACA,yBAAA;EACA,qBNnUa;AJ4zKf;;AUt/JA;EACE,qBNvUa;AJg0Kf;;AUt/JA;EACE,eAAA;AVy/JF;;AUt/JA;EACE,gBAAA;EACA,kBAAA;AVy/JF;;AUt/JA,WAAA;AAEA;EACE,aAAA;AVw/JF;;AUr/JA;EACE,yBAAA;AVw/JF;;AUr/JA;EACE,yBAAA;EACA,wBAAA;AVw/JF;;AUr/JA;EACE,yBAAA;AVw/JF;;AUr/JA;EACE,gCAAA;EACA,sBAAA;AVw/JF;;AUr/JA;EACE,6BAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;AVw/JF;;AUr/JA,WAAA;AAEA;EACE,gBAAA;EACA,SAAA;AVu/JF;;AUp/JA;EACE,iBAAA;AVu/JF;;AUp/JA;EACE,cAAA;EACA,gBAAA;EACA,4BAAA;AVu/JF;;AUp/JA;EACE,cNlZW;AJy4Kb;;AUp/JA;EACE,eAAA;AVu/JF;;AUp/JA,YAAA;AAEA;EACE,qBAAA;AVs/JF;;AUn/JA;EACE,uBAAA;AVs/JF;;AUn/JA;EACE,oBAAA;AVs/JF;;AUn/JA;EACE,wBAAA;AVs/JF;;AUn/JA;EACE,iBAAA;EACA,iBAAA;AVs/JF;;AUn/JA;EACE,8BAAA;EACA,+BAAA;AVs/JF;;AUn/JA;EACE,6BAAA;EACA,gCAAA;AVs/JF;;AUn/JA;EACE,8BAAA;AVs/JF;;AUn/JA;EACE,+BAAA;AVs/JF;;AUn/JA;EACE,6BAAA;AVs/JF;;AUn/JA;EACE,gCAAA;AVs/JF;;AUn/JA;EACE,iBAAA;AVs/JF;;AUn/JA;EACE,iBAAA;AVs/JF;;AUn/JA;EACE,iBAAA;AVs/JF;;AUn/JA;EACE,kBAAA;AVs/JF;;AUn/JA;EACE,sBAAA;AVs/JF;;AUn/JA;EACE,eAAA;EACA,aAAA;AVs/JF;;AUn/JA;EACE,eAAA;AVs/JF;;AUn/JA;EAAoB,iBAAA;AVu/JpB;;AUr/JA;EACE,eAAA;EACA,cAAA;AVw/JF;;AUp/JA;EACE,aAAA;AVu/JF;;AUp/JA;EACE,yBAAA;EACA,kBAAA;AVu/JF;;AUp/JA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBNvgBK;AJ8/KP;;AUp/JA;EACE,eAAA;AVu/JF;;AUp/JA;EACE,gBAAA;EACA,mBAAA;AVu/JF;;AUp/JA;EACE,eAAA;EACA,cAAA;EACA,cN9gBW;AJqgLb;;AUp/JA;EACE,cAAA;AVu/JF;;AUp/JA;EACE,aAAA;EAEA,WAAA;EACA,cAAA;AVs/JF;;AUn/JA;EACE,YAAA;AVs/JF;;AUn/JA;EACE,yBAAA;EACA,UAAA;EACA,gBAAA;AVs/JF;;AUn/JA;EACE,cAAA;AVs/JF;;AUn/JA;EACE,cAAA;AVs/JF;;AUn/JA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AVs/JF;;AUn/JA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;AVs/JF;;AUn/JA;EACE,aAAA;AVs/JF;;AUn/JA;EACE,YAAA;AVs/JF;;AUn/JA;EACE,YAAA;AVs/JF;;AUn/JA;EACE,cAAA;AVs/JF;;AUn/JA;EACE,yBNhkBa;EMikBb,qBNlkBa;EMmkBb,kBAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EAGA,0BAAA;AVs/JF;;AUn/JA;EACE,yBNhlBe;EMilBf,cAAA;EACA,4BAAA;EACA,qBNrlBa;EMslBb,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AVs/JF;;AUn/JA;EACE,cAAA;EACA,6BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AVs/JF;;AUn/JA;EACE,aAAA;AVs/JF;;AUn/JA;EACE,kBAAA;AVs/JF;;AUn/JA;EACE,mBAAA;AVs/JF;;AUn/JA;EACE,WAAA;AVs/JF;;AUn/JA;EACE,gBAAA;EACA,cAAA;AVs/JF;;AUn/JA;EACE,mBAAA;EACA,cAAA;AVs/JF;;AUn/JA;EACE,yBAAA;AVs/JF;;AUn/JA;EACE,WAAA;AVs/JF;;AUn/JA;EACE,yBAAA;EACA,mBAAA;AVs/JF;;AUn/JA;EACE,gBAAA;EACA,eAAA;AVs/JF;;AUn/JA;EACE,qBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;AVs/JF;;AUn/JA;EACE,gBAAA;AVs/JF;;AUn/JA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AVs/JF;;AUn/JA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;AVs/JF;;AUn/JA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AVs/JF;;AUn/JA;EACE,sBAAA;AVs/JF;;AUn/JA;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;AVs/JF;;AUn/JA;EACE,UAAA;EACA,QAAA;AVs/JF;;AUn/JA;EACE,aAAA;AVs/JF;;AUn/JA;EACE,WAAA;AVs/JF;;AUn/JA;EACE,yBAAA;EACA,cAAA;AVs/JF;;AUn/JA,gBAAA;AAEA;EACE,yBNhuBK;AJqtLP;;AUl/JA;EACE,yBAAA;AVq/JF;;AUl/JA;EACE,oCAAA;EACA,cAAA;AVq/JF;;AUl/JA;EACE,oCAAA;EACA,cAAA;AVq/JF;;AUl/JA;EACE,oCAAA;EACA,cAAA;AVq/JF;;AUl/JA;EACE,oCAAA;EACA,cAAA;AVq/JF;;AUl/JA;EACE,oCAAA;EACA,cAAA;AVq/JF;;AUl/JA;EACE,yBAAA;AVq/JF;;AUl/JA;EACE,qBN9wBK;AJmwLP;;AUl/JA;EACE,yBNlxBK;EMmxBL,qBNnxBK;AJwwLP;;AUl/JA;EACE,qBNrxBK;AJ0wLP;;AUl/JA;EACE,yBNzxBK;EM0xBL,qBN1xBK;EM2xBL,cAAA;AVq/JF;;AUl/JA;EACE,qBN9xBM;AJmxLR;;AUl/JA;EACE,yBNlyBM;EMmyBN,qBNnyBM;EMoyBN,cAAA;AVq/JF;;AUl/JA;EACE,qBNvyBO;AJ4xLT;;AUl/JA;EACE,yBN3yBO;EM4yBP,qBN5yBO;EM6yBP,cAAA;AVq/JF;;AUl/JA;EACE,qBNhzBI;AJqyLN;;AUl/JA;EACE,yBNpzBI;EMqzBJ,qBNrzBI;EMszBJ,cAAA;AVq/JF;;AUl/JA;EACE,yBN/zBK;AJozLP;;AUl/JA;EACE,YAAA;AVq/JF;;AUl/JA;EACE,eAAA;AVq/JF;;AUl/JA;EACE,WAAA;EACA,gBAAA;AVq/JF;;AUl/JA;EACE,yBAAA;AVq/JF;;AUl/JA;EACE,yBNl1BK;AJu0LP;;AUl/JA;EACE,yBNr1BM;AJ00LR;;AUl/JA;EACE,yBNx1BO;AJ60LT;;AUl/JA;EACE,yBN31BI;AJg1LN;;AUl/JA;EACE,kBAAA;AVq/JF;;AUl/JA;EACE,kBAAA;EACA,aAAA;AVq/JF;;AUl/JA;EACE,aAAA;AVq/JF;;AUl/JA,WAAA;AAEA;EACE,yBAAA;AVo/JF;;AUj/JA;EACE,yBAAA;AVo/JF;;AUj/JA;EACE,yBAAA;AVo/JF;;AUj/JA;EACE,yBAAA;AVo/JF;;AUj/JA;EACE,yBAAA;AVo/JF;;AUj/JA;EACE,yBAAA;AVo/JF;;AUj/JA;EACE,yBAAA;AVo/JF;;AUj/JA;EACE,cAAA;AVo/JF;;AUj/JA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AVo/JF;;AUj/JA;EAGE,6BAAA;AVo/JF;;AUj/JA;;;;;;;;EAQE,gBAAA;AVo/JF;;AUh/JA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AVm/JF;;AUh/JA;EACE,WAAA;AVm/JF;;AUh/JA;EACE,aAAA;AVm/JF;;AUh/JA;EACE,cAAA;AVm/JF;;AUh/JA;EACE,sBAAA;AVm/JF;;AUh/JA,gBAAA;AAEA;EACE,YAAA;AVk/JF;;AU/+JA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;AVk/JF;;AU/+JA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AVk/JF;;AU/+JA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AVk/JF;;AU/+JA;EACE,wBAAA;AVk/JF;;AU/+JA;EACE,wBAAA;AVk/JF;;AU/+JA;EACE,aAAA;EACA,iBAAA;AVk/JF;;AU/+JA;EACE,eAAA;AVk/JF;;AU/+JA,uBAAA;AAEA;EACE,YAAA;AVi/JF;;AU9+JA;EACE,aAAA;AVi/JF;;AU9+JA;EACE,aAAA;AVi/JF;;AU9+JA;EACE,aAAA;AVi/JF;;AU9+JA;EACE,aAAA;AVi/JF;;AU9+JA;EACE,aAAA;AVi/JF;;AU9+JA;EACE,aAAA;AVi/JF;;AU9+JA;EACE,eAAA;AVi/JF;;AU9+JA;EACE,eAAA;AVi/JF;;AU7+JA;EACE,eAAA;AVg/JF;;AU5+JA;EACE,eAAA;AV++JF;;AU3+JA;EACE,eAAA;AV8+JF;;AU1+JA;EACE,eAAA;AV6+JF;;AUz+JA;EACE,eAAA;AV4+JF;;AUz+JA;EACE,eAAA;AV4+JF;;AUx+JA;EACE,eAAA;AV2+JF;;AUv+JA;EACE,eAAA;AV0+JF;;AUt+JA;EACE,eAAA;AVy+JF;;AUr+JA;EACE,eAAA;AVw+JF;;AUp+JA;EACE,eAAA;AVu+JF;;AUp+JA;EACE,YAAA;AVu+JF;;AUp+JA;EACE,WAAA;AVu+JF;;AUp+JA;EACE,YAAA;AVu+JF;;AUp+JA;EACE,YAAA;AVu+JF;;AUp+JA;EACE,YAAA;AVu+JF;;AUp+JA;EACE,YAAA;AVu+JF;;AUp+JA;EACE,oBAAA;AVu+JF;;AUp+JA;EACE,cAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,aAAA;AVu+JF;;AUp+JA;EACE,eAAA;AVu+JF;;AUp+JA;EACE,eAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,eAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,iBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,gBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,kBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,mBAAA;AVu+JF;;AUp+JA;EACE,oBAAA;AVu+JF;;AUp+JA;EACE,oBAAA;AVu+JF;;AUp+JA;EACE,oBAAA;AVu+JF;;AUp+JA;EACE,oBAAA;AVu+JF;;AUp+JA;EACE,oBAAA;AVu+JF;;AUp+JA;EACE,cAAA;AVu+JF;;AUp+JA;EACE,cAAA;AVu+JF;;AUp+JA;EACE,cAAA;AVu+JF;;AUp+JA;EACE,cAAA;AVu+JF;;AUl+JA;EACE,WAAA;EACA,YAAA;AVq+JF;;AUl+JA;EACE,WAAA;EACA,YAAA;AVq+JF;;AUl+JA;EACE,WAAA;EACA,YAAA;AVq+JF;;AUh+JA;EAGE,kBAAA;AVm+JF;;AUh+JA;EAGE,kBAAA;AVm+JF;;AUh+JA;EAGE,kBAAA;AVm+JF;;AUh+JA;EAGE,mBAAA;AVm+JF;;AUh+JA;EAGE,mBAAA;AVm+JF;;AU99JA;EACE,eAAA;AVi+JF;;AU99JA;EACE,kBAAA;AVi+JF;;AU99JA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AVi+JF;;AU99JA;EACE,aAAA;AVi+JF;;AU99JA;EACE,6BAAA;AVi+JF;;AU59JA;EACE,iCAAA;AV+9JF;;AU39JA;EACE,uBAAA;EACA,uBAAA;EACA,eAAA;AV89JF;;AU19JA;EACE,4BAAA;EACA,gBAAA;AV69JF;;AU19JA,2CAAA;AACA;EACE,yBAAA;AV69JF;;AU19JA;EACE,kBAAA;AV69JF;;AU19JA;EACE,aAAA;AV69JF;;AUx9JA;EACE,eAAA;AV29JF;;AUx9JA;EACE,qBAAA;AV29JF;;AUx9JA;EACE,uBAAA;AV29JF;AUz9JE;EACE,uBAAA;AV29JJ;;AW97MA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AXi8MF;;AW97MA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AXi8MF;;AW97MA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AXi8MF;;AW97MA;EACE,YAAA;EACA,mBAAA;AXi8MF;;AW97MA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AXi8MF;;AW97MA;EACE,cAAA;AXi8MF;;AW77ME;EACE,YAAA;EACA,WAAA;AXg8MJ;;AW57MA;EACE,cAAA;AX+7MF;;AW57MA;EAEE,aAAA;AX87MF;AW57ME;EACE,mBPvBK;EOwBL,iBAAA;EACA,iBAAA;EACA,WAAA;AX87MJ;AW37ME;EACE,YAAA;EACA,eAAA;EACA,mBAAA;AX67MJ;AW17ME;EACE,kBAAA;AX47MJ;AW17MI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AX47MN;AWz7MI;EACE,oBAAA;AX27MN;AWx7MI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AX07MN;AWv7MI;EACE,mBAAA;EACA,WAAA;AXy7MN;AWt7MI;EACE,gBAAA;EACA,WAAA;AXw7MN;AWt7MM;EACE,WAAA;AXw7MR;AWp7MI;EACE,iBAAA;EACA,WAAA;AXs7MN;AWp7MM;EACE,YAAA;AXs7MR;AW/6ME;EACE,kBAAA;AXi7MJ;;AY5iNA;;;;;;;EAAA;AASA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,YAAA;EACA,oBAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EAGE,wBAAA;AZ8iNF;;AY3iNA;EACE,YAAA;AZ8iNF;;AY3iNA;EACE,aAAA;AZ8iNF;;AY3iNA;EACE,cAAA;AZ8iNF;;AY3iNA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EAEA,gCAAA;EAEA,0BAAA;EAEA,uCAAA;AZ8iNF;;AY1iNE;EACE,UAAA;AZ6iNJ;AY3iNE;EACE,UAAA;AZ6iNJ;AY3iNE;EACE,aAAA;AZ6iNJ;AY3iNE;EACE,cAAA;AZ6iNJ;;AapoNA;;;;;EAAA;AAOA;EACE,WAAA;EACA,YAAA;EACA,yBTTK;ESUL,cTMY;ESJZ,mDAAA;AbsoNF;AalnNA;EACE;IAEE,yDAAA;EbmoNF;EahoNA;IAEE,8DAAA;EbkoNF;Ea/nNA;IAEE,iEAAA;EbioNF;AACF;Aa9nNA;;;;;;;;EAAA;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cT9CY;AJ8qNd;;Aa7nNA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBTrEK;ESsEL,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,kDAAA;AbgoNF;;Aa7nNA;EAEE,oBAAA;AbgoNF;AajnNA;EACE;IAEE,mBAAA;Eb8nNF;Ea3nNA;IAEE,mBAAA;Eb6nNF;AACF;Aa1nNA;;;;;;;;;;;EAAA;AAYA;EACE,cTxGY;ESyGZ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;Ab4nNF;;AaznNA;EACE,yBThIK;ESiIL,YAAA;EACA,UAAA;EACA,qBAAA;EAEA,wDAAA;Ab4nNF;;AaznNA;EAEE,sBAAA;Ab4nNF;;AaznNA;EAEE,oBAAA;Ab4nNF;;AaznNA;EAEE,sBAAA;Ab4nNF;;AaznNA;EAEE,sBAAA;Ab4nNF;Aa7mNA;EACE;IAEE,sBAAA;Eb0nNF;EavnNA;IAEE,oBAAA;EbynNF;AACF;AatnNA;;;;;;;;EAAA;AASA;EACE,cT9KY;ES+KZ,WAAA;EACA,YAAA;EACA,kBAAA;AbwnNF;;AarnNA;EACE,yBTrMK;ESsML,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,yDAAA;AbwnNF;;AarnNA;EAEE,sBAAA;AbwnNF;AazlNA;EACE;IAEE,qDAAA;EbmnNF;EahnNA;IACE,kDAAA;IAEA,4DAAA;EbknNF;Ea/mNA;IAEE,4DAAA;EbinNF;Ea9mNA;IAEE,sEAAA;EbgnNF;Ea7mNA;IAEE,0BAAA;Eb+mNF;AACF;Aa5mNA;;;;;EAAA;AAMA;EACE,WAAA;EACA,YAAA;EACA,cTrQY;ESsQZ,yBTtRK;ESuRL,mBAAA;EAEA,mDAAA;Ab8mNF;Aa9lNA;EACE;IAEE,mBAAA;Eb4mNF;EazmNA;IAEE,mBAAA;IACA,UAAA;Eb2mNF;AACF;AaxmNA;;;;;;;;EAAA;AASA;EACE,cThTY;ESiTZ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAEA,kDAAA;Ab0mNF;;AavmNA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,yBT/UK;ESgVL,mBAAA;EAEA,uDAAA;Ab0mNF;;AavmNA;EACE,SAAA;EACA,SAAA;EAEA,oBAAA;Ab0mNF;AahmNA;EACE;IAEE,yBAAA;EbymNF;AACF;Aa1lNA;EACE;IAEE,mBAAA;EbsmNF;EanmNA;IAEE,mBAAA;EbqmNF;AACF;AalmNA;;;;;;;;;EAAA;AAUA;EACE,cT7XY;ES8XZ,WAAA;EACA,kBAAA;AbomNF;;AajmNA;EACE,WAAA;EACA,YAAA;EACA,yBTrZK;ESsZL,mBAAA;EACA,qBAAA;EAEA,wDAAA;EACA,8DAAA;EAEA,yBAAA;AbomNF;;AajmNA;EAEE,uBAAA;AbomNF;;AajmNA;EAEE,uBAAA;AbomNF;AarlNA;EACE;IAEE,mBAAA;EbkmNF;Ea/lNA;IAEE,mBAAA;EbimNF;AACF;Aa9lNA;;;;;;;;;;;;;;;;;;EAAA;AAmBA;EACE,cTrcY;ESscZ,WAAA;EACA,YAAA;EACA,kBAAA;AbgmNF;;Aa7lNA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AbgmNF;;Aa7lNA;EACE,WAAA;EACA,cAAA;EACA,cTtdY;ESudZ,UAAA;EACA,WAAA;EACA,yBTzeK;ES0eL,mBAAA;EAEA,yDAAA;EACA,8DAAA;EAEA,yBAAA;AbgmNF;;Aa7lNA;EAGE,wBAAA;AbgmNF;;Aa7lNA;EAGE,wBAAA;AbgmNF;;Aa7lNA;EAGE,wBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAGE,yBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,oBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;;Aa7lNA;EAEE,sBAAA;AbgmNF;AajlNA;EACE;IAEE,mBAAA;Eb8lNF;Ea3lNA;IAEE,mBAAA;Eb6lNF;AACF;Aa1lNA;;;;;;;;;;;;;;;EAAA;AAgBA;EACE;;;;;IAAA;AbimNF;;AazlNA;EACE,WAAA;EACA,YAAA;EACA,cT/oBY;AJ2uOd;;AazlNA;EACE,UAAA;EACA,WAAA;EACA,yBTrqBK;ESsqBL,WAAA;EAEA,0DAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;;AazlNA;EAEE,mBAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;;AazlNA;EAEE,qBAAA;Ab4lNF;Aa7kNA;EACE;IAEE,2BAAA;Eb0lNF;EavlNA;IAEE,2BAAA;EbylNF;AACF;AatlNA;;;;;;;EAAA;AAQA;EACE,yBTzvBK;ES0vBL,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cT9uBY;ESgvBZ,4CAAA;AbwlNF;;AarlNA;EACE,cAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AbwlNF;AazkNA;EACE;IAEE,oBAAA;EbslNF;EanlNA;IAEE,yBAAA;EbqlNF;AACF;AallNA;;;;;;;;;;;;;;;;;;EAAA;AAmBA;EACE,cT1yBY;ES2yBZ,WAAA;EACA,YAAA;EACA,kBAAA;AbolNF;;AajlNA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AbolNF;;AajlNA;EACE,WAAA;EACA,cAAA;EACA,cT3zBY;ES4zBZ,UAAA;EACA,WAAA;EACA,yBT90BK;ES+0BL,mBAAA;EAEA,uDAAA;EACA,8DAAA;EAEA,yBAAA;AbolNF;;AajlNA;EAGE,wBAAA;AbolNF;;AajlNA;EAGE,wBAAA;AbolNF;;AajlNA;EAGE,wBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAGE,yBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,oBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;;AajlNA;EAEE,sBAAA;AbolNF;AavkNA;EACE;IACE,UAAA;EbklNF;Ea/kNA;IACE,UAAA;EbilNF;AACF;Aa9kNA;EACE,aAAA;AbglNF;;Aa7kNA;EACE,kBAAA;AbglNF;;Aa7kNA;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AbglNF;;Aa5kNA;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;Ab+kNF;;Ac9kPA;;;;;CAAA;AAcA;EACE,yBAAA;AdykPF;;ActkPA;EACE,kBAAA;AdykPF;;ActkPA;EACE,yBAAA;AdykPF;;ActkPA;EACE,8BAAA;AdykPF;;ActkPA;EACE,yBAvBa;EAwBb,yDAAA;AdykPF;;ActkPA;EACE,mBA3Bc;AdomPhB;;ActkPA;EACE,uBAAA;AdykPF;;ActkPA;EACE,YAAA;AdykPF;;ActkPA;EACE,mBAAA;AdykPF;;ActkPA;EACE,cA1Ce;AdmnPjB;;ActkPA;EACE,yBAAA;AdykPF;;ActkPA;EACE,WAAA;AdykPF;;ActkPA;EACE,mBAxDa;EAyDb,qBAzDa;AdkoPf;;ActkPA;EACE,mBA5Dc;AdqoPhB;;ActkPA;EACE,mBAAA;AdykPF;;ActkPA;EACE,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,4BAAA;AdykPF;;ActkPA;EACE,gBAAA;AdykPF;;ActkPA;EACE,kBAAA;AdykPF;;ActkPA;EACE,mBAjFe;Ad0pPjB;;ActkPA;EACE,iBAAA;AdykPF;;ActkPA;EACE,qCAAA;AdykPF;;ActkPA;EACE,YAAA;AdykPF;;ActkPA;EACE,4BAAA;AdykPF;;ActkPA;EACE,WAAA;EACA,gBAAA;AdykPF;;ActkPA;EACE,WAAA;EACA,YAAA;AdykPF;;ActkPA;EACE,kBAAA;AdykPF;;ActkPA;EACE,kBAAA;AdykPF;;ActkPA;EACE,mBAAA;EACA,WAAA;AdykPF;;ActkPA;EACE,WAAA;AdykPF;;ActkPA;EACE,uBAAA;AdykPF;;ActkPA;;;;;CAAA;AAcA;EACE,yBAAA;AdikPF;;Ac9jPA;EACE,yBAAA;AdikPF;;Ac9jPA;EACE,kBAAA;AdikPF;;Ac9jPA;EACE,8BAAA;AdikPF;;Ac9jPA;EACE,yBAvBa;EAwBb,0DAAA;AdikPF;;Ac9jPA;EACE,mBA3Bc;Ad4lPhB;;Ac9jPA;EACE,uBAAA;AdikPF;;Ac9jPA;EACE,yBAAA;AdikPF;;Ac9jPA;EACE,YAAA;EACA,oCAAA;AdikPF;;Ac9jPA;EACE,yBAAA;AdikPF;;Ac9jPA;EACE,mBAAA;AdikPF;;Ac9jPA;EACE,eAAA;AdikPF;;Ac9jPA;EACE,cAAA;AdikPF;;Ac9jPA;EACE,cAAA;EACA,YAAA;AdikPF;;Ac9jPA;EACE,cAAA;AdikPF;;Ac9jPA;EACE,cApEkB;AdqoPpB;;Ac9jPA;EACE,mBAxEkB;AdyoPpB;;Ac9jPA;EACE,mBA9Ea;EA+Eb,qBA/Ea;AdgpPf;;Ac9jPA;EACE,8BAAA;AdikPF;;Ac9jPA;EACE,WAAA;AdikPF;;Ac9jPA;EACE,yBA1Fc;Ad2pPhB;;Ac9jPA;EACE,mBA7FkB;Ad8pPpB;;Ac9jPA;EACE,mBAjGkB;EAkGlB,8BAAA;AdikPF;;Ac9jPA;EACE,4BAAA;AdikPF;;Ac9jPA;EACE,oCAAA;EACA,8BAAA;EACA,gBAAA;EACA,4BAAA;AdikPF;;Ac9jPA;EACE,kBAAA;AdikPF;;Ac9jPA;EACE,yBAAA;AdikPF;;Ac9jPA;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;AdikPF;;Ac9jPA;EACE,oCAAA;EACA,uBAAA;AdikPF;;Ac9jPA;EACE,mBAAA;EAIA,yEAAA;EACA,oGAAA;AdikPF;;Ac9jPA;EACE,iBAAA;AdikPF;;Ac9jPA;EACE,qCAAA;AdikPF;;Ac9jPA;EACE,YAAA;AdikPF;;Ac9jPA;EACE,cAAA;EACA,gBAAA;AdikPF;;Ac9jPA;EACE,cAAA;EACA,YAAA;AdikPF;;Ac9jPA;EACE,mBAAA;AdikPF;;Ac9jPA;EACE,mBAAA;AdikPF;;Ac9jPA;EACE,mBAAA;EACA,cAAA;AdikPF;;Ac9jPA;EACE,WAAA;AdikPF;;Ac9jPA;EACE,uBAAA;AdikPF;;Ac9jPA;;;;;CAAA;AAcA;EACE,yBAAA;AdyjPF;;ActjPA;EACE,kBAAA;AdyjPF;;ActjPA;EACE,yBAAA;AdyjPF;;ActjPA;EACE,8BAAA;AdyjPF;;ActjPA;EACE,mBAtBc;Ad+kPhB;;ActjPA;EACE,yBA3Ba;EA4Bb,0DAAA;AdyjPF;;ActjPA;EACE,mBA/Bc;AdwlPhB;;ActjPA;EACE,uBAAA;AdyjPF;;ActjPA;EACE,YAAA;AdyjPF;;ActjPA;EACE,yBAAA;AdyjPF;;ActjPA;EACE,mBAAA;AdyjPF;;ActjPA;EACE,gBAAA;AdyjPF;;ActjPA;EACE,cAtDe;Ad+mPjB;;ActjPA;EACE,WAAA;AdyjPF;;ActjPA;EACE,mBAhEa;EAiEb,qBAjEa;Ad0nPf;;ActjPA;EACE,mBApEc;Ad6nPhB;;ActjPA;EACE,mBAAA;AdyjPF;;ActjPA;EACE,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,4BAAA;AdyjPF;;ActjPA;EACE,kBAAA;AdyjPF;;ActjPA;EACE,mBArFe;Ad8oPjB;;ActjPA;EACE,iBAAA;AdyjPF;;ActjPA;EACE,qCAAA;AdyjPF;;ActjPA;EACE,YAAA;AdyjPF;;ActjPA;EACE,4BAAA;AdyjPF;;ActjPA;EACE,WAAA;EACA,gBAAA;AdyjPF;;ActjPA;EACE,WAAA;EACA,YAAA;AdyjPF;;ActjPA;EACE,kBAAA;AdyjPF;;ActjPA;EACE,kBAAA;AdyjPF;;ActjPA;EACE,mBAAA;EACA,WAAA;AdyjPF;;ActjPA;EACE,WAAA;AdyjPF;;ActjPA;EACE,uBAAA;AdyjPF;;AcrjPA;;;;;CAAA;AAcA;EACE,yBAPU;EAQV,cAAA;AdgjPF;;Ac3iPE;EACE,eAAA;Ad8iPJ;Ac3iPE;EACE,iBAAA;Ad6iPJ;Ac1iPE;EACE,6BAAA;Ad4iPJ;AcziPE;;;;;;;;EAQE,uBAAA;Ad2iPJ;AcxiPE;EACE,yBAAA;Ad0iPJ;AcviPE;EACE,yBAzCQ;EA0CR,uEAzCgB;AdklPpB;ActiPE;EACE,gBAAA;AdwiPJ;AcriPE;EACE,yBAlDQ;AdylPZ;AcpiPE;EACE,uEArDgB;Ad2lPpB;Ac/hPE;EACE,yBA9DQ;Ad+lPZ;Ac9hPE;EACE,yBAlEQ;AdkmPZ;Ac7hPE;EACE,cAnEa;AdkmPjB;Ac5hPE;EACE,cAvEa;EAwEb,gBAAA;EACA,mBAAA;Ad8hPJ;Ac3hPE;EACE,gBAAA;EACA,mBAAA;Ad6hPJ;Ac1hPE;EACE,cAnFoB;EAoFpB,gBAAA;Ad4hPJ;AczhPE;EACE,cAxFoB;AdmnPxB;AcxhPE;EACE,yBAAA;EACA,cA7FoB;EA8FpB,gBAAA;Ad0hPJ;AcvhPE;EACE,eAAA;EACA,gBAAA;EACA,cApGoB;Ad6nPxB;ActhPE;EACE,yBAAA;EACA,eAAA;AdwhPJ;AcrhPE;EACE,yBA/GQ;EAgHR,sBAAA;EACA,4BAAA;AduhPJ;AcphPE;EACE,6BAAA;AdshPJ;AcnhPE;EACE,mBAzHQ;Ad8oPZ;AclhPE;EACE,mBA7HQ;AdipPZ;AcjhPE;EACE,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,wBAAA;EACA,uEArIgB;AdwpPpB;AchhPE;EACE,oBAAA;AdkhPJ;Ac/gPE;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;AdihPJ;Ac9gPE;EACE,eAAA;AdghPJ;Ac7gPE;EACE,UAAA;Ad+gPJ;Ac7gPI;EACE,yBAAA;Ad+gPN;Ac3gPE;EACE,sBAAA;EACA,mBAAA;Ad6gPJ;Ac1gPE;EACE,uEApKgB;EAqKhB,kBAAA;EACA,YAAA;EACA,yBAAA;Ad4gPJ;AczgPE;EACE,6BAAA;Ad2gPJ;AcxgPE;EACE,yBAAA;Ad0gPJ;AcvgPE;EACE,YAAA;EACA,gBAAA;AdygPJ;ActgPE;EACE,sBAAA;AdwgPJ;AcrgPE;EACE,qCAAA;AdugPJ;AcpgPE;EACE,0BAAA;AdsgPJ;AcngPE;EACE,2CAAA;AdqgPJ;AcngPE;EACE,6BAAA;AdqgPJ;AclgPE;EACE,yBAAA;AdogPJ;AcjgPE;EACE,yBAAA;AdmgPJ;AchgPE;EACE,eAAA;EACA,YAAA;EACA,uEArNgB;EAsNhB,kBAAA;AdkgPJ;Ac//OE;EACE,uEA1NgB;EA2NhB,YAAA;AdigPJ;Ac9/OE;;EAEE,cAAA;AdggPJ;;Ae3sQA;EACE;IACE,iBAAA;IACA,iBAAA;Ef8sQF;;Ee3sQA;IACE,aAAA;IACA,gBXoBY;EJ0rQd;;Ee3sQA;;;IAGE,iBAAA;Ef8sQF;AACF;Ae3sQA;EAEE;IACE,iBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;Ef4sQF;;EezsQA;IACE,cAAA;IACA,aAAA;IACA,QAAA;IACA,gBAAA;Ef4sQF;;EezsQA;IACE,cAAA;IACA,iBAAA;Ef4sQF;;EezsQA;IACE,aAAA;Ef4sQF;;EezsQA;IACE,aAAA;Ef4sQF;;EezsQA;IACE,eAAA;IACA,WAAA;Ef4sQF;;EezsQA;IACE,UAAA;IACA,kBAAA;IACA,WAAA;IACA,2BAAA;Ef4sQF;;EezsQA;IACE,gBAAA;IACA,UAAA;Ef4sQF;;EezsQA;IACE,aAAA;IACA,aAAA;IACA,eAAA;IACA,YXxCY;EJovQd;;EezsQA;IACE,cAAA;Ef4sQF;;EezsQA;IACE,WAAA;IACA,iBAAA;IACA,cAAA;Ef4sQF;;EezsQA;IACE,aAAA;Ef4sQF;;EezsQA;IAKE,yCAAA;IACA,yBAAA;Ef4sQF;AACF;AexsQA;EAEE;IACE,gBAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;EfysQF;;EetsQA;IACE,kBAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,yBAAA;IACA,mBAAA;EfysQF;;EetsQA;IACE,iBAAA;IACA,6BAAA;IACA,iBAAA;IACA,iBAAA;EfysQF;;EetsQA;IACE,aAAA;EfysQF;;EetsQA;IACE,WAAA;IACA,gBAAA;IACA,qBAAA;EfysQF;AACF;AA1yQA;EACE;IACE,aAAA;EA4yQF;;EAzyQA;IAAO,4BAAA;EA6yQP;;EA3yQA;IACE,SAAA;EA8yQF;AACF","sourcesContent":["/*\n *\n *   INSPINIA - Responsive Admin Theme\n *   version 2.9.3\n *\n*/\n@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700\");\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:400,300,500,700\");\n\n// Variables, Mixins\n@import \"base/variables\";\n@import \"base/mixins\";\n\n// INSPINIA Theme Elements\n@import \"base/typography\";\n@import \"base/glyphicons\";\n@import \"base/navigation\";\n@import \"base/top_navigation\";\n@import \"base/buttons\";\n@import \"base/badges_labels\";\n@import \"base/elements\";\n@import \"base/sidebar\";\n@import \"base/base\";\n@import \"base/chat\";\n@import \"base/metismenu\";\n@import \"base/spinners\";\n\n// INSPINIA Skins\n@import \"base/skins\";\n\n// Media query style\n@import \"base/media\";\n\n// Clear layout on print mode\n@media print {\n  nav.navbar-static-side {\n    display: none;\n  }\n\n  body { overflow: visible !important; }\n\n  #page-wrapper {\n    margin: 0;\n  }\n}\n","h1, h2, h3, h4, h5, h6 {\n  font-weight: 100;\n}\n\n.h1, .h2, .h3, h1, h2, h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\nh1 {\n  font-size: 30px;\n}\n\nh2 {\n  font-size: 24px;\n}\n\nh3 {\n  font-size: 16px;\n}\n\nh4 {\n  font-size: 14px;\n}\n\nh5 {\n  font-size: 12px;\n}\n\nh6 {\n  font-size: 10px;\n}\n\nh3, h4, h5 {\n  margin-top: 5px;\n  font-weight: 600;\n}","// Glyphicons for Bootstrap\n//\n// Since icons are fonts, they can be placed anywhere text is placed and are\n// thus automatically sized to match the surrounding child. To use, create an\n// inline element with the appropriate classes, like so:\n//\n// <a href=\"#\"><span class=\"glyphicon glyphicon-star\"></span> Star</a>\n\n// Import the fonts\n@font-face {\n  font-family: 'Glyphicons Halflings';\n  src: url(../../../../fonts/glyphicons-halflings-regular.eot);\n  src: url(../../../../fonts/glyphicons-halflings-regular.eot?#iefixx) format('embedded-opentype'),\n  url(../../../../fonts/glyphicons-halflings-regular.woff2) format('woff2'),\n  url(../../../../fonts/glyphicons-halflings-regular.woff) format('woff'),\n  url(../../../../fonts/glyphicons-halflings-regular.ttf) format('truetype'),\n  url(../../../../fonts/glyphicons-halflings-regular.svg) format('svg');\n}\n\n// Catchall baseclass\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// Individual icons\n.glyphicon-asterisk {\n  &:before {\n    content: \"\\002a\";\n  }\n}\n\n.glyphicon-plus {\n  &:before {\n    content: \"\\002b\";\n  }\n}\n\n.glyphicon-euro,\n.glyphicon-eur {\n  &:before {\n    content: \"\\20ac\";\n  }\n}\n\n.glyphicon-minus {\n  &:before {\n    content: \"\\2212\";\n  }\n}\n\n.glyphicon-cloud {\n  &:before {\n    content: \"\\2601\";\n  }\n}\n\n.glyphicon-envelope {\n  &:before {\n    content: \"\\2709\";\n  }\n}\n\n.glyphicon-pencil {\n  &:before {\n    content: \"\\270f\";\n  }\n}\n\n.glyphicon-glass {\n  &:before {\n    content: \"\\e001\";\n  }\n}\n\n.glyphicon-music {\n  &:before {\n    content: \"\\e002\";\n  }\n}\n\n.glyphicon-search {\n  &:before {\n    content: \"\\e003\";\n  }\n}\n\n.glyphicon-heart {\n  &:before {\n    content: \"\\e005\";\n  }\n}\n\n.glyphicon-star {\n  &:before {\n    content: \"\\e006\";\n  }\n}\n\n.glyphicon-star-empty {\n  &:before {\n    content: \"\\e007\";\n  }\n}\n\n.glyphicon-user {\n  &:before {\n    content: \"\\e008\";\n  }\n}\n\n.glyphicon-film {\n  &:before {\n    content: \"\\e009\";\n  }\n}\n\n.glyphicon-th-large {\n  &:before {\n    content: \"\\e010\";\n  }\n}\n\n.glyphicon-th {\n  &:before {\n    content: \"\\e011\";\n  }\n}\n\n.glyphicon-th-list {\n  &:before {\n    content: \"\\e012\";\n  }\n}\n\n.glyphicon-ok {\n  &:before {\n    content: \"\\e013\";\n  }\n}\n\n.glyphicon-remove {\n  &:before {\n    content: \"\\e014\";\n  }\n}\n\n.glyphicon-zoom-in {\n  &:before {\n    content: \"\\e015\";\n  }\n}\n\n.glyphicon-zoom-out {\n  &:before {\n    content: \"\\e016\";\n  }\n}\n\n.glyphicon-off {\n  &:before {\n    content: \"\\e017\";\n  }\n}\n\n.glyphicon-signal {\n  &:before {\n    content: \"\\e018\";\n  }\n}\n\n.glyphicon-cog {\n  &:before {\n    content: \"\\e019\";\n  }\n}\n\n.glyphicon-trash {\n  &:before {\n    content: \"\\e020\";\n  }\n}\n\n.glyphicon-home {\n  &:before {\n    content: \"\\e021\";\n  }\n}\n\n.glyphicon-file {\n  &:before {\n    content: \"\\e022\";\n  }\n}\n\n.glyphicon-time {\n  &:before {\n    content: \"\\e023\";\n  }\n}\n\n.glyphicon-road {\n  &:before {\n    content: \"\\e024\";\n  }\n}\n\n.glyphicon-download-alt {\n  &:before {\n    content: \"\\e025\";\n  }\n}\n\n.glyphicon-download {\n  &:before {\n    content: \"\\e026\";\n  }\n}\n\n.glyphicon-upload {\n  &:before {\n    content: \"\\e027\";\n  }\n}\n\n.glyphicon-inbox {\n  &:before {\n    content: \"\\e028\";\n  }\n}\n\n.glyphicon-play-circle {\n  &:before {\n    content: \"\\e029\";\n  }\n}\n\n.glyphicon-repeat {\n  &:before {\n    content: \"\\e030\";\n  }\n}\n\n.glyphicon-refresh {\n  &:before {\n    content: \"\\e031\";\n  }\n}\n\n.glyphicon-list-alt {\n  &:before {\n    content: \"\\e032\";\n  }\n}\n\n.glyphicon-lock {\n  &:before {\n    content: \"\\e033\";\n  }\n}\n\n.glyphicon-flag {\n  &:before {\n    content: \"\\e034\";\n  }\n}\n\n.glyphicon-headphones {\n  &:before {\n    content: \"\\e035\";\n  }\n}\n\n.glyphicon-volume-off {\n  &:before {\n    content: \"\\e036\";\n  }\n}\n\n.glyphicon-volume-down {\n  &:before {\n    content: \"\\e037\";\n  }\n}\n\n.glyphicon-volume-up {\n  &:before {\n    content: \"\\e038\";\n  }\n}\n\n.glyphicon-qrcode {\n  &:before {\n    content: \"\\e039\";\n  }\n}\n\n.glyphicon-barcode {\n  &:before {\n    content: \"\\e040\";\n  }\n}\n\n.glyphicon-tag {\n  &:before {\n    content: \"\\e041\";\n  }\n}\n\n.glyphicon-tags {\n  &:before {\n    content: \"\\e042\";\n  }\n}\n\n.glyphicon-book {\n  &:before {\n    content: \"\\e043\";\n  }\n}\n\n.glyphicon-bookmark {\n  &:before {\n    content: \"\\e044\";\n  }\n}\n\n.glyphicon-print {\n  &:before {\n    content: \"\\e045\";\n  }\n}\n\n.glyphicon-camera {\n  &:before {\n    content: \"\\e046\";\n  }\n}\n\n.glyphicon-font {\n  &:before {\n    content: \"\\e047\";\n  }\n}\n\n.glyphicon-bold {\n  &:before {\n    content: \"\\e048\";\n  }\n}\n\n.glyphicon-italic {\n  &:before {\n    content: \"\\e049\";\n  }\n}\n\n.glyphicon-text-height {\n  &:before {\n    content: \"\\e050\";\n  }\n}\n\n.glyphicon-text-width {\n  &:before {\n    content: \"\\e051\";\n  }\n}\n\n.glyphicon-align-left {\n  &:before {\n    content: \"\\e052\";\n  }\n}\n\n.glyphicon-align-center {\n  &:before {\n    content: \"\\e053\";\n  }\n}\n\n.glyphicon-align-right {\n  &:before {\n    content: \"\\e054\";\n  }\n}\n\n.glyphicon-align-justify {\n  &:before {\n    content: \"\\e055\";\n  }\n}\n\n.glyphicon-list {\n  &:before {\n    content: \"\\e056\";\n  }\n}\n\n.glyphicon-indent-left {\n  &:before {\n    content: \"\\e057\";\n  }\n}\n\n.glyphicon-indent-right {\n  &:before {\n    content: \"\\e058\";\n  }\n}\n\n.glyphicon-facetime-video {\n  &:before {\n    content: \"\\e059\";\n  }\n}\n\n.glyphicon-picture {\n  &:before {\n    content: \"\\e060\";\n  }\n}\n\n.glyphicon-map-marker {\n  &:before {\n    content: \"\\e062\";\n  }\n}\n\n.glyphicon-adjust {\n  &:before {\n    content: \"\\e063\";\n  }\n}\n\n.glyphicon-tint {\n  &:before {\n    content: \"\\e064\";\n  }\n}\n\n.glyphicon-edit {\n  &:before {\n    content: \"\\e065\";\n  }\n}\n\n.glyphicon-share {\n  &:before {\n    content: \"\\e066\";\n  }\n}\n\n.glyphicon-check {\n  &:before {\n    content: \"\\e067\";\n  }\n}\n\n.glyphicon-move {\n  &:before {\n    content: \"\\e068\";\n  }\n}\n\n.glyphicon-step-backward {\n  &:before {\n    content: \"\\e069\";\n  }\n}\n\n.glyphicon-fast-backward {\n  &:before {\n    content: \"\\e070\";\n  }\n}\n\n.glyphicon-backward {\n  &:before {\n    content: \"\\e071\";\n  }\n}\n\n.glyphicon-play {\n  &:before {\n    content: \"\\e072\";\n  }\n}\n\n.glyphicon-pause {\n  &:before {\n    content: \"\\e073\";\n  }\n}\n\n.glyphicon-stop {\n  &:before {\n    content: \"\\e074\";\n  }\n}\n\n.glyphicon-forward {\n  &:before {\n    content: \"\\e075\";\n  }\n}\n\n.glyphicon-fast-forward {\n  &:before {\n    content: \"\\e076\";\n  }\n}\n\n.glyphicon-step-forward {\n  &:before {\n    content: \"\\e077\";\n  }\n}\n\n.glyphicon-eject {\n  &:before {\n    content: \"\\e078\";\n  }\n}\n\n.glyphicon-chevron-left {\n  &:before {\n    content: \"\\e079\";\n  }\n}\n\n.glyphicon-chevron-right {\n  &:before {\n    content: \"\\e080\";\n  }\n}\n\n.glyphicon-plus-sign {\n  &:before {\n    content: \"\\e081\";\n  }\n}\n\n.glyphicon-minus-sign {\n  &:before {\n    content: \"\\e082\";\n  }\n}\n\n.glyphicon-remove-sign {\n  &:before {\n    content: \"\\e083\";\n  }\n}\n\n.glyphicon-ok-sign {\n  &:before {\n    content: \"\\e084\";\n  }\n}\n\n.glyphicon-question-sign {\n  &:before {\n    content: \"\\e085\";\n  }\n}\n\n.glyphicon-info-sign {\n  &:before {\n    content: \"\\e086\";\n  }\n}\n\n.glyphicon-screenshot {\n  &:before {\n    content: \"\\e087\";\n  }\n}\n\n.glyphicon-remove-circle {\n  &:before {\n    content: \"\\e088\";\n  }\n}\n\n.glyphicon-ok-circle {\n  &:before {\n    content: \"\\e089\";\n  }\n}\n\n.glyphicon-ban-circle {\n  &:before {\n    content: \"\\e090\";\n  }\n}\n\n.glyphicon-arrow-left {\n  &:before {\n    content: \"\\e091\";\n  }\n}\n\n.glyphicon-arrow-right {\n  &:before {\n    content: \"\\e092\";\n  }\n}\n\n.glyphicon-arrow-up {\n  &:before {\n    content: \"\\e093\";\n  }\n}\n\n.glyphicon-arrow-down {\n  &:before {\n    content: \"\\e094\";\n  }\n}\n\n.glyphicon-share-alt {\n  &:before {\n    content: \"\\e095\";\n  }\n}\n\n.glyphicon-resize-full {\n  &:before {\n    content: \"\\e096\";\n  }\n}\n\n.glyphicon-resize-small {\n  &:before {\n    content: \"\\e097\";\n  }\n}\n\n.glyphicon-exclamation-sign {\n  &:before {\n    content: \"\\e101\";\n  }\n}\n\n.glyphicon-gift {\n  &:before {\n    content: \"\\e102\";\n  }\n}\n\n.glyphicon-leaf {\n  &:before {\n    content: \"\\e103\";\n  }\n}\n\n.glyphicon-fire {\n  &:before {\n    content: \"\\e104\";\n  }\n}\n\n.glyphicon-eye-open {\n  &:before {\n    content: \"\\e105\";\n  }\n}\n\n.glyphicon-eye-close {\n  &:before {\n    content: \"\\e106\";\n  }\n}\n\n.glyphicon-warning-sign {\n  &:before {\n    content: \"\\e107\";\n  }\n}\n\n.glyphicon-plane {\n  &:before {\n    content: \"\\e108\";\n  }\n}\n\n.glyphicon-calendar {\n  &:before {\n    content: \"\\e109\";\n  }\n}\n\n.glyphicon-random {\n  &:before {\n    content: \"\\e110\";\n  }\n}\n\n.glyphicon-comment {\n  &:before {\n    content: \"\\e111\";\n  }\n}\n\n.glyphicon-magnet {\n  &:before {\n    content: \"\\e112\";\n  }\n}\n\n.glyphicon-chevron-up {\n  &:before {\n    content: \"\\e113\";\n  }\n}\n\n.glyphicon-chevron-down {\n  &:before {\n    content: \"\\e114\";\n  }\n}\n\n.glyphicon-retweet {\n  &:before {\n    content: \"\\e115\";\n  }\n}\n\n.glyphicon-shopping-cart {\n  &:before {\n    content: \"\\e116\";\n  }\n}\n\n.glyphicon-folder-close {\n  &:before {\n    content: \"\\e117\";\n  }\n}\n\n.glyphicon-folder-open {\n  &:before {\n    content: \"\\e118\";\n  }\n}\n\n.glyphicon-resize-vertical {\n  &:before {\n    content: \"\\e119\";\n  }\n}\n\n.glyphicon-resize-horizontal {\n  &:before {\n    content: \"\\e120\";\n  }\n}\n\n.glyphicon-hdd {\n  &:before {\n    content: \"\\e121\";\n  }\n}\n\n.glyphicon-bullhorn {\n  &:before {\n    content: \"\\e122\";\n  }\n}\n\n.glyphicon-bell {\n  &:before {\n    content: \"\\e123\";\n  }\n}\n\n.glyphicon-certificate {\n  &:before {\n    content: \"\\e124\";\n  }\n}\n\n.glyphicon-thumbs-up {\n  &:before {\n    content: \"\\e125\";\n  }\n}\n\n.glyphicon-thumbs-down {\n  &:before {\n    content: \"\\e126\";\n  }\n}\n\n.glyphicon-hand-right {\n  &:before {\n    content: \"\\e127\";\n  }\n}\n\n.glyphicon-hand-left {\n  &:before {\n    content: \"\\e128\";\n  }\n}\n\n.glyphicon-hand-up {\n  &:before {\n    content: \"\\e129\";\n  }\n}\n\n.glyphicon-hand-down {\n  &:before {\n    content: \"\\e130\";\n  }\n}\n\n.glyphicon-circle-arrow-right {\n  &:before {\n    content: \"\\e131\";\n  }\n}\n\n.glyphicon-circle-arrow-left {\n  &:before {\n    content: \"\\e132\";\n  }\n}\n\n.glyphicon-circle-arrow-up {\n  &:before {\n    content: \"\\e133\";\n  }\n}\n\n.glyphicon-circle-arrow-down {\n  &:before {\n    content: \"\\e134\";\n  }\n}\n\n.glyphicon-globe {\n  &:before {\n    content: \"\\e135\";\n  }\n}\n\n.glyphicon-wrench {\n  &:before {\n    content: \"\\e136\";\n  }\n}\n\n.glyphicon-tasks {\n  &:before {\n    content: \"\\e137\";\n  }\n}\n\n.glyphicon-filter {\n  &:before {\n    content: \"\\e138\";\n  }\n}\n\n.glyphicon-briefcase {\n  &:before {\n    content: \"\\e139\";\n  }\n}\n\n.glyphicon-fullscreen {\n  &:before {\n    content: \"\\e140\";\n  }\n}\n\n.glyphicon-dashboard {\n  &:before {\n    content: \"\\e141\";\n  }\n}\n\n.glyphicon-paperclip {\n  &:before {\n    content: \"\\e142\";\n  }\n}\n\n.glyphicon-heart-empty {\n  &:before {\n    content: \"\\e143\";\n  }\n}\n\n.glyphicon-link {\n  &:before {\n    content: \"\\e144\";\n  }\n}\n\n.glyphicon-phone {\n  &:before {\n    content: \"\\e145\";\n  }\n}\n\n.glyphicon-pushpin {\n  &:before {\n    content: \"\\e146\";\n  }\n}\n\n.glyphicon-usd {\n  &:before {\n    content: \"\\e148\";\n  }\n}\n\n.glyphicon-gbp {\n  &:before {\n    content: \"\\e149\";\n  }\n}\n\n.glyphicon-sort {\n  &:before {\n    content: \"\\e150\";\n  }\n}\n\n.glyphicon-sort-by-alphabet {\n  &:before {\n    content: \"\\e151\";\n  }\n}\n\n.glyphicon-sort-by-alphabet-alt {\n  &:before {\n    content: \"\\e152\";\n  }\n}\n\n.glyphicon-sort-by-order {\n  &:before {\n    content: \"\\e153\";\n  }\n}\n\n.glyphicon-sort-by-order-alt {\n  &:before {\n    content: \"\\e154\";\n  }\n}\n\n.glyphicon-sort-by-attributes {\n  &:before {\n    content: \"\\e155\";\n  }\n}\n\n.glyphicon-sort-by-attributes-alt {\n  &:before {\n    content: \"\\e156\";\n  }\n}\n\n.glyphicon-unchecked {\n  &:before {\n    content: \"\\e157\";\n  }\n}\n\n.glyphicon-expand {\n  &:before {\n    content: \"\\e158\";\n  }\n}\n\n.glyphicon-collapse-down {\n  &:before {\n    content: \"\\e159\";\n  }\n}\n\n.glyphicon-collapse-up {\n  &:before {\n    content: \"\\e160\";\n  }\n}\n\n.glyphicon-log-in {\n  &:before {\n    content: \"\\e161\";\n  }\n}\n\n.glyphicon-flash {\n  &:before {\n    content: \"\\e162\";\n  }\n}\n\n.glyphicon-log-out {\n  &:before {\n    content: \"\\e163\";\n  }\n}\n\n.glyphicon-new-window {\n  &:before {\n    content: \"\\e164\";\n  }\n}\n\n.glyphicon-record {\n  &:before {\n    content: \"\\e165\";\n  }\n}\n\n.glyphicon-save {\n  &:before {\n    content: \"\\e166\";\n  }\n}\n\n.glyphicon-open {\n  &:before {\n    content: \"\\e167\";\n  }\n}\n\n.glyphicon-saved {\n  &:before {\n    content: \"\\e168\";\n  }\n}\n\n.glyphicon-import {\n  &:before {\n    content: \"\\e169\";\n  }\n}\n\n.glyphicon-export {\n  &:before {\n    content: \"\\e170\";\n  }\n}\n\n.glyphicon-send {\n  &:before {\n    content: \"\\e171\";\n  }\n}\n\n.glyphicon-floppy-disk {\n  &:before {\n    content: \"\\e172\";\n  }\n}\n\n.glyphicon-floppy-saved {\n  &:before {\n    content: \"\\e173\";\n  }\n}\n\n.glyphicon-floppy-remove {\n  &:before {\n    content: \"\\e174\";\n  }\n}\n\n.glyphicon-floppy-save {\n  &:before {\n    content: \"\\e175\";\n  }\n}\n\n.glyphicon-floppy-open {\n  &:before {\n    content: \"\\e176\";\n  }\n}\n\n.glyphicon-credit-card {\n  &:before {\n    content: \"\\e177\";\n  }\n}\n\n.glyphicon-transfer {\n  &:before {\n    content: \"\\e178\";\n  }\n}\n\n.glyphicon-cutlery {\n  &:before {\n    content: \"\\e179\";\n  }\n}\n\n.glyphicon-header {\n  &:before {\n    content: \"\\e180\";\n  }\n}\n\n.glyphicon-compressed {\n  &:before {\n    content: \"\\e181\";\n  }\n}\n\n.glyphicon-earphone {\n  &:before {\n    content: \"\\e182\";\n  }\n}\n\n.glyphicon-phone-alt {\n  &:before {\n    content: \"\\e183\";\n  }\n}\n\n.glyphicon-tower {\n  &:before {\n    content: \"\\e184\";\n  }\n}\n\n.glyphicon-stats {\n  &:before {\n    content: \"\\e185\";\n  }\n}\n\n.glyphicon-sd-video {\n  &:before {\n    content: \"\\e186\";\n  }\n}\n\n.glyphicon-hd-video {\n  &:before {\n    content: \"\\e187\";\n  }\n}\n\n.glyphicon-subtitles {\n  &:before {\n    content: \"\\e188\";\n  }\n}\n\n.glyphicon-sound-stereo {\n  &:before {\n    content: \"\\e189\";\n  }\n}\n\n.glyphicon-sound-dolby {\n  &:before {\n    content: \"\\e190\";\n  }\n}\n\n.glyphicon-sound-5-1 {\n  &:before {\n    content: \"\\e191\";\n  }\n}\n\n.glyphicon-sound-6-1 {\n  &:before {\n    content: \"\\e192\";\n  }\n}\n\n.glyphicon-sound-7-1 {\n  &:before {\n    content: \"\\e193\";\n  }\n}\n\n.glyphicon-copyright-mark {\n  &:before {\n    content: \"\\e194\";\n  }\n}\n\n.glyphicon-registration-mark {\n  &:before {\n    content: \"\\e195\";\n  }\n}\n\n.glyphicon-cloud-download {\n  &:before {\n    content: \"\\e197\";\n  }\n}\n\n.glyphicon-cloud-upload {\n  &:before {\n    content: \"\\e198\";\n  }\n}\n\n.glyphicon-tree-conifer {\n  &:before {\n    content: \"\\e199\";\n  }\n}\n\n.glyphicon-tree-deciduous {\n  &:before {\n    content: \"\\e200\";\n  }\n}\n\n.glyphicon-cd {\n  &:before {\n    content: \"\\e201\";\n  }\n}\n\n.glyphicon-save-file {\n  &:before {\n    content: \"\\e202\";\n  }\n}\n\n.glyphicon-open-file {\n  &:before {\n    content: \"\\e203\";\n  }\n}\n\n.glyphicon-level-up {\n  &:before {\n    content: \"\\e204\";\n  }\n}\n\n.glyphicon-copy {\n  &:before {\n    content: \"\\e205\";\n  }\n}\n\n.glyphicon-paste {\n  &:before {\n    content: \"\\e206\";\n  }\n}\n\n// The following 2 Glyphicons are omitted for the time being because\n// they currently use Unicode codepoints that are outside the\n// Basic Multilingual Plane (BMP). Older buggy versions of WebKit can't handle\n// non-BMP codepoints in CSS string escapes, and thus can't display these two icons.\n// Notably, the bug affects some older versions of the Android Browser.\n// More info: https://github.com/twbs/bootstrap/issues/10106\n// .glyphicon-door                   { &:before { content: \"\\1f6aa\"; } }\n// .glyphicon-key                    { &:before { content: \"\\1f511\"; } }\n.glyphicon-alert {\n  &:before {\n    content: \"\\e209\";\n  }\n}\n\n.glyphicon-equalizer {\n  &:before {\n    content: \"\\e210\";\n  }\n}\n\n.glyphicon-king {\n  &:before {\n    content: \"\\e211\";\n  }\n}\n\n.glyphicon-queen {\n  &:before {\n    content: \"\\e212\";\n  }\n}\n\n.glyphicon-pawn {\n  &:before {\n    content: \"\\e213\";\n  }\n}\n\n.glyphicon-bishop {\n  &:before {\n    content: \"\\e214\";\n  }\n}\n\n.glyphicon-knight {\n  &:before {\n    content: \"\\e215\";\n  }\n}\n\n.glyphicon-baby-formula {\n  &:before {\n    content: \"\\e216\";\n  }\n}\n\n.glyphicon-tent {\n  &:before {\n    content: \"\\26fa\";\n  }\n}\n\n.glyphicon-blackboard {\n  &:before {\n    content: \"\\e218\";\n  }\n}\n\n.glyphicon-bed {\n  &:before {\n    content: \"\\e219\";\n  }\n}\n\n.glyphicon-apple {\n  &:before {\n    content: \"\\f8ff\";\n  }\n}\n\n.glyphicon-erase {\n  &:before {\n    content: \"\\e221\";\n  }\n}\n\n.glyphicon-hourglass {\n  &:before {\n    content: \"\\231b\";\n  }\n}\n\n.glyphicon-lamp {\n  &:before {\n    content: \"\\e223\";\n  }\n}\n\n.glyphicon-duplicate {\n  &:before {\n    content: \"\\e224\";\n  }\n}\n\n.glyphicon-piggy-bank {\n  &:before {\n    content: \"\\e225\";\n  }\n}\n\n.glyphicon-scissors {\n  &:before {\n    content: \"\\e226\";\n  }\n}\n\n.glyphicon-bitcoin {\n  &:before {\n    content: \"\\e227\";\n  }\n}\n\n.glyphicon-btc {\n  &:before {\n    content: \"\\e227\";\n  }\n}\n\n.glyphicon-xbt {\n  &:before {\n    content: \"\\e227\";\n  }\n}\n\n.glyphicon-yen {\n  &:before {\n    content: \"\\00a5\";\n  }\n}\n\n.glyphicon-jpy {\n  &:before {\n    content: \"\\00a5\";\n  }\n}\n\n.glyphicon-ruble {\n  &:before {\n    content: \"\\20bd\";\n  }\n}\n\n.glyphicon-rub {\n  &:before {\n    content: \"\\20bd\";\n  }\n}\n\n.glyphicon-scale {\n  &:before {\n    content: \"\\e230\";\n  }\n}\n\n.glyphicon-ice-lolly {\n  &:before {\n    content: \"\\e231\";\n  }\n}\n\n.glyphicon-ice-lolly-tasted {\n  &:before {\n    content: \"\\e232\";\n  }\n}\n\n.glyphicon-education {\n  &:before {\n    content: \"\\e233\";\n  }\n}\n\n.glyphicon-option-horizontal {\n  &:before {\n    content: \"\\e234\";\n  }\n}\n\n.glyphicon-option-vertical {\n  &:before {\n    content: \"\\e235\";\n  }\n}\n\n.glyphicon-menu-hamburger {\n  &:before {\n    content: \"\\e236\";\n  }\n}\n\n.glyphicon-modal-window {\n  &:before {\n    content: \"\\e237\";\n  }\n}\n\n.glyphicon-oil {\n  &:before {\n    content: \"\\e238\";\n  }\n}\n\n.glyphicon-grain {\n  &:before {\n    content: \"\\e239\";\n  }\n}\n\n.glyphicon-sunglasses {\n  &:before {\n    content: \"\\e240\";\n  }\n}\n\n.glyphicon-text-size {\n  &:before {\n    content: \"\\e241\";\n  }\n}\n\n.glyphicon-text-color {\n  &:before {\n    content: \"\\e242\";\n  }\n}\n\n.glyphicon-text-background {\n  &:before {\n    content: \"\\e243\";\n  }\n}\n\n.glyphicon-object-align-top {\n  &:before {\n    content: \"\\e244\";\n  }\n}\n\n.glyphicon-object-align-bottom {\n  &:before {\n    content: \"\\e245\";\n  }\n}\n\n.glyphicon-object-align-horizontal {\n  &:before {\n    content: \"\\e246\";\n  }\n}\n\n.glyphicon-object-align-left {\n  &:before {\n    content: \"\\e247\";\n  }\n}\n\n.glyphicon-object-align-vertical {\n  &:before {\n    content: \"\\e248\";\n  }\n}\n\n.glyphicon-object-align-right {\n  &:before {\n    content: \"\\e249\";\n  }\n}\n\n.glyphicon-triangle-right {\n  &:before {\n    content: \"\\e250\";\n  }\n}\n\n.glyphicon-triangle-left {\n  &:before {\n    content: \"\\e251\";\n  }\n}\n\n.glyphicon-triangle-bottom {\n  &:before {\n    content: \"\\e252\";\n  }\n}\n\n.glyphicon-triangle-top {\n  &:before {\n    content: \"\\e253\";\n  }\n}\n\n.glyphicon-console {\n  &:before {\n    content: \"\\e254\";\n  }\n}\n\n.glyphicon-superscript {\n  &:before {\n    content: \"\\e255\";\n  }\n}\n\n.glyphicon-subscript {\n  &:before {\n    content: \"\\e256\";\n  }\n}\n\n.glyphicon-menu-left {\n  &:before {\n    content: \"\\e257\";\n  }\n}\n\n.glyphicon-menu-right {\n  &:before {\n    content: \"\\e258\";\n  }\n}\n\n.glyphicon-menu-down {\n  &:before {\n    content: \"\\e259\";\n  }\n}\n\n.glyphicon-menu-up {\n  &:before {\n    content: \"\\e260\";\n  }\n}",".nav > li > a {\n  color: #6E6E6E;\n  font-weight: 600;\n  padding: 14px 20px 14px 20px;\n  display: block;\n  &:hover, &:focus {\n    text-decoration: none;\n  }\n}\n\n.nav.metismenu > li {\n  display: block;\n  width: 100%;\n  position: relative;\n}\n\n.nav.metismenu .dropdown-menu > li > a {\n  padding: 3px 20px;\n  display: block;\n}\n\n.nav.navbar-right > li > a {\n  color: #999c9e;\n}\n\n.nav > li.active > a {\n  color: #ffffff;\n}\n\n.navbar-default .nav > li > a:hover, .navbar-default .nav > li > a:focus {\n  color: #242424;\n}\n\n.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {\n  background: #fff;\n}\n\n.nav.navbar-top-links > li > a:hover, .nav.navbar-top-links > li > a:focus {\n  background-color: transparent;\n}\n\n.nav > li > a i {\n  margin-right: 6px;\n}\n\n.navbar {\n  border: 0;\n}\n\n.navbar-default {\n  background-color: transparent;\n  border-color: $nav-bg;\n}\n\n.navbar-top-links li {\n  display: inline-block;\n  align-self: center;\n}\n\n.body-small .navbar-top-links li:last-child {\n  margin-right: 0;\n}\n\n.navbar-top-links li a {\n  padding: 20px 10px;\n  min-height: 50px;\n}\n\n.dropdown-menu {\n  border: medium none;\n  border-radius: 3px;\n  box-shadow: 0 0 3px rgba(86, 96, 117, 0.7);\n  display: none;\n  float: left;\n  font-size: 12px;\n  left: 0;\n  list-style: none outside none;\n  padding: 0;\n  position: absolute;\n  text-shadow: none;\n  top: 100%;\n  z-index: 1000;\n}\n\n.dropdown-menu > li > a {\n  border-radius: 3px;\n  color: inherit;\n  line-height: 25px;\n  margin: 4px;\n  text-align: left;\n  font-weight: normal;\n  display: block;\n  padding: 3px 20px;\n}\n\n.dropdown-menu > li > a:focus, .dropdown-menu > li > a:hover {\n  color: #262626;\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\n\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:focus,\n.dropdown-menu > .active > a:hover {\n  color: #fff;\n  text-decoration: none;\n  background-color: $navy;\n  outline: 0;\n}\n\n.dropdown-menu > li > a.font-bold {\n  font-weight: 600;\n}\n\n.navbar-top-links .dropdown-menu li {\n  display: block;\n}\n\n.navbar-top-links .dropdown-menu li:last-child {\n  margin-right: 0;\n}\n\n.navbar-top-links .dropdown-menu li a {\n  padding: 3px 20px;\n  min-height: 0;\n}\n\n.navbar-top-links .dropdown-menu li a div {\n  white-space: normal;\n}\n\n.navbar-top-links .dropdown-messages,\n.navbar-top-links .dropdown-tasks,\n.navbar-top-links .dropdown-alerts {\n  width: 310px;\n  min-width: 0;\n}\n\n.navbar-top-links .dropdown-messages {\n  margin-left: 5px;\n}\n\n.navbar-top-links .dropdown-tasks {\n  margin-left: -59px;\n}\n\n.navbar-top-links .dropdown-alerts {\n  margin-left: -123px;\n}\n\n.navbar-top-links .dropdown-user {\n  right: 0;\n  left: auto;\n}\n\n.dropdown-messages, .dropdown-alerts {\n  padding: 10px 10px 10px 10px;\n}\n\n.dropdown-messages li a, .dropdown-alerts li a {\n  font-size: 12px;\n}\n\n.dropdown-messages li em, .dropdown-alerts li em {\n  font-size: 10px;\n}\n\n.nav.navbar-top-links .dropdown-alerts a {\n  font-size: 12px;\n}\n\n.nav-header {\n  padding: 33px 25px;\n  background-color: $nav-bg;\n  background-image: $nav-profile-pattern;\n\n}\n\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n\n.profile-element .dropdown-toggle::after {\n  display: none;\n}\n\n.pace-done .nav-header {\n  transition: all 0.4s;\n}\n\nul.nav-second-level {\n  background: darken($nav-bg, 3%);\n}\n\n.nav > li.active {\n  border-left: 4px solid darken($navy, 2%);\n  background: darken($nav-bg, 3%);\n}\n\n.nav.nav-second-level > li.active {\n  border: none;\n}\n\n.nav.nav-second-level.collapse[style] {\n  height: auto !important;\n}\n\n.nav-header a {\n  color: #DFE4ED;\n}\n\n.nav-header .text-muted {\n  color: #8095a8 !important;\n}\n\n.minimalize-styl-2 {\n  padding: 4px 12px;\n  margin: 14px 5px 5px 20px;\n  font-size: 14px;\n  float: left;\n}\n\n.navbar-form-custom {\n  float: left;\n  height: 50px;\n  padding: 0;\n  width: 200px;\n  display: block;\n}\n\n.navbar-form-custom .form-group {\n  margin-bottom: 0;\n}\n\n.nav.navbar-top-links a {\n  font-size: 14px;\n}\n\n.navbar-form-custom .form-control {\n  background: none repeat scroll 0 0 rgba(0, 0, 0, 0);\n  border: medium none;\n  font-size: 14px;\n  height: 60px;\n  margin: 0;\n  z-index: 2000;\n}\n\n.nav.navbar-top-links .dropdown-toggle::after {\n  display: none;\n}\n\n.navbar.navbar-static-top {\n  padding: 0;\n  width: 100%;\n  align-items: inherit;\n}\n\n.navbar-static-top .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n\n.count-info .label {\n  line-height: 12px;\n  padding: 2px 5px;\n  position: absolute;\n  right: 6px;\n  top: 12px;\n}\n\n.arrow {\n  float: right;\n}\n\n.fa.arrow:before {\n  content: \"\\f104\";\n}\n\n.active > a > .fa.arrow:before {\n  content: \"\\f107\";\n}\n\n.nav-second-level li,\n.nav-third-level li {\n  border-bottom: none !important;\n}\n\n.nav.nav-third-level > li.active {\n  border: none;\n}\n\n.nav-second-level li a {\n  padding: 7px 10px 7px 10px;\n  padding-left: 52px;\n}\n\n.fixed-sidebar.mini-navbar .nav-second-level.collapsing li a, .nav-second-level.collapsing li a {\n  min-width: $sidebar-width;\n}\n\n.body-small .nav-second-level.collapsing li a, .mini-navbar .nav-second-level.collapsing li a {\n  min-width: 140px;\n}\n\n.nav-third-level li a, .fixed-sidebar.mini-navbar .nav-second-level li .nav-third-level li a {\n  padding-left: 62px;\n}\n\n.nav-second-level li:last-child {\n  padding-bottom: 10px;\n}\n\nbody:not(.fixed-sidebar):not(.canvas-menu).mini-navbar .nav li:hover > .nav-second-level,\n.mini-navbar .nav li:focus > .nav-second-level {\n  display: block;\n  border-radius: 0 2px 2px 0;\n  min-width: 160px;\n  height: auto;\n}\n\nbody.mini-navbar .navbar-default .nav > li > .nav-second-level li a {\n  font-size: 12px;\n  border-radius: 3px;\n}\n\n.fixed-nav .slimScrollDiv #side-menu {\n  padding-bottom: 60px;\n}\n\n.mini-navbar .nav-second-level li a {\n  padding: 10px 10px 10px 15px;\n}\n\n.mini-navbar .nav .nav-second-level {\n  position: absolute;\n  left: 70px;\n  top: 0;\n  background-color: $nav-bg;\n  padding: 10px 10px 10px 10px;\n  font-size: 12px;\n}\n\n.canvas-menu.mini-navbar .nav-second-level {\n  background: darken($nav-bg, 3%);\n}\n\n.mini-navbar li.active .nav-second-level {\n  left: 65px\n}\n\n.navbar-default .special_link a {\n  background: $navy;\n  color: white;\n}\n\n.navbar-default .special_link a:hover {\n  background: #17987e !important;\n  color: white;\n}\n\n.navbar-default .special_link a span.label {\n  background: #fff;\n  color: $navy;\n}\n\n.navbar-default .landing_link a {\n  background: lighten($navy, 3%);\n  color: white;\n}\n\n.navbar-default .landing_link a:hover {\n  background: $navy !important;\n  color: white;\n}\n\n.navbar-default .landing_link a span.label {\n  background: #fff;\n  color: lighten($navy, 3%);\n}\n\n.logo-element {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n  display: none;\n  padding: 18px 0;\n}\n\n.navbar-static-side { transition: width 0s; }\n.footer { transition: margin 0s; }\n\n.pace-done .navbar-static-side, .pace-done .nav-header, .pace-done li.active, .pace-done #page-wrapper, .pace-done .footer {\n  -webkit-transition: all 0.4s;\n  -moz-transition: all 0.4s;\n  -o-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n.navbar-fixed-top {\n  background: #fff;\n  transition-duration: 0.4s;\n  border-bottom: 1px solid #e7eaec !important;\n  z-index: 2030;\n  position: fixed;\n  right: 0;\n  left: 0;\n  padding: 0;\n  top:0\n}\n\n.navbar-fixed-top .navbar-form-custom .form-control { height: 50px}\n\n.navbar-fixed-top, .navbar-static-top {\n  background: $gray;\n}\n\n.fixed-nav #wrapper {\n  margin-top: 0;\n}\n\n.nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {\n  -moz-border-bottom-colors: none;\n  -moz-border-left-colors: none;\n  -moz-border-right-colors: none;\n  -moz-border-top-colors: none;\n  background: none;\n  border-color: #DDDDDD #DDDDDD rgba(0, 0, 0, 0);\n  border-bottom: $gray;\n  border-image: none;\n  border-style: solid;\n  border-width: 1px;\n  color: #555555;\n  cursor: default;\n}\n\n.nav.nav-tabs li {\n  background: none;\n  border: none;\n}\n\nbody.fixed-nav #wrapper .navbar-static-side,\nbody.fixed-nav #wrapper #page-wrapper {\n  margin-top: 60px;\n}\n\nbody.top-navigation.fixed-nav #wrapper #page-wrapper {\n  margin-top: 0;\n}\n\nbody.fixed-nav.fixed-nav-basic .navbar-fixed-top {\n  left: $sidebar-width;\n}\n\nbody.fixed-nav.fixed-nav-basic.mini-navbar .navbar-fixed-top {\n  left: 70px;\n}\n\nbody.fixed-nav.fixed-nav-basic.fixed-sidebar.mini-navbar .navbar-fixed-top {\n  left: 0;\n}\n\nbody.fixed-nav.fixed-nav-basic #wrapper .navbar-static-side {\n  margin-top: 0;\n}\n\nbody.fixed-nav.fixed-nav-basic.body-small .navbar-fixed-top {\n  left: 0;\n}\n\nbody.fixed-nav.fixed-nav-basic.fixed-sidebar.mini-navbar.body-small .navbar-fixed-top {\n  left: $sidebar-width;\n}\n\n.fixed-nav .minimalize-styl-2 {\n  margin: 10px 5px 5px 15px;\n}\n\n.body-small .navbar-fixed-top {\n  margin-left: 0;\n}\n\nbody.mini-navbar .navbar-static-side {\n  width: 70px;\n}\n\nbody.mini-navbar .profile-element, body.mini-navbar .nav-label, body.mini-navbar .navbar-default .nav li a span {\n  display: none;\n}\n\nbody.canvas-menu .profile-element {\n  display: block;\n}\n\nbody:not(.fixed-sidebar):not(.canvas-menu).mini-navbar .nav-second-level {\n  display: none;\n}\n\nbody.mini-navbar .navbar-default .nav > li > a {\n  font-size: 16px;\n}\n\nbody.mini-navbar .logo-element {\n  display: block;\n}\n\nbody.canvas-menu .logo-element {\n  display: none;\n}\n\nbody.mini-navbar .nav-header {\n  padding: 0;\n  background-color: $navy;\n}\n\nbody.canvas-menu .nav-header {\n  padding: 33px 25px;\n}\n\nbody.canvas-menu .sidebar-collapse li {\n  width: 100%;\n}\n\nbody.mini-navbar #page-wrapper {\n  width: calc(100% - 70px);\n}\n\n\nbody.canvas-menu.mini-navbar #page-wrapper,\nbody.canvas-menu.mini-navbar .footer {\n  margin: 0;\n  width: 100%;\n}\n\nbody.fixed-sidebar .navbar-static-side,\nbody.canvas-menu .navbar-static-side {\n  width: $sidebar-width;\n  z-index: 2001;\n  height: 100vh;\n  position: fixed;\n}\n\nbody.fixed-sidebar.mini-navbar .navbar-static-side {\n  width: 0;\n}\n\nbody.fixed-sidebar #page-wrapper {\n  margin: 0 0 0 $sidebar-width;\n}\n\nbody.fixed-sidebar.body-small #page-wrapper {\n  margin: 0;\n}\n\nbody.fixed-sidebar.mini-navbar #page-wrapper {\n  margin: 0 0 0 0;\n  width: 100%;\n}\n\nbody.body-small.fixed-sidebar.mini-navbar #page-wrapper {\n  margin: 0 0 0 $sidebar-width;\n}\n\nbody.body-small.fixed-sidebar.mini-navbar .navbar-static-side {\n  width: $sidebar-width;\n}\n\n.fixed-sidebar.mini-navbar .nav li:focus > .nav-second-level,\n.canvas-menu.mini-navbar .nav li:focus > .nav-second-level {\n  display: block;\n  height: auto;\n}\n\nbody.fixed-sidebar.mini-navbar .navbar-default .nav > li > .nav-second-level li a {\n  font-size: 12px;\n  border-radius: 3px;\n}\n\nbody.canvas-menu.mini-navbar .navbar-default .nav > li > .nav-second-level li a {\n  font-size: 13px;\n  border-radius: 3px;\n}\n\n.fixed-sidebar.mini-navbar .nav-second-level li a,\n.canvas-menu.mini-navbar .nav-second-level li a {\n  padding: 10px 10px 10px 15px;\n}\n\n.fixed-sidebar.mini-navbar .nav-second-level,\n.canvas-menu.mini-navbar .nav-second-level {\n  position: relative;\n  padding: 0;\n  font-size: 13px;\n}\n\n.fixed-sidebar.mini-navbar li.active .nav-second-level,\n.canvas-menu.mini-navbar li.active .nav-second-level {\n  left: 0\n}\n\nbody.fixed-sidebar.mini-navbar .navbar-default .nav > li > a,\nbody.canvas-menu.mini-navbar .navbar-default .nav > li > a {\n  font-size: 13px;\n}\n\nbody.fixed-sidebar.mini-navbar .nav-label,\nbody.fixed-sidebar.mini-navbar .navbar-default .nav li a span,\nbody.canvas-menu.mini-navbar .nav-label,\nbody.canvas-menu.mini-navbar .navbar-default .nav li a span {\n  display: inline;\n}\n\nbody.canvas-menu.mini-navbar .navbar-default .nav li .profile-element a span {\n  display: block;\n}\n\n.canvas-menu.mini-navbar .nav-second-level li a,\n.fixed-sidebar.mini-navbar .nav-second-level li a {\n  padding: 7px 10px 7px 52px\n}\n\n.fixed-sidebar.mini-navbar .nav-second-level,\n.canvas-menu.mini-navbar .nav-second-level {\n  left: 0\n}\n\nbody.canvas-menu nav.navbar-static-side {\n  z-index: 2001;\n  background: $nav-bg;\n  height: 100%;\n  position: fixed;\n  display: none;\n}\n\nbody.canvas-menu.mini-navbar nav.navbar-static-side {\n  display: block;\n  width: $sidebar-width;\n}\n","// Basic Colors\n$navy: #1db5b6;       // Primary color\n$dark-gray: #c2c2c2;  // Default color\n$blue: #1c84c6;       // Success color\n$lazur: #23c6c8;      // Info color\n$yellow: #f8ac59;     // Warning color\n$red: #ED5565;        // Danger color\n\n// Various colors\n$text-color: #676a6c;   // Body text\n$gray: #f3f3f4;         // Background wrapper color\n$light-gray: #D1DADE;   // Default label, badge\n$label-badge-color: #5E5E5E;\n$light-blue:#f3f6fb;\n\n// Spinner color and margin\n$spin-color: $navy;\n$spin-margin: 0 auto;\n\n//Basics\n$basic-link-color: #337ab7;\n\n// IBOX colors ( default panel colors)\n$border-color: #e7eaec;     // IBox border\n$ibox-title-bg:#ffffff;     // IBox Background header\n$ibox-content-bg:#ffffff;   // IBox Background content\n\n//Sidebar width\n$sidebar-width: 220px;\n\n// Boxed layout width\n$boxed-width: 1200px;\n$boxed-background: url('patterns/shattered.png');\n\n//Border radius for buttons\n$btn-border-radius: 12px;\n\n//Navigation\n$nav-bg: #2F4050;\n$nav-profile-pattern: url(\"patterns/header-profile.png\");\n$nav-text-color: #000000;",".top-navigation #page-wrapper {\n  width:100%;\n}\n\n.top-navigation .navbar-nav .dropdown-menu > .active > a {\n  background: white;\n  color: $navy;\n  font-weight: bold;\n}\n\n.white-bg .navbar-fixed-top, .white-bg .navbar-static-top {\n  background: #fff;\n}\n\n.top-navigation .navbar {\n  margin-bottom: 0;\n}\n\n.top-navigation .nav > li > a {\n  padding: 15px 20px;\n  color: #676a6c;\n}\n\n.top-navigation .nav > li a:hover, .top-navigation .nav > li a:focus {\n  background: #fff;\n  color: $navy;\n}\n\n.top-navigation .navbar .nav > li.active {\n  background: #fff;\n  border: none;\n}\n\n.top-navigation .nav > li.active > a {\n  color: $navy;\n}\n\n.top-navigation .navbar-right {\n  margin-right: 10px;\n}\n\n.top-navigation .navbar-nav .dropdown-menu {\n  box-shadow: none;\n  border: 1px solid #e7eaec;\n}\n\n.top-navigation .dropdown-menu > li > a {\n  margin: 0;\n  padding: 7px 20px;\n}\n\n.navbar .dropdown-menu {\n  margin-top: 0;\n}\n\n.top-navigation .navbar-brand {\n  background: $navy;\n  color: #fff;\n  padding: 15px 25px;\n  font-size: 18px;\n  line-height: 20px;\n  //margin: 8px;\n}\n\n.top-navigation .navbar-top-links li:last-child {\n  margin-right: 0;\n}\n\n.top-navigation.mini-navbar #page-wrapper,\n.top-navigation.body-small.fixed-sidebar.mini-navbar #page-wrapper,\n.mini-navbar .top-navigation #page-wrapper,\n.body-small.fixed-sidebar.mini-navbar .top-navigation #page-wrapper,\n.canvas-menu #page-wrapper {\n  margin: 0;\n  width: 100%;\n}\n\n.top-navigation.fixed-nav #wrapper, .fixed-nav #wrapper.top-navigation {\n  margin-top: 50px;\n}\n\n.top-navigation .footer.fixed {\n  margin-left: 0 !important;\n}\n\n.top-navigation .wrapper.wrapper-content {\n  padding: 40px;\n}\n\n.top-navigation.body-small .wrapper.wrapper-content, .body-small .top-navigation .wrapper.wrapper-content {\n  padding: 40px 0 40px 0;\n}\n\n.navbar-toggler {\n  background-color: $navy;\n  color: #fff;\n  padding: 6px 12px;\n  font-size: 14px;\n  margin: 8px;\n}\n\n.top-navigation .navbar-nav .open .dropdown-menu > li > a, .top-navigation .navbar-nav .open .dropdown-menu .dropdown-header {\n  padding: 10px 15px 10px 20px;\n}\n\n@media (max-width: 768px) {\n  .top-navigation .navbar-header {\n    display: block;\n    float: none;\n  }\n}\n\n.menu-visible-lg, .menu-visible-md {\n  display: none !important;\n}\n\n@media (min-width: 1200px) {\n  .menu-visible-lg {\n    display: block !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .menu-visible-md {\n    display: block !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .menu-visible-md {\n    display: block !important;\n  }\n\n  .menu-visible-lg {\n    display: block !important;\n  }\n}","button:focus {\n  outline: 0 !important;\n}\n\n.btn {\n  font-size: 15px!important;\n  font-weight: 700!important;\n  border-radius: 12px!important;\n  transition: 0.4ms;\n  font-family: 'Inter', sans-serif;\n  line-height: 14px!important;\n  padding: 12px!important;\n}\n\n.btn:hover {\n  transform: scale(0.97);\n}\n\n.btn-icon-wrapper{\n  display: inline-block;\n  margin: 0 5px;\n}\n\n.btn:focus {\n  box-shadow: none;\n}\n\n.btn-xs {\n  font-size: 0.7rem;\n  padding: 0.2rem 0.4rem;\n}\n\n.btn-group-sm > .btn, .btn-sm {\n  font-size: .8rem;\n}\n\n.float-e-margins .btn {\n  margin-bottom: 5px;\n}\n\n.btn-w-m {\n  min-width: 120px;\n}\n\n.btn-primary.btn-outline {\n  color: $navy;\n}\n\n.btn-success.btn-outline {\n  color: $blue;\n}\n\n.btn-info.btn-outline {\n  color: $lazur;\n}\n\n.btn-warning.btn-outline {\n  color: $yellow;\n}\n\n.btn-danger.btn-outline {\n  color: $red;\n}\n\n.btn-primary.btn-outline:hover,\n.btn-success.btn-outline:hover,\n.btn-info.btn-outline:hover,\n.btn-warning.btn-outline:hover,\n.btn-danger.btn-outline:hover {\n  color: #fff;\n}\n\n.btn.active, .btn:active {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.btn-primary {\n  background-color: $navy;\n  border-color: $navy;\n}\n\n.btn-primary:hover, .btn-primary:focus, .btn-primary.focus {\n  background-color: darken($navy, 3%);\n  border-color: darken($navy, 3%);\n  color: #000;\n}\n\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #000;\n  background-color: darken($navy, 3%);\n  border-color: darken($navy, 3%);\n}\n\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n.show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: darken($navy, 3%);\n  border-color: darken($navy, 3%);\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: $blue;\n  border-color: $blue;\n}\n\n.btn-success:hover, .btn-success:focus, .btn-success.focus {\n  color: #fff;\n  background-color: darken($blue, 3%);\n  border-color: darken($blue, 3%);\n}\n\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: darken($blue, 3%);\n  border-color: darken($blue, 3%);\n}\n\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,\n.show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: darken($blue, 3%);\n  border-color: darken($blue, 3%);\n}\n\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: $lazur;\n  border-color: $lazur;\n}\n\n.btn-info:hover, .btn-info:focus, .btn-info.focus {\n  color: #fff;\n  background-color: darken($lazur, 3%);\n  border-color: darken($lazur, 3%);\n}\n\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: darken($lazur, 3%);\n  border-color: darken($lazur, 3%);\n}\n\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,\n.show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: darken($lazur, 3%);\n  border-color: darken($lazur, 3%);\n}\n\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-info.dropdown-toggle:focus {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.btn-default {\n  color: inherit;\n  background: white;\n  border: 1px solid $border-color;\n}\n\n.btn-default:hover, .btn-default:focus, .btn-default:active, .btn-default.active, .open .dropdown-toggle.btn-default, .btn-default:active:focus, .btn-default:active:hover, .btn-default.active:hover, .btn-default.active:focus {\n  color: inherit;\n  border: 1px solid #d2d2d2;\n}\n\n.btn-default:active, .btn-default.active, .open .dropdown-toggle.btn-default {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15) inset;\n}\n\n.btn-default.disabled, .btn-default.disabled:hover, .btn-default.disabled:focus, .btn-default.disabled:active, .btn-default.disabled.active, .btn-default[disabled], .btn-default[disabled]:hover, .btn-default[disabled]:focus, .btn-default[disabled]:active, .btn-default.active[disabled], fieldset[disabled] .btn-default, fieldset[disabled] .btn-default:hover, fieldset[disabled] .btn-default:focus, fieldset[disabled] .btn-default:active, fieldset[disabled] .btn-default.active {\n  color: #cacaca;\n}\n\n.btn-warning {\n  color: #ffffff;\n  background-color: $yellow;\n  border-color: $yellow;\n}\n\n.btn-warning:hover, .btn-warning:focus, .btn-warning.focus {\n  color: #ffffff;\n  background-color: darken($yellow, 3%);\n  border-color: darken($yellow, 3%);\n}\n\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #ffffff;\n  background-color: darken($yellow, 3%);\n  border-color: darken($yellow, 3%);\n}\n\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,\n.show > .btn-warning.dropdown-toggle {\n  color: #ffffff;\n  background-color: darken($yellow, 3%);\n  border-color: darken($yellow, 3%);\n}\n\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-warning.dropdown-toggle:focus {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: $red;\n  border-color: $red;\n}\n\n.btn-danger:hover, .btn-danger:focus, .btn-danger.focus {\n  color: #fff;\n  background-color: darken($red, 3%);\n  border-color: darken($red, 3%);\n}\n\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: darken($red, 3%);\n  border-color: darken($red, 3%);\n}\n\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,\n.show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: darken($red, 3%);\n  border-color: darken($red, 3%);\n}\n\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-danger.dropdown-toggle:focus {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.btn-link {\n  color: inherit;\n}\n\n.btn-link:hover, .btn-link:focus, .btn-link:active, .btn-link.active, .open .dropdown-toggle.btn-link {\n  color: $navy;\n  text-decoration: none;\n}\n\n.btn-link:active, .btn-link.active, .open .dropdown-toggle.btn-link {\n  background-image: none;\n  box-shadow: none;\n}\n\n.btn-link.disabled, .btn-link.disabled:hover, .btn-link.disabled:focus, .btn-link.disabled:active, .btn-link.disabled.active, .btn-link[disabled], .btn-link[disabled]:hover, .btn-link[disabled]:focus, .btn-link[disabled]:active, .btn-link.active[disabled], fieldset[disabled] .btn-link, fieldset[disabled] .btn-link:hover, fieldset[disabled] .btn-link:focus, fieldset[disabled] .btn-link:active, fieldset[disabled] .btn-link.active {\n  color: #cacaca;\n}\n\n.btn-white {\n  color: inherit;\n  background: white;\n  border: 1px solid $border-color;\n}\n\n.btn-white:hover, .btn-white:focus, .btn-white:active, .btn-white.active, .open .dropdown-toggle.btn-white, .btn-white:active:focus, .btn-white:active:hover, .btn-white.active:hover, .btn-white.active:focus {\n  color: inherit;\n  border: 1px solid #d2d2d2;\n}\n\n.btn-white:active, .btn-white.active {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15) inset;\n}\n\n.btn-white:active, .btn-white.active, .open .dropdown-toggle.btn-white {\n  background-image: none;\n}\n\n.btn-white.disabled, .btn-white.disabled:hover, .btn-white.disabled:focus, .btn-white.disabled:active, .btn-white.disabled.active, .btn-white[disabled], .btn-white[disabled]:hover, .btn-white[disabled]:focus, .btn-white[disabled]:active, .btn-white.active[disabled], fieldset[disabled] .btn-white, fieldset[disabled] .btn-white:hover, fieldset[disabled] .btn-white:focus, fieldset[disabled] .btn-white:active, fieldset[disabled] .btn-white.active {\n  color: #cacaca;\n}\n\n.form-control, .form-control:focus, .has-error .form-control:focus, .has-success .form-control:focus, .has-warning .form-control:focus, .navbar-collapse, .navbar-form, .navbar-form-custom .form-control:focus, .navbar-form-custom .form-control:hover, .open .btn.dropdown-toggle, .panel, .popover, .progress, .progress-bar {\n  box-shadow: none;\n}\n\n.btn-outline {\n  color: inherit;\n  background-color: transparent;\n  transition: all .5s;\n}\n\n.btn-rounded {\n  border-radius: 50px;\n}\n\n.btn-large-dim {\n  width: 90px;\n  height: 90px;\n  font-size: 42px;\n}\n\nbutton.dim {\n  display: inline-block;\n  text-decoration: none;\n  text-transform: uppercase;\n  text-align: center;\n  padding-top: 6px;\n  margin-right: 10px;\n  position: relative;\n  cursor: pointer;\n  border-radius: 5px;\n  font-weight: 600;\n  margin-bottom: 20px !important;\n}\n\nbutton.dim:active {\n  top: 3px;\n}\n\nbutton.btn-primary.dim {\n  box-shadow: inset 0 0 0 darken($navy, 6%), 0 5px 0 0 darken($navy, 6%), 0 10px 5px #999 !important;\n}\n\nbutton.btn-primary.dim:active {\n  box-shadow: inset 0 0 0 darken($navy, 6%), 0 2px 0 0 darken($navy, 6%), 0 5px 3px #999 !important;\n}\n\nbutton.btn-default.dim {\n  box-shadow: inset 0 0 0 darken($dark-gray, 6%), 0 5px 0 0 darken($dark-gray, 6%), 0 10px 5px #999 !important;\n}\n\nbutton.btn-default.dim:active {\n  box-shadow: inset 0 0 0 darken($dark-gray, 6%), 0 2px 0 0 darken($dark-gray, 6%), 0 5px 3px #999 !important;\n}\n\nbutton.btn-warning.dim {\n  box-shadow: inset 0 0 0 darken($yellow, 6%), 0 5px 0 0 darken($yellow, 6%), 0 10px 5px #999 !important;\n}\n\nbutton.btn-warning.dim:active {\n  box-shadow: inset 0 0 0 darken($yellow, 6%), 0 2px 0 0 darken($yellow, 6%), 0 5px 3px #999 !important;\n}\n\nbutton.btn-info.dim {\n  box-shadow: inset 0 0 0 darken($lazur, 6%), 0 5px 0 0 darken($lazur, 6%), 0 10px 5px #999 !important;\n}\n\nbutton.btn-info.dim:active {\n  box-shadow: inset 0 0 0 darken($lazur, 6%), 0 2px 0 0 darken($lazur, 6%), 0 5px 3px #999 !important;\n}\n\nbutton.btn-success.dim {\n  box-shadow: inset 0 0 0 darken($blue, 6%), 0 5px 0 0 darken($blue, 6%), 0 10px 5px #999 !important;\n}\n\nbutton.btn-success.dim:active {\n  box-shadow: inset 0 0 0 darken($blue, 6%), 0 2px 0 0 darken($blue, 6%), 0 5px 3px #999 !important;\n}\n\nbutton.btn-danger.dim {\n  box-shadow: inset 0 0 0 darken($red, 6%), 0 5px 0 0 darken($red, 6%), 0 10px 5px #999 !important;\n}\n\nbutton.btn-danger.dim:active {\n  box-shadow: inset 0 0 0 darken($red, 6%), 0 2px 0 0 darken($red, 6%), 0 5px 3px #999 !important;\n}\n\nbutton.dim:before {\n  font-size: 50px;\n  line-height: 1em;\n  font-weight: normal;\n  color: #fff;\n  display: block;\n  padding-top: 10px;\n\n}\n\nbutton.dim:active:before {\n  top: 7px;\n  font-size: 50px;\n}\n\n.btn:focus {\n  outline: none !important;\n}\n","\n.label {\n  background-color: $light-gray;\n  color: $label-badge-color;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-weight: 600;\n  padding: 3px 8px;\n  text-shadow: none;\n  border-radius: 0.25em;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.nav .label, .ibox .label {\n  font-size: 10px;\n}\n\n.badge {\n  background-color: $light-gray;\n  color: $label-badge-color;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  padding-bottom: 4px;\n  padding-left: 6px;\n  padding-right: 6px;\n  text-shadow: none;\n  white-space: nowrap;\n}\n\n.label-primary, .badge-primary {\n  background-color: $navy;\n  color: #FFFFFF;\n}\n\n.label-success, .badge-success {\n  background-color: $blue;\n  color: #FFFFFF;\n}\n\n.label-warning, .badge-warning {\n  background-color: $yellow;\n  color: #FFFFFF;\n}\n\n.label-warning-light, .badge-warning-light {\n  background-color: $yellow;\n  color: #ffffff;\n}\n\n.label-danger, .badge-danger {\n  background-color: $red;\n  color: #FFFFFF;\n}\n\n.label-info, .badge-info {\n  background-color: $lazur;\n  color: #FFFFFF;\n}\n\n.label-inverse, .badge-inverse {\n  background-color: #262626;\n  color: #FFFFFF;\n}\n\n.label-white, .badge-white {\n  background-color: #FFFFFF;\n  color: #5E5E5E;\n}\n\n.label-white, .badge-disable {\n  background-color: #2A2E36;\n  color: #8B91A0;\n}\n","/* TOOGLE SWICH */\n\n.onoffswitch {\n  position: relative;\n  width: 64px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.onoffswitch-checkbox {\n  display: none;\n}\n\n.onoffswitch-label {\n  display: block;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid $navy;\n  border-radius: 2px;\n}\n\n.onoffswitch-inner {\n  width: 200%;\n  margin-left: -100%;\n  -moz-transition: margin 0.3s ease-in 0s;\n  -webkit-transition: margin 0.3s ease-in 0s;\n  -o-transition: margin 0.3s ease-in 0s;\n  transition: margin 0.3s ease-in 0s;\n}\n\n.onoffswitch-inner:before, .onoffswitch-inner:after {\n  float: left;\n  width: 50%;\n  height: 20px;\n  padding: 0;\n  line-height: 20px;\n  font-size: 12px;\n  color: white;\n  font-family: Trebuchet, Arial, sans-serif;\n  font-weight: bold;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.onoffswitch-inner:before {\n  content: \"ON\";\n  padding-left: 10px;\n  background-color: $navy;\n  color: #FFFFFF;\n}\n\n.onoffswitch-inner:after {\n  content: \"OFF\";\n  padding-right: 10px;\n  background-color: #FFFFFF;\n  color: #999999;\n  text-align: right;\n}\n\n.onoffswitch-switch {\n  width: 20px;\n  margin: 0;\n  background: #FFFFFF;\n  border: 2px solid $navy;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 44px;\n  -moz-transition: all 0.3s ease-in 0s;\n  -webkit-transition: all 0.3s ease-in 0s;\n  -o-transition: all 0.3s ease-in 0s;\n  transition: all 0.3s ease-in 0s;\n}\n\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {\n  margin-left: 0;\n}\n\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {\n  right: 0;\n}\n\n.onoffswitch-checkbox:disabled + .onoffswitch-label .onoffswitch-inner:before {\n  background-color: #919191;\n}\n\n.onoffswitch-checkbox:disabled + .onoffswitch-label,\n.onoffswitch-checkbox:disabled + .onoffswitch-label .onoffswitch-switch {\n  border-color: #919191;\n}\n\n/* CHOSEN PLUGIN */\n\n.chosen-container-single .chosen-single {\n  background: #ffffff;\n  box-shadow: none;\n  -moz-box-sizing: border-box;\n  border-radius: 2px;\n  cursor: text;\n  height: auto !important;\n  margin: 0;\n  min-height: 30px;\n  overflow: hidden;\n  padding: 4px 12px;\n  position: relative;\n  width: 100%;\n}\n\n.chosen-container-multi .chosen-choices li.search-choice {\n  background: #f1f1f1;\n  border: 1px solid #e5e6e7;\n  border-radius: 2px;\n  box-shadow: none;\n  color: #333333;\n  cursor: default;\n  line-height: 13px;\n  margin: 3px 0 3px 5px;\n  padding: 3px 20px 3px 5px;\n  position: relative;\n}\n\n/* Tags Input Plugin */\n\n.bootstrap-tagsinput {\n  border: 1px solid #e5e6e7;\n  box-shadow: none;\n}\n\n/* PAGINATIN */\n\n.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus {\n  //background-color: #f4f4f4;\n  border-color: #DDDDDD;\n  //color: inherit;\n  cursor: default;\n  z-index: 2;\n}\n\n.pagination > li > a, .pagination > li > span {\n  background-color: #FFFFFF;\n  border: 1px solid #DDDDDD;\n  color: inherit;\n  float: left;\n  line-height: 1.42857;\n  margin-left: -1px;\n  padding: 4px 10px;\n  position: relative;\n  text-decoration: none;\n}\n\n.page-item.active .page-link {\n  background-color: $navy;\n  border-color: $navy;\n}\n\n.page-link:focus {\n  box-shadow: none;\n}\n\n.page-link:hover {\n  color: $text-color;\n}\n\n.pagination .footable-page.active a {\n  background-color: $navy;\n  border-color: $navy;\n  color: white;\n}\n\n/* TOOLTIPS */\n\n.tooltip-inner {\n  background-color: $nav-bg;\n}\n\n.tooltip.top .tooltip-arrow {\n  border-top-color: $nav-bg;\n}\n\n.tooltip.right .tooltip-arrow {\n  border-right-color: $nav-bg;\n}\n\n.tooltip.bottom .tooltip-arrow {\n  border-bottom-color: $nav-bg;\n}\n\n.tooltip.left .tooltip-arrow {\n  border-left-color: $nav-bg;\n}\n\n/* EASY PIE CHART*/\n\n.easypiechart {\n  position: relative;\n  text-align: center;\n}\n\n.easypiechart .h2 {\n  margin-left: 10px;\n  margin-top: 10px;\n  display: inline-block;\n}\n\n.easypiechart canvas {\n  top: 0;\n  left: 0;\n}\n\n.easypiechart .easypie-text {\n  line-height: 1;\n  position: absolute;\n  top: 33px;\n  width: 100%;\n  z-index: 1;\n}\n\n.easypiechart img {\n  margin-top: -4px;\n}\n\n.jqstooltip {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n/* FULLCALENDAR */\n\n.fc-state-default {\n  background-color: #ffffff;\n  background-image: none;\n  background-repeat: repeat-x;\n  box-shadow: none;\n  color: #333333;\n  text-shadow: none;\n}\n\n.fc-state-default {\n  border: 1px solid;\n}\n\n.fc-button {\n  color: inherit;\n  border: 1px solid $border-color;\n  cursor: pointer;\n  display: inline-block;\n  height: 1.9em;\n  line-height: 1.9em;\n  overflow: hidden;\n  padding: 0 0.6em;\n  position: relative;\n  white-space: nowrap;\n}\n\n.fc-state-active {\n  background-color: $navy;\n  border-color: $navy;\n  color: #ffffff;\n}\n\n.fc-header-title h2 {\n  font-size: 16px;\n  font-weight: 600;\n  color: inherit;\n}\n\n.fc-content .fc-widget-header, .fc-content .fc-widget-content {\n  border-color: $border-color;\n  font-weight: normal;\n}\n\n.fc-border-separate tbody {\n  background-color: #F8F8F8;\n}\n\n.fc-state-highlight {\n  background: none repeat scroll 0 0 #FCF8E3;\n}\n\n.external-event {\n  padding: 5px 10px;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n\n.fc-ltr .fc-event-hori.fc-event-end, .fc-rtl .fc-event-hori.fc-event-start {\n  border-radius: 2px;\n}\n\n.fc-event,\n.fc-agenda .fc-event-time,\n.fc-event a {\n  padding: 4px 6px;\n  background-color: $navy; /* background color */\n  border-color: $navy; /* border color */\n}\n\n.fc-event-time, .fc-event-title {\n  color: #717171;\n  padding: 0 1px;\n}\n\n.ui-calendar .fc-event-time, .ui-calendar .fc-event-title {\n  color: #fff;\n}\n\n.fc-event-container a.fc-event {\n  color: #fff;\n}\n\n/* Chat */\n.chat-activity-list .chat-element {\n  border-bottom: 1px solid $border-color;\n}\n\n.chat-element:first-child {\n  margin-top: 0;\n}\n\n.chat-element {\n  padding-bottom: 15px;\n}\n\n.chat-element, .chat-element .media {\n  margin-top: 15px;\n}\n\n.chat-element, .media-body {\n  overflow: hidden;\n}\n\n.chat-element .media-body {\n  display: block;\n  width: auto;\n}\n\n.chat-element > .float-left {\n  margin-right: 10px;\n}\n\n.chat-element img.rounded-circle, .dropdown-messages-box img.rounded-circle {\n  width: 38px;\n  height: 38px;\n}\n\n.chat-element .well {\n  border: 1px solid $border-color;\n  box-shadow: none;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  padding: 10px 20px;\n  font-size: 11px;\n  line-height: 16px;\n}\n\n.chat-element .actions {\n  margin-top: 10px;\n}\n\n.chat-element .photos {\n  margin: 10px 0;\n\n}\n\n.right.chat-element > .float-right {\n  margin-left: 10px;\n}\n\n.chat-photo {\n  max-height: 180px;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.chat {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.chat li {\n  margin-bottom: 10px;\n  padding-bottom: 5px;\n  border-bottom: 1px dotted #B3A9A9;\n}\n\n.chat li.left .chat-body {\n  margin-left: 60px;\n}\n\n.chat li.right .chat-body {\n  margin-right: 60px;\n}\n\n.chat li .chat-body p {\n  margin: 0;\n  color: #777777;\n}\n\n.panel .slidedown .glyphicon,\n.chat .glyphicon {\n  margin-right: 5px;\n}\n\n.chat-panel .panel-body {\n  height: 350px;\n  overflow-y: scroll;\n}\n\n/* LIST GROUP */\n\na.list-group-item.active, a.list-group-item.active:hover, a.list-group-item.active:focus {\n  background-color: $navy;\n  border-color: $navy;\n  color: #FFFFFF;\n  z-index: 2;\n}\n\n.list-group-item-heading {\n  margin-top: 10px;\n}\n\n.list-group-item-text {\n  margin: 0 0 10px;\n  color: inherit;\n  font-size: 12px;\n  line-height: inherit;\n}\n\n.no-padding .list-group-item {\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n}\n\n.no-padding .list-group-item:first-child {\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n  border-top: none;\n}\n\n.no-padding .list-group {\n  margin-bottom: 0;\n}\n\n.list-group-item {\n  background-color: inherit;\n  border: 1px solid $border-color;\n  display: block;\n  margin-bottom: -1px;\n  padding: 10px 15px;\n  position: relative;\n}\n\n.elements-list .list-group-item {\n  border-left: none;\n  border-right: none;\n  padding: 0;\n\n}\n\n.elements-list .list-group-item:first-child {\n  border-left: none;\n  border-right: none;\n  border-top: none !important;\n}\n\n.elements-list .list-group {\n  margin-bottom: 0;\n}\n\n.elements-list a {\n  color: inherit;\n}\n\n.elements-list .list-group-item a.active,\n.elements-list .list-group-item a:hover {\n  background: #f3f3f4;\n  color: inherit;\n  border-color: #e7eaec;\n  border-radius: 0;\n}\n\n.elements-list li.active {\n  transition: none;\n}\n\n.elements-list .nav-link {\n  padding: 15px 25px;\n}\n\n.element-detail-box {\n  padding: 25px;\n}\n\n/* FLOT CHART  */\n\n.flot-chart {\n  display: block;\n  height: 200px;\n}\n\n.widget .flot-chart.dashboard-chart {\n  display: block;\n  height: 120px;\n  margin-top: 40px;\n}\n\n.flot-chart.dashboard-chart {\n  display: block;\n  height: 180px;\n  margin-top: 40px;\n}\n\n.flot-chart-content {\n  width: 100%;\n  height: 100%;\n}\n\n.flot-chart-pie-content {\n  width: 200px;\n  height: 200px;\n  margin: auto;\n}\n\n.jqstooltip {\n  position: absolute;\n  display: block;\n  left: 0;\n  top: 0;\n  visibility: hidden;\n  background: rgb(43, 48, 58);\n  background-color: rgba(43, 48, 58, 0.8);\n  color: white;\n  text-align: left;\n  white-space: nowrap;\n  z-index: 10000;\n  padding: 5px 5px 5px 5px;\n  min-height: 22px;\n  border-radius: 3px;\n}\n\n.jqsfield {\n  color: white;\n  text-align: left;\n}\n\n.fh-150 {\n  height: 150px;\n}\n\n.fh-200 {\n  height: 200px;\n}\n\n.h-150 {\n  min-height: 150px;\n}\n\n.h-200 {\n  min-height: 200px;\n}\n\n.h-300 {\n  min-height: 300px;\n}\n\n.w-150 {\n  min-width: 150px;\n}\n\n.w-200 {\n  min-width: 200px;\n}\n\n.w-300 {\n  min-width: 300px;\n}\n\n.legendLabel {\n  padding-left: 5px;\n}\n\n.stat-list li:first-child {\n  margin-top: 0;\n}\n\n.stat-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.stat-percent {\n  float: right;\n}\n\n.stat-list li {\n  margin-top: 15px;\n  position: relative;\n}\n\n/* DATATABLES */\n\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n  background: transparent;\n}\n\n.dataTables_wrapper {\n  padding-bottom: 30px;\n}\n\n.dataTables_length {\n  float: left;\n}\n\n.dataTables_filter label {\n  margin-right: 5px;\n}\n\n.html5buttons {\n  float: right;\n}\n\n.html5buttons a {\n  border: 1px solid #e7eaec;\n  background: #fff;\n  color: #676a6c;\n  box-shadow: none;\n  padding: 6px 8px;\n  font-size: 12px;\n\n  &:hover, &:focus:active {\n    background-color: #eee;\n    color: inherit;\n    border-color: #d2d2d2;\n  }\n}\n\ndiv.dt-button-info {\n  z-index: 100;\n}\n\n@media (max-width: 768px) {\n  .html5buttons {\n    float: none;\n    margin-top: 10px;\n  }\n\n  .dataTables_length {\n    float: none;\n  }\n}\n\n/* CIRCLE */\n\n.img-circle {\n  border-radius: 50%;\n}\n\n.btn-circle {\n  width: 30px;\n  height: 30px;\n  padding: 6px 0;\n  border-radius: 15px;\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.428571429;\n}\n\n.btn-circle.btn-lg {\n  width: 50px;\n  height: 50px;\n  padding: 10px 16px;\n  border-radius: 25px;\n  font-size: 18px;\n  line-height: 1.33;\n}\n\n.btn-circle.btn-xl {\n  width: 70px;\n  height: 70px;\n  padding: 10px 16px;\n  border-radius: 35px;\n  font-size: 24px;\n  line-height: 1.33;\n}\n\n.show-grid [class^=\"col-\"] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border: 1px solid #ddd;\n  background-color: #eee !important;\n}\n\n.show-grid {\n  margin: 15px 0;\n}\n\n/* ANIMATION */\n\n.css-animation-box h1 {\n  font-size: 44px;\n}\n\n.animation-efect-links a {\n  padding: 4px 6px;\n  font-size: 12px;\n}\n\n#animation_box {\n  background-color: #f9f8f8;\n  border-radius: 16px;\n  width: 80%;\n  margin: 0 auto;\n  padding-top: 80px;\n}\n\n.animation-text-box {\n  position: absolute;\n  margin-top: 40px;\n  left: 50%;\n  margin-left: -100px;\n  width: 200px;\n}\n\n.animation-text-info {\n  position: absolute;\n  margin-top: -60px;\n  left: 50%;\n  margin-left: -100px;\n  width: 200px;\n  font-size: 10px;\n}\n\n.animation-text-box h2 {\n  font-size: 54px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.animation-text-box p {\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n/* PEACE */\n\n.pace {\n  -webkit-pointer-events: none;\n  pointer-events: none;\n\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n.pace-inactive {\n  display: none;\n}\n\n.pace .pace-progress {\n  background: $navy;\n  position: fixed;\n  z-index: 2040;\n  top: 0;\n  right: 100%;\n  width: 100%;\n  height: 2px;\n}\n\n.pace-inactive {\n  display: none;\n}\n\n/* WIDGETS */\n\n.widget {\n  border-radius: 5px;\n  padding: 15px 20px;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n.widget.style1 h2 {\n  font-size: 30px;\n}\n\n.widget h2, .widget h3 {\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.widget-text-box {\n  padding: 20px;\n  border: 1px solid $border-color;\n  background: #ffffff;\n}\n\n.widget-head-color-box {\n  border-radius: 5px 5px 0 0;\n  margin-top: 10px;\n\n}\n\n.widget .flot-chart {\n  height: 100px;\n}\n\n.vertical-align div {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.vertical-align h2, .vertical-align h3 {\n  margin: 0;\n}\n\n.todo-list {\n  list-style: none outside none;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n}\n\n.todo-list.small-list {\n  font-size: 12px;\n}\n\n.todo-list.small-list > li {\n  background: $gray;\n  border-left: none;\n  border-right: none;\n  border-radius: 4px;\n  color: inherit;\n  margin-bottom: 2px;\n  padding: 6px 6px 6px 12px;\n}\n\n.todo-list.small-list .btn-xs, .todo-list.small-list .btn-group-xs > .btn {\n  border-radius: 5px;\n  font-size: 10px;\n  line-height: 1.5;\n  padding: 1px 2px 1px 5px;\n}\n\n.todo-list > li {\n  background: $gray;\n  border-left: 6px solid $border-color;\n  border-right: 6px solid $border-color;\n  border-radius: 4px;\n  color: inherit;\n  margin-bottom: 2px;\n  padding: 10px;\n}\n\n.todo-list .handle {\n  cursor: move;\n  display: inline-block;\n  font-size: 16px;\n  margin: 0 5px;\n}\n\n.todo-list > li .label {\n  font-size: 9px;\n  margin-left: 10px;\n}\n\n.check-link {\n  font-size: 16px;\n}\n\n.todo-completed {\n  text-decoration: line-through;\n}\n\n.geo-statistic h1 {\n  font-size: 36px;\n  margin-bottom: 0;\n}\n\n.glyphicon.fa {\n  font-family: \"FontAwesome\";\n}\n\n/* INPUTS */\n.inline {\n  display: inline-block !important;\n}\n\n.input-s-sm {\n  width: 120px;\n}\n\n.input-s {\n  width: 200px;\n}\n\n.form-control {\n  font-size: 0.9rem;\n}\n\nselect.form-control:not([size]):not([multiple]) {\n  height: 2.05rem;\n}\n\n.input-sm, .form-control-sm {\n  height: 31px;\n}\n\n.input-s-lg {\n  width: 250px;\n}\n\n.i-checks {\n  padding-left: 0;\n}\n\n.form-control, .single-line {\n  background-color: #FFFFFF !important;\n  background-image: none !important;\n  border: 1px solid #e5e6e7 !important;\n  border-radius: 1px !important;\n  color: inherit;\n  display: block;\n  padding: 6px 12px;\n  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;\n  width: 100% !important;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-control:focus, .single-line:focus {\n  border-color: $navy;\n}\n\n.has-success .form-control, .has-success .form-control:focus {\n  border-color: $navy;\n}\n\n.has-warning .form-control, .has-warning .form-control:focus {\n  border-color: $yellow;\n}\n\n.has-error .form-control, .has-error .form-control:focus {\n  border-color: $red;\n}\n\n.has-success .control-label {\n  color: $navy;\n}\n\n.has-warning .control-label {\n  color: $yellow;\n}\n\n.has-error .control-label {\n  color: $red;\n}\n\n.input-group-addon {\n  background-color: #fff;\n  border: 1px solid #E5E6E7;\n  border-radius: 1px;\n  color: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1;\n  padding: 9px 12px 4px 12px;\n  text-align: center;\n}\n\n.input-daterange .input-group-addon {\n  margin: 0;\n}\n\n.input-group.date .input-group-addon {\n  border-right: 0;\n}\n\n.spinner-buttons.input-group-btn .btn-xs {\n  line-height: 1.13;\n}\n\n.spinner-buttons.input-group-btn {\n  width: 20%;\n}\n\n.noUi-connect {\n  background: none repeat scroll 0 0 $navy;\n  box-shadow: none;\n}\n\n.slider_red .noUi-connect {\n  background: none repeat scroll 0 0 $red;\n  box-shadow: none;\n}\n\n/* UI Sortable */\n\n.ui-sortable .ibox-title {\n  cursor: move;\n}\n\n.ui-sortable-placeholder {\n  border: 1px dashed #cecece !important;\n  visibility: visible !important;\n  background: #e7eaec;\n}\n\n.ibox.ui-sortable-placeholder {\n  margin: 0 0 23px !important;\n}\n\n/* SWITCHES */\n.onoffswitch {\n  position: relative;\n  width: 54px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.onoffswitch-checkbox {\n  display: none;\n}\n\n.onoffswitch-label {\n  display: block;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid #1AB394;\n  border-radius: 3px;\n}\n\n.onoffswitch-inner {\n  display: block;\n  width: 200%;\n  margin-left: -100%;\n  -moz-transition: margin 0.3s ease-in 0s;\n  -webkit-transition: margin 0.3s ease-in 0s;\n  -o-transition: margin 0.3s ease-in 0s;\n  transition: margin 0.3s ease-in 0s;\n}\n\n.onoffswitch-inner:before, .onoffswitch-inner:after {\n  display: block;\n  float: left;\n  width: 50%;\n  height: 16px;\n  padding: 0;\n  line-height: 16px;\n  font-size: 10px;\n  color: white;\n  font-family: Trebuchet, Arial, sans-serif;\n  font-weight: bold;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.onoffswitch-inner:before {\n  content: \"ON\";\n  padding-left: 7px;\n  background-color: #1AB394;\n  color: #FFFFFF;\n}\n\n.onoffswitch-inner:after {\n  content: \"OFF\";\n  padding-right: 7px;\n  background-color: #FFFFFF;\n  color: #919191;\n  text-align: right;\n}\n\n.onoffswitch-switch {\n  display: block;\n  width: 18px;\n  margin: 0;\n  background: #FFFFFF;\n  border: 2px solid #1AB394;\n  border-radius: 3px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 36px;\n  -moz-transition: all 0.3s ease-in 0s;\n  -webkit-transition: all 0.3s ease-in 0s;\n  -o-transition: all 0.3s ease-in 0s;\n  transition: all 0.3s ease-in 0s;\n}\n\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {\n  margin-left: 0;\n}\n\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {\n  right: 0;\n}\n\n/* jqGrid */\n\n.ui-jqgrid {\n  -moz-box-sizing: content-box;\n}\n\n.ui-jqgrid-btable {\n  border-collapse: separate;\n}\n\n.ui-jqgrid-htable {\n  border-collapse: separate;\n}\n\n.ui-jqgrid-titlebar {\n  height: 40px;\n  line-height: 15px;\n  color: #676a6c;\n  background-color: #F9F9F9;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.ui-jqgrid .ui-jqgrid-title {\n  float: left;\n  margin: 1.1em 1em 0.2em;\n}\n\n.ui-jqgrid .ui-jqgrid-titlebar {\n  position: relative;\n  border-left: 0 solid;\n  border-right: 0 solid;\n  border-top: 0 solid;\n}\n\n.ui-widget-header {\n  background: none;\n  background-image: none;\n  background-color: #f5f5f6;\n  text-transform: uppercase;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.ui-jqgrid tr.ui-row-ltr td {\n  border-right-color: inherit;\n  border-right-style: solid;\n  border-right-width: 1px;\n  text-align: left;\n  border-color: #DDDDDD;\n  background-color: inherit;\n}\n\n.ui-search-toolbar input[type=\"text\"] {\n  font-size: 12px;\n  height: 15px;\n  border: 1px solid #CCCCCC;\n  border-radius: 0;\n}\n\n.ui-state-default, .ui-widget-content .ui-state-default, .ui-widget-header .ui-state-default {\n  background: #F9F9F9;\n  border: 1px solid #DDDDDD;\n  line-height: 15px;\n  font-weight: bold;\n  color: #676a6c;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.ui-widget-content {\n  box-sizing: content-box;\n}\n\n.ui-icon-triangle-1-n {\n  background-position: 1px -16px;\n}\n\n.ui-jqgrid tr.ui-search-toolbar th {\n  border-top-width: 0 !important;\n  border-top-color: inherit !important;\n  border-top-style: ridge !important\n}\n\n.ui-state-hover, .ui-widget-content .ui-state-hover, .ui-state-focus, .ui-widget-content .ui-state-focus, .ui-widget-header .ui-state-focus {\n  background: #f5f5f5;\n  border-collapse: separate;\n}\n\n.ui-state-highlight, .ui-widget-content .ui-state-highlight, .ui-widget-header .ui-state-highlight {\n  background: #f2fbff;\n}\n\n.ui-state-active, .ui-widget-content .ui-state-active, .ui-widget-header .ui-state-active {\n  border: 1px solid #dddddd;\n  background: #ffffff;\n  font-weight: normal;\n  color: #212121;\n}\n\n.ui-jqgrid .ui-pg-input {\n  font-size: inherit;\n  width: 50px;\n  border: 1px solid #CCCCCC;\n  height: 15px;\n}\n\n.ui-jqgrid .ui-pg-selbox {\n  display: block;\n  font-size: 1em;\n  height: 25px;\n  line-height: 18px;\n  margin: 0;\n  width: auto;\n}\n\n.ui-jqgrid .ui-pager-control {\n  position: relative;\n}\n\n.ui-jqgrid .ui-jqgrid-pager {\n  height: 32px;\n  position: relative;\n}\n\n.ui-pg-table .navtable .ui-corner-all {\n  border-radius: 0;\n}\n\n.ui-jqgrid .ui-pg-button:hover {\n  padding: 1px;\n  border: 0;\n}\n\n.ui-jqgrid .loading {\n  position: absolute;\n  top: 45%;\n  left: 45%;\n  width: auto;\n  height: auto;\n  z-index: 101;\n  padding: 6px;\n  margin: 5px;\n  text-align: center;\n  font-weight: bold;\n  display: none;\n  border-width: 2px !important;\n  font-size: 11px;\n}\n\n.ui-jqgrid .form-control {\n  height: 10px;\n  width: auto;\n  display: inline;\n  padding: 10px 12px;\n}\n\n.ui-jqgrid-pager {\n  height: 32px;\n}\n\n.ui-corner-all, .ui-corner-top, .ui-corner-left, .ui-corner-tl {\n  border-top-left-radius: 0;\n}\n\n.ui-corner-all, .ui-corner-top, .ui-corner-right, .ui-corner-tr {\n  border-top-right-radius: 0;\n}\n\n.ui-corner-all, .ui-corner-bottom, .ui-corner-left, .ui-corner-bl {\n  border-bottom-left-radius: 0;\n}\n\n.ui-corner-all, .ui-corner-bottom, .ui-corner-right, .ui-corner-br {\n  border-bottom-right-radius: 0;\n}\n\n.ui-widget-content {\n  border: 1px solid #ddd;\n}\n\n.ui-jqgrid .ui-jqgrid-titlebar {\n  padding: 0;\n}\n\n.ui-jqgrid .ui-jqgrid-titlebar {\n  border-bottom: 1px solid #ddd;\n}\n\n.ui-jqgrid tr.jqgrow td {\n  padding: 6px;\n}\n\n.ui-jqdialog .ui-jqdialog-titlebar {\n  padding: 10px 10px;\n\n}\n\n.ui-jqdialog .ui-jqdialog-title {\n  float: none !important;\n}\n\n.ui-jqdialog > .ui-resizable-se {\n  position: absolute;\n}\n\n/* Nestable list */\n\n.dd {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: 13px;\n  line-height: 20px;\n}\n\n.dd-list {\n  display: block;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.dd-list .dd-list {\n  padding-left: 30px;\n}\n\n.dd-collapsed .dd-list {\n  display: none;\n}\n\n.dd-item,\n.dd-empty,\n.dd-placeholder {\n  display: block;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  min-height: 20px;\n  font-size: 13px;\n  line-height: 20px;\n}\n\n.dd-handle {\n  display: block;\n  margin: 5px 0;\n  padding: 5px 10px;\n  color: #333;\n  text-decoration: none;\n  border: 1px solid #e7eaec;\n  background: #f5f5f5;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n.dd-handle span {\n  font-weight: bold;\n}\n\n.dd-handle:hover {\n  background: #f0f0f0;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.dd-item > button {\n  display: block;\n  position: relative;\n  cursor: pointer;\n  float: left;\n  width: 25px;\n  height: 20px;\n  margin: 5px 0;\n  padding: 0;\n  text-indent: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  border: 0;\n  background: transparent;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  font-weight: bold;\n}\n\n.dd-item > button:before {\n  content: '+';\n  display: block;\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  text-indent: 0;\n}\n\n.dd-item > button[data-action=\"collapse\"]:before {\n  content: '-';\n}\n\n#nestable2 .dd-item > button {\n  font-family: FontAwesome;\n  height: 34px;\n  width: 33px;\n  color: #c1c1c1;\n\n}\n\n#nestable2 .dd-item > button:before {\n  content: \"\\f067\";\n}\n\n#nestable2 .dd-item > button[data-action=\"collapse\"]:before {\n  content: \"\\f068\";\n}\n\n.dd-placeholder,\n.dd-empty {\n  margin: 5px 0;\n  padding: 0;\n  min-height: 30px;\n  background: #f2fbff;\n  border: 1px dashed #b6bcbf;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n.dd-empty {\n  border: 1px dashed #bbb;\n  min-height: 100px;\n  background-color: #e5e5e5;\n  background-image: -webkit-linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff), -webkit-linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff);\n  background-image: -moz-linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff), -moz-linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff);\n  background-image: linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff), linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff);\n  background-size: 60px 60px;\n  background-position: 0 0, 30px 30px;\n}\n\n.dd-dragel {\n  position: absolute;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.dd-dragel > .dd-item .dd-handle {\n  margin-top: 0;\n}\n\n.dd-dragel .dd-handle {\n  -webkit-box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, .1);\n  box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, .1);\n}\n\n/**\n* Nestable Extras\n*/\n.nestable-lists {\n  display: block;\n  clear: both;\n  padding: 30px 0;\n  width: 100%;\n  border: 0;\n  border-top: 2px solid #ddd;\n  border-bottom: 2px solid #ddd;\n}\n\n#nestable-menu {\n  padding: 0;\n  margin: 10px 0 20px 0;\n}\n\n#nestable-output,\n#nestable2-output {\n  width: 100%;\n  font-size: 0.75em;\n  line-height: 1.333333em;\n  font-family: open sans, lucida grande, lucida sans unicode, helvetica, arial, sans-serif;\n  padding: 5px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n#nestable2 .dd-handle {\n  color: inherit;\n  border: 1px dashed #e7eaec;\n  background: #f3f3f4;\n  padding: 10px;\n}\n\n#nestable2 span.label {\n  margin-right: 10px;\n}\n\n#nestable-output,\n#nestable2-output {\n  font-size: 12px;\n  padding: 25px;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n/* CodeMirror */\n.CodeMirror {\n  border: 1px solid #eee;\n  height: auto;\n}\n\n.CodeMirror-scroll {\n  overflow-y: hidden;\n  overflow-x: auto;\n}\n\n/* Google Maps */\n.google-map {\n  height: 300px;\n}\n\n/* Validation */\nlabel.error {\n  color: #cc5965;\n  display: inline-block;\n  margin-left: 5px;\n}\n\n.form-control.error {\n  border: 1px dotted #cc5965;\n}\n\n/* ngGrid */\n.gridStyle {\n  border: 1px solid rgb(212, 212, 212);\n  width: 100%;\n  height: 400px\n}\n\n.gridStyle2 {\n  border: 1px solid rgb(212, 212, 212);\n  width: 500px;\n  height: 300px;\n}\n\n.ngH eaderCell {\n  border-right: none;\n  border-bottom: 1px solid #e7eaec;\n}\n\n.ngCell {\n  border-right: none;\n}\n\n.ngTopPanel {\n  background: #F5F5F6;\n}\n\n.ngRow.even {\n  background: #f9f9f9;\n}\n\n.ngRow.selected {\n  background: #EBF2F1;\n}\n\n.ngRow {\n  border-bottom: 1px solid #e7eaec;\n}\n\n.ngCell {\n  background-color: transparent;\n}\n\n.ngHeaderCell {\n  border-right: none;\n}\n\n/* Toastr custom style */\n\n#toast-container > div {\n  -moz-box-shadow: 0 0 3px #999;\n  -webkit-box-shadow: 0 0 3px #999;\n  box-shadow: 0 0 3px #999;\n  opacity: .9;\n  -ms-filter: alpha(Opacity=90);\n  filter: alpha(opacity=90)\n}\n\n#toast-container > :hover {\n  -moz-box-shadow: 0 0 4px #999;\n  -webkit-box-shadow: 0 0 4px #999;\n  box-shadow: 0 0 4px #999;\n  opacity: 1;\n  -ms-filter: alpha(Opacity=100);\n  filter: alpha(opacity=100);\n  cursor: pointer\n}\n\n.toast {\n  background-color: $navy;\n  border-color: $border-color;\n}\n\n.toast-success {\n  background-color: $navy\n}\n\n.toast-error {\n  background-color: $red\n}\n\n.toast-info {\n  background-color: $lazur\n}\n\n.toast-warning {\n  background-color: $yellow\n}\n\n.toast-top-full-width {\n  margin-top: 20px;\n}\n\n.toast-bottom-full-width {\n  margin-bottom: 20px;\n}\n\n.toast {\n  z-index: 3000;\n}\n\n.toast.toast-bootstrap {\n  background-color: white;\n\n  .toast-body {\n    background-color: #fbfbfb;\n    font-size: .775rem;\n  }\n}\n\n/* Notifie */\n.cg-notify-message.inspinia-notify {\n  background: #fff;\n  padding: 0;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);\n  border: none;\n  margin-top: 30px;\n  color: inherit;\n}\n\n.inspinia-notify.alert-warning {\n  border-left: 6px solid $yellow;\n}\n\n.inspinia-notify.alert-success {\n  border-left: 6px solid $blue;\n}\n\n.inspinia-notify.alert-danger {\n  border-left: 6px solid $red;\n}\n\n.inspinia-notify.alert-info {\n  border-left: 6px solid $navy;\n}\n\n/* Image cropper style */\n.img-container, .img-preview {\n  overflow: hidden;\n  text-align: center;\n  width: 100%;\n}\n\n.img-preview-sm {\n  height: 130px;\n  width: 200px;\n}\n\n/* Forum styles  */\n.forum-post-container .media {\n  margin: 10px 10px 10px 10px;\n  padding: 20px 10px 20px 10px;\n  border-bottom: 1px solid #f1f1f1;\n}\n\n.forum-avatar {\n  float: left;\n  margin-right: 20px;\n  text-align: center;\n  width: 110px;\n}\n\n.forum-avatar .rounded-circle {\n  height: 48px;\n  width: 48px;\n}\n\n.author-info {\n  color: #676a6c;\n  font-size: 11px;\n  margin-top: 5px;\n  text-align: center;\n}\n\n.forum-post-info {\n  padding: 9px 12px 6px 12px;\n  background: #f9f9f9;\n  border: 1px solid #f1f1f1;\n}\n\n.media-body > .media {\n  background: #f9f9f9;\n  border-radius: 3px;\n  border: 1px solid #f1f1f1;\n}\n\n.forum-post-container .media-body .photos {\n  margin: 10px 0;\n}\n\n.forum-photo {\n  max-width: 140px;\n  border-radius: 3px;\n\n}\n\n.media-body > .media .forum-avatar {\n  width: 70px;\n  margin-right: 10px;\n}\n\n.media-body > .media .forum-avatar .rounded-circle {\n  height: 38px;\n  width: 38px;\n}\n\n.mid-icon {\n  font-size: 66px;\n}\n\n.forum-item {\n  margin: 10px 0;\n  padding: 10px 0 20px;\n  border-bottom: 1px solid #f1f1f1;\n}\n\n.views-number {\n  font-size: 24px;\n  line-height: 18px;\n  font-weight: 400;\n}\n\n.forum-container, .forum-post-container {\n  padding: 30px !important;\n}\n\n.forum-item small {\n  color: #999;\n}\n\n.forum-item .forum-sub-title {\n  color: #999;\n  margin-left: 50px;\n}\n\n.forum-title {\n  margin: 15px 0 15px 0;\n}\n\n.forum-info {\n  text-align: center;\n}\n\n.forum-desc {\n  color: #999;\n}\n\n.forum-icon {\n  float: left;\n  width: 30px;\n  margin-right: 20px;\n  text-align: center;\n}\n\na.forum-item-title {\n  color: inherit;\n  display: block;\n  font-size: 18px;\n  font-weight: 600;\n}\n\na.forum-item-title:hover {\n  color: inherit;\n}\n\n.forum-icon .fa {\n\n  font-size: 30px;\n  margin-top: 8px;\n  color: #9b9b9b;\n}\n\n.forum-item.active .fa {\n  color: $navy;\n}\n\n.forum-item.active a.forum-item-title {\n  color: $navy;\n}\n\n@media (max-width: 992px) {\n\n  .forum-info {\n    margin: 15px 0 10px 0;\n\n    /* Comment this is you want to show forum info in small devices */\n    display: none;\n  }\n\n  .forum-desc {\n    float: none !important;\n  }\n\n}\n\n/* New Timeline style */\n\n.vertical-container {\n  /* this class is used to give a max-width to the element it is applied to, and center it horizontally when it reaches that max-width */\n  width: 90%;\n  max-width: 1170px;\n  margin: 0 auto;\n}\n\n.vertical-container::after {\n  /* clearfix */\n  content: '';\n  display: table;\n  clear: both;\n}\n\n#vertical-timeline {\n  position: relative;\n  padding: 0;\n  margin-top: 2em;\n  margin-bottom: 2em;\n}\n\n#vertical-timeline::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 18px;\n  height: 100%;\n  width: 4px;\n  background: #f1f1f1;\n}\n\n.vertical-timeline-content .btn {\n  float: right;\n}\n\n#vertical-timeline.light-timeline:before {\n  background: #e7eaec;\n}\n\n.dark-timeline .vertical-timeline-content:before {\n  border-color: transparent #f5f5f5 transparent transparent;\n}\n\n.dark-timeline.center-orientation .vertical-timeline-content:before {\n  border-color: transparent transparent transparent #f5f5f5;\n}\n\n.dark-timeline .vertical-timeline-block:nth-child(2n) .vertical-timeline-content:before,\n.dark-timeline.center-orientation .vertical-timeline-block:nth-child(2n) .vertical-timeline-content:before {\n  border-color: transparent #f5f5f5 transparent transparent;\n}\n\n.dark-timeline .vertical-timeline-content,\n.dark-timeline.center-orientation .vertical-timeline-content {\n  background: #f5f5f5;\n}\n\n@media only screen and (min-width: 1170px) {\n  #vertical-timeline.center-orientation {\n    margin-top: 3em;\n    margin-bottom: 3em;\n  }\n\n  #vertical-timeline.center-orientation:before {\n    left: 50%;\n    margin-left: -2px;\n  }\n}\n\n@media only screen and (max-width: 1170px) {\n  .center-orientation.dark-timeline .vertical-timeline-content:before {\n    border-color: transparent #f5f5f5 transparent transparent;\n  }\n}\n\n.vertical-timeline-block {\n  position: relative;\n  margin: 2em 0;\n}\n\n.vertical-timeline-block:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.vertical-timeline-block:first-child {\n  margin-top: 0;\n}\n\n.vertical-timeline-block:last-child {\n  margin-bottom: 0;\n}\n\n@media only screen and (min-width: 1170px) {\n  .center-orientation .vertical-timeline-block {\n    margin: 4em 0;\n  }\n\n  .center-orientation .vertical-timeline-block:first-child {\n    margin-top: 0;\n  }\n\n  .center-orientation .vertical-timeline-block:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.vertical-timeline-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 16px;\n  border: 3px solid #f1f1f1;\n  text-align: center;\n}\n\n.vertical-timeline-icon i {\n  display: block;\n  width: 24px;\n  height: 24px;\n  position: relative;\n  left: 50%;\n  top: 50%;\n  margin-left: -12px;\n  margin-top: -9px;\n}\n\n@media only screen and (min-width: 1170px) {\n  .center-orientation .vertical-timeline-icon {\n    width: 50px;\n    height: 50px;\n    left: 50%;\n    margin-left: -25px;\n    -webkit-transform: translateZ(0);\n    -webkit-backface-visibility: hidden;\n    font-size: 19px;\n  }\n\n  .center-orientation .vertical-timeline-icon i {\n    margin-left: -12px;\n    margin-top: -10px;\n  }\n\n  .center-orientation .cssanimations .vertical-timeline-icon.is-hidden {\n    visibility: hidden;\n  }\n}\n\n.vertical-timeline-content {\n  position: relative;\n  margin-left: 60px;\n  background: white;\n  border-radius: 0.25em;\n  padding: 1em;\n}\n\n.vertical-timeline-content:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.vertical-timeline-content h2 {\n  font-weight: 400;\n  margin-top: 4px;\n}\n\n.vertical-timeline-content p {\n  margin: 1em 0;\n  line-height: 1.6;\n}\n\n.vertical-timeline-content .vertical-date {\n  float: left;\n  font-weight: 500;\n}\n\n.vertical-date small {\n  color: $navy;\n  font-weight: 400;\n}\n\n.vertical-timeline-content::before {\n  content: '';\n  position: absolute;\n  top: 16px;\n  right: 100%;\n  height: 0;\n  width: 0;\n  border: 7px solid transparent;\n  border-right: 7px solid white;\n}\n\n@media only screen and (min-width: 768px) {\n  .vertical-timeline-content h2 {\n    font-size: 18px;\n  }\n\n  .vertical-timeline-content p {\n    font-size: 13px;\n  }\n\n}\n\n@media only screen and (min-width: 1170px) {\n  .center-orientation .vertical-timeline-content {\n    margin-left: 0;\n    padding: 1.6em;\n    width: 45%;\n  }\n\n  .center-orientation .vertical-timeline-content::before {\n    top: 24px;\n    left: 100%;\n    border-color: transparent;\n    border-left-color: white;\n  }\n\n  .center-orientation .vertical-timeline-content .btn {\n    float: left;\n  }\n\n  .center-orientation .vertical-timeline-content .vertical-date {\n    position: absolute;\n    width: 100%;\n    left: 122%;\n    top: 2px;\n    font-size: 14px;\n  }\n\n  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content {\n    float: right;\n  }\n\n  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content::before {\n    top: 24px;\n    left: auto;\n    right: 100%;\n    border-color: transparent;\n    border-right-color: white;\n  }\n\n  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .btn {\n    float: right;\n  }\n\n  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .vertical-date {\n    left: auto;\n    right: 122%;\n    text-align: right;\n  }\n\n  .center-orientation .cssanimations .vertical-timeline-content.is-hidden {\n    visibility: hidden;\n  }\n}\n\n/* Tabs */\n\n.tabs-container {\n\n  .panel-body {\n    background: #fff;\n    border: 1px solid $border-color;\n    border-radius: 2px;\n    padding: 20px;\n    position: relative;\n  }\n\n  .nav-tabs > li.active > a,\n  .nav-tabs > li.active > a:hover,\n  .nav-tabs > li.active > a:focus {\n    border: 1px solid $border-color;\n    border-bottom-color: transparent;\n    background-color: #fff;\n  }\n\n  .nav-tabs > li {\n    float: left;\n    margin-bottom: -1px;\n  }\n\n  .tab-pane .panel-body {\n    border-top: none;\n  }\n\n  .nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {\n    border: 1px solid $border-color;\n    border-bottom-color: transparent;\n  }\n\n  .nav-tabs {\n    border-bottom: 1px solid $border-color;\n  }\n\n  .tab-pane .panel-body {\n    border-top: none;\n  }\n\n  .tabs-left .tab-pane .panel-body, .tabs-right .tab-pane .panel-body {\n    border-top: 1px solid $border-color;\n  }\n\n  .tabs-below > .nav-tabs,\n  .tabs-right > .nav-tabs,\n  .tabs-left > .nav-tabs {\n    border-bottom: 0;\n  }\n\n  .tabs-left .panel-body {\n    position: static;\n  }\n\n  .tabs-left > .nav-tabs, .tabs-right > .nav-tabs {\n    width: 20%;\n  }\n\n  .tabs-left .panel-body {\n    width: 80%;\n    margin-left: 20%;\n  }\n\n  .tabs-right .panel-body {\n    width: 80%;\n    margin-right: 20%;\n  }\n\n  .tab-content > .tab-pane,\n  .pill-content > .pill-pane {\n    display: none;\n  }\n\n  .tab-content > .active,\n  .pill-content > .active {\n    display: block;\n  }\n\n  .tabs-below > .nav-tabs {\n    border-top: 1px solid $border-color;\n  }\n\n  .tabs-below > .nav-tabs > li {\n    margin-top: -1px;\n    margin-bottom: 0;\n  }\n\n  .tabs-below > .nav-tabs > li > a {\n    -webkit-border-radius: 0 0 4px 4px;\n    -moz-border-radius: 0 0 4px 4px;\n    border-radius: 0 0 4px 4px;\n  }\n\n  .tabs-below > .nav-tabs > li > a:hover,\n  .tabs-below > .nav-tabs > li > a:focus {\n    border-top-color: $border-color;\n    border-bottom-color: transparent;\n  }\n\n  .tabs-left > .nav-tabs > li,\n  .tabs-right > .nav-tabs > li {\n    float: none;\n    word-break: break-word;\n    width: 100%;\n  }\n\n  .tabs-left > .nav-tabs > li > a,\n  .tabs-right > .nav-tabs > li > a {\n    min-width: 124px;\n    margin-right: 0;\n    margin-bottom: 3px;\n  }\n\n  .tabs-left > .nav-tabs {\n    float: left;\n    margin-right: 19px;\n  }\n\n  .tabs-left > .nav-tabs > li > a {\n    margin-right: -1px;\n    -webkit-border-radius: 4px 0 0 4px;\n    -moz-border-radius: 4px 0 0 4px;\n    border-radius: 4px 0 0 4px;\n  }\n\n  .tabs-left > .nav-tabs a.active,\n  .tabs-left > .nav-tabs a.active:hover,\n  .tabs-left > .nav-tabs a.active:focus {\n    border-color: $border-color transparent $border-color $border-color;\n  }\n\n  .tabs-right > .nav-tabs {\n    float: right;\n    margin-left: 19px;\n  }\n\n  .tabs-right > .nav-tabs > li > a {\n    margin-left: -1px;\n    -webkit-border-radius: 0 4px 4px 0;\n    -moz-border-radius: 0 4px 4px 0;\n    border-radius: 0 4px 4px 0;\n  }\n\n  .tabs-right > .nav-tabs a.active,\n  .tabs-right > .nav-tabs a.active:hover,\n  .tabs-right > .nav-tabs a.active:focus {\n    border-color: $border-color $border-color $border-color transparent;\n    z-index: 1;\n  }\n\n  .tabs-right > .nav-tabs li {\n    z-index: 1;\n  }\n\n}\n\n.nav-tabs .nav-link:not(.active):focus, .nav-tabs .nav-link:not(.active):hover {\n  border-color: transparent;\n}\n\n@media (max-width: 767px) {\n  .tabs-container .nav-tabs > li {\n    float: none !important;\n  }\n\n  .tabs-container .nav-tabs > li.active > a {\n    border-bottom: 1px solid #e7eaec !important;\n    margin: 0;\n  }\n}\n\n/* jsvectormap */\n.jvectormap-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.jvectormap-tip {\n  position: absolute;\n  display: none;\n  border: solid 1px #CDCDCD;\n  border-radius: 3px;\n  background: #292929;\n  color: white;\n  font-family: sans-serif, Verdana;\n  font-size: smaller;\n  padding: 5px;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n  position: absolute;\n  left: 10px;\n  border-radius: 3px;\n  background: $navy;\n  padding: 3px;\n  color: white;\n  cursor: pointer;\n  line-height: 10px;\n  text-align: center;\n  box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n  width: 10px;\n  height: 10px;\n}\n\n.jvectormap-zoomin {\n  top: 10px;\n}\n\n.jvectormap-zoomout {\n  top: 30px;\n}\n\n.jvectormap-goback {\n  bottom: 10px;\n  z-index: 1000;\n  padding: 6px;\n}\n\n.jvectormap-spinner {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n  font-weight: bold;\n  font-size: 14px;\n  text-align: center;\n}\n\n.jvectormap-legend-cnt {\n  position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n  bottom: 0;\n  right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n  top: 0;\n  right: 0;\n}\n\n.jvectormap-legend {\n  background: black;\n  color: white;\n  border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n  float: left;\n  margin: 0 10px 10px 0;\n  padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n  float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n  margin: 10px 10px 0 0;\n  padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n  width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n  height: 20px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n  font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n  text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 20px;\n  padding-left: 3px;\n}\n\n/*Slick Carousel */\n\n.slick-prev:before,\n.slick-next:before {\n  color: $navy !important;\n}\n\n/* Payments */\n\n.payment-card {\n  background: #ffffff;\n  padding: 20px;\n  margin-bottom: 25px;\n  border: 1px solid $border-color;\n}\n\n.payment-icon-big {\n  font-size: 60px;\n  color: $light-gray;\n}\n\n.payments-method.panel-group .panel + .panel {\n  margin-top: -1px;\n}\n\n.payments-method .panel-heading {\n  padding: 15px;\n  background-color: $gray;\n}\n\n.payments-method .panel-default {\n  border: 1px solid $border-color;\n}\n\n.payments-method .panel {\n  border-radius: 0;\n}\n\n.payments-method .panel-heading h5 {\n  margin-bottom: 5px;\n}\n\n.payments-method .panel-heading i {\n  font-size: 26px;\n}\n\n/* Select2 custom styles */\n.select2-container--bootstrap4 .select2-results__option--highlighted,\n.select2-container--bootstrap4 .select2-results__option--highlighted.select2-results__option[aria-selected=true] {\n  background-color: $navy;\n}\n\n.select2-container--bootstrap4 .select2-selection,\n.select2-container--bootstrap4 .select2-dropdown.select2-dropdown--above,\n.select2-container--bootstrap4 .select2-dropdown {\n  border-color: $border-color;\n}\n\n.select2-container :focus {\n  outline: none\n}\n\n\n.select2-container--bootstrap4.select2-container--focus .select2-selection {\n  box-shadow: none;\n  border-color: $navy;\n}\n\n.select2-container--bootstrap4 .select2-selection__clear {\n  margin-top: 0.9em;\n}\n/* Tour */\n\n.tour-tour .btn.btn-default {\n  background-color: #ffffff;\n  border: 1px solid #d2d2d2;\n  color: inherit;\n}\n\n.tour-step-backdrop {\n  z-index: 2101;\n}\n\n.tour-backdrop {\n  z-index: 2100;\n  opacity: .7;\n}\n\n.popover[class*=tour-] {\n  z-index: 2100;\n}\n\n.popover-header {\n  margin-top: 0;\n}\n\nbody.tour-open .animated {\n  animation-fill-mode: initial;\n}\n\n.tour-tour .btn.btn-secondary {\n  background-color: #ffffff;\n  border: 1px solid #d2d2d2;\n  color: inherit;\n}\n\n/* Resizable */\n\n.resizable-panels .ibox {\n  clear: none;\n  margin: 10px;\n  float: left;\n  overflow: hidden;\n  min-height: 150px;\n  min-width: 150px;\n}\n\n.resizable-panels .ibox .ibox-content {\n  height: calc(100% - 49px);\n}\n\n.ui-resizable-helper {\n  background: rgba(211, 211, 211, 0.4)\n\n}\n\n/* Wizard step fix */\n.wizard > .content > .body {\n  position: relative\n}\n\n/* PDF js style */\n\n.pdf-toolbar {\n  max-width: 600px;\n  margin: 0 auto;\n\n  .input-group {\n    width: 100px;\n  }\n}\n/* Dropzone */\n\n.dropzone {\n  min-height: 140px;\n  border: 1px dashed $navy;\n  background: white;\n  padding: 20px 15px;\n  text-align: center;\n\n  .dz-message {\n    font-size: 16px;\n\n  }\n}\n\n/* Activity stream */\n\n.stream {\n\n  position: relative;\n  padding: 10px 0;\n\n  &:first-child .stream-badge:before {\n    top: 10px;\n  }\n\n  &:last-child .stream-badge:before {\n    height: 30px;\n  }\n\n  .stream-badge {\n    width: 50px;\n\n    i {\n      border: 1px solid $border-color;\n      border-radius: 50%;\n      padding: 6px;\n      color: lighten($text-color, 10%);\n      position: absolute;\n      background-color: #ffffff;\n      left: 8px;\n\n      &.fa-circle {\n        color: lighten($text-color, 40%);\n      }\n\n      &.bg-success {\n        color: #ffffff;\n        background-color: $blue;\n        border-color: $blue;\n      }\n\n      &.bg-primary {\n        color: #ffffff;\n        background-color: $navy;\n        border-color: $navy;\n      }\n\n      &.bg-warning {\n        color: #ffffff;\n        background-color: $yellow;\n        border-color: $yellow;\n      }\n\n      &.bg-info {\n        color: #ffffff;\n        background-color: $lazur;\n        border-color: $lazur;\n      }\n\n      &.bg-danger {\n        color: #ffffff;\n        background-color: $red;\n        border-color: $red;\n      }\n\n    }\n\n    &:before {\n      content: '';\n      width: 1px;\n      background-color: $border-color;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 20px;\n\n    }\n\n  }\n\n  .stream-info {\n    font-size: 12px;\n    margin-bottom: 5px;\n\n    img {\n      border-radius: 50%;\n      width: 18px;\n      height: 18px;\n      margin-right: 2px;\n      margin-top: -4px;\n    }\n\n    .date {\n      color: lighten($text-color, 20%);\n      font-size: 80%;\n    }\n\n  }\n\n  .stream-panel {\n    margin-left: 55px;\n  }\n\n}\n\n.stream-small {\n  margin: 10px 0;\n\n  .label {\n    padding: 2px 6px;\n    margin-right: 2px;\n  }\n}\n\n/* Touch Spin */\n\n.bootstrap-touchspin-postfix.input-group-addon {\n  padding: inherit;\n\n}\n\n.bootstrap-touchspin-postfix .input-group-text {\n  background-color: inherit;\n  line-height: 1;\n  border: none;\n}\n\n/* Code */\n\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  color: #333;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: lighten($light-gray, 10%);\n  border: 1px solid $light-gray;\n  border-radius: 2px;\n}\n\ncode, kbd, pre, samp {\n  font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}",".sidebar-panel {\n  width: 220px;\n  background: darken($gray, 3%);\n  padding: 10px 20px;\n  position: absolute;\n  right: 0;\n  height: calc(100% - 62px);\n}\n\n.sidebar-panel .feed-element img.rounded-circle {\n  width: 32px;\n  height: 32px;\n}\n\n.sidebar-panel .feed-element, .media-body, .sidebar-panel p {\n  font-size: 12px;\n}\n\n.sidebar-panel .feed-element {\n  margin-top: 20px;\n  padding-bottom: 0;\n}\n\n.sidebar-panel .list-group {\n  margin-bottom: 10px;\n}\n\n.sidebar-panel .list-group .list-group-item {\n  padding: 5px 0;\n  font-size: 12px;\n  border: 0;\n}\n\n.sidebar-content .wrapper, .wrapper.sidebar-content {\n  padding-right: 230px !important;\n}\n\n.body-small .sidebar-content .wrapper, .body-small .wrapper.sidebar-content {\n  padding-right: 20px !important;\n}\n\n// Right sidebar\n\n#right-sidebar {\n  background-color: #fff;\n  border-left: 1px solid #e7eaec;\n  border-top: 1px solid #e7eaec;\n  overflow: hidden;\n  position: fixed;\n  top: 60px;\n  width: 260px !important;\n  z-index: 1009;\n  bottom: 0;\n  right: -260px;\n}\n\n#right-sidebar.sidebar-open {\n  right: 0;\n}\n\n#right-sidebar.sidebar-open.sidebar-top {\n  top: 0;\n  border-top: none;\n}\n\n.sidebar-container {\n\n  ul.nav-tabs {\n    border: none;\n  }\n\n  ul.nav-tabs.navs-4 li {\n    width: 25%;\n  }\n  ul.nav-tabs.navs-3 li {\n    width: 33.3333%;\n  }\n  ul.nav-tabs.navs-2 li {\n    width: 50%;\n  }\n\n  ul.nav-tabs li {\n    border: none;\n  }\n\n  ul.nav-tabs li a {\n    border: none;\n    padding: 12px 10px;\n    margin: 0;\n    border-radius: 0;\n    background: $nav-bg;\n    color: #fff;\n    text-align: center;\n\n    border-right: 1px solid lighten($nav-bg, 2%);\n  }\n\n  ul.nav-tabs li.active a {\n    border: none;\n    background: #f9f9f9;\n    color: $text-color;\n    font-weight: bold;\n\n  }\n\n  .nav-tabs > li.active > a:hover,\n  .nav-tabs > li.active > a:focus {\n\n    border: none;\n\n  }\n\n  ul.sidebar-list {\n    margin: 0;\n    padding: 0;\n  }\n\n  ul.sidebar-list li {\n    border-bottom: 1px solid $border-color;\n    padding: 15px 20px;\n    list-style: none;\n\n    font-size: 12px;\n  }\n\n  ul.sidebar-list li:nth-child(2n+2) {\n    //    background: #f9f9f9;\n  }\n\n  .sidebar-message:nth-child(2n+2) {\n    background: #f9f9f9;\n  }\n\n  ul.sidebar-list li a {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  .sidebar-content {\n    padding: 15px 20px;\n    font-size: 12px;\n  }\n\n  .date-item {\n\n  }\n\n  .sidebar-title {\n    background: #f9f9f9;\n    padding: 20px;\n    border-bottom: 1px solid $border-color;\n\n    h3 {\n      margin-bottom: 3px;\n      padding-left: 2px;\n    }\n  }\n\n  .tab-content {\n\n    h4 {\n      margin-bottom: 5px;\n    }\n\n  }\n\n  .sidebar-message > a > .float-left {\n    margin-right: 10px;\n  }\n\n  .sidebar-message > a {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  .sidebar-message {\n    padding: 15px 20px;\n  }\n\n  .sidebar-message .media-body {\n    display: block;\n    width: auto;\n  }\n\n  .sidebar-message:hover {\n    //    background: #f9f9f9;\n  }\n\n  .sidebar-message .message-avatar {\n    height: 38px;\n    width: 38px;\n    border-radius: 50%;\n  }\n\n  .setings-item {\n    padding: 15px 20px;\n    border-bottom: 1px solid $border-color;\n  }\n\n}\n\n","body {\n  font-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  background-color: $nav-bg;\n  font-size: 13px;\n  color: $text-color;\n  overflow-x: hidden;\n\n}\n\nhtml, body {\n  height: 100%;\n\n}\n\nbody.full-height-layout #wrapper,\nbody.full-height-layout #page-wrapper {\n  height: 100%;\n}\n\n#page-wrapper {\n  min-height: 100vh;\n}\n\nbody.boxed-layout {\n  background: $boxed-background;\n}\n\nbody.boxed-layout #wrapper {\n  background-color: $nav-bg;\n  max-width: $boxed-width;\n  margin: 0 auto;\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n}\n\n.top-navigation.boxed-layout #wrapper,\n.boxed-layout #wrapper.top-navigation {\n  max-width: 1300px !important;\n}\n\n.block {\n  display: block;\n}\n\n.clear {\n  display: block;\n  overflow: hidden;\n}\n\na {\n  color: $basic-link-color;\n  cursor: pointer;\n}\n\na:hover, a:focus {\n  text-decoration: none;\n}\n\n.border-bottom {\n  border-bottom: 1px solid $border-color !important;\n}\n\n.font-bold {\n  font-weight: 600;\n}\n\n.font-normal {\n  font-weight: 400;\n}\n\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.font-italic {\n  font-style: italic;\n}\n\n.b-r {\n  border-right: 1px solid $border-color;\n}\n\n.hr-line-dashed {\n  border-top: 1px dashed $border-color;\n  color: #ffffff;\n  background-color: #ffffff;\n  height: 1px;\n  margin: 20px 0;\n}\n\n.hr-line-solid {\n  border-bottom: 1px solid $border-color;\n  background-color: rgba(0, 0, 0, 0);\n  border-style: solid !important;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\nvideo {\n  width: 100% !important;\n  height: auto !important;\n}\n\n/* GALLERY */\n.gallery > .row > div {\n  margin-bottom: 15px;\n}\n\n.fancybox img {\n  margin-bottom: 5px;\n  /* Only for demo */\n  width: 24%;\n}\n\n/* Summernote text editor  */\n.note-editor {\n  height: auto !important;\n  //min-height: 300px;\n}\n\n.note-editor.fullscreen {\n  z-index: 2050;\n}\n\n.note-editor.note-frame.fullscreen {\n  z-index: 2020;\n}\n\n.note-editor.note-frame .note-editing-area .note-editable {\n  color: $text-color;\n  padding: 15px;\n}\n\n.note-editor.note-frame {\n  border: none;\n}\n\n.note-editor.panel {\n  margin-bottom: 0;\n}\n\n/* MODAL */\n.modal-content {\n  background-clip: padding-box;\n  background-color: #FFFFFF;\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  outline: 0 none;\n  position: relative;\n}\n\n.modal-dialog {\n  z-index: 2200;\n}\n\n.modal-body {\n  padding: 20px 30px 30px 30px;\n}\n\n.inmodal .modal-body {\n  background: #f8fafb;\n}\n\n.inmodal .modal-header {\n  padding: 30px 15px;\n  text-align: center;\n  display: block;\n}\n\n.animated.modal.fade .modal-dialog {\n  -webkit-transform: none;\n  -ms-transform: none;\n  -o-transform: none;\n  transform: none;\n}\n\n.inmodal .modal-title {\n  font-size: 26px;\n}\n\n.inmodal .modal-icon {\n  font-size: 84px;\n  color: #e2e3e3;\n}\n\n.modal-footer {\n  margin-top: 0;\n}\n\n/* WRAPPERS */\n\n#wrapper {\n  width: 100%;\n  overflow-x: hidden;\n  display: -ms-flex;\n  display: -webkit-flex;\n  display: flex;\n\n}\n\n.wrapper {\n  padding: 0 20px;\n}\n\n.wrapper-content {\n  padding: 20px 10px 40px;\n}\n\n#page-wrapper {\n  padding: 0 15px;\n  position: relative !important;\n  flex-shrink: 1;\n  width: calc(100% - 220px);\n}\n\n@media (min-width: 768px) {\n  #page-wrapper {\n    position: inherit;\n  }\n}\n\n.title-action {\n  text-align: right;\n  padding-top: 30px;\n}\n\n.ibox-content h1, .ibox-content h2, .ibox-content h3, .ibox-content h4, .ibox-content h5,\n.ibox-title h1, .ibox-title h2, .ibox-title h3, .ibox-title h4, .ibox-title h5 {\n  margin-top: 5px;\n}\n\nul.unstyled, ol.unstyled {\n  list-style: none outside none;\n  margin-left: 0;\n}\n\n.big-icon {\n  font-size: 100px !important;\n  color: #e5e6e7;\n}\n\n/* FOOTER */\n\n.footer {\n\n  background: none repeat scroll 0 0 white;\n  border-top: 1px solid $border-color;\n  bottom: 0;\n  left: 0;\n  padding: 10px 20px;\n  position: absolute;\n  right: 0;\n}\n\n.footer.fixed_full {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 10px 20px;\n  background: white;\n  border-top: 1px solid $border-color;\n}\n\n.footer.fixed {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 10px 20px;\n  background: white;\n  border-top: 1px solid $border-color;\n  margin-left: $sidebar-width;\n}\n\nbody.mini-navbar .footer.fixed,\nbody.body-small.mini-navbar .footer.fixed {\n  margin: 0 0 0 70px;\n}\n\nbody.mini-navbar.fixed-sidebar .footer.fixed {\n  margin: 0;\n}\n\nbody.mini-navbar.canvas-menu .footer.fixed,\nbody.canvas-menu .footer.fixed {\n  margin: 0 !important;\n}\n\nbody.fixed-sidebar.body-small.mini-navbar .footer.fixed {\n  margin: 0 0 0 $sidebar-width;\n}\n\nbody.body-small .footer.fixed {\n  margin-left: 0;\n}\n\n/* PANELS */\n\n.panel-title > .small, .panel-title > .small > a, .panel-title > a, .panel-title > small, .panel-title > small > a {\n  color: inherit;\n}\n\n.page-heading {\n  border-top: 0;\n  padding: 0 10px 20px 10px;\n}\n\n.panel-heading h1, .panel-heading h2 {\n  margin-bottom: 5px;\n}\n\n.panel-body {\n  padding: 15px;\n}\n\n/* Bootstrap 3.3.x panels */\n.panel {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.panel-heading {\n  color: white;\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.panel-footer {\n  padding: 10px 15px;\n  border-top: 1px solid $border-color;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.panel-default > .panel-heading {\n  color: #333;\n  background-color: #f5f5f5;\n  border-color: $border-color;\n}\n\n.panel-default {\n  border-color: $border-color;\n}\n\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n\n.panel-group .panel {\n  margin-bottom: 0;\n  border-radius: 4px;\n}\n\n/* TABLES */\n\n.table > caption + thead > tr:first-child > td, .table > caption + thead > tr:first-child > th, .table > colgroup + thead > tr:first-child > td, .table > colgroup + thead > tr:first-child > th, .table > thead:first-child > tr:first-child > td, .table > thead:first-child > tr:first-child > th {\n  border-top: 0;\n}\n\n.table-bordered {\n  border: 1px solid #EBEBEB;\n}\n\n.table-bordered > thead > tr > th, .table-bordered > thead > tr > td {\n  background-color: #F5F5F6;\n  border-bottom-width: 1px;\n}\n\n.table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td {\n  border: 1px solid #e7e7e7;\n}\n\n.table > thead > tr > th {\n  border-bottom: 1px solid #DDDDDD;\n  vertical-align: bottom;\n}\n\n.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {\n  border-top: 1px solid $border-color;\n  line-height: 1.42857;\n  padding: 8px;\n  vertical-align: top;\n}\n\n/* PANELS */\n\n.panel.blank-panel {\n  background: none;\n  margin: 0;\n}\n\n.blank-panel .panel-heading {\n  padding-bottom: 0;\n}\n\n.nav-tabs > li > a {\n  color: #A7B1C2;\n  font-weight: 600;\n  padding: 10px 20px 10px 25px;\n}\n\n.nav-tabs > li > a:hover, .nav-tabs > li > a:focus {\n  color: $text-color;\n}\n\n.ui-tab .tab-content {\n  padding: 20px 0;\n}\n\n/* GLOBAL  */\n\n.no-padding {\n  padding: 0 !important;\n}\n\n.no-borders {\n  border: none !important;\n}\n\n.no-margins {\n  margin: 0 !important;\n}\n\n.no-top-border {\n  border-top: 0 !important;\n}\n\n.ibox-content.text-box {\n  padding-bottom: 0;\n  padding-top: 15px;\n}\n\n.border-left-right {\n  border-left: 1px solid $border-color;\n  border-right: 1px solid $border-color;\n}\n\n.border-top-bottom {\n  border-top: 1px solid $border-color;\n  border-bottom: 1px solid $border-color;\n}\n\n.border-left {\n  border-left: 1px solid $border-color;\n}\n\n.border-right {\n  border-right: 1px solid $border-color;\n}\n\n.border-top {\n  border-top: 1px solid $border-color;\n}\n\n.border-bottom {\n  border-bottom: 1px solid $border-color;\n}\n\n.border-size-sm {\n  border-width: 3px;\n}\n\n.border-size-md {\n  border-width: 6px;\n}\n\n.border-size-lg {\n  border-width: 9px;\n}\n\n.border-size-xl {\n  border-width: 12px;\n}\n\n.full-width {\n  width: 100% !important;\n}\n\n.link-block {\n  font-size: 12px;\n  padding: 10px;\n}\n\n.nav.navbar-top-links .link-block a {\n  font-size: 12px;\n}\n\n.navbar-top-links { text-align: right }\n\n.link-block a {\n  font-size: 10px;\n  color: inherit;\n\n}\n\nbody.mini-navbar .branding {\n  display: none;\n}\n\nimg.circle-border {\n  border: 6px solid #FFFFFF;\n  border-radius: 50%;\n}\n\n.branding {\n  float: left;\n  color: #FFFFFF;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 17px 20px;\n  text-align: center;\n  background-color: $navy;\n}\n\n.login-panel {\n  margin-top: 25%;\n}\n\n.icons-box h3 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.icons-box .infont a i {\n  font-size: 25px;\n  display: block;\n  color: $text-color;\n}\n\n.icons-box .infont a {\n  color: #a6a8a9;\n}\n\n.icons-box .infont a {\n  padding: 10px;\n\n  margin: 1px;\n  display: block;\n}\n\n.ui-draggable .ibox-title {\n  cursor: move;\n}\n\n.breadcrumb {\n  background-color: #ffffff;\n  padding: 0;\n  margin-bottom: 0;\n}\n\n.breadcrumb > li a {\n  color: inherit;\n}\n\n.breadcrumb > .active {\n  color: inherit;\n}\n\ncode {\n  background-color: #F9F2F4;\n  border-radius: 4px;\n  color: #ca4440;\n  font-size: 90%;\n  padding: 2px 4px;\n  white-space: nowrap;\n}\n\n.ibox {\n  clear: both;\n  margin-bottom: 25px;\n  margin-top: 0;\n  padding: 0;\n}\n\n.ibox.collapsed .ibox-content {\n  display: none;\n}\n\n.ibox.collapsed .fa.fa-chevron-up:before {\n  content: \"\\f078\";\n}\n\n.ibox.collapsed .fa.fa-chevron-down:before {\n  content: \"\\f077\";\n}\n\n.ibox:after, .ibox:before {\n  display: table;\n}\n\n.ibox-title {\n  background-color: $ibox-title-bg;\n  border-color: $border-color;\n  border-image: none;\n  border-style: solid solid none;\n  border-width: 1px;\n  color: inherit;\n  margin-bottom: 0;\n  padding: 15px 90px 8px 15px;\n  min-height: 48px;\n  position: relative;\n  clear: both;\n  -webkit-border-radius: 3px 3px 0 0;\n  -moz-border-radius: 3px 3px 0 0;\n  border-radius: 2px 2px 0 0;\n}\n\n.ibox-content {\n  background-color: $ibox-content-bg;\n  color: inherit;\n  padding: 15px 20px 20px 20px;\n  border-color: $border-color;\n  border-image: none;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 10px;\n}\n\n.ibox-footer {\n  color: inherit;\n  border-top: 1px solid $border-color;\n  font-size: 90%;\n  background: #ffffff;\n  padding: 10px 15px;\n}\n\ntable.table-mail tr td {\n  padding: 12px;\n}\n\n.table-mail .check-mail {\n  padding-left: 20px;\n}\n\n.table-mail .mail-date {\n  padding-right: 20px;\n}\n\n.star-mail, .check-mail {\n  width: 40px;\n}\n\n.unread td a, .unread td {\n  font-weight: 600;\n  color: inherit;\n}\n\n.read td a, .read td {\n  font-weight: normal;\n  color: inherit;\n}\n\n.unread td {\n  background-color: #f9f8f8;\n}\n\n.ibox-content {\n  clear: both;\n}\n\n.ibox-heading {\n  background-color: #f3f6fb;\n  border-bottom: none;\n}\n\n.ibox-heading h3 {\n  font-weight: 200;\n  font-size: 24px;\n}\n\n.ibox-title h5 {\n  display: inline-block;\n  font-size: 14px;\n  margin: 0 0 7px;\n  padding: 0;\n  text-overflow: ellipsis;\n  float: none;\n}\n\n.ibox-title .label {\n  margin-left: 4px;\n}\n\n.ibox-title .pull-right {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n}\n\n.ibox-tools {\n  display: block;\n  float: none;\n  margin-top: 0;\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  padding: 0;\n  text-align: right;\n}\n\n.ibox-tools a {\n  cursor: pointer;\n  margin-left: 5px;\n  color: #c4c4c4 !important;\n}\n\n.ibox-tools a.btn-primary {\n  color: #fff !important;\n}\n\n.ibox-tools .dropdown-menu > li > a {\n  padding: 4px 10px;\n  font-size: 12px;\n  color: $text-color !important;\n}\n\n.ibox .ibox-tools.open > .dropdown-menu {\n  left: auto;\n  right: 0;\n}\n\n.ibox-tools .dropdown-toggle::after {\n  display: none;\n}\n\n.dropdown-item {\n  width: auto;\n}\n\n.dropdown-item.active, .dropdown-item:active {\n  background-color: inherit;\n  color: inherit;\n}\n\n/* BACKGROUNDS */\n\n.gray-bg, .bg-muted {\n  background-color: $gray;\n}\n\n.white-bg {\n  background-color: #ffffff;\n}\n\n.blue-bg, .bg-success {\n  background-color: $blue !important;\n  color: #ffffff;\n}\n\n.navy-bg, .bg-primary {\n  background-color: $navy !important;;\n  color: #ffffff;\n}\n\n.lazur-bg, .bg-info {\n  background-color: $lazur !important;;\n  color: #ffffff;\n}\n\n.yellow-bg, .bg-warning {\n  background-color: $yellow !important;;\n  color: #ffffff;\n}\n\n.red-bg, .bg-danger {\n  background-color: $red !important;;\n  color: #ffffff;\n}\n\n.black-bg {\n  background-color: #262626;\n}\n\n.panel-primary {\n  border-color: $navy;\n}\n\n.panel-primary > .panel-heading {\n  background-color: $navy;\n  border-color: $navy;\n}\n\n.panel-success {\n  border-color: $blue;\n}\n\n.panel-success > .panel-heading {\n  background-color: $blue;\n  border-color: $blue;\n  color: #ffffff;\n}\n\n.panel-info {\n  border-color: $lazur;\n}\n\n.panel-info > .panel-heading {\n  background-color: $lazur;\n  border-color: $lazur;\n  color: #ffffff;\n}\n\n.panel-warning {\n  border-color: $yellow;\n}\n\n.panel-warning > .panel-heading {\n  background-color: $yellow;\n  border-color: $yellow;\n  color: #ffffff;\n}\n\n.panel-danger {\n  border-color: $red;\n}\n\n.panel-danger > .panel-heading {\n  background-color: $red;\n  border-color: $red;\n  color: #ffffff;\n}\n\n.progress-bar {\n  background-color: $navy;\n}\n\n.progress-small, .progress-small .progress-bar {\n  height: 10px;\n}\n\n.progress-small, .progress-mini {\n  margin-top: 5px;\n}\n\n.progress-mini, .progress-mini .progress-bar {\n  height: 5px;\n  margin-bottom: 0;\n}\n\n.progress-bar-navy-light {\n  background-color: #3dc7ab;\n}\n\n.progress-bar-success {\n  background-color: $blue;\n}\n\n.progress-bar-info {\n  background-color: $lazur;\n}\n\n.progress-bar-warning {\n  background-color: $yellow;\n}\n\n.progress-bar-danger {\n  background-color: $red;\n}\n\n.panel-title {\n  font-size: inherit;\n}\n\n.jumbotron {\n  border-radius: 6px;\n  padding: 40px;\n}\n\n.jumbotron h1 {\n  margin-top: 0;\n}\n\n/* COLORS */\n\n.text-navy {\n  color: $navy !important;\n}\n\n.text-primary {\n  color: inherit !important;;\n}\n\n.text-success {\n  color: $blue !important;;\n}\n\n.text-info {\n  color: $lazur !important;;\n}\n\n.text-warning {\n  color: $yellow !important;;\n}\n\n.text-danger {\n  color: $red !important;;\n}\n\n.text-muted {\n  color: #888888 !important;;\n}\n\n.text-white {\n  color: #ffffff;\n}\n\n.simple_tag {\n  background-color: #f3f3f4;\n  border: 1px solid #e7eaec;\n  border-radius: 2px;\n  color: inherit;\n  font-size: 10px;\n  margin-right: 5px;\n  margin-top: 5px;\n  padding: 5px 12px;\n  display: inline-block;\n}\n\n.img-shadow {\n  -webkit-box-shadow: 0 0 3px 0 rgba(145, 145, 145, 1);\n  -moz-box-shadow: 0 0 3px 0 rgba(145, 145, 145, 1);\n  box-shadow: 0 0 3px 0 rgba(145, 145, 145, 1);\n}\n\n.dashboards\\.dashboard_2 nav.navbar,\n.dashboards\\.dashboard_3 nav.navbar,\n.mailbox\\.inbox nav.navbar,\n.mailbox\\.email_view nav.navbar,\n.mailbox\\.email_compose nav.navbar,\n.dashboards\\.dashboard_4_1 nav.navbar,\n.metrics nav.navbar, .metrics\\.index nav.navbar,\n.dashboards\\.dashboard_5 nav.navbar {\n  background: #fff;\n}\n\n\na.close-canvas-menu {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  z-index: 1011;\n  color: #a7b1c2;\n}\n\na.close-canvas-menu:hover {\n  color: #fff;\n}\n\n.close-canvas-menu {\n  display: none;\n}\n\n.canvas-menu .close-canvas-menu {\n  display: block\n}\n\n.light-navbar .navbar.navbar-static-top {\n  background-color: #fff\n}\n\n/* FULL HEIGHT */\n\n.full-height {\n  height: 100%;\n}\n\n.fh-breadcrumb {\n  height: calc(100% - 196px);\n  margin: 0 -15px;\n  position: relative\n}\n\n.fh-no-breadcrumb {\n  height: calc(100% - 99px);\n  margin: 0 -15px;\n  position: relative\n}\n\n.fh-column {\n  background: #fff;\n  height: 100%;\n  width: 240px;\n  float: left\n}\n\n.modal-backdrop {\n  z-index: 2040 !important;\n}\n\n.modal {\n  z-index: 2050 !important;\n}\n\n.spiner-example {\n  height: 200px;\n  padding-top: 70px;\n}\n\nlegend {\n  font-size: 1rem;\n}\n\n/* MARGINS & PADDINGS */\n\n.p-xxs {\n  padding: 5px;\n}\n\n.p-xs {\n  padding: 10px;\n}\n\n.p-sm {\n  padding: 15px;\n}\n\n.p-m {\n  padding: 20px;\n}\n\n.p-md {\n  padding: 25px;\n}\n\n.p-lg {\n  padding: 30px;\n}\n\n.p-xl {\n  padding: 40px;\n}\n\n.p-w-xs {\n  padding: 0 10px;\n}\n\n.p-w-sm {\n  padding: 0 15px;\n\n}\n\n.p-w-m {\n  padding: 0 20px;\n\n}\n\n.p-w-md {\n  padding: 0 25px;\n\n}\n\n.p-w-lg {\n  padding: 0 30px;\n\n}\n\n.p-w-xl {\n  padding: 0 40px;\n\n}\n\n.p-h-xs {\n  padding: 10px 0;\n}\n\n.p-h-sm {\n  padding: 15px 0;\n\n}\n\n.p-h-m {\n  padding: 20px 0;\n\n}\n\n.p-h-md {\n  padding: 25px 0;\n\n}\n\n.p-h-lg {\n  padding: 30px 0;\n\n}\n\n.p-h-xl {\n  padding: 40px 0;\n\n}\n\n.m-xxs {\n  margin: 2px 4px;\n}\n\n.m {\n  margin: 15px;\n}\n\n.m-xs {\n  margin: 5px;\n}\n\n.m-sm {\n  margin: 10px;\n}\n\n.m-md {\n  margin: 20px;\n}\n\n.m-lg {\n  margin: 30px;\n}\n\n.m-xl {\n  margin: 50px;\n}\n\n.m-n {\n  margin: 0 !important;\n}\n\n.m-l-none {\n  margin-left: 0;\n}\n\n.m-l-xs {\n  margin-left: 5px;\n}\n\n.m-l-sm {\n  margin-left: 10px;\n}\n\n.m-l {\n  margin-left: 15px;\n}\n\n.m-l-md {\n  margin-left: 20px;\n}\n\n.m-l-lg {\n  margin-left: 30px;\n}\n\n.m-l-xl {\n  margin-left: 40px;\n}\n\n.m-l-n-xxs {\n  margin-left: -1px;\n}\n\n.m-l-n-xs {\n  margin-left: -5px;\n}\n\n.m-l-n-sm {\n  margin-left: -10px;\n}\n\n.m-l-n {\n  margin-left: -15px;\n}\n\n.m-l-n-md {\n  margin-left: -20px;\n}\n\n.m-l-n-lg {\n  margin-left: -30px;\n}\n\n.m-l-n-xl {\n  margin-left: -40px;\n}\n\n.m-t-none {\n  margin-top: 0;\n}\n\n.m-t-xxs {\n  margin-top: 1px;\n}\n\n.m-t-xs {\n  margin-top: 5px;\n}\n\n.m-t-sm {\n  margin-top: 10px;\n}\n\n.m-t {\n  margin-top: 15px;\n}\n\n.m-t-md {\n  margin-top: 20px;\n}\n\n.m-t-lg {\n  margin-top: 30px;\n}\n\n.m-t-xl {\n  margin-top: 40px;\n}\n\n.m-t-n-xxs {\n  margin-top: -1px;\n}\n\n.m-t-n-xs {\n  margin-top: -5px;\n}\n\n.m-t-n-sm {\n  margin-top: -10px;\n}\n\n.m-t-n {\n  margin-top: -15px;\n}\n\n.m-t-n-md {\n  margin-top: -20px;\n}\n\n.m-t-n-lg {\n  margin-top: -30px;\n}\n\n.m-t-n-xl {\n  margin-top: -40px;\n}\n\n.m-r-none {\n  margin-right: 0;\n}\n\n.m-r-xxs {\n  margin-right: 1px;\n}\n\n.m-r-xs {\n  margin-right: 5px;\n}\n\n.m-r-sm {\n  margin-right: 10px;\n}\n\n.m-r {\n  margin-right: 15px;\n}\n\n.m-r-md {\n  margin-right: 20px;\n}\n\n.m-r-lg {\n  margin-right: 30px;\n}\n\n.m-r-xl {\n  margin-right: 40px;\n}\n\n.m-r-n-xxs {\n  margin-right: -1px;\n}\n\n.m-r-n-xs {\n  margin-right: -5px;\n}\n\n.m-r-n-sm {\n  margin-right: -10px;\n}\n\n.m-r-n {\n  margin-right: -15px;\n}\n\n.m-r-n-md {\n  margin-right: -20px;\n}\n\n.m-r-n-lg {\n  margin-right: -30px;\n}\n\n.m-r-n-xl {\n  margin-right: -40px;\n}\n\n.m-b-none {\n  margin-bottom: 0;\n}\n\n.m-b-xxs {\n  margin-bottom: 1px;\n}\n\n.m-b-xs {\n  margin-bottom: 5px;\n}\n\n.m-b-sm {\n  margin-bottom: 10px;\n}\n\n.m-b {\n  margin-bottom: 15px;\n}\n\n.m-b-md {\n  margin-bottom: 20px;\n}\n\n.m-b-lg {\n  margin-bottom: 30px;\n}\n\n.m-b-xl {\n  margin-bottom: 40px;\n}\n\n.m-b-n-xxs {\n  margin-bottom: -1px;\n}\n\n.m-b-n-xs {\n  margin-bottom: -5px;\n}\n\n.m-b-n-sm {\n  margin-bottom: -10px;\n}\n\n.m-b-n {\n  margin-bottom: -15px;\n}\n\n.m-b-n-md {\n  margin-bottom: -20px;\n}\n\n.m-b-n-lg {\n  margin-bottom: -30px;\n}\n\n.m-b-n-xl {\n  margin-bottom: -40px;\n}\n\n.space-15 {\n  margin: 15px 0;\n}\n\n.space-20 {\n  margin: 20px 0;\n}\n\n.space-25 {\n  margin: 25px 0;\n}\n\n.space-30 {\n  margin: 30px 0;\n}\n\n// IMAGES SIZE\n\n.img-sm {\n  width: 32px;\n  height: 32px;\n}\n\n.img-md {\n  width: 64px;\n  height: 64px;\n}\n\n.img-lg {\n  width: 96px;\n  height: 96px;\n}\n\n// BORDER RADIUS\n\n.b-r-xs {\n  -webkit-border-radius: 1px;\n  -moz-border-radius: 1px;\n  border-radius: 1px;\n}\n\n.b-r-sm {\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.b-r-md {\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.b-r-lg {\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  border-radius: 12px;\n}\n\n.b-r-xl {\n  -webkit-border-radius: 24px;\n  -moz-border-radius: 24px;\n  border-radius: 24px;\n}\n\n// Fullscreen functions\n\n.fullscreen-ibox-mode .animated {\n  animation: none;\n}\n\nbody.fullscreen-ibox-mode {\n  overflow-y: hidden;\n}\n\n.ibox.fullscreen {\n  z-index: 2030;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: auto;\n  margin-bottom: 0;\n}\n\n.ibox.fullscreen .collapse-link {\n  display: none;\n}\n\n.ibox.fullscreen .ibox-content {\n  min-height: calc(100% - 48px);\n}\n\n// Bootstrap issue in 3.3.0 with modal https://github.com/twbs/bootstrap/issues/9855\n// Fix\nbody.modal-open {\n  padding-right: inherit !important;\n}\n\n// Fix modal in Safari browser\n_::-webkit-full-page-media, _:future, :root body.modal-open .wrapper-content.animated {\n  -webkit-animation: none;\n  -ms-animation-nam: none;\n  animation: none;\n}\n\n// Fix for modal backdrop with animate.css\nbody.modal-open .animated {\n  animation-fill-mode: initial;\n  z-index: inherit\n}\n\n/* Show profile dropdown on fixed sidebar */\nbody.mini-navbar.fixed-sidebar .profile-element, .block {\n  display: block !important;\n}\n\nbody.mini-navbar.fixed-sidebar .nav-header {\n  padding: 33px 25px;\n}\n\nbody.mini-navbar.fixed-sidebar .logo-element {\n  display: none;\n}\n\n// Remove animation on fullscreen video\n\n.fullscreen-video .animated {\n  animation: none;\n}\n\n.list-inline > li {\n  display: inline-block;\n}\n\n.custom-file-label {\n  padding: .5rem .75rem;\n\n  &::after {\n    padding: .5rem .75rem;\n  }\n}\n","#small-chat {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n\n#small-chat .badge {\n  position: absolute;\n  top: -3px;\n  right: -4px;\n}\n\n.open-small-chat {\n  height: 38px;\n  width: 38px;\n  display: block;\n  background: #1ab394;\n  padding: 9px 8px;\n  text-align: center;\n  color: #fff;\n  border-radius: 50%;\n}\n\n.open-small-chat:hover {\n  color: white;\n  background: #1ab394;\n}\n\n.small-chat-box {\n  display: none;\n  position: fixed;\n  bottom: 20px;\n  right: 75px;\n  background: #fff;\n  border: 1px solid $border-color;\n  width: 230px;\n  height: 320px;\n  border-radius: 4px;\n}\n\n.small-chat-box.ng-small-chat {\n  display: block;\n}\n\n.body-small {\n  .small-chat-box {\n    bottom: 70px;\n    right: 20px;\n  }\n}\n\n.small-chat-box.active {\n  display: block;\n}\n\n.small-chat-box {\n\n  z-index: 1001;\n\n  .heading {\n    background: $nav-bg;\n    padding: 8px 15px;\n    font-weight: bold;\n    color: #fff;\n  }\n\n  .chat-date {\n    opacity: 0.6;\n    font-size: 10px;\n    font-weight: normal;\n  }\n\n  .content {\n    padding: 15px 15px;\n\n    .author-name {\n      font-weight: bold;\n      margin-bottom: 3px;\n      font-size: 11px;\n    }\n\n    > div {\n      padding-bottom: 20px;\n    }\n\n    .chat-message {\n      padding: 5px 10px;\n      border-radius: 6px;\n      font-size: 11px;\n      line-height: 14px;\n      max-width: 80%;\n      background: #f3f3f4;\n      margin-bottom: 10px;\n    }\n\n    .chat-message.active {\n      background: #1ab394;\n      color: #fff;\n    }\n\n    .left {\n      text-align: left;\n      clear: both;\n\n      .chat-message {\n        float: left;\n      }\n    }\n\n    .right {\n      text-align: right;\n      clear: both;\n\n      .chat-message {\n        float: right;\n      }\n\n    }\n\n  }\n\n  .form-chat {\n    padding: 10px 10px;\n  }\n\n}","/*\n * metismenu - v2.0.2\n * A jQuery menu plugin\n * https://github.com/onokumus/metisMenu\n *\n * Made by Osman Nuri Okumus\n * Under MIT License\n */\n\n.metismenu .plus-minus, .metismenu .plus-times {\n  float: right\n}\n\n.metismenu .arrow {\n  float: right;\n  line-height: 1.42857\n}\n\n.metismenu .glyphicon.arrow:before {\n  content: \"\\e079\"\n}\n\n.metismenu .active > a > .glyphicon.arrow:before {\n  content: \"\\e114\"\n}\n\n.metismenu .fa.arrow:before {\n  content: \"\\f104\"\n}\n\n.metismenu .active > a > .fa.arrow:before {\n  content: \"\\f107\"\n}\n\n.metismenu .ion.arrow:before {\n  content: \"\\f3d2\"\n}\n\n.metismenu .active > a > .ion.arrow:before {\n  content: \"\\f3d0\"\n}\n\n.metismenu .fa.plus-minus:before, .metismenu .fa.plus-times:before {\n  content: \"\\f067\"\n}\n\n.metismenu .active > a > .fa.plus-times {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg)\n}\n\n.metismenu .active > a > .fa.plus-minus:before {\n  content: \"\\f068\"\n}\n\n.metismenu .collapse {\n  display: none\n}\n\n.metismenu .collapse.in {\n  display: block\n}\n\n.metismenu .collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition-timing-function: ease;\n  transition-timing-function: ease;\n  -webkit-transition-duration: .35s;\n  transition-duration: .35s;\n  -webkit-transition-property: height, visibility;\n  transition-property: height, visibility\n}\n\n.mini-navbar {\n  .metismenu .collapse {\n    opacity: 0;\n  }\n  .metismenu .collapse.in {\n    opacity: 1;\n  }\n  .metismenu .collapse a {\n    display: none\n  }\n  .metismenu .collapse.in a {\n    display: block\n  }\n}\n\n\n\n\n\n\n\n","/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-rotating-plane\"></div>\n *\n */\n\n.sk-spinner-rotating-plane.sk-spinner {\n  width: 30px;\n  height: 30px;\n  background-color: $spin-color;\n  margin: $spin-margin;\n  -webkit-animation: sk-rotatePlane 1.2s infinite ease-in-out;\n  animation: sk-rotatePlane 1.2s infinite ease-in-out;\n}\n\n@-webkit-keyframes sk-rotatePlane {\n  0% {\n    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n  }\n\n  50% {\n    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n  }\n}\n\n@keyframes sk-rotatePlane {\n  0% {\n    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n  }\n\n  50% {\n    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-double-bounce\">\n *      <div class=\"sk-double-bounce1\"></div>\n *      <div class=\"sk-double-bounce2\"></div>\n *    </div>\n *\n */\n.sk-spinner-double-bounce.sk-spinner {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  margin: $spin-margin;\n}\n\n.sk-spinner-double-bounce .sk-double-bounce1, .sk-spinner-double-bounce .sk-double-bounce2 {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: $spin-color;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-animation: sk-doubleBounce 2s infinite ease-in-out;\n  animation: sk-doubleBounce 2s infinite ease-in-out;\n}\n\n.sk-spinner-double-bounce .sk-double-bounce2 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n@-webkit-keyframes sk-doubleBounce {\n  0%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  50% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-doubleBounce {\n  0%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  50% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-wave\">\n *      <div class=\"sk-rect1\"></div>\n *      <div class=\"sk-rect2\"></div>\n *      <div class=\"sk-rect3\"></div>\n *      <div class=\"sk-rect4\"></div>\n *      <div class=\"sk-rect5\"></div>\n *    </div>\n *\n */\n.sk-spinner-wave.sk-spinner {\n  margin: $spin-margin;\n  width: 50px;\n  height: 30px;\n  text-align: center;\n  font-size: 10px;\n}\n\n.sk-spinner-wave div {\n  background-color: $spin-color;\n  height: 100%;\n  width: 6px;\n  display: inline-block;\n  -webkit-animation: sk-waveStretchDelay 1.2s infinite ease-in-out;\n  animation: sk-waveStretchDelay 1.2s infinite ease-in-out;\n}\n\n.sk-spinner-wave .sk-rect2 {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-spinner-wave .sk-rect3 {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-spinner-wave .sk-rect4 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-spinner-wave .sk-rect5 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n@-webkit-keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n    transform: scaleY(0.4);\n  }\n\n  20% {\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n  }\n}\n\n@keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n    transform: scaleY(0.4);\n  }\n\n  20% {\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-wandering-cubes\">\n *      <div class=\"sk-cube1\"></div>\n *      <div class=\"sk-cube2\"></div>\n *    </div>\n *\n */\n.sk-spinner-wandering-cubes.sk-spinner {\n  margin: $spin-margin;\n  width: 32px;\n  height: 32px;\n  position: relative;\n}\n\n.sk-spinner-wandering-cubes .sk-cube1, .sk-spinner-wandering-cubes .sk-cube2 {\n  background-color: $spin-color;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-animation: sk-wanderingCubeMove 1.8s infinite ease-in-out;\n  animation: sk-wanderingCubeMove 1.8s infinite ease-in-out;\n}\n\n.sk-spinner-wandering-cubes .sk-cube2 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n@-webkit-keyframes sk-wanderingCubeMove {\n  25% {\n    -webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);\n    transform: translateX(42px) rotate(-90deg) scale(0.5);\n  }\n\n  50% {\n    /* Hack to make FF rotate in the right direction */\n    -webkit-transform: translateX(42px) translateY(42px) rotate(-179deg);\n    transform: translateX(42px) translateY(42px) rotate(-179deg);\n  }\n\n  50.1% {\n    -webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);\n    transform: translateX(42px) translateY(42px) rotate(-180deg);\n  }\n\n  75% {\n    -webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);\n    transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);\n  }\n\n  100% {\n    -webkit-transform: rotate(-360deg);\n    transform: rotate(-360deg);\n  }\n}\n\n@keyframes sk-wanderingCubeMove {\n  25% {\n    -webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);\n    transform: translateX(42px) rotate(-90deg) scale(0.5);\n  }\n\n  50% {\n    /* Hack to make FF rotate in the right direction */\n    -webkit-transform: translateX(42px) translateY(42px) rotate(-179deg);\n    transform: translateX(42px) translateY(42px) rotate(-179deg);\n  }\n\n  50.1% {\n    -webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);\n    transform: translateX(42px) translateY(42px) rotate(-180deg);\n  }\n\n  75% {\n    -webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);\n    transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);\n  }\n\n  100% {\n    -webkit-transform: rotate(-360deg);\n    transform: rotate(-360deg);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-pulse\"></div>\n *\n */\n.sk-spinner-pulse.sk-spinner {\n  width: 40px;\n  height: 40px;\n  margin: $spin-margin;\n  background-color: $spin-color;\n  border-radius: 100%;\n  -webkit-animation: sk-pulseScaleOut 1s infinite ease-in-out;\n  animation: sk-pulseScaleOut 1s infinite ease-in-out;\n}\n\n@-webkit-keyframes sk-pulseScaleOut {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n@keyframes sk-pulseScaleOut {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-chasing-dots\">\n *      <div class=\"sk-dot1\"></div>\n *      <div class=\"sk-dot2\"></div>\n *    </div>\n *\n */\n.sk-spinner-chasing-dots.sk-spinner {\n  margin: $spin-margin;\n  width: 40px;\n  height: 40px;\n  position: relative;\n  text-align: center;\n  -webkit-animation: sk-chasingDotsRotate 2s infinite linear;\n  animation: sk-chasingDotsRotate 2s infinite linear;\n}\n\n.sk-spinner-chasing-dots .sk-dot1, .sk-spinner-chasing-dots .sk-dot2 {\n  width: 60%;\n  height: 60%;\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  background-color: $spin-color;\n  border-radius: 100%;\n  -webkit-animation: sk-chasingDotsBounce 2s infinite ease-in-out;\n  animation: sk-chasingDotsBounce 2s infinite ease-in-out;\n}\n\n.sk-spinner-chasing-dots .sk-dot2 {\n  top: auto;\n  bottom: 0;\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n@-webkit-keyframes sk-chasingDotsRotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes sk-chasingDotsRotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes sk-chasingDotsBounce {\n  0%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  50% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-chasingDotsBounce {\n  0%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  50% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-three-bounce\">\n *      <div class=\"sk-bounce1\"></div>\n *      <div class=\"sk-bounce2\"></div>\n *      <div class=\"sk-bounce3\"></div>\n *    </div>\n *\n */\n.sk-spinner-three-bounce.sk-spinner {\n  margin: $spin-margin;\n  width: 70px;\n  text-align: center;\n}\n\n.sk-spinner-three-bounce div {\n  width: 18px;\n  height: 18px;\n  background-color: $spin-color;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-threeBounceDelay 1.4s infinite ease-in-out;\n  animation: sk-threeBounceDelay 1.4s infinite ease-in-out;\n  /* Prevent first frame from flickering when animation starts */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.sk-spinner-three-bounce .sk-bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.sk-spinner-three-bounce .sk-bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-threeBounceDelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-threeBounceDelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-circle\">\n *      <div class=\"sk-circle1 sk-circle\"></div>\n *      <div class=\"sk-circle2 sk-circle\"></div>\n *      <div class=\"sk-circle3 sk-circle\"></div>\n *      <div class=\"sk-circle4 sk-circle\"></div>\n *      <div class=\"sk-circle5 sk-circle\"></div>\n *      <div class=\"sk-circle6 sk-circle\"></div>\n *      <div class=\"sk-circle7 sk-circle\"></div>\n *      <div class=\"sk-circle8 sk-circle\"></div>\n *      <div class=\"sk-circle9 sk-circle\"></div>\n *      <div class=\"sk-circle10 sk-circle\"></div>\n *      <div class=\"sk-circle11 sk-circle\"></div>\n *      <div class=\"sk-circle12 sk-circle\"></div>\n *    </div>\n *\n */\n.sk-spinner-circle.sk-spinner {\n  margin: $spin-margin;\n  width: 22px;\n  height: 22px;\n  position: relative;\n}\n\n.sk-spinner-circle .sk-circle {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.sk-spinner-circle .sk-circle:before {\n  content: '';\n  display: block;\n  margin: $spin-margin;\n  width: 20%;\n  height: 20%;\n  background-color: $spin-color;\n  border-radius: 100%;\n  -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out;\n  animation: sk-circleBounceDelay 1.2s infinite ease-in-out;\n  /* Prevent first frame from flickering when animation starts */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.sk-spinner-circle .sk-circle2 {\n  -webkit-transform: rotate(30deg);\n  -ms-transform: rotate(30deg);\n  transform: rotate(30deg);\n}\n\n.sk-spinner-circle .sk-circle3 {\n  -webkit-transform: rotate(60deg);\n  -ms-transform: rotate(60deg);\n  transform: rotate(60deg);\n}\n\n.sk-spinner-circle .sk-circle4 {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.sk-spinner-circle .sk-circle5 {\n  -webkit-transform: rotate(120deg);\n  -ms-transform: rotate(120deg);\n  transform: rotate(120deg);\n}\n\n.sk-spinner-circle .sk-circle6 {\n  -webkit-transform: rotate(150deg);\n  -ms-transform: rotate(150deg);\n  transform: rotate(150deg);\n}\n\n.sk-spinner-circle .sk-circle7 {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.sk-spinner-circle .sk-circle8 {\n  -webkit-transform: rotate(210deg);\n  -ms-transform: rotate(210deg);\n  transform: rotate(210deg);\n}\n\n.sk-spinner-circle .sk-circle9 {\n  -webkit-transform: rotate(240deg);\n  -ms-transform: rotate(240deg);\n  transform: rotate(240deg);\n}\n\n.sk-spinner-circle .sk-circle10 {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.sk-spinner-circle .sk-circle11 {\n  -webkit-transform: rotate(300deg);\n  -ms-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\n\n.sk-spinner-circle .sk-circle12 {\n  -webkit-transform: rotate(330deg);\n  -ms-transform: rotate(330deg);\n  transform: rotate(330deg);\n}\n\n.sk-spinner-circle .sk-circle2:before {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-spinner-circle .sk-circle3:before {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-spinner-circle .sk-circle4:before {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-spinner-circle .sk-circle5:before {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.sk-spinner-circle .sk-circle6:before {\n  -webkit-animation-delay: -0.7s;\n  animation-delay: -0.7s;\n}\n\n.sk-spinner-circle .sk-circle7:before {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s;\n}\n\n.sk-spinner-circle .sk-circle8:before {\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n.sk-spinner-circle .sk-circle9:before {\n  -webkit-animation-delay: -0.4s;\n  animation-delay: -0.4s;\n}\n\n.sk-spinner-circle .sk-circle10:before {\n  -webkit-animation-delay: -0.3s;\n  animation-delay: -0.3s;\n}\n\n.sk-spinner-circle .sk-circle11:before {\n  -webkit-animation-delay: -0.2s;\n  animation-delay: -0.2s;\n}\n\n.sk-spinner-circle .sk-circle12:before {\n  -webkit-animation-delay: -0.1s;\n  animation-delay: -0.1s;\n}\n\n@-webkit-keyframes sk-circleBounceDelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-circleBounceDelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-cube-grid\">\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *      <div class=\"sk-cube\"></div>\n *    </div>\n *\n */\n.sk-spinner-cube-grid {\n  /*\n   * Spinner positions\n   * 1 2 3\n   * 4 5 6\n   * 7 8 9\n   */\n}\n\n.sk-spinner-cube-grid.sk-spinner {\n  width: 30px;\n  height: 30px;\n  margin: $spin-margin;\n}\n\n.sk-spinner-cube-grid .sk-cube {\n  width: 33%;\n  height: 33%;\n  background-color: $spin-color;\n  float: left;\n  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;\n  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(1) {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(2) {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(3) {\n  -webkit-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(4) {\n  -webkit-animation-delay: 0.1s;\n  animation-delay: 0.1s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(5) {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(6) {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(7) {\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(8) {\n  -webkit-animation-delay: 0.1s;\n  animation-delay: 0.1s;\n}\n\n.sk-spinner-cube-grid .sk-cube:nth-child(9) {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n@-webkit-keyframes sk-cubeGridScaleDelay {\n  0%, 70%, 100% {\n    -webkit-transform: scale3D(1, 1, 1);\n    transform: scale3D(1, 1, 1);\n  }\n\n  35% {\n    -webkit-transform: scale3D(0, 0, 1);\n    transform: scale3D(0, 0, 1);\n  }\n}\n\n@keyframes sk-cubeGridScaleDelay {\n  0%, 70%, 100% {\n    -webkit-transform: scale3D(1, 1, 1);\n    transform: scale3D(1, 1, 1);\n  }\n\n  35% {\n    -webkit-transform: scale3D(0, 0, 1);\n    transform: scale3D(0, 0, 1);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-wordpress\">\n *      <span class=\"sk-inner-circle\"></span>\n *    </div>\n *\n */\n.sk-spinner-wordpress.sk-spinner {\n  background-color: $spin-color;\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  position: relative;\n  margin: $spin-margin;\n  -webkit-animation: sk-innerCircle 1s linear infinite;\n  animation: sk-innerCircle 1s linear infinite;\n}\n\n.sk-spinner-wordpress .sk-inner-circle {\n  display: block;\n  background-color: #fff;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  border-radius: 8px;\n  top: 5px;\n  left: 5px;\n}\n\n@-webkit-keyframes sk-innerCircle {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes sk-innerCircle {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*\n *  Usage:\n *\n *    <div class=\"sk-spinner sk-spinner-fading-circle\">\n *      <div class=\"sk-circle1 sk-circle\"></div>\n *      <div class=\"sk-circle2 sk-circle\"></div>\n *      <div class=\"sk-circle3 sk-circle\"></div>\n *      <div class=\"sk-circle4 sk-circle\"></div>\n *      <div class=\"sk-circle5 sk-circle\"></div>\n *      <div class=\"sk-circle6 sk-circle\"></div>\n *      <div class=\"sk-circle7 sk-circle\"></div>\n *      <div class=\"sk-circle8 sk-circle\"></div>\n *      <div class=\"sk-circle9 sk-circle\"></div>\n *      <div class=\"sk-circle10 sk-circle\"></div>\n *      <div class=\"sk-circle11 sk-circle\"></div>\n *      <div class=\"sk-circle12 sk-circle\"></div>\n *    </div>\n *\n */\n.sk-spinner-fading-circle.sk-spinner {\n  margin: $spin-margin;\n  width: 22px;\n  height: 22px;\n  position: relative;\n}\n\n.sk-spinner-fading-circle .sk-circle {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.sk-spinner-fading-circle .sk-circle:before {\n  content: '';\n  display: block;\n  margin: $spin-margin;\n  width: 18%;\n  height: 18%;\n  background-color: $spin-color;\n  border-radius: 100%;\n  -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out;\n  animation: sk-circleFadeDelay 1.2s infinite ease-in-out;\n  /* Prevent first frame from flickering when animation starts */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.sk-spinner-fading-circle .sk-circle2 {\n  -webkit-transform: rotate(30deg);\n  -ms-transform: rotate(30deg);\n  transform: rotate(30deg);\n}\n\n.sk-spinner-fading-circle .sk-circle3 {\n  -webkit-transform: rotate(60deg);\n  -ms-transform: rotate(60deg);\n  transform: rotate(60deg);\n}\n\n.sk-spinner-fading-circle .sk-circle4 {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.sk-spinner-fading-circle .sk-circle5 {\n  -webkit-transform: rotate(120deg);\n  -ms-transform: rotate(120deg);\n  transform: rotate(120deg);\n}\n\n.sk-spinner-fading-circle .sk-circle6 {\n  -webkit-transform: rotate(150deg);\n  -ms-transform: rotate(150deg);\n  transform: rotate(150deg);\n}\n\n.sk-spinner-fading-circle .sk-circle7 {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.sk-spinner-fading-circle .sk-circle8 {\n  -webkit-transform: rotate(210deg);\n  -ms-transform: rotate(210deg);\n  transform: rotate(210deg);\n}\n\n.sk-spinner-fading-circle .sk-circle9 {\n  -webkit-transform: rotate(240deg);\n  -ms-transform: rotate(240deg);\n  transform: rotate(240deg);\n}\n\n.sk-spinner-fading-circle .sk-circle10 {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.sk-spinner-fading-circle .sk-circle11 {\n  -webkit-transform: rotate(300deg);\n  -ms-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\n\n.sk-spinner-fading-circle .sk-circle12 {\n  -webkit-transform: rotate(330deg);\n  -ms-transform: rotate(330deg);\n  transform: rotate(330deg);\n}\n\n.sk-spinner-fading-circle .sk-circle2:before {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.sk-spinner-fading-circle .sk-circle3:before {\n  -webkit-animation-delay: -1s;\n  animation-delay: -1s;\n}\n\n.sk-spinner-fading-circle .sk-circle4:before {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.sk-spinner-fading-circle .sk-circle5:before {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.sk-spinner-fading-circle .sk-circle6:before {\n  -webkit-animation-delay: -0.7s;\n  animation-delay: -0.7s;\n}\n\n.sk-spinner-fading-circle .sk-circle7:before {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s;\n}\n\n.sk-spinner-fading-circle .sk-circle8:before {\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n.sk-spinner-fading-circle .sk-circle9:before {\n  -webkit-animation-delay: -0.4s;\n  animation-delay: -0.4s;\n}\n\n.sk-spinner-fading-circle .sk-circle10:before {\n  -webkit-animation-delay: -0.3s;\n  animation-delay: -0.3s;\n}\n\n.sk-spinner-fading-circle .sk-circle11:before {\n  -webkit-animation-delay: -0.2s;\n  animation-delay: -0.2s;\n}\n\n.sk-spinner-fading-circle .sk-circle12:before {\n  -webkit-animation-delay: -0.1s;\n  animation-delay: -0.1s;\n}\n\n@-webkit-keyframes sk-circleFadeDelay {\n  0%, 39%, 100% {\n    opacity: 0;\n  }\n\n  40% {\n    opacity: 1;\n  }\n}\n\n@keyframes sk-circleFadeDelay {\n  0%, 39%, 100% {\n    opacity: 0;\n  }\n\n  40% {\n    opacity: 1;\n  }\n}\n\n.ibox-content > .sk-spinner {\n  display: none;\n}\n\n.sk-loading {\n  position: relative;\n}\n\n.sk-loading:after {\n  content: '';\n  background-color: rgba(255, 255, 255, 0.7);\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999999;\n\n}\n\n.sk-loading > .sk-spinner {\n  display: block;\n  position: absolute;\n  top: 40%;\n  left: 0;\n  right: 0;\n  z-index: 2000;\n}\n","/*\n *\n *   SKIN 1 - INSPINIA - Responsive Admin Theme\n *   NAME - Blue light\n *\n*/\n\n// Main colors\n$skin-1-color: #0e9aef;\n$skin-1-nav-bg: #3e495f;\n$skin-1-a-color: #9ea6b9;\n$skin-1-page-bg: #f4f6fa;\n\n// Custom style\n.skin-1 .minimalize-styl-2 {\n  margin: 14px 5px 5px 30px;\n}\n\n.skin-1 .navbar-top-links li:last-child {\n  margin-right: 30px;\n}\n\n.skin-1.fixed-nav .minimalize-styl-2 {\n  margin: 14px 5px 5px 15px;\n}\n\n.skin-1 .spin-icon {\n  background: $skin-1-color !important;\n}\n\n.skin-1 .nav-header {\n  background-color: $skin-1-color;\n  background-image: url('patterns/header-profile-skin-1.png');\n}\n\n.skin-1.mini-navbar .nav-second-level {\n  background: $skin-1-nav-bg;\n}\n\n.skin-1 .breadcrumb {\n  background: transparent;\n}\n\n.skin-1 .page-heading {\n  border: none;\n}\n\n.skin-1 .nav > li.active {\n  background: darken($skin-1-nav-bg, 2%);\n}\n\n.skin-1 .nav > li > a {\n  color: $skin-1-a-color;\n}\n\n.skin-1 ul.nav-second-level {\n  background-color: inherit;\n}\n\n.skin-1 .nav > li.active > a {\n  color: #fff;\n}\n\n.skin-1 .navbar-minimalize {\n  background: $skin-1-color;\n  border-color: $skin-1-color;\n}\n\nbody.skin-1 {\n  background: $skin-1-nav-bg;\n}\n\n.skin-1 .navbar-static-top {\n  background: #ffffff;\n}\n\n.skin-1 .dashboard-header {\n  background: transparent;\n  border-bottom: none !important;\n  border-top: none;\n  padding: 20px 30px 10px 30px;\n}\n\n.fixed-nav.skin-1 .navbar-fixed-top {\n  background: #fff;\n}\n\n.skin-1 .wrapper-content {\n  padding: 30px 15px;\n}\n\n.skin-1 #page-wrapper {\n  background: $skin-1-page-bg;\n}\n\n.skin-1 .ibox-title, .skin-1 .ibox-content {\n  border-width: 1px;\n}\n\n.skin-1 .ibox-content:last-child {\n  border-style: solid solid solid solid;\n}\n\n.skin-1 .nav > li.active {\n  border: none;\n}\n\n.skin-1 .nav-header {\n  padding: 35px 25px 25px 25px;\n}\n\n.skin-1 .nav-header a.dropdown-toggle {\n  color: #fff;\n  margin-top: 10px;\n}\n\n.skin-1 .nav-header a.dropdown-toggle .text-muted {\n  color: #fff;\n  opacity: 0.8;\n}\n\n.skin-1 .profile-element {\n  text-align: center;\n}\n\n.skin-1 .rounded-circle {\n  border-radius: 5px;\n}\n\n.skin-1 .navbar-default .nav > li > a:hover, .skin-1 .navbar-default .nav > li > a:focus {\n  background: darken($skin-1-nav-bg, 2%);\n  color: #fff;\n}\n\n.skin-1 .nav.nav-tabs > li.active > a {\n  color: #555;\n}\n\n.skin-1 .nav.nav-tabs > li.active {\n  background: transparent;\n}\n\n/*\n *\n *   SKIN 2 - INSPINIA - Responsive Admin Theme\n *   NAME - Inspinia Ultra\n *\n*/\n\n// Main colors\n$skin-2-color: #23c6c8;\n$skin-2-nav-bg: #ededed;\n$skin-2-nav-top-bg: #213a53;\n\n// Custom style\n\nbody.skin-2 {\n  color: #565758 !important;\n}\n\n.skin-2 .minimalize-styl-2 {\n  margin: 14px 5px 5px 25px;\n}\n\n.skin-2 .navbar-top-links li:last-child {\n  margin-right: 30px;\n}\n\n.skin-2 .spin-icon {\n  background: $skin-2-color !important;\n}\n\n.skin-2 .nav-header {\n  background-color: $skin-2-color;\n  background-image: url('patterns/header-profile-skin-2.png');\n}\n\n.skin-2.mini-navbar .nav-second-level {\n  background: $skin-2-nav-bg;\n}\n\n.skin-2 .breadcrumb {\n  background: transparent;\n}\n\n.skin-2.fixed-nav .minimalize-styl-2 {\n  margin: 14px 5px 5px 15px;\n}\n\n.skin-2 .page-heading {\n  border: none;\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.skin-2 ul.nav-second-level {\n  background-color: inherit;\n}\n\n.skin-2 .nav > li.active {\n  background: #e0e0e0;\n}\n\n.skin-2 .logo-element {\n  padding: 17px 0;\n}\n\n.skin-2 .nav > li > a, .skin-2 .welcome-message {\n  color: #edf6ff;\n}\n\n.skin-2 #top-search::-moz-placeholder {\n  color: #edf6ff;\n  opacity: 0.5;\n}\n\n.skin-2 #side-menu > li > a, .skin-2 .nav.nav-second-level > li > a {\n  color: #586b7d;\n}\n\n.skin-2 .nav > li.active > a {\n  color: $skin-2-nav-top-bg;\n}\n\n.skin-2.mini-navbar .nav-header {\n  background: $skin-2-nav-top-bg;\n}\n\n.skin-2 .navbar-minimalize {\n  background: $skin-2-color;\n  border-color: $skin-2-color;\n}\n\n.skin-2 .border-bottom {\n  border-bottom: none !important;\n}\n\n.skin-2 #top-search {\n  color: #fff;\n}\n\nbody.skin-2 #wrapper {\n  background-color: $skin-2-nav-bg;\n}\n\n.skin-2 .navbar-static-top {\n  background: $skin-2-nav-top-bg;\n}\n\n.fixed-nav.skin-2 .navbar-fixed-top {\n  background: $skin-2-nav-top-bg;\n  border-bottom: none !important;\n}\n\n.skin-2 .nav-header {\n  padding: 30px 25px 30px 25px;\n}\n\n.skin-2 .dashboard-header {\n  background: rgba(255, 255, 255, 0.4);\n  border-bottom: none !important;\n  border-top: none;\n  padding: 20px 30px 20px 30px;\n}\n\n.skin-2 .wrapper-content {\n  padding: 30px 15px;\n}\n\n.skin-2 .dashoard-1 .wrapper-content {\n  padding: 0 30px 25px 30px;\n}\n\n.skin-2 .ibox-title {\n  background: rgba(255, 255, 255, 0.7);\n  border: none;\n  margin-bottom: 1px;\n}\n\n.skin-2 .ibox-content {\n  background: rgba(255, 255, 255, 0.4);\n  border: none !important;\n}\n\n.skin-2 #page-wrapper {\n  background: rgba(246, 246, 246, 1);\n  background: -webkit-radial-gradient(center, ellipse cover, rgba(246, 246, 246, 1) 20%, rgba(213, 213, 213, 1) 100%);\n  background: -o-radial-gradient(center, ellipse cover, rgba(246, 246, 246, 1) 20%, rgba(213, 213, 213, 1) 100%);\n  background: -ms-radial-gradient(center, ellipse cover, rgba(246, 246, 246, 1) 20%, rgba(213, 213, 213, 1) 100%);\n  background: radial-gradient(ellipse at center, rgba(246, 246, 246, 1) 20%, rgba(213, 213, 213, 1) 100%);\n  -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr=#f6f6f6, endColorstr=#d5d5d5)\";\n}\n\n.skin-2 .ibox-title, .skin-2 .ibox-content {\n  border-width: 1px;\n}\n\n.skin-2 .ibox-content:last-child {\n  border-style: solid solid solid solid;\n}\n\n.skin-2 .nav > li.active {\n  border: none;\n}\n\n.skin-2 .nav-header a.dropdown-toggle {\n  color: #edf6ff;\n  margin-top: 10px;\n}\n\n.skin-2 .nav-header a.dropdown-toggle .text-muted {\n  color: #edf6ff;\n  opacity: 0.8;\n}\n\n.skin-2 .rounded-circle {\n  border-radius: 10px;\n}\n\n.skin-2 .nav.navbar-top-links > li > a:hover, .skin-2 .nav.navbar-top-links > li > a:focus {\n  background: darken($skin-2-nav-top-bg, 5%);\n}\n\n.skin-2 .navbar-default .nav > li > a:hover, .skin-2 .navbar-default .nav > li > a:focus {\n  background: #e0e0e0;\n  color: #213a53;\n}\n\n.skin-2 .nav.nav-tabs > li.active > a {\n  color: #555;\n}\n\n.skin-2 .nav.nav-tabs > li.active {\n  background: transparent;\n}\n\n/*\n *\n *   SKIN 3 - INSPINIA - Responsive Admin Theme\n *   NAME - Yellow/purple\n *\n*/\n\n// Main colors\n$skin-3-color: #ecba52;\n$skin-3-nav-bg: #3e2c42;\n$skin-3-a-color: #948b96;\n$skin-3-page-bg: #f4f6fa;\n\n// Custom style\n.skin-3 .minimalize-styl-2 {\n  margin: 14px 5px 5px 30px;\n}\n\n.skin-3 .navbar-top-links li:last-child {\n  margin-right: 30px;\n}\n\n.skin-3.fixed-nav .minimalize-styl-2 {\n  margin: 14px 5px 5px 15px;\n}\n\n.skin-3 .spin-icon {\n  background: $skin-3-color !important;\n}\n\nbody.boxed-layout.skin-3 #wrapper {\n  background: $skin-3-nav-bg;\n}\n\n.skin-3 .nav-header {\n  background-color: $skin-3-color;\n  background-image: url('patterns/header-profile-skin-3.png');\n}\n\n.skin-3.mini-navbar .nav-second-level {\n  background: $skin-3-nav-bg;\n}\n\n.skin-3 .breadcrumb {\n  background: transparent;\n}\n\n.skin-3 .page-heading {\n  border: none;\n}\n\n.skin-3 ul.nav-second-level {\n  background-color: inherit;\n}\n\n.skin-3 .nav > li.active {\n  background: darken($skin-3-nav-bg, 2%);\n}\n\n.fixed-nav.skin-3 .navbar-fixed-top {\n  background: #fff;\n}\n\n.skin-3 .nav > li > a {\n  color: $skin-3-a-color;\n}\n\n.skin-3 .nav > li.active > a {\n  color: #fff;\n}\n\n.skin-3 .navbar-minimalize {\n  background: $skin-3-color;\n  border-color: $skin-3-color;\n}\n\nbody.skin-3 {\n  background: $skin-3-nav-bg;\n}\n\n.skin-3 .navbar-static-top {\n  background: #ffffff;\n}\n\n.skin-3 .dashboard-header {\n  background: transparent;\n  border-bottom: none !important;\n  border-top: none;\n  padding: 20px 30px 10px 30px;\n}\n\n.skin-3 .wrapper-content {\n  padding: 30px 15px;\n}\n\n.skin-3 #page-wrapper {\n  background: $skin-3-page-bg;\n}\n\n.skin-3 .ibox-title, .skin-3 .ibox-content {\n  border-width: 1px;\n}\n\n.skin-3 .ibox-content:last-child {\n  border-style: solid solid solid solid;\n}\n\n.skin-3 .nav > li.active {\n  border: none;\n}\n\n.skin-3 .nav-header {\n  padding: 35px 25px 25px 25px;\n}\n\n.skin-3 .nav-header a.dropdown-toggle {\n  color: #fff;\n  margin-top: 10px;\n}\n\n.skin-3 .nav-header a.dropdown-toggle .text-muted {\n  color: #fff;\n  opacity: 0.8;\n}\n\n.skin-3 .profile-element {\n  text-align: center;\n}\n\n.skin-3 .rounded-circle {\n  border-radius: 5px;\n}\n\n.skin-3 .navbar-default .nav > li > a:hover, .skin-3 .navbar-default .nav > li > a:focus {\n  background: darken($skin-3-nav-bg, 2%);\n  color: #fff;\n}\n\n.skin-3 .nav.nav-tabs > li.active > a {\n  color: #555;\n}\n\n.skin-3 .nav.nav-tabs > li.active {\n  background: transparent;\n}\n\n\n/*\n *\n *   SKIN 4 - INSPINIA - Responsive Admin Theme\n *   NAME - Light-Skin\n *\n*/\n\n// Main colors\n$skin-4-bg: #f9f9f9;\n$skin-4-box-shadow: 0 1px 8px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.1);\n$skin-4-a-color-active: #384D6C;\n$skin-4-a-color: #7c899a;\n\n\nbody.light-skin {\n  background-color: $skin-4-bg;\n  color: #3e5476;\n}\n\n.light-skin {\n\n  .select2-container--default .select2-selection--single, .select2-container--default .select2-selection--multiple, .select2-container--default .select2-selection--single .select2-selection__arrow {\n    height: 2.05rem;\n  }\n\n  .select2-container--default .select2-selection--single .select2-selection__rendered {\n    line-height: 32px;\n  }\n\n  .navbar-fixed-top, .navbar-static-top {\n    background-color: transparent;\n  }\n\n  .dashboards\\.dashboard_2 nav.navbar,\n  .dashboards\\.dashboard_3 nav.navbar,\n  .mailbox\\.inbox nav.navbar,\n  .mailbox\\.email_view nav.navbar,\n  .mailbox\\.email_compose nav.navbar,\n  .dashboards\\.dashboard_4_1 nav.navbar,\n  .metrics nav.navbar, .metrics\\.index nav.navbar,\n  .dashboards\\.dashboard_5 nav.navbar {\n    background: transparent;\n  }\n\n  &.fixed-nav .navbar-fixed-top {\n    background-color: #FFFFFF;\n  }\n\n  &.mini-navbar .nav .nav-second-level {\n    background-color: $skin-4-bg;\n    box-shadow: $skin-4-box-shadow;\n  }\n\n  &.fixed-sidebar.mini-navbar .nav .nav-second-level, &.canvas-menu.mini-navbar .nav .nav-second-level {\n    box-shadow: none;\n  }\n\n  &.canvas-menu nav.navbar-static-side {\n    background-color: $skin-4-bg;\n  }\n\n  &.canvas-menu.mini-navbar nav.navbar-static-side {\n    box-shadow: $skin-4-box-shadow;\n  }\n\n  &.body-small.fixed-sidebar.mini-navbar .navbar-static-side {\n    //border: 1px solid gray\n  }\n\n  &.mini-navbar .nav-header {\n    background-color: $skin-4-bg;\n  }\n\n  #page-wrapper.gray-bg, #page-wrapper.bg-muted {\n    background-color: $skin-4-bg;\n  }\n\n  .logo-element {\n    color: $skin-4-a-color\n  }\n\n  nav > .sidebar-collapse > ul > li  a {\n    color: $skin-4-a-color;\n    padding-top: 9px;\n    padding-bottom: 9px;\n  }\n\n  nav > .sidebar-collapse .nav-second-level li a {\n    padding-top: 7px;\n    padding-bottom: 7px;\n  }\n\n  .nav > li.active > a {\n    color: $skin-4-a-color-active;\n    font-weight: 700;\n  }\n\n  .nav-header a {\n    color: $skin-4-a-color-active;\n  }\n\n  .navbar-default .nav > li > a:hover, .navbar-default .nav > li > a:focus {\n    background-color: inherit;\n    color: $skin-4-a-color-active;\n    font-weight: 700;\n  }\n\n  .nav-header .font-bold {\n    font-size: 12px;\n    font-weight: 700;\n    color: $skin-4-a-color-active;\n  }\n\n  .nav-header .text-muted {\n    color: #8291a3 !important;\n    font-size: 12px;\n  }\n\n  .nav-header {\n    background-color: $skin-4-bg;\n    background-image: none;\n    padding: 20px 25px 20px 25px;\n  }\n\n  .profile-element img {\n    border-radius: 6px !important;\n  }\n\n  .nav > li.active {\n    background: $skin-4-bg;\n  }\n\n  ul.nav-second-level {\n    background: $skin-4-bg;\n  }\n\n  .dashboard-header {\n    border-bottom: none !important;\n    border-top: 0;\n    border-radius: 4px;\n    padding: 20px 20px 20px 20px;\n    margin: 10px 10px 0 10px;\n    box-shadow: $skin-4-box-shadow;\n  }\n\n  .page-heading {\n    padding-bottom: 10px;\n  }\n\n  .ibox-title {\n    background-color: transparent;\n    border: none;\n    padding-left: 5px;\n  }\n\n  .ibox-title h5 {\n    font-size: 12px;\n  }\n\n  .ibox-tools {\n    right: 5px;\n\n    a {\n      color: $skin-4-a-color !important\n    }\n  }\n\n  .ibox-heading {\n    background-color: #fff;\n    margin-bottom: 20px;\n  }\n\n  .ibox-content {\n    box-shadow: $skin-4-box-shadow;\n    border-radius: 4px;\n    border: none;\n    background-color: #FFFFFF;\n  }\n\n  .breadcrumb {\n    background-color: transparent;\n  }\n\n  .minimalize-styl-2 {\n    margin: 14px 5px 5px 30px;\n  }\n\n  .footer {\n    border: none;\n    background: none;\n  }\n\n  .sidebar-panel {\n    background-color: #fff;\n  }\n\n  #page-wrapper > .border-bottom, .ibox.border-bottom {\n    border-bottom: transparent !important;\n  }\n\n  .fh-breadcrumb {\n    height: calc(100% - 176px) ;\n  }\n\n  &.top-navigation #page-wrapper > .border-bottom {\n    border-bottom: 1px solid $border-color !important;\n  }\n  .wrapper.white-bg {\n    background-color: transparent;\n  }\n\n  .ibox-tools a.btn-primary {\n    color: #FFFFFF !important;\n  }\n\n  .chat-discussion {\n    background-color: #FFFFFF;\n  }\n\n  .ibox-footer {\n    margin-top: 4px;\n    border: none;\n    box-shadow: $skin-4-box-shadow;\n    border-radius: 4px;\n  }\n\n  .contact-box, .social-feed-box, .vertical-timeline-content {\n    box-shadow: $skin-4-box-shadow;\n    border: none;\n  }\n\n  .navbar-default .landing_link a,\n  .navbar-default .special_link a {\n    color: #FFFFFF;\n  }\n\n}","@media (min-width: 768px) {\n  #page-wrapper {\n    position: inherit;\n    min-height: 100vh;\n  }\n\n  .navbar-static-side {\n    z-index: 1000;\n    max-width: $sidebar-width;\n  }\n\n  .navbar-top-links .dropdown-messages,\n  .navbar-top-links .dropdown-tasks,\n  .navbar-top-links .dropdown-alerts {\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 768px) {\n\n  #page-wrapper {\n    position: inherit;\n    margin: 0 0 0 0;\n    min-height: 100vh;\n    width: 100%;\n  }\n\n  .body-small .navbar-static-side {\n    display: block;\n    z-index: 2001;\n    width: 0;\n    overflow: hidden;\n  }\n\n  .body-small.mini-navbar .navbar-static-side {\n    display: block;\n    overflow: visible;\n  }\n\n  .lock-word {\n    display: none;\n  }\n\n  .navbar-form-custom {\n    display: none;\n  }\n\n  .navbar-header {\n    display: inline;\n    float: left;\n  }\n\n  .sidebar-panel {\n    z-index: 2;\n    position: relative;\n    width: auto;\n    min-height: 100% !important;\n  }\n\n  .sidebar-content .wrapper {\n    padding-right: 0;\n    z-index: 1;\n  }\n\n  .fixed-sidebar.body-small .navbar-static-side {\n    display: none;\n    z-index: 2001;\n    position: fixed;\n    width: $sidebar-width;\n  }\n\n  .fixed-sidebar.body-small.mini-navbar .navbar-static-side {\n    display: block;\n  }\n\n  .ibox-tools {\n    float: none;\n    text-align: right;\n    display: block;\n  }\n\n  .navbar-static-side {\n    display: none;\n  }\n\n  body:not(.mini-navbar) {\n    -webkit-transition: background-color 500ms linear;\n    -moz-transition: background-color 500ms linear;\n    -o-transition: background-color 500ms linear;\n    -ms-transition: background-color 500ms linear;\n    transition: background-color 500ms linear;\n    background-color: #f3f3f4\n  }\n\n}\n\n@media (max-width: 350px) {\n\n  .timeline-item .date {\n    text-align: left;\n    width: 110px;\n    position: relative;\n    padding-top: 30px;\n  }\n\n  .timeline-item .date i {\n    position: absolute;\n    top: 0;\n    left: 15px;\n    padding: 5px;\n    width: 30px;\n    text-align: center;\n    border: 1px solid $border-color;\n    background: #f8f8f8;\n  }\n\n  .timeline-item .content {\n    border-left: none;\n    border-top: 1px solid $border-color;\n    padding-top: 10px;\n    min-height: 100px;\n  }\n\n  .nav.navbar-top-links li.dropdown {\n    display: none;\n  }\n\n  .ibox-tools {\n    float: none;\n    text-align: left;\n    display: inline-block;\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
